(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8fbd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8fbd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8prog", function(module, exports) {
/*
"process": {
	"env": {
	  "NODE_ENV": "development"
	  "NODE_ENV": "production"
	}
}*/ //process.env.NODE_ENV = 'development';
//process.env.NODE_ENV = 'production';
//import * as $ from './node_modules/jquery/dist/jquery.min.js';
//import * as $ from 'jquery';
//import './node_modules/jquery/dist/jquery.min.js';
//window.$ = $;
//window.jQuery = $;
//import './node_modules/jquery-qrcode/jquery.qrcode.min.js';
//console.log(window.bootstrap);
//console.log(window.bootstrap.Dropdown);
//console.log(Popper);
//import transitions from "bootstrap";
//window.transitions = transitions;
/*
import * as tinymce from './node_modules/tinymce/tinymce.min.js';
//import * as tinymce from 'tinymce';
import * as tinymce_theme from './node_modules/tinymce/themes/silver/index.js';
import * as tinymce_icons from './node_modules/tinymce/icons/default/index.js';
import './node_modules/tinymce/skins/content/default/content.css';
import './node_modules/tinymce/skins/ui/oxide/content.css';
import './node_modules/tinymce/skins/ui/oxide/skin.css';
*/ //import Stackedit from 'stackedit-js';
//window.Stackedit = Stackedit;
//import woofmark from 'woofmark';
//window.woofmark = woofmark;
//import megamark from 'megamark';
//window.megamark = megamark;
//import domador from 'domador';
//window.domador = domador;
// --
/*
import { Editor } from './tui/apps/editor/dist/esm/index.js';
//import { Editor } from './tui/apps/editor/dist/toastui-editor.js';
//import { Editor } from './tui/editor/dist/toastui-editor.js';
//import Editor from './tui/editor/dist/esm/index.js';
//import { Editor } from './tui/editor/dist/cdn/toastui-editor-all.js';
//import Editor from './tui/editor/dist/cdn/toastui-editor-all.js';

//import editor_uml from '@toast-ui/editor-plugin-uml';
//import editor_webnode from '@toast-ui/editor-plugin-web-node';

window.toastui = { };
window.toastui.Editor = Editor;
*/ /*window.toastui = {
	//editor_uml: editor_uml,
	//editor_webnode: editor_webnode,
	Editor: Editor
};*/ //console.log('window.Editor', window.toastui);

var $60OaQ = parcelRequire("60OaQ");

var $346VI = parcelRequire("346VI");

var $3j512 = parcelRequire("3j512");

var $eesPf = parcelRequire("eesPf");
window.Split = (0, $60OaQ.default);
window.DrDocWeb = (0, $346VI.default);
window.DrDoc = (0, $3j512.default);
window.DrawConnection = (0, $eesPf.default);
//import './script.js'
// Requires: DrDocWeb, Node, DrDoc
(0, $3j512.default).Init();
document.addEventListener('DOMContentLoaded', function(e) {
    (0, $346VI.default).EventFire(document, 'NodeLoaded');
    if (window.DrawConnection !== undefined) (0, $eesPf.default).init();
}); /*window.tinymce = tinymce;
window.tinymce_theme = tinymce_theme;
window.tinymce_icons = tinymce_icons;*/ 

});
parcelRegister("60OaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4609a9aa19959f74$export$2e2bcd8739ae039);
// The programming goals of Split.js are to deliver readable, understandable and
// maintainable code, while at the same time manually optimizing for tiny minified file size,
// browser compatibility without additional requirements
// and very few assumptions about the user's page layout.
var $4609a9aa19959f74$var$global = typeof window !== 'undefined' ? window : null;
var $4609a9aa19959f74$var$ssr = $4609a9aa19959f74$var$global === null;
var $4609a9aa19959f74$var$document = !$4609a9aa19959f74$var$ssr ? $4609a9aa19959f74$var$global.document : undefined;
// Save a couple long function names that are used frequently.
// This optimization saves around 400 bytes.
var $4609a9aa19959f74$var$addEventListener = 'addEventListener';
var $4609a9aa19959f74$var$removeEventListener = 'removeEventListener';
var $4609a9aa19959f74$var$getBoundingClientRect = 'getBoundingClientRect';
var $4609a9aa19959f74$var$gutterStartDragging = '_a';
var $4609a9aa19959f74$var$aGutterSize = '_b';
var $4609a9aa19959f74$var$bGutterSize = '_c';
var $4609a9aa19959f74$var$HORIZONTAL = 'horizontal';
var $4609a9aa19959f74$var$NOOP = function() {
    return false;
};
// Helper function determines which prefixes of CSS calc we need.
// We only need to do this once on startup, when this anonymous function is called.
//
// Tests -webkit, -moz and -o prefixes. Modified from StackOverflow:
// http://stackoverflow.com/questions/16625140/js-feature-detection-to-detect-the-usage-of-webkit-calc-over-calc/16625167#16625167
var $4609a9aa19959f74$var$calc = $4609a9aa19959f74$var$ssr ? 'calc' : [
    '',
    '-webkit-',
    '-moz-',
    '-o-'
].filter(function(prefix) {
    var el = $4609a9aa19959f74$var$document.createElement('div');
    el.style.cssText = "width:" + prefix + "calc(9px)";
    return !!el.style.length;
}).shift() + "calc";
// Helper function checks if its argument is a string-like type
var $4609a9aa19959f74$var$isString = function(v) {
    return typeof v === 'string' || v instanceof String;
};
// Helper function allows elements and string selectors to be used
// interchangeably. In either case an element is returned. This allows us to
// do `Split([elem1, elem2])` as well as `Split(['#id1', '#id2'])`.
var $4609a9aa19959f74$var$elementOrSelector = function(el) {
    if ($4609a9aa19959f74$var$isString(el)) {
        var ele = $4609a9aa19959f74$var$document.querySelector(el);
        if (!ele) throw new Error("Selector " + el + " did not match a DOM element");
        return ele;
    }
    return el;
};
// Helper function gets a property from the properties object, with a default fallback
var $4609a9aa19959f74$var$getOption = function(options, propName, def) {
    var value = options[propName];
    if (value !== undefined) return value;
    return def;
};
var $4609a9aa19959f74$var$getGutterSize = function(gutterSize, isFirst, isLast, gutterAlign) {
    if (isFirst) {
        if (gutterAlign === 'end') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    } else if (isLast) {
        if (gutterAlign === 'start') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    }
    return gutterSize;
};
// Default options
var $4609a9aa19959f74$var$defaultGutterFn = function(i, gutterDirection) {
    var gut = $4609a9aa19959f74$var$document.createElement('div');
    gut.className = "gutter gutter-" + gutterDirection;
    return gut;
};
var $4609a9aa19959f74$var$defaultElementStyleFn = function(dim, size, gutSize) {
    var style = {};
    if (!$4609a9aa19959f74$var$isString(size)) style[dim] = $4609a9aa19959f74$var$calc + "(" + size + "% - " + gutSize + "px)";
    else style[dim] = size;
    return style;
};
var $4609a9aa19959f74$var$defaultGutterStyleFn = function(dim, gutSize) {
    var obj;
    return obj = {}, obj[dim] = gutSize + "px", obj;
};
// The main function to initialize a split. Split.js thinks about each pair
// of elements as an independant pair. Dragging the gutter between two elements
// only changes the dimensions of elements in that pair. This is key to understanding
// how the following functions operate, since each function is bound to a pair.
//
// A pair object is shaped like this:
//
// {
//     a: DOM element,
//     b: DOM element,
//     aMin: Number,
//     bMin: Number,
//     dragging: Boolean,
//     parent: DOM element,
//     direction: 'horizontal' | 'vertical'
// }
//
// The basic sequence:
//
// 1. Set defaults to something sane. `options` doesn't have to be passed at all.
// 2. Initialize a bunch of strings based on the direction we're splitting.
//    A lot of the behavior in the rest of the library is paramatized down to
//    rely on CSS strings and classes.
// 3. Define the dragging helper functions, and a few helpers to go with them.
// 4. Loop through the elements while pairing them off. Every pair gets an
//    `pair` object and a gutter.
// 5. Actually size the pair elements, insert gutters and attach event listeners.
var $4609a9aa19959f74$var$Split = function(idsOption, options) {
    if (options === void 0) options = {};
    if ($4609a9aa19959f74$var$ssr) return {};
    var ids = idsOption;
    var dimension;
    var clientAxis;
    var position;
    var positionEnd;
    var clientSize;
    var elements;
    // Allow HTMLCollection to be used as an argument when supported
    if (Array.from) ids = Array.from(ids);
    // All DOM elements in the split should have a common parent. We can grab
    // the first elements parent and hope users read the docs because the
    // behavior will be whacky otherwise.
    var firstElement = $4609a9aa19959f74$var$elementOrSelector(ids[0]);
    var parent = firstElement.parentNode;
    var parentStyle = getComputedStyle ? getComputedStyle(parent) : null;
    var parentFlexDirection = parentStyle ? parentStyle.flexDirection : null;
    // Set default options.sizes to equal percentages of the parent element.
    var sizes = $4609a9aa19959f74$var$getOption(options, 'sizes') || ids.map(function() {
        return 100 / ids.length;
    });
    // Standardize minSize and maxSize to an array if it isn't already.
    // This allows minSize and maxSize to be passed as a number.
    var minSize = $4609a9aa19959f74$var$getOption(options, 'minSize', 100);
    var minSizes = Array.isArray(minSize) ? minSize : ids.map(function() {
        return minSize;
    });
    var maxSize = $4609a9aa19959f74$var$getOption(options, 'maxSize', Infinity);
    var maxSizes = Array.isArray(maxSize) ? maxSize : ids.map(function() {
        return maxSize;
    });
    // Get other options
    var expandToMin = $4609a9aa19959f74$var$getOption(options, 'expandToMin', false);
    var gutterSize = $4609a9aa19959f74$var$getOption(options, 'gutterSize', 10);
    var gutterAlign = $4609a9aa19959f74$var$getOption(options, 'gutterAlign', 'center');
    var snapOffset = $4609a9aa19959f74$var$getOption(options, 'snapOffset', 30);
    var snapOffsets = Array.isArray(snapOffset) ? snapOffset : ids.map(function() {
        return snapOffset;
    });
    var dragInterval = $4609a9aa19959f74$var$getOption(options, 'dragInterval', 1);
    var direction = $4609a9aa19959f74$var$getOption(options, 'direction', $4609a9aa19959f74$var$HORIZONTAL);
    var cursor = $4609a9aa19959f74$var$getOption(options, 'cursor', direction === $4609a9aa19959f74$var$HORIZONTAL ? 'col-resize' : 'row-resize');
    var gutter = $4609a9aa19959f74$var$getOption(options, 'gutter', $4609a9aa19959f74$var$defaultGutterFn);
    var elementStyle = $4609a9aa19959f74$var$getOption(options, 'elementStyle', $4609a9aa19959f74$var$defaultElementStyleFn);
    var gutterStyle = $4609a9aa19959f74$var$getOption(options, 'gutterStyle', $4609a9aa19959f74$var$defaultGutterStyleFn);
    // 2. Initialize a bunch of strings based on the direction we're splitting.
    // A lot of the behavior in the rest of the library is paramatized down to
    // rely on CSS strings and classes.
    if (direction === $4609a9aa19959f74$var$HORIZONTAL) {
        dimension = 'width';
        clientAxis = 'clientX';
        position = 'left';
        positionEnd = 'right';
        clientSize = 'clientWidth';
    } else if (direction === 'vertical') {
        dimension = 'height';
        clientAxis = 'clientY';
        position = 'top';
        positionEnd = 'bottom';
        clientSize = 'clientHeight';
    }
    // 3. Define the dragging helper functions, and a few helpers to go with them.
    // Each helper is bound to a pair object that contains its metadata. This
    // also makes it easy to store references to listeners that that will be
    // added and removed.
    //
    // Even though there are no other functions contained in them, aliasing
    // this to self saves 50 bytes or so since it's used so frequently.
    //
    // The pair object saves metadata like dragging state, position and
    // event listener references.
    function setElementSize(el, size, gutSize, i) {
        // Split.js allows setting sizes via numbers (ideally), or if you must,
        // by string, like '300px'. This is less than ideal, because it breaks
        // the fluid layout that `calc(% - px)` provides. You're on your own if you do that,
        // make sure you calculate the gutter size by hand.
        var style = elementStyle(dimension, size, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            el.style[prop] = style[prop];
        });
    }
    function setGutterSize(gutterElement, gutSize, i) {
        var style = gutterStyle(dimension, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            gutterElement.style[prop] = style[prop];
        });
    }
    function getSizes() {
        return elements.map(function(element) {
            return element.size;
        });
    }
    // Supports touch events, but not multitouch, so only the first
    // finger `touches[0]` is counted.
    function getMousePosition(e) {
        if ('touches' in e) return e.touches[0][clientAxis];
        return e[clientAxis];
    }
    // Actually adjust the size of elements `a` and `b` to `offset` while dragging.
    // calc is used to allow calc(percentage + gutterpx) on the whole split instance,
    // which allows the viewport to be resized without additional logic.
    // Element a's size is the same as offset. b's size is total size - a size.
    // Both sizes are calculated from the initial parent percentage,
    // then the gutter size is subtracted.
    function adjust(offset) {
        var a = elements[this.a];
        var b = elements[this.b];
        var percentage = a.size + b.size;
        a.size = offset / this.size * percentage;
        b.size = percentage - offset / this.size * percentage;
        setElementSize(a.element, a.size, this[$4609a9aa19959f74$var$aGutterSize], a.i);
        setElementSize(b.element, b.size, this[$4609a9aa19959f74$var$bGutterSize], b.i);
    }
    // drag, where all the magic happens. The logic is really quite simple:
    //
    // 1. Ignore if the pair is not dragging.
    // 2. Get the offset of the event.
    // 3. Snap offset to min if within snappable range (within min + snapOffset).
    // 4. Actually adjust each element in the pair to offset.
    //
    // ---------------------------------------------------------------------
    // |    | <- a.minSize               ||              b.minSize -> |    |
    // |    |  | <- this.snapOffset      ||     this.snapOffset -> |  |    |
    // |    |  |                         ||                        |  |    |
    // |    |  |                         ||                        |  |    |
    // ---------------------------------------------------------------------
    // | <- this.start                                        this.size -> |
    function drag(e) {
        var offset;
        var a = elements[this.a];
        var b = elements[this.b];
        if (!this.dragging) return;
        // Get the offset of the event from the first side of the
        // pair `this.start`. Then offset by the initial position of the
        // mouse compared to the gutter size.
        offset = getMousePosition(e) - this.start + (this[$4609a9aa19959f74$var$aGutterSize] - this.dragOffset);
        if (dragInterval > 1) offset = Math.round(offset / dragInterval) * dragInterval;
        // If within snapOffset of min or max, set offset to min or max.
        // snapOffset buffers a.minSize and b.minSize, so logic is opposite for both.
        // Include the appropriate gutter sizes to prevent overflows.
        if (offset <= a.minSize + a.snapOffset + this[$4609a9aa19959f74$var$aGutterSize]) offset = a.minSize + this[$4609a9aa19959f74$var$aGutterSize];
        else if (offset >= this.size - (b.minSize + b.snapOffset + this[$4609a9aa19959f74$var$bGutterSize])) offset = this.size - (b.minSize + this[$4609a9aa19959f74$var$bGutterSize]);
        if (offset >= a.maxSize - a.snapOffset + this[$4609a9aa19959f74$var$aGutterSize]) offset = a.maxSize + this[$4609a9aa19959f74$var$aGutterSize];
        else if (offset <= this.size - (b.maxSize - b.snapOffset + this[$4609a9aa19959f74$var$bGutterSize])) offset = this.size - (b.maxSize + this[$4609a9aa19959f74$var$bGutterSize]);
        // Actually adjust the size.
        adjust.call(this, offset);
        // Call the drag callback continously. Don't do anything too intensive
        // in this callback.
        $4609a9aa19959f74$var$getOption(options, 'onDrag', $4609a9aa19959f74$var$NOOP)(getSizes());
    }
    // Cache some important sizes when drag starts, so we don't have to do that
    // continously:
    //
    // `size`: The total size of the pair. First + second + first gutter + second gutter.
    // `start`: The leading side of the first element.
    //
    // ------------------------------------------------
    // |      aGutterSize -> |||                      |
    // |                     |||                      |
    // |                     |||                      |
    // |                     ||| <- bGutterSize       |
    // ------------------------------------------------
    // | <- start                             size -> |
    function calculateSizes() {
        // Figure out the parent size minus padding.
        var a = elements[this.a].element;
        var b = elements[this.b].element;
        var aBounds = a[$4609a9aa19959f74$var$getBoundingClientRect]();
        var bBounds = b[$4609a9aa19959f74$var$getBoundingClientRect]();
        this.size = aBounds[dimension] + bBounds[dimension] + this[$4609a9aa19959f74$var$aGutterSize] + this[$4609a9aa19959f74$var$bGutterSize];
        this.start = aBounds[position];
        this.end = aBounds[positionEnd];
    }
    function innerSize(element) {
        // Return nothing if getComputedStyle is not supported (< IE9)
        // Or if parent element has no layout yet
        if (!getComputedStyle) return null;
        var computedStyle = getComputedStyle(element);
        if (!computedStyle) return null;
        var size = element[clientSize];
        if (size === 0) return null;
        if (direction === $4609a9aa19959f74$var$HORIZONTAL) size -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
        else size -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
        return size;
    }
    // When specifying percentage sizes that are less than the computed
    // size of the element minus the gutter, the lesser percentages must be increased
    // (and decreased from the other elements) to make space for the pixels
    // subtracted by the gutters.
    function trimToMin(sizesToTrim) {
        // Try to get inner size of parent element.
        // If it's no supported, return original sizes.
        var parentSize = innerSize(parent);
        if (parentSize === null) return sizesToTrim;
        if (minSizes.reduce(function(a, b) {
            return a + b;
        }, 0) > parentSize) return sizesToTrim;
        // Keep track of the excess pixels, the amount of pixels over the desired percentage
        // Also keep track of the elements with pixels to spare, to decrease after if needed
        var excessPixels = 0;
        var toSpare = [];
        var pixelSizes = sizesToTrim.map(function(size, i) {
            // Convert requested percentages to pixel sizes
            var pixelSize = parentSize * size / 100;
            var elementGutterSize = $4609a9aa19959f74$var$getGutterSize(gutterSize, i === 0, i === sizesToTrim.length - 1, gutterAlign);
            var elementMinSize = minSizes[i] + elementGutterSize;
            // If element is too smal, increase excess pixels by the difference
            // and mark that it has no pixels to spare
            if (pixelSize < elementMinSize) {
                excessPixels += elementMinSize - pixelSize;
                toSpare.push(0);
                return elementMinSize;
            }
            // Otherwise, mark the pixels it has to spare and return it's original size
            toSpare.push(pixelSize - elementMinSize);
            return pixelSize;
        });
        // If nothing was adjusted, return the original sizes
        if (excessPixels === 0) return sizesToTrim;
        return pixelSizes.map(function(pixelSize, i) {
            var newPixelSize = pixelSize;
            // While there's still pixels to take, and there's enough pixels to spare,
            // take as many as possible up to the total excess pixels
            if (excessPixels > 0 && toSpare[i] - excessPixels > 0) {
                var takenPixels = Math.min(excessPixels, toSpare[i] - excessPixels);
                // Subtract the amount taken for the next iteration
                excessPixels -= takenPixels;
                newPixelSize = pixelSize - takenPixels;
            }
            // Return the pixel size adjusted as a percentage
            return newPixelSize / parentSize * 100;
        });
    }
    // stopDragging is very similar to startDragging in reverse.
    function stopDragging() {
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        if (self.dragging) $4609a9aa19959f74$var$getOption(options, 'onDragEnd', $4609a9aa19959f74$var$NOOP)(getSizes());
        self.dragging = false;
        // Remove the stored event listeners. This is why we store them.
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('mouseup', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('touchend', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('touchcancel', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('mousemove', self.move);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('touchmove', self.move);
        // Clear bound function references
        self.stop = null;
        self.move = null;
        a[$4609a9aa19959f74$var$removeEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        a[$4609a9aa19959f74$var$removeEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$removeEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$removeEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        a.style.userSelect = '';
        a.style.webkitUserSelect = '';
        a.style.MozUserSelect = '';
        a.style.pointerEvents = '';
        b.style.userSelect = '';
        b.style.webkitUserSelect = '';
        b.style.MozUserSelect = '';
        b.style.pointerEvents = '';
        self.gutter.style.cursor = '';
        self.parent.style.cursor = '';
        $4609a9aa19959f74$var$document.body.style.cursor = '';
    }
    // startDragging calls `calculateSizes` to store the inital size in the pair object.
    // It also adds event listeners for mouse/touch events,
    // and prevents selection while dragging so avoid the selecting text.
    function startDragging(e) {
        // Right-clicking can't start dragging.
        if ('button' in e && e.button !== 0) return;
        // Alias frequently used variables to save space. 200 bytes.
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        // Call the onDragStart callback.
        if (!self.dragging) $4609a9aa19959f74$var$getOption(options, 'onDragStart', $4609a9aa19959f74$var$NOOP)(getSizes());
        // Don't actually drag the element. We emulate that in the drag function.
        e.preventDefault();
        // Set the dragging property of the pair object.
        self.dragging = true;
        // Create two event listeners bound to the same pair object and store
        // them in the pair object.
        self.move = drag.bind(self);
        self.stop = stopDragging.bind(self);
        // All the binding. `window` gets the stop events in case we drag out of the elements.
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('mouseup', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('touchend', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('touchcancel', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('mousemove', self.move);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('touchmove', self.move);
        // Disable selection. Disable!
        a[$4609a9aa19959f74$var$addEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        a[$4609a9aa19959f74$var$addEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$addEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$addEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        a.style.userSelect = 'none';
        a.style.webkitUserSelect = 'none';
        a.style.MozUserSelect = 'none';
        a.style.pointerEvents = 'none';
        b.style.userSelect = 'none';
        b.style.webkitUserSelect = 'none';
        b.style.MozUserSelect = 'none';
        b.style.pointerEvents = 'none';
        // Set the cursor at multiple levels
        self.gutter.style.cursor = cursor;
        self.parent.style.cursor = cursor;
        $4609a9aa19959f74$var$document.body.style.cursor = cursor;
        // Cache the initial sizes of the pair.
        calculateSizes.call(self);
        // Determine the position of the mouse compared to the gutter
        self.dragOffset = getMousePosition(e) - self.end;
    }
    // adjust sizes to ensure percentage is within min size and gutter.
    sizes = trimToMin(sizes);
    // 5. Create pair and element objects. Each pair has an index reference to
    // elements `a` and `b` of the pair (first and second elements).
    // Loop through the elements while pairing them off. Every pair gets a
    // `pair` object and a gutter.
    //
    // Basic logic:
    //
    // - Starting with the second element `i > 0`, create `pair` objects with
    //   `a = i - 1` and `b = i`
    // - Set gutter sizes based on the _pair_ being first/last. The first and last
    //   pair have gutterSize / 2, since they only have one half gutter, and not two.
    // - Create gutter elements and add event listeners.
    // - Set the size of the elements, minus the gutter sizes.
    //
    // -----------------------------------------------------------------------
    // |     i=0     |         i=1         |        i=2       |      i=3     |
    // |             |                     |                  |              |
    // |           pair 0                pair 1             pair 2           |
    // |             |                     |                  |              |
    // -----------------------------------------------------------------------
    var pairs = [];
    elements = ids.map(function(id, i) {
        // Create the element object.
        var element = {
            element: $4609a9aa19959f74$var$elementOrSelector(id),
            size: sizes[i],
            minSize: minSizes[i],
            maxSize: maxSizes[i],
            snapOffset: snapOffsets[i],
            i: i
        };
        var pair;
        if (i > 0) {
            // Create the pair object with its metadata.
            pair = {
                a: i - 1,
                b: i,
                dragging: false,
                direction: direction,
                parent: parent
            };
            pair[$4609a9aa19959f74$var$aGutterSize] = $4609a9aa19959f74$var$getGutterSize(gutterSize, i - 1 === 0, false, gutterAlign);
            pair[$4609a9aa19959f74$var$bGutterSize] = $4609a9aa19959f74$var$getGutterSize(gutterSize, false, i === ids.length - 1, gutterAlign);
            // if the parent has a reverse flex-direction, switch the pair elements.
            if (parentFlexDirection === 'row-reverse' || parentFlexDirection === 'column-reverse') {
                var temp = pair.a;
                pair.a = pair.b;
                pair.b = temp;
            }
        }
        // Determine the size of the current element. IE8 is supported by
        // staticly assigning sizes without draggable gutters. Assigns a string
        // to `size`.
        //
        // Create gutter elements for each pair.
        if (i > 0) {
            var gutterElement = gutter(i, direction, element.element);
            setGutterSize(gutterElement, gutterSize, i);
            // Save bound event listener for removal later
            pair[$4609a9aa19959f74$var$gutterStartDragging] = startDragging.bind(pair);
            // Attach bound event listener
            gutterElement[$4609a9aa19959f74$var$addEventListener]('mousedown', pair[$4609a9aa19959f74$var$gutterStartDragging]);
            gutterElement[$4609a9aa19959f74$var$addEventListener]('touchstart', pair[$4609a9aa19959f74$var$gutterStartDragging]);
            parent.insertBefore(gutterElement, element.element);
            pair.gutter = gutterElement;
        }
        setElementSize(element.element, element.size, $4609a9aa19959f74$var$getGutterSize(gutterSize, i === 0, i === ids.length - 1, gutterAlign), i);
        // After the first iteration, and we have a pair object, append it to the
        // list of pairs.
        if (i > 0) pairs.push(pair);
        return element;
    });
    function adjustToMin(element) {
        var isLast = element.i === pairs.length;
        var pair = isLast ? pairs[element.i - 1] : pairs[element.i];
        calculateSizes.call(pair);
        var size = isLast ? pair.size - element.minSize - pair[$4609a9aa19959f74$var$bGutterSize] : element.minSize + pair[$4609a9aa19959f74$var$aGutterSize];
        adjust.call(pair, size);
    }
    elements.forEach(function(element) {
        var computedSize = element.element[$4609a9aa19959f74$var$getBoundingClientRect]()[dimension];
        if (computedSize < element.minSize) {
            if (expandToMin) adjustToMin(element);
            else // eslint-disable-next-line no-param-reassign
            element.minSize = computedSize;
        }
    });
    function setSizes(newSizes) {
        var trimmed = trimToMin(newSizes);
        trimmed.forEach(function(newSize, i) {
            if (i > 0) {
                var pair = pairs[i - 1];
                var a = elements[pair.a];
                var b = elements[pair.b];
                a.size = trimmed[i - 1];
                b.size = newSize;
                setElementSize(a.element, a.size, pair[$4609a9aa19959f74$var$aGutterSize], a.i);
                setElementSize(b.element, b.size, pair[$4609a9aa19959f74$var$bGutterSize], b.i);
            }
        });
    }
    function destroy(preserveStyles, preserveGutter) {
        pairs.forEach(function(pair) {
            if (preserveGutter !== true) pair.parent.removeChild(pair.gutter);
            else {
                pair.gutter[$4609a9aa19959f74$var$removeEventListener]('mousedown', pair[$4609a9aa19959f74$var$gutterStartDragging]);
                pair.gutter[$4609a9aa19959f74$var$removeEventListener]('touchstart', pair[$4609a9aa19959f74$var$gutterStartDragging]);
            }
            if (preserveStyles !== true) {
                var style = elementStyle(dimension, pair.a.size, pair[$4609a9aa19959f74$var$aGutterSize]);
                Object.keys(style).forEach(function(prop) {
                    elements[pair.a].element.style[prop] = '';
                    elements[pair.b].element.style[prop] = '';
                });
            }
        });
    }
    return {
        setSizes: setSizes,
        getSizes: getSizes,
        collapse: function collapse(i) {
            adjustToMin(elements[i]);
        },
        destroy: destroy,
        parent: parent,
        pairs: pairs
    };
};
var $4609a9aa19959f74$export$2e2bcd8739ae039 = $4609a9aa19959f74$var$Split;

});

parcelRegister("346VI", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b71ef8c0192a76$export$2e2bcd8739ae039);
if (window.DrDocWeb !== undefined) console.warn('Lib Duplicate: DrDocWeb');
function $23b71ef8c0192a76$export$2e2bcd8739ae039() {}
/**
 * Convert a string to HTML entities
 */ String.prototype.toHtmlEntities = function() {
    return this.replace(/./gm, function(s) {
        // return "&#" + s.charCodeAt(0) + ";";
        return s.match(/[a-z0-9\s]+/i) ? s : "&#" + s.charCodeAt(0) + ";";
    });
};
/**
 * Create string from HTML entities
 */ String.fromHtmlEntities = function(string) {
    return (string + "").replace(/&#\d+;/gm, function(s) {
        return String.fromCharCode(s.match(/\d+/gm)[0]);
    });
};
String.prototype.contains = function(search, start) {
    'use strict';
    if (typeof start !== 'number') start = 0;
    if (start + search.length > this.length) return false;
    else return this.indexOf(search, start) !== -1;
};
String.prototype.hashCode = function() {
    var hash = 0, i1, chr;
    if (this.length === 0) return hash;
    for(i1 = 0; i1 < this.length; i1++){
        chr = this.charCodeAt(i1);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};
console.log('DRDOCWEB INIT');
//module.exports = DrDocWeb
//export default DrDocWeb
//export { DrDocWeb };
window.DrDocWeb = $23b71ef8c0192a76$export$2e2bcd8739ae039;
$23b71ef8c0192a76$export$2e2bcd8739ae039.ServerHost = document.location.protocol + '//' + document.location.hostname;
$23b71ef8c0192a76$export$2e2bcd8739ae039.ServerPort = document.location.port;
$23b71ef8c0192a76$export$2e2bcd8739ae039.ServerBase = function() {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.ServerHost + (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty($23b71ef8c0192a76$export$2e2bcd8739ae039.ServerPort) ? ':' + $23b71ef8c0192a76$export$2e2bcd8739ae039.ServerPort : '');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.DefaultError = function(error) {
    console.warn(error);
    $23b71ef8c0192a76$export$2e2bcd8739ae039.ModalError('Fehler!');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.IsMobile = function() {
    return window.innerWidth < window.innerHeight && window.innerWidth < 560; //850;
//return window.innerWidth < 800;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode = function(val) {
    return encodeURIComponent(typeof val === "object" ? $23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToJson(val) : val);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToQueryStr = function(obj) {
    if (obj === null || obj === undefined) return '';
    if (typeof obj === 'string') return obj;
    var strArr = [];
    for(var p in obj)if (obj.hasOwnProperty(p)) {
        var v = obj[p];
        /*strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? JSON.stringify(JsonResolve(v), function(key, value)
            {
                // => typeof Dataset
                // IDataset / Dataset.IsModel(value): $ModelType, $ClassName, Dataset
                if (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset') return;
                else return value;
            }) : v));*/ strArr.push($23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(p) + "=" + $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(v));
    }
    var str = strArr.join("&");
    //return (str.length == 0 ? '' : '?' + str);
    return str;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.QueryStrToObject = function(str) {
    let obj = {};
    if (str === null || str === undefined) return obj;
    if (str.substring(0, 1) === '?') str = str.substring(1);
    let arr = str.split('&');
    for(var i1 in arr){
        let kvp = arr[i1].split('=');
        if (kvp !== undefined && kvp.length === 2) obj[decodeURIComponent(kvp[0])] = decodeURIComponent(kvp[1]);
    }
    return obj;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetDataToObject = function() {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.QueryStrToObject(window.location.search);
};
/*DrDocWeb.ArrayEquals = function(a, b) {
  return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index]);
};*/ // Sind alle arr1 in arr2 enthalten?
$23b71ef8c0192a76$export$2e2bcd8739ae039.ArrayEquals = function(arr1, arr2, caseSensitive) {
    if ((arr1 === undefined || arr1 === null || arr1.length == 0) && (arr2 === undefined || arr2 === null || arr2.length == 0)) return true;
    for (let elem1 of arr1){
        if (elem1 === undefined || elem1 === null || elem1.length == 0) continue;
        //console.log('elem1', elem1);
        let found = false;
        for (let elem2 of arr2){
            if (elem2 === undefined || elem2 === null || elem2.length == 0) continue;
            if (caseSensitive && elem2 === elem1 || !caseSensitive && elem2.toLowerCase() === elem1.toLowerCase()) {
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    //console.log('ArrayEquals', arr1, ' === ', arr2);
    return true;
};
/*DrDocWeb.ArrayEquals = function(arr1, arr2, caseSensitive)
{
    if ((arr1 === undefined || arr1 === null || arr1.length == 0) && (arr2 === undefined || arr2 === null || arr2.length == 0))
    {
        return true;
    }
    	
    for (let i in arr1)
    {
        if ((caseSensitive && arr1[i] !== arr2[i]) || (!caseSensitive && arr1[i].toLowerCase() !== arr2[i].toLowerCase()))
            return false;
    }
        
    //console.log('ArrayEquals', arr1, ' === ', arr2);
    return true;
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.GetArrayItemWhere = function(data, propName, propValue) {
    let i1 = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetArrayItemIndexWhere(data, propName, propValue);
    if (i1 >= 0) return data[i1];
    return null;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetArrayItemIndexWhere = function(data, propName, propValue) {
    for(var i1 = 0; i1 < data.length; i1++)if (typeof propName === 'function') {
        if (propName(data[i1]) === true) return i1;
    } else {
        if (data[i1][propName] == propValue) return i1;
    }
    return -1;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjGetKeys = function(obj) {
    let ret = [];
    if (obj != null && obj != undefined) {
        for(let x in obj)ret.push(x);
        return ret;
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FormToObject = function(formName, splitter) {
    let form = null;
    if (typeof formName === 'string') form = document.forms[formName];
    else form = formName;
    if (form === undefined) return undefined;
    if (splitter === undefined || splitter === null) splitter = String.fromCharCode(1);
    if (typeof splitter === 'number') splitter = String.fromCharCode(splitter);
    let data = {};
    // $(form).serializeArray();
    for(let i1 = 0; i1 < form.elements.length; i1++){
        let form_elem = form.elements[i1];
        //if (form_elem.value !== undefined)
        let name = form_elem.name;
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(name)) {
            //if (pre !== undefined)
            //{
            //    name = pre + name;
            //}
            // Wenn ein Element checkable ist, dann nur den aktiven Wert setzen.
            let type = form_elem.getAttribute('type');
            if (type != undefined && type != null) type = type.toLowerCase();
            let isCheckable = type === 'select' || type === 'radio' || type === 'checkbox';
            //console.log('Form: ', name, type, isCheckable);
            //if (!isCheckable || type === 'checkbox' || (isCheckable && form_elem.checked === true))
            //if (!isCheckable || (type === 'checkbox' || form_elem.getAttribute('data-has-changed') == 'true'))
            //{
            let val = '';
            if (form_elem.value !== undefined && form_elem.value !== null) {
                if (isCheckable) val = form_elem.checked === true ? form_elem.value : '';
                else val = form_elem.value;
            }
            // 
            /*if (val == '' && type === 'checkbox' && form_elem.getAttribute('data-has-changed') == 'true')
            {
                val = '!' + form_elem.value;
            }*/ if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(val)) val = '';
            if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(val) && form_elem.getAttribute('trim') == 'true') continue;
            if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(val) && isCheckable) continue;
            // Falls ein Wert bereits vorhanden ist, dann anfügen.
            if (data[name] !== undefined && data[name] !== null) {
                if (typeof splitter === 'function') data[name] = splitter(name, data[name], val);
                else if (splitter === 'array') data[name].push(val);
                else data[name] = data[name] + splitter + val;
            } else if (splitter === 'array') data[name] = [
                val
            ];
            else data[name] = val;
        //}
        }
        continue;
    }
    // Am Ende leere Splitter trimmen
    if (typeof splitter !== 'function' && splitter !== 'array') for(let fieldName in data){
        let fieldValue = data[fieldName];
        if (fieldValue !== undefined && fieldValue !== null && typeof fieldValue === 'string') //data[fieldName] = fieldValue.replace(/[\|]+$/, '');
        data[fieldName] = fieldValue.replace(new RegExp('[\\' + splitter + ']+$'), '');
    }
    //console.log('Form A', data);
    //console.log('Form B', form.elements);
    return data;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetFormDataFromEvent = function(ev) {
    if (ev instanceof FormData) return ev;
    let hasFile = false;
    var formData = new FormData();
    if (ev.dataTransfer && ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for(var i1 = 0; i1 < ev.dataTransfer.items.length; i1++)// If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i1].kind === 'file') {
            var file = ev.dataTransfer.items[i1].getAsFile();
            //console.log('... file[' + i + '].name = ' + file.name);
            formData.append("file" + i1, file);
            hasFile = true;
        }
    } else if (ev.dataTransfer && ev.dataTransfer.files) // Use DataTransfer interface to access the file(s)
    for(var i1 = 0; i1 < ev.dataTransfer.files.length; i1++){
        //console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
        formData.append("file" + i1, ev.dataTransfer.files[i1]);
        hasFile = true;
    }
    else if (ev.target && ev.target.files) for(var i1 = 0; i1 < ev.target.files.length; i1++){
        formData.append("file" + i1, ev.target.files[i1]);
        hasFile = true;
    }
    else if (ev.files) for(var i1 = 0; i1 < ev.files.length; i1++){
        formData.append("file" + i1, ev.files[i1]);
        hasFile = true;
    }
    if (hasFile) return formData;
    else return false;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestTag = function(sourceElement, tagName) {
    let trElem = sourceElement;
    while(trElem != undefined && trElem != null){
        if (trElem.tagName.toLowerCase() == tagName.toLowerCase()) return trElem;
        trElem = trElem.parentNode;
    }
    return undefined;
};
// Holt das nächste Form, welches kein Child von einem Element mit dem Attribut "data-form-ignore" ist.
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestForm = function(sourceElement) {
    //formData = document.querySelector('form [' + attr_name + '="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]');
    let result = null;
    if (sourceElement !== undefined && sourceElement !== null && sourceElement.tagName != undefined && sourceElement.tagName.toLowerCase() == 'form') result = sourceElement;
    else result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement(sourceElement, 'form:not([data-form-ignore] *)', true);
    //result = DrDocWeb.GetElement(sourceElement, 'form:has(:not([data-ignore]))');
    //result = DrDocWeb.GetElement(sourceElement, 'form:not(:has([data-ignore]))');
    return result;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestFormToObject = function(sourceElement, splitter) {
    //formData = document.querySelector('form [' + attr_name + '="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]');
    let result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestForm(sourceElement);
    if (result !== undefined && result !== null) return $23b71ef8c0192a76$export$2e2bcd8739ae039.FormToObject(result, splitter);
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ClearClosestForm = function(sourceElement) {
    let form = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestForm(sourceElement);
    if (form !== undefined && form !== null) for(let i1 = 0; i1 < form.elements.length; i1++){
        let form_elem = form.elements[i1];
        let name = form_elem.name;
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(name)) {
            // Wenn ein Element checkable ist, dann nur den aktiven Wert setzen.
            let type = form_elem.getAttribute('type');
            if (type != undefined && type != null) type = type.toLowerCase();
            let isCheckable = type === 'select' || type === 'radio' || type === 'checkbox';
            let val = '';
            if (form_elem.value !== undefined && form_elem.value !== null) {
                if (isCheckable) form_elem.checked = null;
                else form_elem.value = '';
            }
        }
    }
};
/*DrDocWeb._ClosestFormToObject = function(sourceElement, splitter)
{
    let result = undefined;
    if (sourceElement.nodeName !== undefined && sourceElement.nodeName.toLowerCase() === 'form')
        result = sourceElement;
    else
    {
        result = $(sourceElement).parents('form')[0];
        if (result === undefined || result === null)
        {
            result = $(sourceElement).children('form')[0];
        }
    }
    if (result !== undefined && result !== null)
    {
        return DrDocWeb.FormToObject(result, splitter);
    }
    return undefined;
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker = function(parentObj, parentProp, refObjList) {
    let obj = parentObj[parentProp];
    for(var prop in obj){
        let value = obj[prop];
        if (prop === '$id') {
            refObjList[value] = obj;
            delete obj['$id'];
        } else if (prop === '$values') {
            $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker(obj, prop, refObjList);
            parentObj[parentProp] = value;
        } else if (prop === '$ref') parentObj[parentProp] = refObjList[value];
        else if (typeof value === 'object') $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker(obj, prop, refObjList);
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObject = function(text) {
    if (text == null || text == undefined) return {};
    if (typeof text === 'object') return text;
    if (typeof text !== 'string') {
        console.log('DrDocWeb.JsonToObject: Bad format: ', text);
        return text;
    }
    var obj = {
        _root: JSON.parse(text)
    };
    var refObjList = {};
    $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker(obj, '_root', refObjList);
    return obj._root;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToJson = function(obj) {
    if (obj == undefined || obj == null) return '';
    return JSON.stringify(obj);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CloneCopy = function(obj) {
    if (obj == undefined || obj == null) return obj;
    if (typeof obj === 'string' || typeof obj === 'number') return obj;
    if (Array.isArray(obj)) return obj.slice(0);
    if (typeof obj === 'object') {
        var arrTmp = {};
        Object.assign(arrTmp, obj);
        return arrTmp;
    }
    console.warn('DrDocWeb.CloneCopy: unknown obj type: ', typeof obj, obj);
    return obj;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CloneCopyTo = function(src, dst, ignorePropsArr) {
    for(var i1 in src)if (ignorePropsArr == undefined || ignorePropsArr == null || ignorePropsArr.indexOf(i1) === -1) dst[i1] = src[i1];
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetRequestUrl = function(url, getData) {
    var requestUrl = $23b71ef8c0192a76$export$2e2bcd8739ae039.ServerBase();
    // hat die "url" schon einen Hostnamen?
    // => dann setzen
    if (url !== null && url !== undefined) {
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) requestUrl = url;
        else if (url.indexOf(requestUrl) === 0) requestUrl = url;
        else if (url.indexOf('/') === 0) requestUrl += url;
        else requestUrl += '/' + url;
    }
    // GET Parameter in URL übernehmen
    if (getData !== null && getData !== undefined) {
        requestUrl += requestUrl.indexOf('?') === -1 ? '?' : '&';
        requestUrl += $23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToQueryStr(getData);
    }
    return requestUrl;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.Send = function(method, url, getData, postData, parseAs, sendAs, cookie, retAsync) {
    const promiseFn = function(resolve, reject) {
        //console.log('DrDocWeb.Send', method, url, getData, postData, parseAs, sendAs);
        try {
            var requestUrl = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetRequestUrl(url, getData);
            var request = new XMLHttpRequest();
            //try {
            const openRequestFn = function() {
                // Asynchron
                request.open(method, requestUrl, retAsync === true || retAsync === undefined);
                // Synchron
                //request.open(method, requestUrl, false);
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(cookie)) {
                    request.withCredentials = true;
                    //request.setRequestHeader('Access-Control-Allow-Origin', '*');
                    //request.setRequestHeader('Access-Control-Allow-Headers', 'Cookie');
                    request.setRequestHeader('Cookie', cookie);
                //console.log('DrDocWeb.Send ('+requestUrl+'): Cookie: ' + cookie);
                }
            };
            var processResponse = function(responseObj) {
                if (parseAs !== undefined && parseAs !== null && (parseAs.toLowerCase() == 'json' || parseAs.toLowerCase() == 'text/json' || parseAs.toLowerCase() == 'application/json')) return $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObject(responseObj.responseText); //JSON.parse(event.target.responseText));
                else return responseObj.responseText;
            };
            postData !== undefined && FormData;
            //request.setRequestHeader('Access-Control-Allow-Origin', '*');
            /*request.setRequestHeader('Referer', null);
            request.setRequestHeader('Cookie', null);
            request.setRequestHeader('Host', null);
            request.setRequestHeader('Origin', null);
            request.setRequestHeader('User-Agent', null);
    
            request.removeRequestHeader('Referer');
            request.removeRequestHeader('Cookie');
            request.removeRequestHeader('Host');
            request.removeRequestHeader('Origin');
            request.removeRequestHeader('User-Agent');*/ if (retAsync === true || retAsync === undefined) {
                //console.log('DrDocWeb.Send loading... ', event, method, url, getData, postData, parseAs, sendAs);
                if (resolve !== undefined && resolve !== null) request.addEventListener('load', function(event) {
                    //console.log('DrDocWeb.Send.onLoad', event, method, url, getData, postData, parseAs, sendAs);
                    //console.log('reponse', event);
                    if (reject !== undefined && reject !== null && event.target.status >= 400) {
                        console.log('DrDocWeb.Send.onLoad.catch status ', event.target.status);
                        reject(processResponse(event.target));
                    } else resolve(processResponse(event.target));
                });
                if (reject !== undefined && reject !== null) {
                    request.addEventListener('timeout', reject);
                    request.addEventListener('error', reject);
                    request.addEventListener('abort', reject);
                }
            }
            // POST Parameter senden
            if (postData === undefined) {
                openRequestFn();
                request.send();
            } else if (postData instanceof FormData || sendAs == 'form') {
                // Progress-Bar
                /*
                let progressBarId = 'progress-' + DrDocWeb.RandomChars(12);
                let progressBarHtml = `
                <div id="${progressBarId}" class="progress" role="progressbar" aria-label="Document File Upload" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
  <div id="${progressBarId}-bar" class="progress-bar progress-bar-striped progress-bar-animated" style="width: 0%;"></div>
</div>
                `;
                let progressBarModal = DrDocWeb.ModalSecondary('Upload', progressBarHtml);

                let progressbarOnChange = function (e) {
                    //console.log('Upload Progress (e): ', e);
                    const percentComplete = e ? ((e.loaded / e.total) * 100) : 0;
                    //if (e.lengthComputable) {
                    //console.log('Upload Progress: ', percentComplete);
                    document.getElementById(progressBarId + '-bar').style.width = percentComplete + '%';
                    let progressBarElem = document.getElementById(progressBarId);
                    progressBarElem.setAttribute('aria-valuenow', percentComplete);
                    //}
                };
                progressbarOnChange();
                request.addEventListener('progress', progressbarOnChange);
                if (request.upload !== undefined)
                    request.upload.onprogress = progressbarOnChange;
                request.onprogress = progressbarOnChange;
                let progressBarCloseFn = function () {
                    if (progressBarModal != undefined && progressBarModal != null)
                        progressBarModal.close();
                };*/ if ($23b71ef8c0192a76$export$2e2bcd8739ae039.ModalProgress != undefined) {
                    let progressBarModal = $23b71ef8c0192a76$export$2e2bcd8739ae039.ModalProgress('Document File Upload..');
                    progressBarModal.setPercentComplete(0);
                    let progressbarOnChange = function(e) {
                        //console.log('Upload Progress (e): ', e);
                        const percentComplete = e ? e.loaded / e.total * 100 : 0;
                        progressBarModal.setPercentComplete(percentComplete);
                    };
                    request.addEventListener('progress', progressbarOnChange);
                    if (request.upload !== undefined) request.upload.onprogress = progressbarOnChange;
                    request.onprogress = progressbarOnChange;
                    let progressBarCloseFn = function() {
                        if (progressBarModal != undefined && progressBarModal != null) progressBarModal.close();
                    };
                    request.addEventListener('load', progressBarCloseFn);
                    request.addEventListener('timeout', progressBarCloseFn);
                    request.addEventListener('error', progressBarCloseFn);
                    request.addEventListener('abort', progressBarCloseFn);
                }
                openRequestFn();
                request.send(postData);
            } else if (sendAs == 'json' || sendAs == 'text/json' || sendAs == 'application/json') {
                openRequestFn();
                request.setRequestHeader('Content-Type', 'application/json');
                request.send(JSON.stringify(postData));
            } else {
                openRequestFn();
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                request.send($23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToQueryStr(postData));
            }
            if (retAsync === true || retAsync === undefined) ;
            else //Sync
            return processResponse(request);
        } catch (err) {
            if (reject !== undefined && reject !== null) {
                console.log('DrDocWeb.Send.catch 1');
                reject(err);
            } else {
                console.log('DrDocWeb.Send.catch 2');
                console.error(err);
                throw err;
            }
        }
    };
    if (retAsync === true || retAsync === undefined) //console.log('DrDocWeb.Send.Promise');
    return new Promise(promiseFn);
    else //console.log('DrDocWeb.Send.Sync');
    return promiseFn();
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.SendGet = function(url, getData, parseAs) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.Send('GET', url, getData, undefined, parseAs);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.SendPost = function(url, getData, postData, parseAs) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.Send('POST', url, getData, postData, parseAs);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.RandomChars = function(length) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.Random(length, 'abcdefghijklmnopqrstuvwxyz');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.Random = function(length, characters) {
    let result = '';
    if (length === undefined) length = 32;
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(characters)) characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    let counter = 0;
    while(counter < length){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};
// Checksum
$23b71ef8c0192a76$export$2e2bcd8739ae039.ChecksumCyrb53 = function(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(let i1 = 0, ch; i1 < str.length; i1++){
        ch = str.charCodeAt(i1);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CheckRecursion = function() {
    // the name of the calling function 
    var fname = $23b71ef8c0192a76$export$2e2bcd8739ae039.CheckRecursion.arguments.callee.caller.name;
    // obtain the stack trace ***not cross browser***
    // tested on Firefox
    var err = new Error();
    var stack = err.stack.split('\n');
    // returns true if the calling function appears more than once
    var i1, n, cnt;
    n = stack.length;
    cnt = 0;
    for(i1 = 0; i1 < n; i1++)if (fname == stack[i1].substring(0, stack[i1].indexOf('@'))) {
        cnt++;
        if (cnt > 1) return true;
    }
    return false;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.Crud = function(getData) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.SendGet('/model/crud', getData, 'json');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CrudListen = function(callback) {
    /*if (callback != null)
    {
        callback(null, null);
    }*/ // Dataset.GetData = function (url, paramsObj, successCallback, errorCallback, finallyCallback)
    $23b71ef8c0192a76$export$2e2bcd8739ae039.SendGet('/node/de/test', {
        listener: 99
    }, (obj)=>{
        //console.warn('MAIN Load', e.target.responseText);
        //console.warn('MAIN Load', e);
        //Vue.set(Dataset.Model[obj.$ModelType], Dataset.GetID(obj), obj);
        if (callback != null) callback(obj, true);
        //Dataset.ListenState = true;
        //Vue.set(Dataset, 'ListenState', true);
        $23b71ef8c0192a76$export$2e2bcd8739ae039.CrudListen(callback);
    }, (obj)=>{
        //Dataset.ListenState = false;
        //Vue.set(Dataset, 'ListenState', false);
        // Bei Fehler, nach einigen Sekunden erneut versuchen.
        setTimeout(()=>{
            $23b71ef8c0192a76$export$2e2bcd8739ae039.CrudListen(callback);
        }, 1000);
        if (callback != null) callback(null, false);
        console.warn('MAIN Error', obj, callback, false);
        if ($23b71ef8c0192a76$export$2e2bcd8739ae039.DefaultError != null) $23b71ef8c0192a76$export$2e2bcd8739ae039.DefaultError(obj);
    });
};
/*DrDocWeb.DataSelect = function(data, selector)
{
    if (data === undefined || data === null)
        return [];
    
    let ret_data = [];
    data.forEach(function(itm) {
        if (selector === undefined || selector(ret_data) === true)
        ret_data.push(itm);
    });
    return ret_data;
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.ParseBool = function(value) {
    if (value === undefined || value === null) return false;
    if (typeof value === 'bool' || typeof value === 'boolean') return value;
    if (typeof value === 'string') return value.toLocaleLowerCase() === 'true' || value === '1';
    return false;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ParseInt = function(value) {
    if (value === undefined || value === null || isNaN(value)) return 0;
    if (typeof value === 'float') return value;
    if (typeof value === 'number') return value;
    //return +value;
    return parseFloat(value);
// parseInt
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ParseDateTime = function(dateStr) {
    dateStr = $23b71ef8c0192a76$export$2e2bcd8739ae039.ToIsoDateTimeStr(dateStr);
    if (dateStr === undefined) return undefined;
    if (!isNaN(dateStr) && (typeof dateStr === 'date' || dateStr instanceof Date)) return dateStr;
    return new Date(dateStr);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ToIsoDateTimeStr = function(dateStr) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(dateStr)) return undefined;
    if (!isNaN(dateStr) && (typeof dateStr === 'date' || dateStr instanceof Date)) return dateStr.toISOString();
    // toUTCString
    if (typeof dateStr === 'number') //console.log('DrDocWeb.ToIsoDateTimeStr: typeof dateStr === number', dateStr, new Date(dateStr * 1000), new Date(dateStr * 1000), new Date(dateStr * 1000 * 100));
    return new Date(dateStr).toISOString();
    if (typeof dateStr !== 'string') {
        console.warn('DrDocWeb.ToIsoDateTimeStr / typeof dateStr !== string / ', typeof dateStr, ' / ', dateStr);
        return undefined;
    }
    let dateTimeComponents = dateStr.split(' ');
    if (dateTimeComponents.length == 2) {
        let dateComponents = dateTimeComponents[0].split('.');
        let timeComponents = dateTimeComponents[1].split(':');
        if (dateComponents.length == 3 && timeComponents.length >= 2) return dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0] + 'T' + timeComponents[0] + ':' + timeComponents[0];
    } else if (dateTimeComponents.length == 1) {
        let dateComponents = dateTimeComponents[0].split('.');
        if (dateComponents.length == 3) return dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0];
    //return dateComponents[1];
    }
    //console.warn('DrDocWeb.ParseDateTime: bad date', dateStr, dateTimeComponents);
    return dateStr;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.DateTimeAddMulti = function(dsDate, duration_total_str) {
    for (let dauer_str of duration_total_str.split(' ')){
        if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(dauer_str) || dauer_str.length < 2) continue;
        let dauer_unit = dauer_str.substring(dauer_str.length - 1);
        let dauer_num = $23b71ef8c0192a76$export$2e2bcd8739ae039.ParseInt(dauer_str.substring(0, dauer_str.length - 1));
        dsDate = $23b71ef8c0192a76$export$2e2bcd8739ae039.DateTimeAdd(dsDate, dauer_num, dauer_unit);
    }
    return dsDate;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.DateTimeAdd = function(dt, amount, dateType) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(dt)) dt = new Date();
    else if (typeof dt === 'date' || dt instanceof Date) ;
    else dt = $23b71ef8c0192a76$export$2e2bcd8739ae039.ParseDateTime(dt);
    switch(dateType.toUpperCase()){
        case 'T':
        case 'D':
        case 'DAY':
        case 'DAYS':
            return dt.setDate(dt.getDate() + amount) && dt;
        case 'W':
        case 'WEEK':
        case 'WEEKS':
            return dt.setDate(dt.getDate() + 7 * amount) && dt;
        case 'M':
        case 'MONTH':
        case 'MONTHS':
            return dt.setMonth(dt.getMonth() + amount) && dt;
        case 'Y':
        case 'J':
        case 'YEAR':
        case 'YEARS':
            return dt.setFullYear(dt.getFullYear() + amount) && dt;
        default:
            console.warn('DrDocWeb.DateTimeAdd: bad date unit: ', dateType);
            break;
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.EventFire = function(el, eventName, fn) {
    var doc = !el ? document : el.ownerDocument || document;
    //console.log('Fire Event', eventName, el);
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(eventName) && eventName.substring(0, 2) == 'on') //console.log('DrDocWeb.EventFire: mod: ', eventName, ' -> ', eventName.substring(2));
    eventName = eventName.substring(2);
    var evObj = null;
    if (document.createEvent) {
        evObj = doc.createEvent('Events'); // HTMLEvents
        // initEvent(type, bubbles, cancelable)
        evObj.initEvent(eventName, true, true); //false);
    } else {
        evObj = doc.createEventObject();
        evObj.eventType = eventName;
    }
    if (fn !== undefined && fn !== null && typeof fn === 'function') try {
        fn(evObj);
    } catch (ex) {
        console.warn('DrDocWeb.EventFire: ', el, eventName, ex);
    }
    if (document.createEvent) doc.dispatchEvent(evObj);
    else //if (doc.fireEvent)
    //doc.fireEvent('on' + eventName);
    doc.fireEvent('on' + evObj.eventType, evObj);
};
// --
// DOM
// Suche nach:
// - DrDocWeb.GetParentNode
// - DrDocWeb.FindChildElement
// - DrDocWeb.FindChildElements
// - DrDocWeb.SelectLastElementById
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement = function(sourceElement, selector, first, searchParent) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    try {
        if (typeof sourceElement === 'string') sourceElement = document.querySelectorAll(sourceElement);
    } catch  {
        console.warn('DrDocWeb.GetElement: Bad sourceElement', sourceElement, selector);
        sourceElement = document;
    }
    //if (sourceElement === document)
    //    sourceElement = document.documentElement;
    let elems = null;
    // 1. Element selbst prüfen
    if (sourceElement.matches !== undefined && typeof sourceElement.matches === 'function') {
        if (sourceElement.matches(selector) === true) //console.log('DrDocWeb.GetElement: sourceElement.matches(selector): ', selector, sourceElement);
        return sourceElement;
    }
    // 2. Children durchsuchen
    if (sourceElement.querySelectorAll !== undefined && typeof sourceElement.querySelectorAll === 'function') elems = sourceElement.querySelectorAll(selector);
    // 3. Parents durchsuchen, einschließlich dem Element selbst
    elems = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElements(sourceElement, selector);
    // elem.closest() sucht nur den DOM nach oben und nicht wieder im siblingNode nach unten (nächster Ast), daher DrDocWeb.GetParentElements verwenden
    /*if (elems === undefined || elems === null || elems.length === 0) {
        // The closest() method..
        // - searches up the DOM tree for elements which matches a specified CSS selector.
        // - starts at the element itself, then the anchestors (parent, grandparent, ...) until a match is found.
        // returns null() if no match is found.

        if (sourceElement.closest !== undefined && typeof sourceElement.closest === 'function') {
            let ret = sourceElement.closest(selector);
            //if (ret)
            //console.log('DrDocWeb.GetElement: sourceElement.closest(selector): ', selector, sourceElement, ret);
            if (ret != undefined && ret != null)
                return ret;
        }
        console.log('DrDocWeb.GetElement: sourceElement.closest() nicht gefunden! Selector: ', selector, ' / sourceElement: ', sourceElement);
    }*/ if (elems === undefined || elems === null || elems.length === 0) //console.log('DrDocWeb.GetElement: Element wurde nicht gefunden! ', selector, sourceElement);
    return undefined;
    if (first === undefined && elems.length > 1) console.log('DrDocWeb.GetElement: Element wurde mehrfach gefunden! Selector: ', selector, ' / first: ', first, ' / Elements: ', elems, ' / Source: ', sourceElement);
    if (first === true || first === 1) return elems[0];
    if (first === -1) return elems[elems.length - 1];
    else return elems[elems.length - 1];
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetElements = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    let result = null;
    result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetChildElements(sourceElement, selector);
    if (result !== undefined && result !== null && result.length > 0) return result;
    result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElements(sourceElement, selector);
    if (result !== undefined && result !== null && result.length > 0) return result;
    return [];
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElements = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    while(sourceElement !== undefined && sourceElement !== null){
        let result = sourceElement.querySelectorAll(selector);
        if (result !== undefined && result !== null && result.length > 0) return result;
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElement = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    while(sourceElement !== undefined && sourceElement !== null){
        let result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement(sourceElement, selector, true);
        console.log('DrDocWeb.GetParentElement: selector: ', selector, ' / sourceElement: ', sourceElement, ' / result: ', result);
        if (result !== undefined && result !== null) return result;
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetChildElements = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    /*for (let i in sourceElement.childNodes)
    {

    }*/ return sourceElement.querySelectorAll(selector);
};
/*DrDocWeb._GetParentNode = function(sourceElement, compare)
{
    if (compare === undefined || typeof compare !== 'function')
        return undefined;
    if (sourceElement === undefined)
        sourceElement = document;

    while (sourceElement !== undefined && sourceElement !== null)
    {
        let result = compare(sourceElement);
        if (result !== undefined && result !== null && result !== false)
        {
            return sourceElement;
            //return result;
        }
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};*/ /*DrDocWeb._SelectLastElementById = function(id)
{
    var elems = document.querySelectorAll('#' + id);
    if (elems === undefined)
    return undefined;
    return elems[elems.length-1];
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElement = function(element, attr_name, attr_value, attr_comparer) {
    if (element === null || element === undefined || element.nodeName == '#text' || element.nodeName == '#comment') return undefined;
    if (attr_value === null || attr_value === undefined) return undefined;
    if (typeof element.getAttribute === 'function') {
        let elem_attr_val = element.getAttribute(attr_name);
        if (elem_attr_val !== undefined && elem_attr_val !== null && elem_attr_val.length > 0) {
            if (attr_comparer !== undefined && attr_comparer(elem_attr_val, attr_value) === true) return element;
            if (attr_comparer === undefined && elem_attr_val == attr_value) return element;
        }
    }
    for(var i1 in element.childNodes){
        let sub = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElement(element.childNodes[i1], attr_name, attr_value, attr_comparer);
        if (sub != null) return sub;
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElements = function(element, attr_name, attr_value, attr_comparer) {
    if (element === null || element === undefined || element.nodeName == '#text' || element.nodeName == '#comment') return undefined;
    if (attr_value === null || attr_value === undefined) return undefined;
    let list = [];
    if (typeof element.getAttribute === 'function') {
        let elem_attr_val = element.getAttribute(attr_name);
        if (elem_attr_val !== undefined && elem_attr_val !== null && elem_attr_val.length > 0) {
            if (attr_comparer !== undefined && attr_comparer(elem_attr_val, attr_value) === true) list = [
                element
            ];
            if (attr_comparer === undefined && elem_attr_val == attr_value) list = [
                element
            ];
        }
    }
    for(var i1 in element.childNodes){
        let sub = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElements(element.childNodes[i1], attr_name, attr_value, attr_comparer);
        if (sub !== undefined && sub !== null && sub.length > 0) //if (list === undefined)
        //    list = sub;
        //else
        //{
        //list.push(...sub);
        for(let sub_i in sub)list.push(sub[sub_i]);
    }
    return list;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.WindowIsMaximized = function() {
    let isFullscreen = screen.availWidth - window.innerWidth === 0;
    return window.fullScreen === true || document.fullscreenElement != undefined || isFullscreen;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.loadCSS = function(cssFilePath, cssId, initDoc) {
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(cssId) && document.getElementById(cssId) != undefined) return;
    if (initDoc) {
        console.log(document.getElementsByTagName('head'));
        console.log(document.getElementsByTagName('body'));
        var head = document.getElementsByTagName('head')[0];
        if (head == null || head == undefined) return;
        var meta = document.createElement('meta');
        meta.setAttribute('name', 'viewport');
        meta.setAttribute('content', 'width=device-width, initial-scale=1, shrink-to-fit=no');
        head.appendChild(meta);
        var meta = document.createElement('meta');
        meta.setAttribute('charset', 'utf-8');
        head.appendChild(meta);
    }
    var link = document.createElement('link');
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(cssId)) link.id = cssId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = cssFilePath;
    //link.media = 'all';
    head.appendChild(link);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.setInnerHTML = function(elm, html, callback) {
    var doc = elm.ownerDocument || document;
    try {
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(html) && html.indexOf('<') == -1 && html.indexOf('>') == -1) elm.innerText = html;
        else elm.innerHTML = html;
        Array.from(elm.querySelectorAll("script")).forEach((oldScript)=>{
            const newScript = doc.createElement("script");
            Array.from(oldScript.attributes).forEach((attr)=>newScript.setAttribute(attr.name, attr.value));
            newScript.appendChild(doc.createTextNode(oldScript.innerHTML));
            if (callback != undefined) {
                newScript.onload = callback;
                newScript.onreadystatechange = function() {
                    if (this.readyState == 'complete') callback();
                };
            }
            oldScript.parentNode.replaceChild(newScript, oldScript);
        });
    } catch (ex) {
        console.warn('DrDocWeb.setInnerHTML: HTML konnte nicht geparst werden', html, elem, ex);
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize = function(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr) {
    if (iframe != undefined && iframe != null) {
        if (iframe.contentWindow != undefined && iframe.contentWindow != null && iframe.contentWindow.document != undefined && iframe.contentWindow.document != null) {
            //console.log('DrDocWeb.IframeAutosize: SetSize (1): ', iframe.contentWindow.document.readyState);
            // Erneut ausführen, bis das Dokument geladen ist
            if (iframe.contentWindow.document.readyState !== 'complete') {
                //console.log('DrDocWeb.IframeAutosize: iframe.contentWindow.document.readyState: ', iframe.contentWindow.document.readyState);
                setTimeout(function() {
                    $23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr);
                }, 200);
                //DrDocWeb.IframeAutosize(iframe, selector);
                return;
            }
            if (lastWidth == undefined || lastWidth === null) iframe.width = '100%';
            //iframe.height = '400px';
            //iframe.style.width = '100%';
            //iframe.style.width = '100px';
            //iframe.style.height = '1000px';
            let doc = iframe.contentWindow.document;
            let maxW = 0;
            let maxH = 0; //iframe.height;
            if (doc.body != undefined && doc.body != null) {
                if (doc.body.scrollWidth != undefined) maxW = Math.max(maxW, doc.body.scrollWidth);
                if (doc.body.scrollHeight != undefined) maxH = Math.max(maxH, doc.body.scrollHeight);
            }
            if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(selector)) {
                let selectorElemArr = doc.querySelectorAll(selector);
                //console.log('DrDocWeb.IframeAutosize: selector: ', selector, selectorElem);
                if (selectorElemArr != undefined && selectorElemArr != null) selectorElemArr.forEach(function(selectorElem) {
                    if (selectorElem != undefined && selectorElem != null) {
                        //if (selectorElem.width != undefined)
                        //    maxW = Math.max(maxW, selectorElem.width);
                        if (selectorElem.scrollWidth != undefined) maxW = Math.max(maxW, selectorElem.scrollWidth);
                        //if (selectorElem.height != undefined)
                        //    maxH = Math.max(maxH, selectorElem.height);
                        if (selectorElem.scrollHeight != undefined) maxH = Math.max(maxH, selectorElem.scrollHeight);
                    }
                });
            //console.log('DrDocWeb.IframeAutosize: Size: ', maxW, ' x ', maxH);
            }
            if (doc.documentElement != undefined && doc.documentElement != null) {
                if (doc.documentElement.scrollWidth != undefined) maxW = Math.max(maxW, doc.documentElement.scrollWidth);
                if (doc.documentElement.scrollHeight != undefined) maxH = Math.max(maxH, doc.documentElement.scrollHeight);
            }
            /*if (iframe.contentWindow.width != undefined)
                maxW = Math.max(maxW, iframe.contentWindow.width);
            if (iframe.contentWindow.height != undefined)
                maxH = Math.max(maxH, iframe.contentWindow.height);*/ //console.log('DrDocWeb.IframeAutosize: SetSize (2): ', iframe.src, maxH, doc.body.scrollHeight, doc.documentElement.scrollHeight, iframe.contentWindow.height); //, doc);
            /*if (maxH > 150) {
                //iframe.width = maxW + 'px';
                iframe.height = maxH + 'px';

                // Wenn auch Inhalte bereits geladen wurden, nur alle 5 Sek. Größe erneut anpassen
                setTimeout(function () {
                    DrDocWeb.IframeAutosize(iframe, selector, false);
                }, 5000);
            }
            else {
                // Wenn auch Inhalte noch nicht geladen wurden, alle 0,2 Sek. Größe erneut anpassen
                setTimeout(function () {
                    DrDocWeb.IframeAutosize(iframe, selector, false);
                }, 1000);
            }*/ // Wenn auch Inhalte noch nicht geladen wurden, alle 0,2 Sek. Größe erneut anpassen
            setTimeout(function() {
                $23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize(iframe, selector, maxW, maxH, maxWidthStr, maxHeightStr);
            }, 1000);
            //console.log('DrDocWeb.IframeAutosize: Size: Neu: ', maxW, ' x ', maxH, ' / alt: ', lastWidth, ' x ', lastHeight, ' / max: ', maxWidthStr, 'x', maxHeightStr);
            if (lastWidth == undefined || maxW > lastWidth + 150) {
                iframe.style.width = maxW + 0 + 'px';
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(maxWidthStr)) iframe.style.maxWidth = maxWidthStr;
                else iframe.style.maxWidth = maxW + 0 + 'px';
            }
            if (lastHeight == undefined || maxH > lastHeight + 150) {
                iframe.style.height = maxH + 0 + 'px';
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(maxHeightStr)) iframe.style.maxHeight = maxHeightStr;
                else iframe.style.maxHeight = maxH + 0 + 'px';
            }
            iframe.contentWindow.document.documentElement.style.overflow = 'hidden';
        } else {
            //console.log('DrDocWeb.IframeAutosize: Init (0): ', iframe.src);
            if (iframe._hasLoadEvent === true) return;
            iframe._hasLoadEvent = true;
            iframe.addEventListener('load', function(e) {
                //console.log('DrDocWeb.IframeAutosize: onLoad (1, root): ', iframe.src);
                $23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr);
            });
        }
    } else ;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindLeftWindowBoundry = function(wnd) {
    // In Internet Explorer window.screenLeft is the window's left boundry
    if (wnd.screenLeft) return wnd.screenLeft;
    // In Firefox window.screenX is the window's left boundry
    if (wnd.screenX) return wnd.screenX;
    return 0;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindTopWindowBoundry = function(wnd) {
    // In Internet Explorer window.screenLeft is the window's left boundry
    if (wnd.screenTop) return wnd.screenTop;
    // In Firefox window.screenX is the window's left boundry
    if (wnd.screenY) return wnd.screenY;
    return 0;
};
// // Find Left Boundry of the Screen/Monitor
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindLeftScreenBoundry = function(wnd) {
    let left = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindLeftWindowBoundry(wnd);
    // Check if the window is off the primary monitor in a positive axis
    // X,Y                  X,Y                    S = Screen, W = Window
    // 0,0  ----------   1280,0  ----------
    //     |          |         |  ---     |
    //     |          |         | | W |    |
    //     |        S |         |  ---   S |
    //      ----------           ----------
    if (left > wnd.screen.width) return left - (left - wnd.screen.width);
    // Check if the window is off the primary monitor in a negative axis
    // X,Y                  X,Y                    S = Screen, W = Window
    // 0,0  ----------  -1280,0  ----------
    //     |          |         |  ---     |
    //     |          |         | | W |    |
    //     |        S |         |  ---   S |
    //      ----------           ----------
    // This only works in Firefox at the moment due to a bug in Internet Explorer opening new windows into a negative axis
    // However, you can move opened windows into a negative axis as a workaround
    if (left < 0 && left > wnd.screen.width * -1) return wnd.screen.width * -1;
    // If neither of the above, the monitor is on the primary monitor whose's screen X should be 0
    return 0;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindTopScreenBoundry = function(wnd) {
    let top = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindTopWindowBoundry(wnd);
    if (top > wnd.screen.height) return top - (top - wnd.screen.height);
    if (top < 0 && top > wnd.screen.height * -1) return wnd.screen.height * -1;
    return 0;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectForEachSorted = function(obj, action) {
    var keys = Object.keys(obj);
    var len = keys.length;
    keys.sort();
    for(i = 0; i < len; i++)action(keys[i], obj[keys[i]]);
};
// --
// Cookie Funktionen
$23b71ef8c0192a76$export$2e2bcd8739ae039.SetCookie = function(cname, cvalue, exdays, path) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = "Expires=" + d.toUTCString();
    //console.log('DrDocWeb.SetCookie(' + cname + ', ' + cvalue + ')', '\r\n', document.cookie);
    document.cookie = $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(cname) + "=" + $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(cvalue) + "; " + expires + "; Path=" + (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(path) ? path : '/') + "; SameSite=Lax;"; //SameSite=None;"; //samesite=lax;"; // SameSite=Lax;"; //SameSite=None; Secure";
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetCookie = function(cname, defaultValue) {
    let name = $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(cname) + "=";
    let ret = '';
    //let decodedCookie = document.cookie);
    if (document.cookie) {
        let ca = document.cookie.split(';');
        for(let i1 = 0; i1 < ca.length; i1++){
            let c = ca[i1];
            while(c.charAt(0) == ' ')c = c.substring(1);
            if (c.indexOf(name) === 0) {
                ret = decodeURIComponent(c.substring(name.length, c.length));
                break;
            }
        }
    //console.log('Cookie... ', ca);
    }
    if (defaultValue === undefined) defaultValue = '';
    //console.log('DrDocWeb.GetCookie(' + cname + ', ' + defaultValue + ') = ', ret, '\r\n', document.cookie);
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(ret) ? defaultValue : ret;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetCookiePrefix = function(namePrefix) {
    //let name = DrDocWeb.UrlEncode(cname) + "=";
    let ret = [];
    //let decodedCookie = document.cookie);
    if (document.cookie) {
        let ca = document.cookie.split(';');
        for(let i1 = 0; i1 < ca.length; i1++){
            let c = ca[i1];
            while(c.charAt(0) == ' ')c = c.substring(1);
            let iOfEq = c.indexOf('=');
            if (iOfEq < 0) continue;
            let name = c.substring(0, iOfEq);
            if (name.indexOf(namePrefix) === 0) {
                let value = decodeURIComponent(c.substring(iOfEq + 1));
                console.log('DrDocWeb.GetCookiePrefix: Cookie gefunden! ', name, '|', value, '|');
                ret.push({
                    name: name,
                    value: value
                });
            }
        }
    //console.log('Cookie... ', ca);
    }
    //console.log('DrDocWeb.GetCookie(' + cname + ', ' + defaultValue + ') = ', ret, '\r\n', document.cookie);
    return ret;
};
// ---
// Tree-View
// Root Element (UL): .tree
// Item Element (LI): .tree-item (ggf.: .tree-item-action)
// Item Element Container (UL): (ggf.: .tree-sub .tree-active)
$23b71ef8c0192a76$export$2e2bcd8739ae039.TreeView = function() {
    //console.log('DrDocWeb.TreeView: init');
    var treeRootElemArr = document.querySelectorAll(".tree");
    if (treeRootElemArr != undefined && treeRootElemArr != null && treeRootElemArr.length > 0) for(let i1 = 0; i1 < treeRootElemArr.length; i1++)$23b71ef8c0192a76$export$2e2bcd8739ae039.TreeViewIntern(treeRootElemArr[i1]);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.TreeViewIntern = function(treeRootElem) {
    /*if (treeRootElem._tree_initialized === true)
    {
        console.log('DrDocWeb.TreeViewIntern (bereits initialisiert): ', treeRootElem);
        return;
    }
    treeRootElem._tree_initialized = true;
    console.log('DrDocWeb.TreeViewIntern: init', treeRootElem);*/ var treeToggler = treeRootElem.querySelectorAll(".tree-item");
    //console.log('DrDocWeb.TreeViewIntern: .tree-item"*: ', treeToggler, '/', treeRootElem);
    if (treeToggler == undefined || treeToggler == null || treeToggler.length == 0) {
        treeToggler = treeRootElem.childNodes;
        //console.log('DrDocWeb.TreeViewIntern: >*: ', treeToggler, '/', treeRootElem);
        if (treeToggler != undefined && treeToggler != null && treeToggler.length > 0) for(let i1 = 0; i1 < treeToggler.length; i1++){
            let liElem = treeToggler[i1];
            if (!liElem.classList) continue;
            liElem.classList.add('tree-item');
            let ulElem = liElem.querySelector("ul");
            if (ulElem) ulElem.classList.add('tree-sub');
        }
    }
    treeToggler = treeRootElem.querySelectorAll(".tree-item");
    if (treeToggler != undefined && treeToggler != null && treeToggler.length > 0) {
        //console.log('DrDocWeb.TreeViewIntern: ', treeToggler);
        let updateTreeElem = function(liElem) {
            //liElem.classList.add("tree-caret-item");
            let ulElem = liElem.querySelector(".tree-sub");
            // wenn kein .tree-sub gefunden wurde, das erste "ul" finden
            if (ulElem == null || ulElem == undefined) {
                ulElem = liElem.querySelector("ul");
                if (ulElem) ulElem.classList.add('tree-sub');
            }
            //if (ulElem == null || ulElem == undefined)
            //    ulElem = liElem.querySelector("*");
            if (ulElem) {
                if (ulElem.classList.contains('tree-active')) liElem.classList.add("tree-caret-down");
                else liElem.classList.remove("tree-caret-down");
            } else ;
        };
        for(let i1 = 0; i1 < treeToggler.length; i1++){
            let liElem = treeToggler[i1];
            if (!liElem.classList) continue;
            updateTreeElem(liElem);
            //console.log('Tree, LI: ', liElem.firstChild, liElem.querySelector("*"), liElem.querySelector("span"), liElem.childNodes[0]);
            let onClick = function(e) {
                //let liElem = treeToggler[i]; //DrDocWeb.GetElement(liElem, 'li', true);
                // nur Event ausführen, wenn das OnClick Target passt: als das selbe Element oder ein direktes Child ist
                if (e.target !== liElem && e.target.parentNode !== liElem && !e.target.classList.contains('tree-item-action')) {
                    console.log('DrDocWeb.TreeViewIntern: onClick: e.target !== liElem, ', e, e.target, liElem);
                    return;
                }
                //console.log('DrDocWeb.TreeViewIntern: onClick: ', liElem);
                //let ulElem = DrDocWeb.GetElement(liElem, 'ul', true);
                let ulElem = liElem.querySelector(".tree-sub");
                /*if (ulElem == null || ulElem == undefined)
                {
                    ulElem = liElem.querySelector("ul");
                    if (ulElem)
                        ulElem.classList.add('tree-sub');
                }*/ //if (ulElem == null || ulElem == undefined)
                //    ulElem = liElem.querySelector("*");
                if (ulElem) ulElem.classList.toggle("tree-active");
                updateTreeElem(liElem);
            };
            //liElem.addEventListener("click", onClick);
            let actionElem = null;
            if (actionElem == null || actionElem == undefined) actionElem = liElem.querySelector(".tree-item-action");
            //if (actionElem == null || actionElem == undefined)
            //    actionElem = liElem.querySelector("li");
            //if (actionElem == null || actionElem == undefined)
            //    actionElem = liElem.querySelector("*");
            if (actionElem == null || actionElem == undefined) // Trigger für Action darf nicht direkt das "li"-Element sein, sonst wird beim Click alle darunter sgeschlossen
            actionElem = liElem;
            if (actionElem != undefined && actionElem != null) {
                if (actionElem.__tree_onClick != undefined) {
                    actionElem.removeEventListener("click", actionElem.__tree_onClick);
                    actionElem.removeEventListener("click", actionElem.__tree_onClick, true);
                    actionElem.removeEventListener("click", actionElem.__tree_onClick, false);
                }
                actionElem.__tree_onClick = onClick;
                actionElem.addEventListener("click", onClick, false);
            } else console.log('DrDocWeb.TreeViewIntern: no action Element found: ', liElem, actionElem);
        }
    }
};
// ---
$23b71ef8c0192a76$export$2e2bcd8739ae039.SelectorAttributeEncode = function(str) {
    return str.replace(/["\\]/g, '\\$&');
};
// ---
$23b71ef8c0192a76$export$2e2bcd8739ae039.DataGroup = function(data, selector_arr, emptyKeyValue, selector_i) {
    if (selector_i === undefined || selector_i < 0) selector_i = 0;
    if (selector_i >= selector_arr.length) return undefined;
    let ret_data = {};
    if (data !== undefined && data !== null) {
        //data.forEach(function (itm) {
        for(let data_key in data){
            let itm = data[data_key];
            let key = selector_arr[selector_i](itm);
            let key_arr = null;
            // "itm" in "ret_data" einsortieren
            // Wenn key ein Array ist, für jedes Element einzeln einsortieren
            if (key != undefined && key != null && Array.isArray(key)) {
                if (key.length === 0) key_arr = [
                    ''
                ];
                else key_arr = key;
            } else key_arr = [
                key
            ];
            for (let key_itm of key_arr){
                // Default Key setzen, falls leer
                if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(key_itm) && !$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(emptyKeyValue)) key_itm = emptyKeyValue;
                if (ret_data[key_itm] === undefined) ret_data[key_itm] = [];
                //console.log('DrDocWeb.DataGroup: key_arr: ', key_itm, ': ', ret_data[key_itm]);
                if (ret_data[key_itm].indexOf(itm) === -1) ret_data[key_itm].push(itm);
            }
        }
        if (selector_i + 1 < selector_arr.length) for(let key in ret_data)ret_data[key] = $23b71ef8c0192a76$export$2e2bcd8739ae039.DataGroup(ret_data[key], selector_arr, emptyKeyValue, selector_i + 1);
    }
    //console.log('DrDocWeb.DataGroup: ', ret_data);
    return ret_data;
};
// ---
// KVP / Key-Value-Pair
// DrDocWeb.kvp_get(this, 'rootNamespace-1', 'search', 'field_')
// DrDocWeb.kvp_get(sourceElement, 'rootNamespace-1', 'search', 'field_', searchData, true);
// data-kvp-namespace="rootNamespace-1" data-kvp-key="Feld1" data-kvp-search="Test GmbH" data-kvp-value2="Test"
// => { 'field_Feld1': 'Test GmbH', field_value2: 'Test' }
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR = 'data-kvp';
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_NAMESPACE = $23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-namespace';
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_KEY = $23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-key';
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_VALUE = $23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-value';
$23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_get = function(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy) {
    if (sourceElement == undefined || sourceElement == null) return;
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(valueName)) valueName = 'value';
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(returnKeyPrefix)) returnKeyPrefix = '';
    if (obj == undefined || obj == null) obj = {};
    //var rootElement = DrDocWeb.IsNullOrEmpty(selector) ? null : DrDocWeb.GetElement(sourceElement, selector);
    if (strictParentHierarchy) $23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
    else {
        let elemList = document.querySelectorAll(`[${$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_NAMESPACE}="${$23b71ef8c0192a76$export$2e2bcd8739ae039.SelectorAttributeEncode(rootNamespace)}"]`);
        if (elemList != undefined && elemList != null) for (let elem1 of elemList)$23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal(elem1, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
    }
    //let elemNodeIgnoreList = [];
    //DrDocWeb.kvp_getInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList);
    //console.log('DrDocWeb.kvp_get: root: ', obj);
    return obj;
};
/*DrDocWeb.kvp_getInternal = function (sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList) {
    if (elemNodeIgnoreList.indexOf(sourceElement) >= 0)
        return;
    elemNodeIgnoreList.push(sourceElement);

    if (strictHierarchy) {
        // Strikt suchen
        DrDocWeb.kvp_getRecursiveInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList);
    }
    else {
        let elemList = document.querySelectorAll(`[${DrDocWeb.KVP_ATTR_NAMESPACE}="${DrDocWeb.SelectorAttributeEncode(rootNamespace)}"]`);
        if (elemList != undefined && elemList != null) {
            for (let elem of elemList) {
                DrDocWeb.kvp_getRecursiveInternal(elem, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, false, elemNodeIgnoreList);
            }
        }
    }
}*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal = function(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy) {
    if (sourceElement.getAttribute !== undefined && typeof sourceElement.getAttribute === 'function') {
        let key = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_KEY);
        // key vorhanden?
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(key)) {
            let namespace = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_NAMESPACE);
            // Namespace prüfen
            if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(namespace) && $23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(rootNamespace) || namespace === rootNamespace) {
                // data-kvp-<valueName>="..."
                let value = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-' + valueName.toLowerCase());
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(value)) obj[returnKeyPrefix + key] = value;
            }
        }
    }
    //if (rootElement === sourceElement)
    //    return;
    if (strictParentHierarchy) // Rekursive über Parent Node durchlaufen
    {
        if (sourceElement.parentNode != null && sourceElement.parentNode != undefined) $23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal(sourceElement.parentNode, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
    }
};
// ---
// Drag and Drop
/*
+CSS:
[data-drag]
{
    cursor: pointer;
    user-select: none;
}
.drag-active[data-drag]
{
    border-color: $gray-500;
    border-width: 1px;
    border-style: solid;
}

+HTML:
<ul data-drag-value="value">
    <li data-drag="{{$_this.ID_Name}}" data-drag-value="apple" data-drag-action="copy,move,copyMove,link">Apples</li>
    <li data-drag="{{$_this.ID_Name}}">Oranges</li>
    <li data-drag="{{$_this.ID_Name}}">Bananas</li>
    <li data-drag="{{$_this.ID_Name}}">Strawberries</li>
</ul>
<div data-drag-action="drop">

DrDocWeb.dnd_init(elem)
DrDocWeb.dnd_getValue(elem)
*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR = 'data-drag';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_DROP = 'data-drop';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_VALUE = $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR + '-value';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION = $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR + '-action';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_TRIGGER = $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR + '-trigger';
//DrDocWeb.DND_ATTR_IGNORE = DrDocWeb.DND_ATTR + '-ignore';
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected = {};
// Initialisiert alle Elemente mit dem Attribut data-drag="Name"
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_init = function(sourceElement) {
    let selector = `[${$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR}]`;
    let arr = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElements(sourceElement, selector);
    //console.log('dnd_init: ', arr);
    for (let elem1 of arr)$23b71ef8c0192a76$var$dnd_initElement(elem1);
/*for (let elem of DrDocWeb.GetElements(sourceElement, `[${DrDocWeb.DND_ATTR_IGNORE}]`)) {
        if (DrDocWeb.ParseBool(elem.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
            elem.draggable = false;

            elem.addEventListener('dragstart', function (e) {
                console.log('DND: Disable: Start: ', e.targer, elem);
                e.preventDefault();
                return false;
            });
        }
    }*/ };
function $23b71ef8c0192a76$var$dnd_getDragDropEvent(type, dataTransfer) {
    var dragDropEvent = new DragEvent(type);
    console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', dataTransfer);
    Object.defineProperty(dragDropEvent.constructor.prototype, 'dataTransfer', dataTransfer);
    dragDropEvent['dataTransfer'] = dataTransfer;
    //console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',  dragDropEvent.dataTransfer.getData('Text'));
    console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', dragDropEvent);
    return dragDropEvent;
}
// Drag n Drop Element initialisieren
function $23b71ef8c0192a76$var$dnd_initElement(sourceElement, name) {
    if (sourceElement == undefined || sourceElement == null) return;
    // nur einmal initialisieren
    if (sourceElement._dnd_initialized === true) return;
    sourceElement._dnd_initialized = true;
    if (typeof sourceElement.getAttribute !== 'function') return;
    //if (DrDocWeb.IsNullOrEmpty(name))
    name = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR);
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(name)) return;
    // prüfen, ob das Draggable Element ein anderes Trigger Element hat
    let triggerElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement(sourceElement, `[${$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_TRIGGER}="${$23b71ef8c0192a76$export$2e2bcd8739ae039.SelectorAttributeEncode(name)}"]`, true);
    if (triggerElement != undefined && triggerElement != null) {
        //console.log('DND Init: User Trigger Element ', triggerElement, ' for source elem ', sourceElement);
        let dragAction = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION);
        //console.log('dnd_initElement: ', name);
        if (dragAction == 'false' || dragAction == 'none' || dragAction == 'drop' || dragAction == 'dropzone') {
            // Nur als Dropzone
            // Element nicht als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
        } else {
            // Element als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
            sourceElement.addEventListener('dragstart', function(e) {
                //console.log('dragstart: ', e.target, e);
                /*console.log('dragstart: ', DrDocWeb.DND_ATTR_IGNORE, ' / ', e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE), ' / ', e.target, e);
                if (DrDocWeb.ParseBool(e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
                    console.log('DRAG n Drop Cancel: ', e.target);
                    e.preventDefault();
                    return false;
                }*/ $23b71ef8c0192a76$var$dnd_dragStart(name, e);
            });
            // Element als Draggable markieren
            triggerElement.addEventListener('mousedown', function(e) {
                e.preventDefault();
                sourceElement.draggable = true;
                sourceElement.setAttribute('draggable', 'true');
                //setTimeout(function () {
                //    DrDocWeb.EventFire(sourceElement, 'mousedown');
                //    DrDocWeb.EventFire(sourceElement, 'dragstart');
                //}, 100);
                //DrDocWeb.EventFire(sourceElement, 'dragstart');
                /*var dragDataTransfer = {
                    data: {},
                    setData: function(type, value) { this.data[type] = value; },
                    getData: function(type) { return this.data[type] }
                 };

                 dragDataTransfer.setData('Text', 'foo....................');
                 var dragstaEv = dnd_getDragDropEvent('dragstart', dragDataTransfer);
                 sourceElement.dispatchEvent(dragstaEv);*/ return false;
            });
        }
        sourceElement.addEventListener('dragover', function(e) {
            $23b71ef8c0192a76$var$dnd_dragOver(name, e);
        });
        /*sourceElement.addEventListener('dragend', function (e) {
            dnd_dragEnd(name, e);
        });*/ sourceElement.addEventListener('drop', function(e) {
            $23b71ef8c0192a76$var$dnd_drop(name, e);
        });
    } else {
        let dragAction = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION);
        //console.log('dnd_initElement: ', name);
        if (dragAction == 'false' || dragAction == 'none' || dragAction == 'drop' || dragAction == 'dropzone') {
            // Nur als Dropzone
            // Element nicht als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
        } else {
            // Element als Draggable markieren
            sourceElement.draggable = true;
            sourceElement.setAttribute('draggable', 'true');
            sourceElement.addEventListener('dragstart', function(e) {
                /*console.log('dragstart: ', DrDocWeb.DND_ATTR_IGNORE, ' / ', e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE), ' / ', e.target, e);
                if (DrDocWeb.ParseBool(e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
                    console.log('DRAG n Drop Cancel: ', e.target);
                    e.preventDefault();
                    return false;
                }*/ $23b71ef8c0192a76$var$dnd_dragStart(name, e);
            });
        }
        sourceElement.addEventListener('dragover', function(e) {
            $23b71ef8c0192a76$var$dnd_dragOver(name, e);
        });
        /*sourceElement.addEventListener('dragend', function (e) {
            dnd_dragEnd(name, e);
        });*/ sourceElement.addEventListener('drop', function(e) {
            $23b71ef8c0192a76$var$dnd_drop(name, e);
        });
    }
}
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem = function(name, sourceElement, getContainer) {
    if (typeof sourceElement.hasAttribute === 'function') {
        if (sourceElement.hasAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR) && name == sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR)) /*if (getContainer === true) {
                let containerElement = DrDocWeb.GetElement(sourceElement, `[${DrDocWeb.DND_ATTR}-container="${DrDocWeb.SelectorAttributeEncode(name)}"]`, true);
                if (containerElement != undefined && containerElement != null) {
                    //console.log('DrDocWeb.dnd_getElem: Container, ', DrDocWeb.DND_ATTR, name, sourceElement, ' => ', containerElement);
                    return containerElement;
                }
            }*/ //console.log('DrDocWeb.dnd_getElem: ', DrDocWeb.DND_ATTR, name, sourceElement);
        return sourceElement;
    /*if (sourceElement.hasAttribute(DrDocWeb.DND_ATTR_DROP) && name == sourceElement.getAttribute(DrDocWeb.DND_ATTR_DROP)) {
            console.log('DrDocWeb.dnd_getElem: ', DrDocWeb.DND_ATTR_DROP, name, sourceElement);
            return sourceElement;
        }*/ }
    let elemTmp = sourceElement.parentNode;
    if (elemTmp !== undefined && elemTmp !== null) {
        let parent = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, elemTmp, getContainer);
        if (parent !== undefined && parent !== null) return parent;
    }
    //let selector = `[${DrDocWeb.DND_ATTR}="${name}"]`;
    //return DrDocWeb.GetElement(sourceElement, selector, true);
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValueElem = function(sourceElement) {
    if (sourceElement != undefined && sourceElement != null) {
        if (typeof sourceElement.hasAttribute === 'function' && sourceElement.hasAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_VALUE)) return sourceElement;
        let elemTmp = sourceElement.parentNode;
        if (elemTmp !== undefined && elemTmp !== null) {
            let parent = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValueElem(elemTmp);
            if (parent !== undefined && parent !== null) return parent;
        }
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValue = function(sourceElement) {
    sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValueElem(sourceElement);
    return sourceElement != undefined && sourceElement != null && typeof sourceElement.getAttribute === 'function' ? sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_VALUE) : '';
};
// The user starts to drag an element
function $23b71ef8c0192a76$var$dnd_dragStart(name, e) {
    if (!e) return;
    let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    let sourceElementTrigger = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, false);
    if (!sourceElement) return;
    /*
    // Drag n Drop Container und Trigger Element unterscheiden sich
    if (sourceElementTrigger !== sourceElement)
    {
        console.log('DND: Drag n Drop Container und Trigger Element unterscheiden sich: ', sourceElementTrigger, sourceElement);
        // sourceElement.draggable = true;
        // Container Element initialisieren
        dnd_initElement(sourceElement, name);
        e.preventDefault();
        // "dragstart" erneut für Container Element ausführen
        setTimeout(function(){
            DrDocWeb.EventFire(sourceElement, 'dragstart', function(e2){
        console.log('DND: Drag n Drop Container', ' / dragstart fired', e2);
            });
        }, 100);
        return false;
    }
    console.log('DND: Drag n Drop Start', sourceElementTrigger, sourceElement);
    */ //let moveElement = DrDocWeb.GetElement(sourceElement, `[${DrDocWeb.DND_ATTR}-container="${DrDocWeb.SelectorAttributeEncode(name)}"]`, true);
    //if (moveElement != undefined && moveElement != null) {
    //    sourceElement = moveElement;
    //}
    sourceElement.classList.add('drag-active');
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations
    //console.log('dnd_dragStart: ', sourceElement, ' Prev: ', sourceElement.previousElementSibling, ' / Next: ', sourceElement.nextElementSibling);
    let actionStr = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION);
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(actionStr)) //console.log('dnd_dragStart: effectAllowed: ', actionStr);
    e.dataTransfer.effectAllowed = actionStr;
    else e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', null);
    sourceElement.dnd = {
        sourceElement: sourceElement,
        sourceElementParent: sourceElement.parentNode,
        targetElement: null,
        targetElementParent: null,
        previousElementSibling: sourceElement.previousElementSibling,
        nextElementSibling: sourceElement.nextElementSibling,
        effectAllowed: e.dataTransfer.effectAllowed
    };
    //sourceElement.style.cursor = 'move';
    //sourceElement.style.backgroundColor = 'green';
    $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] = sourceElement;
}
// A dragged element is over the drop target
// The ondragover event specifies where the dragged data can be dropped.
function $23b71ef8c0192a76$var$dnd_dragOver(name, e) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] == null) //console.log('dnd_dragOver: DrDocWeb.dnd_selected[name] == null: ', name);
    return;
    e.preventDefault();
    /*let sourceElement = null;
    if (e.target._dnd_elem !== undefined) {
        sourceElement = e.target._dnd_elem;
    }
    else {
        sourceElement = DrDocWeb.dnd_getElem(name, e.target, true);
        e.target._dnd_elem = sourceElement;
    }*/ let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name];
    let targetElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    if (sourceElement == null || sourceElement == undefined) return;
    // Effekt setzen für Cursor Symbol
    if (sourceElement.dnd != undefined && !$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(sourceElement.dnd.effectAllowed)) e.dataTransfer.dropEffect = sourceElement.dnd.effectAllowed;
    // Element beim Drag and Drop einsortieren
    //if (DrDocWeb.IsNullOrEmpty(e.dataTransfer.effectAllowed) || e.dataTransfer.effectAllowed == 'move') {
    /*try {
        //console.log('dnd_dragOver: ', sourceElement, sourceElement.nextElementSibling);
        if (dnd_dragOver_isBeforeInternal(DrDocWeb.dnd_selected[name], sourceElement)) {
            sourceElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], sourceElement);
        } else {
            sourceElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], sourceElement.nextElementSibling);
        }
    } catch { }*/ /*}
    else {
        //console.log('dnd_dragOver: effectAllowed: ', e.dataTransfer.effectAllowed);
        //var dt =  e.originalEvent.dataTransfer;
        //dt.dropEffect = e.dataTransfer.effectAllowed;
        //e.dataTransfer.dropEffect = e.dataTransfer.effectAllowed;
        //e.preventDefault();
    }*/ // Ziel Parent Element setzen
    if (sourceElement.dnd != undefined) {
        if (targetElement != undefined && targetElement != null) {
            e.target.dnd = sourceElement.dnd;
            targetElement.dnd = sourceElement.dnd;
            sourceElement.dnd.targetElement = targetElement;
            if (targetElement.parentNode != undefined && targetElement.parentNode != null) sourceElement.dnd.targetElementParent = targetElement.parentNode;
        }
    }
}
function $23b71ef8c0192a76$var$dnd_dragOver_isBeforeInternal(el1, el2) {
    if (!el1 || !el2) return false;
    let cur = null;
    if (el2.parentNode === el1.parentNode) for(cur = el1.previousElementSibling; cur; cur = cur.previousElementSibling){
        if (cur === el2) return true;
    }
    return false;
}
// A dragged element is dropped on the target
// onDrop wird VOR onDragEnd aufgerufen
function $23b71ef8c0192a76$var$dnd_drop(name, e) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] == null) //console.log('dnd_drop: DrDocWeb.dnd_selected[name] == null: ', name, e.target);
    return;
    //console.log('dnd_drop: e: ', name, DrDocWeb.dnd_selected[name], e);
    let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name];
    if (sourceElement == undefined || sourceElement == null) //console.log('dnd_drop: sourceElement == null: ', name, e.target);
    return;
    let targetElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    // Call preventDefault() to prevent the browser default handling of the data (default is open as link on drop)
    e.preventDefault();
    sourceElement.classList.remove('drag-active');
    // Ziel Parent Element setzen
    /*if (sourceElement.dnd != undefined)
    {
        sourceElement.dnd.targetElement = sourceElement;

        if (sourceElement.parentNode != undefined && sourceElement.parentNode != null)
            sourceElement.dnd.targetElementParent = sourceElement.parentNode;
    }*/ if (sourceElement.dnd != undefined) {
        // In Target einsortieren
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(sourceElement.dnd.effectAllowed) && sourceElement.dnd.effectAllowed == 'move') try {
            if ($23b71ef8c0192a76$var$dnd_dragOver_isBeforeInternal($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name], targetElement)) targetElement.parentNode.insertBefore($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name], targetElement);
            else targetElement.parentNode.insertBefore($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name], targetElement.nextElementSibling);
        } catch  {}
        // Ziel Parent Element setzen
        if (targetElement != undefined && targetElement != null) {
            e.target.dnd = sourceElement.dnd;
            targetElement.dnd = sourceElement.dnd;
            sourceElement.dnd.targetElement = targetElement;
            if (targetElement.parentNode != undefined && targetElement.parentNode != null) sourceElement.dnd.targetElementParent = targetElement.parentNode;
        }
    }
    //console.log('dnd_drop: ', name, ' / Target: ', e.target, ' / Source: ', sourceElement, ' / DND: ', sourceElement.dnd);
    //console.log('dnd_drop: ', name, ' / DND: ', sourceElement.dnd);
    // Source Element zurücksetzen
    //setTimeout(function () {
    $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] = null;
//}, 5);
}
// onDragEnd wird NACH onDrop aufgerufen
function $23b71ef8c0192a76$var$dnd_dragEnd(name, e) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] == null) // console.log('dnd_dragEnd: DrDocWeb.dnd_selected[name] == null: ', name, e.target);
    return;
    let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    if (!sourceElement) return;
    sourceElement.classList.remove('drag-active');
    //console.log('dnd_dragEnd: ', e, sourceElement, ' Prev: ', sourceElement.previousElementSibling, ' / Next: ', sourceElement.nextElementSibling);
    // Ziel Parent Element setzen
    if (sourceElement.dnd != undefined && sourceElement.parentNode != undefined && sourceElement.parentNode != null) sourceElement.dnd.targetElementParent = sourceElement.parentNode;
    // mit Timeout ausführen, damit "e.target" auf das Ziel weist
    //setTimeout(function(){
    // Element wieder an Quelle zurückschieben, wenn effectAllowed z.B. 'copy' ist
    // aber nur wenn: Element beim Drag and Drop einsortiert wurde
    /*if (sourceElement.dnd != undefined && !DrDocWeb.IsNullOrEmpty(sourceElement.dnd.effectAllowed) && sourceElement.dnd.effectAllowed != 'move') {
        //console.log('dnd_dragEnd: dnd 1 copy: ', sourceElement.dnd.effectAllowed, e.target===sourceElement, sourceElement.dnd.sourceElement===sourceElement, sourceElement);
        if (sourceElement.parentNode !== sourceElement.dnd.sourceElementParent) {
            sourceElement.parentNode.removeChild(sourceElement);
            sourceElement.dnd.sourceElementParent.appendChild(sourceElement);
        }
    }
    else {
        // move
        //console.log('dnd_dragEnd: dnd 2 move: ', e.target===sourceElement, sourceElement.dnd.sourceElement===sourceElement, sourceElement);
    }*/ //}, 100);
    // Source Element zurücksetzen
    setTimeout(function() {
        $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] = null;
    }, 5);
}
// --
/*

            function mergeNode(node_new, node_old) {
                    if (node_new.childNodes === undefined && node_old.childNodes === undefined) {
                        //console.log('mergeNode undefined', node_new, node_old);
                        if (node_new.isSameNode(node_old))
                            console.log('mergeNode undefined', node_new, node_old);
                        return true;
                    }
    
                    if (node_new.childNodes.length != node_old.childNodes.length) {
                        console.log('mergeNode Length', node_new.childNodes.length, node_old.childNodes.length, node_new.childNodes, node_old.childNodes);
                        return false;
                    }
    
                    if (node_new.childNodes !== undefined && node_old.childNodes !== undefined) {
                        for (let i in node_new.childNodes) {
                            if (mergeNode(node_new.childNodes[i], node_old.childNodes[i]) === false)
                                return false;
                        }
                        return true;
                    }
    
                    return false;
                }
*/ // ---
// Math Helper
$23b71ef8c0192a76$export$2e2bcd8739ae039.Math_Median = function(values) {
    if (values.length === 0) return 0;
    values.sort(function(a, b) {
        return a - b;
    });
    var half = Math.floor(values.length / 2);
    if (values.length % 2) return values[half];
    return (values[half - 1] + values[half]) / 2.0;
};
// --
// String Funktionen
$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty = function(val) {
    return val === undefined || val === null || typeof val === 'string' && val === '' || typeof val === 'number' && isNaN(val) === true;
};
// --
// String Extensions
if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
};
if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
// --
// Base64 Encode
$23b71ef8c0192a76$export$2e2bcd8739ae039.b64EncodeUnicode = function(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    //return String.fromCharCode('0x' + p1);
    }));
};
/// Base64 Decode
$23b71ef8c0192a76$export$2e2bcd8739ae039.b64DecodeUnicode = function(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
};
// --
// JSON Funktionen
// JSON Parse
$23b71ef8c0192a76$export$2e2bcd8739ae039.JsonParse = function(jsonStr) {
    if (jsonStr == null || jsonStr.length == 0) return null;
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonRetrocycle(JSON.parse(jsonStr)); //event.target.responseText));
};
/**
 * Modified from Douglas Crockford's cycle.js (https://github.com/douglascrockford/JSON-js/blob/master/cycle.js).
 * Ported over to TypeScript, and modified to handle the reference schema that Json.NET uses.
 */ /* = {
    decycle: null,
    retrocycle: null
};*/ (function() {
    /**
     * The findReferences function walks recursively through an object graph built from a Json.NET string,
     * looking for $id properties. When it finds an object with that property, then it adds it to the catalog under that key.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */ function findReferences(obj, catalog) {
        if (obj && typeof obj === "object") {
            var id = obj.$id;
            if (typeof id === "string") catalog[id] = obj;
            if (Object.prototype.toString.apply(obj) === "[object Array]") {
                var i1 = void 0;
                for(i1 = 0; i1 < obj.length; i1 += 1)findReferences(obj[i1], catalog);
            } else for(var name_1 in obj){
                if (obj.hasOwnProperty(name_1)) {
                    if (typeof obj[name_1] === "object") findReferences(obj[name_1], catalog);
                }
            }
        }
    }
    /**
     * The resolveReferences function walks through the object graph and replaces any references with the objects from the catalog.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */ function resolveReferences(obj, catalog) {
        if (obj && typeof obj === "object") {
            var i1 = void 0;
            var item = void 0;
            var id = void 0;
            if (Object.prototype.toString.apply(obj) === "[object Array]") for(i1 = 0; i1 < obj.length; i1 += 1){
                item = obj[i1];
                if (item && typeof item === "object") {
                    id = item.$ref;
                    if (typeof id === "string") obj[i1] = catalog[id];
                    else obj[i1] = resolveReferences(item, catalog);
                }
            }
            else if (obj.$values && Object.prototype.toString.apply(obj.$values) === "[object Array]") {
                var arr = new Array();
                for(i1 = 0; i1 < obj.$values.length; i1 += 1){
                    item = obj.$values[i1];
                    if (item && typeof item === "object") {
                        id = item.$ref;
                        if (typeof id === "string") arr[i1] = catalog[id];
                        else arr[i1] = resolveReferences(item, catalog);
                    } else arr[i1] = item;
                }
                obj = arr;
            } else {
                var name_2;
                for(name_2 in obj){
                    if (obj.hasOwnProperty(name_2)) {
                        if (typeof obj[name_2] === "object") {
                            item = obj[name_2];
                            if (item) {
                                id = item.$ref;
                                if (typeof id === "string") obj[name_2] = catalog[id];
                                else obj[name_2] = resolveReferences(item, catalog);
                            }
                        }
                    }
                }
            }
        }
        return obj;
    }
    /**
     * The createReferences function recurses through the object, producing the deep copy.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */ function getDecycledCopy(obj, catalog) {
        var i1; // The loop counter
        var name; // Property name
        var nu; // The new object or array
        switch(typeof obj){
            case "object":
                // typeof null === 'object', so get out if this value is not really an object.
                // Also get out if it is a weird builtin object.
                if (obj === null || obj instanceof Boolean || obj instanceof Date || obj instanceof Number || obj instanceof RegExp || obj instanceof String) return obj;
                // If the value is an object or array, look to see if we have already
                // encountered it. If so, return a {$id:id} object. This is a hard way, O(n)
                // linear search that will get slower as the number of unique objects grows.
                // JavaScript really should have a decent dictionary or map class.
                for(i1 = 0; i1 < catalog.length; i1 += 1){
                    if (catalog[i1] === obj) return {
                        $ref: i1.toString()
                    };
                }
                // Otherwise, accumulate the unique value and its id.
                obj.$id = catalog.length.toString();
                catalog.push(obj);
                // If it is an array, replicate the array.
                if (Object.prototype.toString.apply(obj) === "[object Array]") {
                    nu = [];
                    for(i1 = 0; i1 < obj.length; i1 += 1)nu[i1] = getDecycledCopy(obj[i1], catalog);
                } else {
                    // If it is an object, replicate the object.
                    nu = {};
                    for(name in obj)if (Object.prototype.hasOwnProperty.call(obj, name)) nu[name] = getDecycledCopy(obj[name], catalog);
                }
                return nu;
            case "number":
            case "string":
            case "boolean":
            default:
                return obj;
        }
    }
    /** Make a deep copy of an object or array, assuring that there is at most
        one instance of each object or array in the resulting structure. The
        duplicate references (which might be forming cycles) are replaced with
        an object of the form
          {$id: id}
        where the id is a simple string
    Modified from Douglas Crockford's cycle.js (https://github.com/douglascrockford/JSON-js/blob/master/cycle.js)
    Ported over to TypeScript, and modified to handle the reference schema that Json.NET uses.
 */ function decycle(obj) {
        var catalog = []; // Keep a reference to each unique object or array
        var newObj = getDecycledCopy(obj, catalog);
        return newObj;
    }
    $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonDecycle = decycle;
    /** Restore an object that was reduced by decycle. Members whose values are objects of the form
         {$ref: id}
    are replaced with references to the value found by the id. This will
    restore cycles. The object will be mutated.

    So,
         var s = '{$id:1, members: [{$ref:"1"}]';
         return retrocycle(JSON.parse(s));
    produces an object containing an array which holds the object itself.
    */ function retrocycle(obj) {
        var catalog = [];
        findReferences(obj, catalog);
        return resolveReferences(obj, catalog);
    }
    $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonRetrocycle = retrocycle;
})();

});

parcelRegister("3j512", function(module, exports) {

$parcel$export(module.exports, "default", () => $2687097d5145937a$export$2e2bcd8739ae039);
/*
// Be sure to include popper.min.js before Bootstrap’s JavaScript
import * as Popper from "@popperjs/core";
import { createPopper } from '@popperjs/core';
window.Popper = Popper;
window.createPopper = createPopper;
*/ //import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';
//import './node_modules/pdfjs-dist/build/pdf.mjs';
//import { getDocument } from "./node_modules/pdfjs-dist/legacy/build/pdf.mjs";

var $346VI = parcelRequire("346VI");
parcelRequire("a7Paw");

var $iuVXB = parcelRequire("iuVXB");

var $hkmmp = parcelRequire("hkmmp");

var $9hg18 = parcelRequire("9hg18");

var $fWhbk = parcelRequire("fWhbk");

var $60OaQ = parcelRequire("60OaQ");

var $iiLdM = parcelRequire("iiLdM");
window.Store = (0, $hkmmp.default);
window.Node = (0, $fWhbk.default);
window.uniqolor = (0, (/*@__PURE__*/$parcel$interopDefault($iiLdM)));
if (window.DrDoc !== undefined) console.warn('Lib Duplicate: DrDoc');
function $2687097d5145937a$export$2e2bcd8739ae039() {}
// DrDoc wird global in DrDoc.Init() gesetzt
// window.DrDoc = DrDoc;
window.Split = (0, $60OaQ.default);
// --
// Dr.DOC
// Requires: DrDocWeb, Node, Store
// --
$2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId = function(sourceElement, archiveName, newWindow) {
    if (newWindow === true) return 'system/mask-info';
    var elem = null;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/mask-searchfields|content', sourceElement);
    // Modal VOR den anderen
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/mask|content', sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/mask-info|content', sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName + '|dataset', sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content|' + archiveName + '|dataset', sourceElement);
    //elem = 'system/mask|content';
    if (elem == undefined || elem == null) //return 'system/list|content|' + archiveName + '|dataset';
    return 'system/mask|content';
    else return elem;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId = function(sourceElement, archiveName, newWindow, forceList) {
    if (newWindow === true) return 'system/list-info';
    var elem = null;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName, sourceElement);
    if (forceList === true) return 'system/list|content|' + archiveName;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-info|content', sourceElement);
    // Kanban Dr.DOC Theme
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content|' + archiveName, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban2|content|' + archiveName, sourceElement);
    // Kanban Default Theme
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban2|content', sourceElement);
    if (elem == undefined || elem == null) //return 'system/list|content|' + archiveName;
    return 'system/list-info|content';
    else return elem;
};
$2687097d5145937a$export$2e2bcd8739ae039.LoadListWebNodeComponent = function(getObj) {
    // Manche Object Properties können werst aufgelöst werden, wenn syst/list geladen wurde (z.B. "targetElement: DrDoc.GetListNodeId(..)")
    // daher als Funktion übergeben
    if (getObj === undefined || getObj === null) {
        console.log('DrDoc.LoadListWebNodeComponent: obj is undefined');
        return undefined;
    }
    let obj = typeof getObj === 'function' ? getObj() : getObj;
    // Wenn targetContainerElement #template_drdoc_main existiert, Soll system/list aufgerufen werden, um im normalen Listen Context (Archiv wählen etc) zu bleiben.
    let targetContainerElement = document.querySelector('#template_drdoc_main');
    let targetElement = (0, $fWhbk.default).GetElement(obj.targetElement, obj.sourceElement);
    //let targetNodeId = DrDoc.GetListNodeId(obj.sourceElement, obj.archiveName, obj.newWindow);
    if (targetContainerElement !== undefined && targetContainerElement !== null) // Main Dr.DOC Container exisitiert
    {
        if (targetElement == undefined || targetElement == null) {
            // Target Element wurde nicht gefunden
            // Type String für targetElement bedeutet, dass das List Element nicht gefunden wurde
            // => 'system/list' in Main Dr.DOC Container laden
            console.log('DrDoc.LoadListWebNodeComponent: system/list laden..');
            return (0, $fWhbk.default).LoadComponent({
                nodeId: 'system/list',
                sourceElement: obj.sourceElement,
                targetElement: targetContainerElement,
                getData: {}
            }).then(function(result) {
                obj = typeof getObj === 'function' ? getObj(targetContainerElement) : getObj;
                console.log('DrDoc.LoadListWebNodeComponent: system/list wurde geladen', ' / obj.targetElement: ', obj.targetElement);
                //if (!DrDocWeb.IsNullOrEmpty(obj.targetElement) && typeof obj.targetElement === 'string')
                //{
                //    obj.targetElement = DrDoc.GetListNodeId(null, obj.getData.archive);
                //}
                obj.targetElement = 'system/list';
                console.log('DrDoc.LoadListWebNodeComponent: system/list wurde geladen', ' / obj: ', obj);
                // 'system/list' sollte jetzt existieren
                $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
                return (0, $fWhbk.default).LoadComponent(obj);
            });
        }
    }
    console.log('DrDoc.LoadListWebNodeComponent: Node.LoadComponent direkt laden: ', obj.targetElement, ' | ', targetElement);
    //obj.targetElement = targetContainerElement;
    //obj.nodeId = 'system/home';
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent(obj);
};
/*DrDoc.GetListTemplateName = function (sourceElement) {
    // system/list | content | wfmain | TODOLISTE | 19735
    let searchTemplateName = '_DEFAULT_';
    //let nodeId = rowElem;
    let nodeIdOrig = Node.GetNodeId(sourceElement);
    if (!DrDocWeb.IsNullOrEmpty(nodeIdOrig)) {
        let nodeIdSegments = nodeIdOrig.split('|');
        if (nodeIdSegments.length > 3) {
            searchTemplateName = nodeIdSegments[3];
        }
        //let nodeId = nodeIdSegments.join('|');
        //console.log('DrDoc.UpdateDatasetRow', nodeIdOrig, " => ", nodeId);
    }
    return searchTemplateName;
};*/ $2687097d5145937a$export$2e2bcd8739ae039.GetListDatasetID = function(sourceElement) {
    var nodeName_selected = (0, $fWhbk.default).GetNodeId(sourceElement);
    var nodeNameSegments_selected = nodeName_selected.split('|');
    var documentId_selected = nodeNameSegments_selected[nodeNameSegments_selected.length - 1];
    return documentId_selected;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate = function(sourceElement, archiveName) {
    let selectedSearchTemplate = (0, $346VI.default).kvp_get(sourceElement, 'searchresult', 'value', null, null, true);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate['searchtemplate'])) {
        //console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate kvp 1 strict true: ', selectedSearchTemplate);
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list/' + archiveName + '/selected-searchtemplate', selectedSearchTemplate['searchtemplate']);
        return selectedSearchTemplate['searchtemplate'];
    }
    /*selectedSearchTemplate = DrDocWeb.kvp_get(sourceElement, 'searchtemplate', 'value', null, null, false);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !DrDocWeb.IsNullOrEmpty(selectedSearchTemplate['searchtemplate']))
    {
        console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate kvp 2 strict false: ', selectedSearchTemplate);
        DrDoc.configDevice.set('view/list/' + archiveName + '/selected-searchtemplate', selectedSearchTemplate['searchtemplate']);
        return selectedSearchTemplate['searchtemplate'];
    }*/ let configSearchTemplate = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list/' + archiveName + '/selected-searchtemplate', '_DEFAULT_');
    //console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate config: ', configSearchTemplate);
    return configSearchTemplate;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetSearchFieldSelection = function(sourceElement, archiveName) {
    // verwendete Feld Auswahlen laden aus DatasetListContainerWebNode
    //let selectedSearchTemplate2 = DrDocWeb.kvp_get(sourceElement, 'selection', 'value', null, null, true);
    //let selectedSearchTemplate3 = DrDocWeb.kvp_get(sourceElement, 'searchtemplate', 'value', null, null, true);
    //let selectedSearchTemplate4 = DrDocWeb.kvp_get(sourceElement, 'recursive-query', 'value', null, null, true);
    let selectedSearchTemplate = (0, $346VI.default).kvp_get(sourceElement, 'searchresult', 'value', null, null, true);
    //console.log('DrDoc.GetSearchFieldSelection: ', selectedSearchTemplate, ' / ', selectedSearchTemplate2, ' / ', selectedSearchTemplate3, ' / ', selectedSearchTemplate4);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate['fieldselection'])) return selectedSearchTemplate['fieldselection'];
    else return '';
};
// DOM Node
$2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal = function(sourceElement, archiveName, byIdGetRow, documentIdOrig) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement, null);
    let elem = undefined;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-default|content', sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list-2|content');
    let selectedSearchTemplate = $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(sourceElement, archiveName);
    let documentId = documentIdOrig;
    if (byIdGetRow) {
        if (!(0, $346VI.default).IsNullOrEmpty(documentId) || documentId != 0) documentId = '|' + documentId;
        else console.warn('DrDoc.GetTableRowElementByIDInternal: es wurde keine "documentId" \xfcbergeben - List Element nicht gefunden!', sourceElement, archiveName, documentIdOrig, '"' + selectedSearchTemplate + '"');
    } else documentId = '';
    // list-info.content ist DatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content|' + archiveName + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-info|content' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content', sourceElement);
    // list-thes.content ist DatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content|' + archiveName + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-thes|content' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content', sourceElement);
    // list-thes.content ist MultiArchiveDatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content|' + archiveName + '|zusatzinfo', sourceElement);
    if ((elem == undefined || elem == null) && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate)) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName + '|' + selectedSearchTemplate + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName + '|_DEFAULT_' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content', sourceElement);
    if ((elem == undefined || elem == null) && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate)) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content|' + archiveName + '|' + selectedSearchTemplate + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban2|content' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_search' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_fav' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_his' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_recent' + documentId, sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list|content|'+archiveName + '|_DEFAULT_');
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|dataset-list-content', sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list-2|content');
    if (elem === undefined || elem === null) {
        if (sourceElement == undefined || sourceElement == null) {
            console.warn('DrDoc.GetTableRowElementByIDInternal: List Element nicht gefunden! / archiveName: ', archiveName, ' / byIdGetRow: ', byIdGetRow, ' / documentId: ', documentId, ' / documentIdOrig: ', documentIdOrig, ' / selectedSearchTemplate: "' + selectedSearchTemplate + '" / sourceElement: ', sourceElement);
            return undefined;
        } else // Nochmal ohne source element probieren
        return $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal(undefined, archiveName, byIdGetRow, documentIdOrig); //, isZusatzInfo);
    }
    //console.log('DrDoc.GetTableRowElementByIDInternal', elem, archiveName, byIdGetRow, documentIdOrig, '"' + selectedSearchTemplate + '"');
    return elem;
};
$2687097d5145937a$export$2e2bcd8739ae039.Home = function(sourceElement) {
    //DrDoc.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Dr.DOC Home',
        //sourceElement: sourceElement,
        //targetElement: document.querySelector('#template_drdoc_main'),
        //nodeId: 'system/home',
        //nav: 'push',
        nodeId: 'system/home',
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.Desktop = function(sourceElement) {
    //DrDoc.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Dr.DOC Desktop',
        //sourceElement: sourceElement,
        //targetElement: document.querySelector('#template_drdoc_main'),
        //nodeId: 'system/desktop',
        //nav: 'push',
        nodeId: 'system/desktop',
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.GetDataset = function(sourceElement, archiveName, documentIdField, documentId, mode, ignoreUnloadEvent) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    //if (typeof node === 'string')
    //{
    //    if (mode !== undefined && mode.length > 0)
    //        nodeId = 'system/mask-' + mode + '|content';
    //    else
    //        nodeId = 'system/mask|content';
    //}
    /*if (DrDocWeb.IsMobile())
    {
        nodeId = null;
    }*/ return (0, $fWhbk.default).LoadComponent({
        title: 'Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id_field: documentIdField === undefined || documentIdField === null ? '' : documentIdField,
            id: documentId === undefined || documentId === null ? '' : documentId,
            mode: mode,
            thes: false //true
        },
        ignoreUnloadEvent: ignoreUnloadEvent
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.ButtonFn = function(sourceElement, archiveName, documentIdField, documentId, fieldName, tableRow, mode, fnStr, hasDocument) {
    // Immer|Kontext,123,Rechendef Ausf.;Parameter
    var fnArgs = fnStr.split(';');
    if (fnArgs == null || fnArgs == undefined || fnArgs.length < 3) {
        console.error('DrDoc.ButtonFn: Bad Buttonfunction', fnStr);
        (0, $346VI.default).Modal('ButtonFn', `Bad Function "${fnStr}".`);
        return;
    }
    var fnExecContext = fnArgs[0];
    var fnNr = fnArgs[1];
    var fnName = fnArgs[2];
    var fnValue = fnArgs[3];
    //let form = DrDocWeb.GetElement(sourceElement, 'form');
    // form[fnValue].value
    let postData = {};
    let form = (0, $fWhbk.default).ParseFormData(sourceElement, null, postData, true, false);
    console.log('ButtonFn', sourceElement, archiveName, documentIdField, documentId, fieldName, tableRow, mode, fnStr, ' / Form: ', form, postData, postData[fnValue]);
    switch(fnNr){
        // 391: Feld drucken
        // 400: Vorblättern
        // 401: Zurückblättern
        // 306: Datenübergabe
        // 308: drucken
        // 126: DS kopieren
        // 403: DS löschen
        // 515: ersetzen
        // 405: Dokument anzeigen
        // 180: Export Ascii
        // 541: Dok. exportieren
        // 402: Speichern
        // 230: Abbrechen
        // 182: Import ASCII
        // 189: Dokument neu
        // 724: Auto. Thes. ausführen
        // 725: DS aktualisieren
        // 55556: Kenntnisnahme
        // 2200: Kalenderneueingabe
        // 3200: Kalenderexport
        case '405':
            // Btn. Dok. anzeigen
            //DrDoc.MaskShowDocument(sourceElement, archiveName, documentId);
            $2687097d5145937a$export$2e2bcd8739ae039.WfGetDataset(sourceElement, true, true);
            break;
        case '332':
        case '434':
            // E-Mail
            $2687097d5145937a$export$2e2bcd8739ae039.ButtonFnEmail(sourceElement, archiveName, documentIdField, documentId, postData[fnValue], hasDocument);
            break;
        case '445':
            // Tel wählen
            window.open('tel:' + postData[fnValue]);
            break;
        case '606':
            // Website
            window.open(postData[fnValue].replaceAll('|', '; '));
            break;
        case '723':
            // Rechendef ausführen
            $2687097d5145937a$export$2e2bcd8739ae039.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'calc', true);
            break;
        default:
            (0, $346VI.default).Modal('ButtonFn', `Function "${fnName}", Nr. "${fnNr}" not Implemented yet!`);
            break;
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.ButtonFnPrintGen = function(_sourceElement, archiveName, documentIdField, documentId, hasDocument) {
    let elemId = 'elem-' + (0, $346VI.default).RandomChars(12); //sourceElement.getAttribute('id');
    let retHtml = ``;
    hasDocument = !(0, $346VI.default).IsNullOrEmpty(documentId) && +documentId > 0 && hasDocument === true;
    // Dokument aus Metadaten generieren und archivieren
    // Dokument aus Metadaten als Anhang per E-Mail versenden
    retHtml += `

        F\xfcr ZUGFeRD PDF + XML anklicken.<br/>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--format_pdf" value="1" ${hasDocument ? '' : 'checked'} />
            <label class="form-check-label d-block" for="${elemId}--format_pdf">PDF</label>
        </div>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--format_xml" value="1" ${hasDocument ? '' : 'checked'} />
            <label class="form-check-label d-block" for="${elemId}--format_xml">XML</label>
        </div>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_html" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_html">File HTML ver\xf6ffentlichen</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_doc" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_doc">File Dokument ver\xf6ffentlichen</label>
        </div>

        <br /><br />

        <button type="button" class="btn btn-success btn-sm" onclick="window['_dd_btn_fn_action_${elemId}'](this);">
            Aktionen ausf\xfchren (z.B. versenden) &nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>
        `;
    retHtml += `
        `;
    console.log('Generate Doc Button 1: ', _sourceElement, archiveName);
    let modal = (0, $346VI.default).Modal('Dokument generieren', retHtml);
    window['_dd_btn_fn_action_' + elemId] = function(sourceElement) {
        console.log('Generate Doc Button 2: ', sourceElement, archiveName);
        return (0, $fWhbk.default).LoadComponent({
            title: 'Dokument generieren (Vorschau)',
            sourceElement: sourceElement,
            targetElement: 'system/rec-out|content|archive-' + archiveName,
            view: 'None',
            //newWindow: true,
            getData: {
                archive: archiveName,
                id_field: !(0, $346VI.default).IsNullOrEmpty(documentIdField) ? documentIdField : $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD,
                id: documentId,
                archive_doc: true,
                email: false,
                email_att: false,
                email_value: '',
                file_html: document.getElementById(elemId + '--file_html').checked,
                file_doc: document.getElementById(elemId + '--file_doc').checked,
                format_pdf: document.getElementById(elemId + '--format_pdf').checked,
                format_xml: document.getElementById(elemId + '--format_xml').checked,
                log: true
            }
        }).then(function(win) {
            modal.hide();
            /*setTimeout(function(){
                DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'get', true);
            }, 1000);*/ setTimeout(function() {
                $2687097d5145937a$export$2e2bcd8739ae039.GetDataset(_sourceElement, archiveName, documentIdField, documentId, 'get', true);
            }, 3500);
        });
    };
};
$2687097d5145937a$export$2e2bcd8739ae039.ButtonFnEmail = function(_sourceElement, archiveName, documentIdField, documentId, value, hasDocument, nodeIdPath) {
    if ((0, $346VI.default).IsNullOrEmpty(nodeIdPath)) nodeIdPath = 'system/rec-out';
    let elemId = 'elem-' + (0, $346VI.default).RandomChars(12);
    let retHtml = ``;
    hasDocument = !(0, $346VI.default).IsNullOrEmpty(documentId) && +documentId > 0 && hasDocument === true;
    // Dokument aus Metadaten generieren und archivieren
    // Dokument aus Metadaten als Anhang per E-Mail versenden
    retHtml += `
<button type="button" class="btn btn-primary btn-sm" onclick="window.open('mailto:${value}');">E-Mail verfassen (lokale App)</button>

<br />
<hr>
<br />

<form onsubmit="window['_dd_btn_fn_action_${elemId}'](this); return false;">

<label class="form-label">Empf\xe4nger E-Mail-Adresse:
<input type="email" class="form-control" placeholder="Empf\xe4nger E-Mail &quot;${value}&quot; \xfcberschreiben" id="${elemId}--email-address" value="${value}">
</label>

<br /><br />

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--email" value="1" checked />
            <label class="form-check-label d-block" for="${elemId}--email"><b>E-Mail versenden</b></label>
        </div>
        <div class="ms-4">
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--email_att" value="1" checked />
            <label class="form-check-label d-block" for="${elemId}--email_att">Ein <b>Dokument als Anhang</b> per <b>E-Mail versenden</b></label>
        </div>
        </div>
        
<br />

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_html" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_html">File HTML ver\xf6ffentlichen</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_doc" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_doc">File Dokument ver\xf6ffentlichen</label>
        </div>

        <br /><br />

        <button type="submit" class="btn btn-success btn-sm">
            Aktionen ausf\xfchren (z.B. versenden) &nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>
</form>
        `;
    retHtml += `
        `;
    console.log('Send Mail Button 1: ', _sourceElement, archiveName);
    let modal = (0, $346VI.default).Modal('E-Mail senden', retHtml);
    window['_dd_btn_fn_action_' + elemId] = function(sourceElement) {
        let sendEmailAtt = document.getElementById(elemId + '--email_att').checked === true;
        console.log('Send Mail Button 2: ', sourceElement, archiveName);
        return (0, $fWhbk.default).LoadComponent({
            title: 'E-Mail versenden (Vorschau)',
            sourceElement: sourceElement,
            //targetElement: 'system/rec-out|content|archive-' + archiveName,
            targetElement: nodeIdPath + '|content|archive-' + archiveName,
            view: 'None',
            //newWindow: true,
            getData: {
                archive: archiveName,
                id_field: !(0, $346VI.default).IsNullOrEmpty(documentIdField) ? documentIdField : $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD,
                id: documentId,
                archive_doc: false,
                zugferd: false,
                email: document.getElementById(elemId + '--email').checked,
                email_value: document.getElementById(elemId + '--email-address').value,
                email_att: sendEmailAtt,
                file_html: document.getElementById(elemId + '--file_html').checked,
                file_doc: document.getElementById(elemId + '--file_doc').checked,
                log: true
            }
        }).then(function(win) {
            modal.hide();
            // Fenster schließen, da existierender DS angezeigt werden soll
            if (win !== undefined) win.close();
            setTimeout(function() {
                $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocument(_sourceElement, archiveName, documentId);
            }, 500);
        });
    };
};
$2687097d5145937a$export$2e2bcd8739ae039.SignForm = function(_sourceElement, archiveName, documentIdField, documentId) {
    let elemId = 'elem-' + (0, $346VI.default).RandomChars(12);
    let retHtml = ``;
    let hasDocument = !(0, $346VI.default).IsNullOrEmpty(documentId) && +documentId > 0;
    //DrDoc.MaskGetDocumentUrlByField(archiveName, documentIdField, documentId, page, sign, sign_create, sign_pos, sign_text_rel, sign_align)
    retHtml += `

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--new" value="1" />
            <label class="form-check-label d-block" for="${elemId}--new">Dieses Dokument als Vorlage verwenden und neues Dokument erstellen.</label>
        </div>
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--preset" value="" />
            <label class="form-label d-block" for="${elemId}--preset">Feldvorbelegung</label>
        </div>
        
        <br /><br />

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_x" value="10%" />
            <label class="form-label d-block" for="${elemId}--pos_x">Position X</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_y" value="80%" />
            <label class="form-label d-block" for="${elemId}--pos_y">Position Y</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_w" value="55%" />
            <label class="form-label d-block" for="${elemId}--pos_w">Breite</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_h" value="80pt" />
            <label class="form-label d-block" for="${elemId}--pos_h">H\xf6he</label>
        </div>

        <br /><br />

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--sign_text_rel" value="Unterschrift;Unterschrift XYZ" />
            <label class="form-label d-block" for="${elemId}--sign_text_rel">Referenz Text</label>
        </div>

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--sign_align" value="top" />
            <label class="form-label d-block" for="${elemId}--sign_align">Align</label>
        </div>

        <br /><br />

        <button type="button" class="btn btn-success btn-sm" onclick="window['_dd_action_${elemId}'](this);">
            Aktionen ausf\xfchren&nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>

            <input type="text" class="form-control" id="${elemId}--result" value="" />
        `;
    retHtml += `
        `;
    let modal = (0, $346VI.default).Modal('Signatur Link erstellen', retHtml);
    window['_dd_action_' + elemId] = function(sourceElement) {
        let url = $2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField(archiveName, documentIdField, documentId, 0, true, document.getElementById(elemId + '--new').checked, document.getElementById(elemId + '--preset').value, document.getElementById(elemId + '--pos_x').value + ';' + document.getElementById(elemId + '--pos_y').value + ';' + document.getElementById(elemId + '--pos_w').value + ';' + document.getElementById(elemId + '--pos_h').value, document.getElementById(elemId + '--sign_text_rel').value, document.getElementById(elemId + '--sign_align').value);
        document.getElementById(elemId + '--result').value = url;
        console.log('Generate Sign Doc Link 2: ', sourceElement, archiveName, url);
    };
};
$2687097d5145937a$export$2e2bcd8739ae039.Thesaurus = function(sourceElement, archiveName, documentId, fieldName, tableRow, mode, append, thesNew, sourceElemIsTargetElem) {
    //let nodeId = 'system/list-thes|content';
    const newWindow = true;
    let nodeId = sourceElemIsTargetElem ? sourceElement : newWindow == true ? 'system/list-thes|content' : $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    let field = $2687097d5145937a$export$2e2bcd8739ae039.GetField(archiveName, fieldName);
    /*let form = DrDocWeb.GetElement(sourceElement, 'form');
    if (form != null && form != undefined)
    {
        console.log('Thes.', form.beforeunload, form.onbeforeunload, form, sourceElement);
        sourceElement.beforeunload = undefined;
        form.beforeunload = undefined;
        window.onbeforeunload = undefined;
    }*/ //let confirmMsg = true;
    //if (thesNew === undefined || thesNew === null)
    //    thesNew = false;
    //if (thesNew)
    return (0, $fWhbk.default).LoadComponent({
        title: "Thesaurus f\xfcr das Feld " + (field != null && field != undefined ? field.Label + ' (' + field.Name + ')' : fieldName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            mode: 'thes',
            //source_mode: mode,
            archive: archiveName,
            field: fieldName,
            row: tableRow === undefined || tableRow === null ? 0 : tableRow,
            recursive: 'new',
            append: append,
            'tree-sub': true,
            //'thes-confirm': confirmMsg,
            'thes-new': thesNew === undefined || thesNew === null ? false : thesNew,
            source: {
                //thes: true,
                mode: mode,
                archive: archiveName,
                field: fieldName,
                row: tableRow === undefined || tableRow === null ? 0 : tableRow,
                //thes_id: (documentId === undefined || documentId === null ? '' : documentId),
                id: documentId === undefined || documentId === null ? '' : documentId,
                append: append
            }
        },
        ignoreUnloadEvent: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.ThesaurusDropdown = function(sourceElement, archiveName, documentId, fieldName) {
    if (sourceElement.options.length > 2) return;
    return (0, $fWhbk.default).LoadComponent({
        title: 'Dropdown',
        sourceElement: sourceElement,
        targetElement: sourceElement,
        getData: {
            archive: archiveName,
            id: documentId,
            mode: 'thes-dropdown',
            thes: true,
            field: fieldName
        },
        ignoreLoadEvent: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.Zusatzinfo = function(sourceElement, archiveName, documentId, fieldName, tableRow, mode, newWindow, sourceElemIsTargetElem) {
    //let nodeId = 'system/list-info|content';
    //if (DrDocWeb.IsNullOrEmpty(nodeId))
    let nodeId = sourceElemIsTargetElem ? sourceElement : newWindow == true ? 'system/list-info' : 'system/list-info|content';
    //let nodeId = 'system/list-info|content';
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, archiveName, true);
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, '_zusatzinfo_');
    //let zusatzArchiveName = DrDoc.GetArchiveSession(archiveName).FieldSessions[fieldName].Zusatzinfo.ZusatzArchive.Archive.SimpleName;
    //DrDoc.configUser.set('view/selected-archive', zusatzArchiveName);
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, zusatzArchiveName, true);
    //console.log('SOURCE ZUSATZ INFO', zusatzArchiveName, nodeId);
    let field = $2687097d5145937a$export$2e2bcd8739ae039.GetField(archiveName, fieldName);
    /*if (newWindow === true)
    {
        window.open()
    }
    else
    {
        DrDocWeb.ModalClose(sourceElement);
    }*/ var ret = (0, $fWhbk.default).LoadComponent({
        title: "Zusatzinfo f\xfcr das Feld " + (field != null && field != undefined ? field.Label + ' (' + field.Name + ')' : fieldName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            mode: 'info',
            //source_mode: mode,
            archive: archiveName,
            field: fieldName,
            row: tableRow === undefined || tableRow === null ? 0 : tableRow,
            recursive: 'new',
            'tree-sub': true,
            source: {
                //thes: true,
                mode: mode,
                archive: archiveName,
                field: fieldName,
                row: tableRow === undefined || tableRow === null ? 0 : tableRow,
                id: documentId === undefined || documentId === null ? '' : documentId,
                append: false
            }
        },
        formFieldsOr: false,
        newWindow: newWindow
    });
    return ret;
};
$2687097d5145937a$export$2e2bcd8739ae039.OnFormInit = function(sourceElement, archiveName, documentId, mode, lockedDocumentId) {
    var formHasChanged = false;
    //console.log('Init Mask ', sourceElement, archiveName, documentId, mode, lockedDocumentId, documentId === lockedDocumentId);
    // get, lock, 
    if (mode != 'form-searchfields' && mode != 'form-create' && mode != 'unlock-only') {
        var onFormInputChanged = function(e2) {
            //console.log('Input has changed!', formElem[0]);
            //formElem.attr('data-changed', 'true');
            formHasChanged = true;
        };
        //$(sourceElement).find('input').on('change', onFormInputChanged);
        //$(sourceElement).find('textarea').on('change', onFormInputChanged);
        //$(sourceElement).find('select').on('change', onFormInputChanged);
        sourceElement.querySelectorAll('input').forEach(function(elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        sourceElement.querySelectorAll('textarea').forEach(function(elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        sourceElement.querySelectorAll('select').forEach(function(elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        var beforeunloadFn = function(e2) {
            //DrDoc.CloseAllDocumentWnd();
            //console.log('..beforeunloadFn..'); //, this, e2);
            //console.log('Sollen die Änderungen in der Maske verworfen verden?', this);
            let ret = false;
            if (window.onbeforeunload == null || window.onbeforeunload == undefined) {
                //console.log('Nix machen, da Thes.!');
                if (this == window || this == document) return undefined;
                else return true;
            }
            // Wenn das Formular nicht geändert wurde und noch kein DS gelockt ist bzw. der geladene DS der gelockte ist,
            // dann abbrechen
            if (!formHasChanged && (lockedDocumentId <= 0 || lockedDocumentId == documentId)) {
                //console.log('Nix machen!');
                if (this == window || this == document) return undefined;
                else return true;
            }
            if (e2 != undefined && this == window || this == document) {
                console.log('beforeunloadFn - preventDefault');
                e2.preventDefault();
            }
            console.log('beforeunloadFn - Confirm Unlock', archiveName, documentId, mode, lockedDocumentId, documentId === lockedDocumentId);
            if (!formHasChanged) {
                //if (this == window)
                //	return 'Soll der von Ihnen gesperrte Datensatz freigegeben werden?';
                //ret = confirm('Soll der von Ihnen gesperrte Datensatz freigegeben werden?');
                ret = true;
                (e2 || window.event).returnValue = 'EVENT: Sollen der von Ihnen gesperrte Datensatz freigegeben werden?';
            } else {
                ret = confirm("Sollen die \xc4nderungen im Datensatz verworfen und freigegeben verden?");
                (e2 || window.event).returnValue = "EVENT: Sollen die \xc4nderungen im Datensatz verworfen und freigegeben verden?";
            }
            if (ret) {
                console.log('beforeunloadFn - freigeben');
                if (sourceElement !== null && sourceElement !== undefined) sourceElement.beforeunload = undefined;
                window.onbeforeunload = undefined;
                // Datensatz entsperren, wenn einer vorliegt
                if (lockedDocumentId >= 0) $2687097d5145937a$export$2e2bcd8739ae039.UnlockOnlyDataset(sourceElement, archiveName, lockedDocumentId);
                return true;
            } else {
                console.log('beforeunloadFn - bearbeiten');
                // Maske einblenden, damit man sie entsperren kann
                $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset(archiveName);
                return false;
            }
        };
        //window.addEventListener("beforeunload", beforeunloadFn);
        window.onbeforeunload = beforeunloadFn;
        if (sourceElement !== null && sourceElement !== undefined) // wenn die Funktion "beforeunload" true zurück gibt, wird der neue Node geladen.
        sourceElement.beforeunload = beforeunloadFn;
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.OnFormSubmit = function(sourceElement, archiveName, documentId, mode) {
    //console.log('DrDoc.OnFormSubmit 1: ', mode, sourceElement);
    sourceElement = (0, $346VI.default).GetClosestForm(sourceElement);
    console.log('Form submitted..');
    if (!sourceElement.checkValidity()) {
        //event.preventDefault();
        //event.stopPropagation();
        sourceElement.classList.add('was-validated');
        console.warn('DrDoc.OnFormSubmit: ', 'Form has Invalid Field-Values!');
    } else {
        //event.preventDefault();
        //event.stopPropagation();
        sourceElement.classList.add('was-validated');
        //console.log('DrDoc.OnFormSubmit 2: ', sourceElement, archiveName, documentId, mode);
        if (mode == 'searchfields' || (0, $fWhbk.default).GetElement('system/mask-searchfields|content') !== undefined) return $2687097d5145937a$export$2e2bcd8739ae039.SearchFields(sourceElement, archiveName);
        else if (mode == 'create' || mode == 'form-create') return $2687097d5145937a$export$2e2bcd8739ae039.CreateDataset(sourceElement, archiveName);
        else if (mode == 'create-new') return $2687097d5145937a$export$2e2bcd8739ae039.CreateDataset(sourceElement, archiveName, true);
        else if (mode == 'create-form') return $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null); // data, presetName, newWindow)
        else return $2687097d5145937a$export$2e2bcd8739ae039.SaveDataset(sourceElement, archiveName, documentId);
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm = function(sourceElement, archiveName, data, presetName, newWindow) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archive, data, presetName);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName, newWindow);
    var getObj = {
        archive: archiveName,
        mode: 'form-create',
        preset: presetName === undefined || presetName === null ? '' : presetName
    };
    if (sourceElement == null || sourceElement == undefined) return (0, $fWhbk.default).LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: null,
        targetElement: nodeId,
        getData: getObj,
        postData: data,
        newWindow: newWindow
    });
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset(archiveName);
    $2687097d5145937a$export$2e2bcd8739ae039.DatasetListUnselectItem(sourceElement, archiveName);
    //Node.SetFormFieldGetData(getObj, data);
    return (0, $fWhbk.default).LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getObj,
        postData: data //(data != null && data != undefined ? data : undefined)
    }).then((data)=>{
    //console.log('CreateDatasetForm (=> geladen): ', archiveName, 'form-create', sourceElement);
    // Wenn der Datensatz geladen wurde, Modal wieder schließen.
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.CreateDataset = function(sourceElement, archiveName, newWindow) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //let nodeId = 'system/mask-create|content';
    //if (DrDocWeb.IsNullOrEmpty(nodeId))
    //    nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName, newWindow);
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            mode: 'create'
        },
        //postData: { }
        closeModalAfter: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsForm = function(sourceElement, archiveName) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsForm(sourceElement, archive);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    let nodeId = 'system/mask-searchfields|content';
    //let nodeId = 'system/mask-searchfields|content|' + archiveName;
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Feldsuche im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            view: 'Search',
            archive: archiveName,
            mode: 'form-searchfields'
        },
        closeModalBefore: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchFields = function(sourceElement, archiveName, data, newWindow) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    let getObj = {
        archive: archiveName,
        mode: 'searchfields'
    };
    // Feldsuche als GET
    //let postObj = null;
    (0, $fWhbk.default).SetFormFieldGetData(getObj, data);
    // Feldsuche als POST
    //let postObj = data;
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Feldsuche im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        //sourceElement: sourceElement,
        //targetElement: DrDoc.GetListNodeId(sourceElement, archiveName, newWindow),
        nodeId: $2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId(sourceElement, archiveName, newWindow, true),
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: getObj,
        postData: data == undefined || data == null ? undefined : {},
        writeToGetData: true,
        formFieldsOr: true,
        newWindow: newWindow,
        nav: 'push',
        // Childs aus Modal nicht entfernen, da es Formulardaten enthält
        closeModalBefore: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsInfo = function(sourceElement, archiveName, data, newWindow) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    // newWindow == null || newWindow == undefined ||
    let nodeId = newWindow == true || sourceElement == undefined || sourceElement == null ? 'system/list-info' : $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    let getObj = {
        archive: archiveName,
        mode: 'searchfields',
        recursive: 'new',
        'tree-sub': true,
        nav: 'push'
    };
    //Node.SetFormFieldGetData(getObj, data);
    return (0, $fWhbk.default).LoadComponent({
        title: 'Feldsuche im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName) + '',
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getObj,
        postData: data,
        formFieldsOr: true,
        newWindow: newWindow
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal = function(sourceElement, archiveName, nodeId, title) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archive, nodeId, title);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //console.log('DrDoc.SearchTemplateForm: ', sourceElement);
    return (0, $fWhbk.default).LoadComponent({
        title: title,
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName
        },
        closeModalBefore: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchPresetForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/preset|content', 'Datensatz erstellen mit Feldvorbelegung');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchTemplateForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/search-template|content', 'Vorlagensuche');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/search|content', 'Suche');
};
$2687097d5145937a$export$2e2bcd8739ae039.SelectArchiveForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/select-archive|content', "Archiv w\xe4hlen");
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchTemplate = function(sourceElement, archiveName, templateName) {
    //if (archiveName === undefined || archiveName === null)
    //    archiveName = DrDoc.configDevice.get('view/selected-archive');
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchTemplate(sourceElement, archive, templateName);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //let nodeId = 'system/list|content';
    /*return DrDoc.LoadListWebNodeComponent(function(sourceElement2){ return {
        title: 'Vorlagensuche',
        sourceElement: sourceElement,
        targetElement: DrDoc.GetListNodeId((sourceElement2 ? sourceElement2 : sourceElement), archiveName),
        getData: {
            archive: archiveName,
            mode: 'template',
            value: templateName,
            //searchTemplateName: templateName,
            search: '',
            content_substring: false
        },
        postData: {},
        nav: 'push',
        closeModalBefore: true,
    };}).then(DrDoc.SetViewInit);*/ $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Vorlagensuche',
        nodeId: $2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId(sourceElement, archiveName, false, true),
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: {
            archive: archiveName,
            mode: 'template',
            value: templateName,
            //searchTemplateName: templateName,
            search: '',
            content_substring: false
        },
        postData: {},
        //nav: 'push',
        closeModalBefore: true
    });
/*.then(async function () {
        await DrDoc.SetViewInit();
        setTimeout(function(){
            DrDoc.UpdateViewMode();
        }, 4500);
        setTimeout(function(){
            DrDoc.SetViewList();
        }, 2*4500);
        //DrDoc.updateMainMenuExpansion();
    });*/ //}).then(DrDoc.SetViewInit);
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchToDo = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archiveName, 'TODOLISTE', '', 'Hypersuche To Do');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchInbox = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archiveName, 'INBOX', '', 'Hypersuche Posteingang');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchHyper = function(sourceElement, archiveName, hyperName, hyperSearchText, title) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archive, hyperName, hyperSearchText, title);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    /*return DrDoc.LoadListWebNodeComponent(function(){ return {
        title: title,
        //sourceElement: sourceElement,
        //targetElement: 'system/list',
        sourceElement: document.querySelector('#template_drdoc_main'),
        targetElement: document.querySelector('#template_drdoc_main'),
        getData: { archive: archiveName, mode: 'hyper', value: hyperName, search: hyperSearchText },
        nav: 'push',
    };}).then(function () {
        DrDoc.SetViewInit();
        DrDoc.updateMainMenuExpansion();
        DrDoc.SearchCountElement();
        progressBarModal.close();
    });*/ $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: title,
        progressTitle: `Starte Hypersuche ${hyperName}..`,
        //sourceElement: sourceElement,
        //sourceElement: 'system/list', //DrDoc.GetListNodeId(sourceElement, archiveName),
        //sourceElement: document.querySelector('#template_drdoc_main'),
        //targetElement: document.querySelector('#template_drdoc_main'),
        //sourceElement: document.querySelector('#template_drdoc_main'),
        nodeId: 'system/list',
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: {
            archive: archiveName,
            mode: 'hyper',
            value: hyperName,
            search: hyperSearchText
        }
    }).then(function() {
        $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
        $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
        $2687097d5145937a$export$2e2bcd8739ae039.SearchCountElement();
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchText = function(sourceElement, archiveName, searchText) {
    //if (archiveName === undefined || archiveName === null)
    //    archiveName = DrDoc.configDevice.get('view/selected-archive');
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchText(sourceElement, archive, searchText);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Datensatz-Liste',
        //sourceElement: sourceElement,
        //targetElement: DrDoc.GetListNodeId(sourceElement, archiveName),
        nodeId: $2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId(sourceElement, archiveName, false, true),
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: {
            archive: archiveName,
            mode: 'textretrieval',
            value: searchText
        },
        //nav: 'push',
        closeModalBefore: true
    }).then($2687097d5145937a$export$2e2bcd8739ae039.SetViewInit);
};
$2687097d5145937a$export$2e2bcd8739ae039.TreeSearchRecursive = function(sourceElement, archiveName, targetNodeID) {
    return $2687097d5145937a$export$2e2bcd8739ae039.ActionRecursive(sourceElement, archiveName, targetNodeID, 'searchfields');
};
$2687097d5145937a$export$2e2bcd8739ae039.ActionRecursive = function(sourceElement, archiveName, targetNodeID, mode, getDataEx) {
    let searchData = {
        archive: archiveName,
        recursive: false,
        mode: mode,
        page: 0,
        tree: false,
        'tree-sub': true
    };
    (0, $346VI.default).kvp_get(sourceElement, targetNodeID, 'search', 'field_', searchData, true);
    (0, $346VI.default).kvp_get(sourceElement, targetNodeID, 'recursive', '', searchData, false);
    /*if (DrDocWeb.IsNullOrEmpty(mode) && !DrDocWeb.IsNullOrEmpty(searchData['recursive-query'])) {
        searchData = searchData['recursive-query'];
        if (typeof searchData === 'string')
            searchData = DrDocWeb.QueryStrToObject(searchData);
    }*/ if ((0, $346VI.default).IsNullOrEmpty(mode) && (0, $346VI.default).IsNullOrEmpty(searchData['field_' + $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD])) {
        searchData['mode'] = 'searchfields';
        searchData['field_' + $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD] = '*';
    }
    if (getDataEx !== undefined && getDataEx !== null) Object.assign(searchData, getDataEx);
    console.log('DrDoc.TreeSearchRecursive: ', searchData);
    //Object.assign(searchData, );
    return (0, $fWhbk.default).LoadComponent({
        nav: false,
        sourceElement: sourceElement,
        targetElement: targetNodeID,
        getData: searchData,
        postData: {}
    });
};
// Datensatz-Zeile aktualisieren
$2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow = function(sourceElement, archiveName, documentId) {
    var rowElem1 = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (rowElem1 === undefined || rowElem1 === null || rowElem1 === false) {
        console.warn('DrDoc.UpdateDatasetRow: rowElem not found: ', sourceElement, archiveName, documentId);
        return undefined;
    }
    //setTimeout(function(){
    // system/list | content | wfmain | TODOLISTE | 19735
    //let searchTemplateName2 = DrDoc.GetListTemplateName(rowElem);
    //let searchTemplateName = f(rowElem, archiveName);
    //console.log('DrDoc.UpdateDatasetRow', rowElem, sourceElement, archiveName, documentId, searchTemplateName); //, ' / ', searchTemplateName2);
    let getData = {
        archive: archiveName,
        searchTemplateName: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(rowElem1, archiveName),
        //id: (documentId === undefined || documentId === null ? '' : documentId),
        //mode: 'get'
        mode: 'searchfields',
        selection: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchFieldSelection(rowElem1, archiveName),
        recursive: 'new',
        tree: false,
        'tree-sub': false
    };
    getData['field_' + $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD] = documentId;
    return (0, $fWhbk.default).LoadComponent({
        exact: true,
        title: 'Datensatz Zeile im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: rowElem1,
        targetElement: rowElem1,
        getData: getData,
        postData: {}
    });
//}, 5000);
};
$2687097d5145937a$export$2e2bcd8739ae039.AiDataset = function(sourceElement, archiveName, documentIdField, documentId, aiMode, aiValue) {
    //let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);
    let nodeId = (0, $fWhbk.default).GetNodeId($2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName)) + '|ai';
    console.log('DrDoc.AiDataset: ', 'node-id:', nodeId, $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName));
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz KI Q&A im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            mode: 'get',
            autolock: false,
            id_field: documentIdField,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            ai: aiMode,
            value: (0, $346VI.default).IsNullOrEmpty(aiValue) ? '' : aiValue
        }
    }).then(function() {
        setTimeout(function() {
            /*//let valueElem = document.getElementsByName('value');
                let valueElem = DrDocWeb.GetElement(sourceElement, 
                console.log('DrDoc.AiDataset: ', valueElem);
                if (valueElem && valueElem.length > 0)
                {
                    valueElem[0].scrollIntoView();
                }*/ //let objectSelector = DrDocWeb.GetElement(document, '.modal-body:has(#ai-chat-container)');
            let objectSelector = document.querySelector('.modal-body:has(#ai-chat-container)');
            if (objectSelector) //console.log('DrDoc.AiDataset: ', objectSelector, objectSelector2, document.querySelector('#ai-chat-container'));
            objectSelector.scrollTo({
                top: objectSelector.scrollHeight
            });
            // ai-chat-input
            let input = document.querySelector('#ai-chat-input');
            if (input) {
                input.scrollIntoView();
                input.focus();
            }
        }, 100);
    });
};
/*DrDoc.AiDatasetChatRequest = function (sourceElement, archiveName, documentId, chatReqText) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName) + '|ai';

    return Node.LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz KI Q&A im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId),
            mode: 'set',
            ai: 'init-chat-doc',
        }
    });
};*/ // Datensatz
$2687097d5145937a$export$2e2bcd8739ae039.SaveDataset = function(sourceElement, archiveName, documentId) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    //let elem = Node.GetElement(nodeId);
    //elem.beforeunload = undefined;
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz speichern im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            mode: 'set'
        },
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        closeModalAfter: true
    }).then((data)=>{
        //console.log('SaveDataset (=> geladen): ', archiveName, 'set', sourceElement);
        $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
    });
};
$2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset = function(sourceElement, archiveName, documentId, action, text, getData) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    if (getData === undefined || getData === null) getData = {};
    getData.archive = archiveName;
    getData.id = (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId;
    getData.mode = action;
    return (0, $fWhbk.default).LoadComponent({
        title: text + ' im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getData,
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        closeModalAfter: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.DeleteDataset = function(sourceElement, archiveName, documentId) {
    if (window.confirm("Soll der Datensatz gel\xf6scht werden?")) return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'delete', "Datensatz l\xf6schen").then((data)=>{
        //DrDoc.UpdateDatasetRow(sourceElement, archiveName, documentId);
        var rowElem1 = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
        if (rowElem1 === undefined || rowElem1 === null || rowElem1 === false) {
            console.warn('DrDoc.DeleteDataset: rowElem not found: ', sourceElement, archiveName, documentId);
            return undefined;
        }
        rowElem1.classList.add('text-decoration-line-through'); // x-d-none');
    });
    else return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.PresetDataset = function(sourceElement, archiveName, documentId, presetName) {
    return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'preset', 'Datensatz (vor)belegen', {
        preset: presetName
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.LockDataset = function(sourceElement, archiveName, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'lock', 'Datensatz sperren');
};
$2687097d5145937a$export$2e2bcd8739ae039.UnlockDataset = function(sourceElement, archiveName, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'unlock', 'Datensatz entsperren');
};
$2687097d5145937a$export$2e2bcd8739ae039.UnlockOnlyDataset = function(sourceElement, archiveName, documentId) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    return (0, $346VI.default).SendGet('model/crud', {
        archive: archiveName,
        action: 'unlock',
        id: documentId
    });
};
// 
$2687097d5145937a$export$2e2bcd8739ae039.CallbackFormInternal = function(sourceElement, nodeId, argValue, title, callbackFn) {
    let fnId = 'form_' + (0, $346VI.default).RandomChars(12);
    // in "system/select-wf-user|content" ruft der User das Callback über ein Promise auf
    return (0, $fWhbk.default).LoadComponent({
        title: !(0, $346VI.default).IsNullOrEmpty(title) ? title : 'Form',
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            // archive: archiveName,
            value: argValue,
            callback: fnId
        }
    }).then(function() {
        // Modal mit "system/select-wf-user|content" wurde geladen
        //console.log('DrDoc.CallbackFormInternal: then');
        return new Promise((resolve, reject)=>{
            // Promise resolve als Callback für Modal setzen
            // console.log('DrDoc.CallbackFormInternal: then->myPromise2');
            window.DrDoc[fnId] = resolve;
        }).then(function(obj) {
            // Modal schließen und Objekt an Callback übergeben
            // console.log('DrDoc.CallbackFormInternal: then->myPromise2->callbackFn', obj);
            (0, $346VI.default).ModalClose(obj.sourceElement);
            // bereinigen
            delete window.DrDoc[fnId];
            return callbackFn(obj);
        }).catch(function() {
            // bereinigen
            delete window.DrDoc[fnId];
        });
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser = async function(sourceElement) {
    let formData = (0, $346VI.default).GetClosestFormToObject(sourceElement, $2687097d5145937a$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
    let WFT_Aufgabe = (0, $iuVXB.default).GetTableRows(formData['WFT_Aufgabe']);
    let WFT_Bearbeiter = (0, $iuVXB.default).GetTableRows(formData['WFT_Bearbeiter']);
    let WFT_erledigt_von = (0, $iuVXB.default).GetTableRows(formData['WFT_erledigt_von']);
    // "modeMulti" gibt an, ob WfSelectUser rekursiv aufgerufen werden soll
    // Es sollen alle %R% aber nur das erste "?" und das erste "[{}]" ersetzt werden
    let modeMulti = true;
    let rowIndexIst = WFT_erledigt_von.length;
    // Workflow-Bearbeiter wählen
    let rowIndexFound = WFT_Bearbeiter.indexOf('%R%');
    if (rowIndexFound === -1) {
        modeMulti = false;
        // Workflow-Bearbeiter zur Laufzeit wählen
        // "?" als zu wählender Soll-Bearbeiter ist nur zulässig, wenn es den nächsten Schritt betrifft
        rowIndexFound = WFT_Bearbeiter.indexOf('?');
        if (rowIndexFound === -1) {
            rowIndexFound = WFT_Bearbeiter.indexOf('[{}]');
            if (rowIndexFound === -1) // kein zu wählender Bearbeiter gefunden
            return true;
            else if (rowIndexFound > rowIndexIst + 1) // zu wähelnder Bearbeiter ist zu weit hinten
            //console.log('DrDoc.WfSelectUser: zu wähelnder Bearbeiter ist zu weit hinten: ', rowIndexFound, rowIndexIst, WFT_Bearbeiter, ' / ', WFT_erledigt_von);
            return true;
        } else if (rowIndexFound > rowIndexIst + 1) // zu wähelnder Bearbeiter ist zu weit hinten
        //console.log('DrDoc.WfSelectUser: zu wähelnder Bearbeiter ist zu weit hinten: ', rowIndexFound, rowIndexIst, WFT_Bearbeiter, ' / ', WFT_erledigt_von);
        return true;
    } else modeMulti = true;
    let formData2 = (0, $346VI.default).GetClosestForm(sourceElement);
    console.log('DrDoc.WfSelectUser: select WF: rowIndexFound: ', rowIndexFound, ' / ', formData2['WFT_Bearbeiter'][rowIndexFound].value);
    // Benutzer wählen
    // erst mit WF-Erledigung fortfahren, wenn alle %R% entfernt wurden
    return $2687097d5145937a$export$2e2bcd8739ae039.CallbackFormInternal(sourceElement, 'system/select-wf-user|content', WFT_Aufgabe[rowIndexFound], `Workflow-Schritt "${WFT_Aufgabe[rowIndexFound]}": Bitte WF-Namen und Benutzer w\xe4hlen`, function(obj) {
        console.log('DrDoc.WfSelectUser/CallbackFormInternal: Username/Group selected: ', obj);
        // neuen WF Namen und Bearbeiter setzen
        formData2['WFT_Aufgabe'][rowIndexFound].value = obj.wfName;
        formData2['WFT_Bearbeiter'][rowIndexFound].value = obj.username;
        // bei %R% erneut ausführen, bis alle angegeben wurden, bis kein %R% mehr gefunden wird
        if (modeMulti) return $2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser(sourceElement);
        else return true;
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfCompleteDataset = async function(sourceElement, archiveName, documentId) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    console.log('DrDoc.WfCompleteDataset: ', sourceElement, archiveName, documentId);
    // Alle WF-Soll-User angeben für %R%
    let ret1 = await $2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser(sourceElement);
    console.log('DrDoc.WfCompleteDataset:  Ret Done!', ret1);
    //return;
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Workflow erledigen im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            mode: 'wf-complete'
        },
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        closeModalAfter: true
    }).then((data)=>{
        //console.log('WfCompleteDataset (=> geladen): ', archiveName, 'wf-complete', sourceElement);
        var prem1 = $2687097d5145937a$export$2e2bcd8739ae039.OnSelectNextDataset(sourceElement, archiveName, '', documentId);
        if (prem1 != undefined && prem1 != null) prem1.then(function(d) {
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
        });
        else {
            console.log('DrDoc.WfCompleteDataset: OnSelectNextDataset ERROR');
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfInsertDataset = async function(sourceElement, archiveName, documentId, insertIndex, mode) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    let formData = (0, $346VI.default).GetClosestForm(sourceElement);
    let WFT_Aufgabe = formData['WFT_Aufgabe'];
    let WFT_Bearbeiter = formData['WFT_Bearbeiter'];
    let taskElem = WFT_Aufgabe[insertIndex];
    let trElem = (0, $346VI.default).GetClosestTag(taskElem, 'tr');
    //console.log('Task Elem Row: ', trElem);
    // Workflow-Schritte anfügen
    // das %R% wird in WfSelectUser angegeben.
    if (mode === 1) {
        // Weiterleiten
        $2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow(trElem);
        WFT_Aufgabe[insertIndex + 1].value = 'Weiterleiten';
        WFT_Bearbeiter[insertIndex + 1].value = '?';
    } else if (mode === 2) {
        // Weiterleiten mit Rücklauf
        $2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow(trElem);
        WFT_Aufgabe[insertIndex + 1].value = 'Weiterleiten';
        WFT_Bearbeiter[insertIndex + 1].value = '?';
        $2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow(trElem);
        WFT_Aufgabe[insertIndex + 2].value = "R\xfccklauf";
        WFT_Bearbeiter[insertIndex + 2].value = $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName).UserSession.Username;
    }
    // Alle WF-Soll-User auswählen für %R%
    let ret1 = await $2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser(sourceElement);
    console.log('DrDoc.WfInsertDataset:  Ret Done!', ret1);
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Workflow erledigen im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            mode: 'set'
        }
    }).then((data)=>{
        $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfGetDataset = function(sourceElement, getDS, getDoc) {
    let formData = (0, $346VI.default).GetClosestFormToObject(sourceElement, $2687097d5145937a$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
    let WF_LinkArchiv = formData['WF_LinkArchiv'];
    let WF_LinkGUID = formData['WF_LinkGUID'];
    if ((0, $346VI.default).IsNullOrEmpty(WF_LinkArchiv)) return false;
    if ((0, $346VI.default).IsNullOrEmpty(WF_LinkGUID)) return false;
    console.log('DrDoc.WfGetDataset: Form:  ', formData);
    let archive_arr = (0, $iuVXB.default).GetTableRows(WF_LinkArchiv);
    let guid_arr = (0, $iuVXB.default).GetTableRows(WF_LinkGUID);
    // Nach Archiv gruppieren
    let searchObj = {};
    for(let i in archive_arr){
        let archiveName = archive_arr[i];
        let guid = guid_arr[i];
        if ((0, $346VI.default).IsNullOrEmpty(archiveName)) continue;
        if ((0, $346VI.default).IsNullOrEmpty(guid)) continue;
        archiveName = archiveName.toLowerCase();
        if (searchObj[archiveName] === undefined) searchObj[archiveName] = [
            guid
        ];
        else searchObj[archiveName].push(guid);
    }
    console.log('DrDoc.WfGetDataset: WF Doks. 3: ', searchObj);
    for(let archiveName in searchObj){
        if (searchObj[archiveName].length > 0 && getDoc) {
            // Dokument laden, wenn nur 1 Dokument
            console.log('DrDoc.MaskShowDocumentByField: ', archiveName, 'DrDocGUID', searchObj[archiveName]);
            $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField(null, archiveName, 'DrDocGUID', searchObj[archiveName].join('|'));
        }
        //else
        //{
        if (getDS) // Feldsuche in neuem Fenster
        $2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsInfo(null, archiveName, {
            DrDocGUID: searchObj[archiveName].join('|')
        }, true);
    //}
    }
    return true;
};
// DrDoc.ID_FIELD = 'Dokument-Nr.';
// DrDoc.TABLE_ROW_SPLITTER = String.fromCharCode(1);
$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD = (0, $iuVXB.default).ID_FIELD;
$2687097d5145937a$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER = (0, $iuVXB.default).TABLE_ROW_SPLITTER;
$2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocument = function(sourceElement, archiveName, documentId) {
    $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField(sourceElement, archiveName, $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD, documentId);
};
$2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField = function(archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align) {
    //let url = `/model/document?archive=${archiveName}&action=get&original=false&id_field=${fieldName}&id=${fieldValue}`;
    /*let url = '/model/document?' + DrDocWeb.ObjectToQueryStr({
        archive: archiveName,
        action: 'get',
        original: false,
        id_field: fieldName,
        id: fieldValue
    });*/ //let url = `/node/system/mask|content|${archiveName}|dataset|Bild?mode=get&archive=${archiveName}&id_field=${fieldName}&id=${fieldValue}`;
    //let url = `/node/system/mask|content|Bild?mode=get&archive=${archiveName}&id_field=${fieldName}&id=${fieldValue}&extern=true`;
    let url = '/node/system/mask|content|Bild?' + (0, $346VI.default).ObjectToQueryStr({
        mode: 'get',
        archive: archiveName,
        id_field: fieldName,
        id: fieldValue,
        extern: 'true',
        autolock: false,
        page: page,
        sign: sign,
        sign_create: sign_create,
        sign_create_preset: sign_create_preset,
        sign_pos: sign_pos,
        sign_text_rel: sign_text_rel,
        sign_align: sign_align
    });
    return url;
};
$2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField = function(sourceElement, archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align) {
    let url = $2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField(archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align);
    return $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentUrl(sourceElement, archiveName, url);
};
$2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentUrl = function(sourceElement, archiveName, url) {
    // wenn es einWF Instanz ist, dann ausführen
    if (sourceElement !== undefined && sourceElement !== null) {
        let wfGetDs = $2687097d5145937a$export$2e2bcd8739ae039.WfGetDataset(sourceElement, false, true);
        if (wfGetDs === true) return true;
    }
    let wnd = $2687097d5145937a$export$2e2bcd8739ae039.GetDocumentWnd(archiveName, true, url);
///if (wnd.location == undefined || DrDocWeb.IsNullOrEmpty(wnd.location.href) || wnd.location.href == 'about:blank')
//    wnd.location.href = url;
//else
//    wnd.location.replace(url);
};
$2687097d5145937a$export$2e2bcd8739ae039.CloseAllDocumentWnd = function() {
    console.log('DrDoc.CloseAllDocumentWnd ', window._docWindow);
    if (window._docWindow == null || window._docWindow == undefined) window._docWindow = {};
    for(var wndId in window._docWindow){
        var wnd = window._docWindow[wndId];
        if (wnd != undefined && wnd != null) wnd.close();
        delete window._docWindow[wndId];
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.GetDocumentWnd = function(archiveName, create, url) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) archiveName = '_DEFAULT_';
    else archiveName = 'wnd-' + (0, $346VI.default).ChecksumCyrb53(archiveName).toString();
    if ((0, $346VI.default).IsNullOrEmpty(url)) url = 'about:blank';
    /*console.log('DrDoc.GetDocumentWnd: Open: ', url);
    if (url == 'about:blank')
    {
        return;
    }*/ var setWndPos = function(wndObj) {
        //var left = DrDocWeb.FindLeftScreenBoundry(wndObj);
        //var top = DrDocWeb.FindTopScreenBoundry(wndObj);
        //console.log('setWndPos: / left: ', left, ' / top: ', top);
        //return;
        if (wndObj == undefined || wndObj == null) return false;
        //DrDoc.configDevice.set(`window/${archiveName}/ext`, 2);
        //console.log('DrDoc.GetDocumentWnd: RESIZE', archiveName, `window/${archiveName}/ext`, DrDoc.configDevice.get(`window/${archiveName}/ext`));
        try {
            /*if (wndObj.outerWidth !== undefined)
                console.log('DrDoc.GetDocumentWnd: RESIZE: WxH: ', wndObj, +wndObj.outerWidth, wndObj.outerHeight);

            if (wndObj.screenX !== undefined)
                console.log('DrDoc.GetDocumentWnd: RESIZE: XxY: ', wndObj, wndObj.screenX, wndObj.screenY, ' / ', wndObj.top, wndObj.left);
            */ let w = 500;
            let h = w * 3.0 / 2.0;
            if (wndObj.width !== undefined) {
                w = wndObj.width;
                h = wndObj.height;
            } else if (wndObj.outerWidth !== undefined) {
                w = wndObj.outerWidth;
                h = wndObj.outerHeight;
            }
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/w`, w);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/h`, h);
            /*if (wndObj.left !== undefined)
            {
                DrDoc.configDevice.set(`window/${archiveName}/x`, wndObj.left);
                DrDoc.configDevice.set(`window/${archiveName}/y`,wndObj.top);
            }
            else if (wndObj.screenLeft !== undefined)
            {
                DrDoc.configDevice.set(`window/${archiveName}/x`, wndObj.screenLeft);
                DrDoc.configDevice.set(`window/${archiveName}/y`,wndObj.screenTop);
            }*/ //DrDoc.configDevice.set(`window/${archiveName}/x`, DrDocWeb.FindLeftScreenBoundry(wndObj));
            //DrDoc.configDevice.set(`window/${archiveName}/y`, DrDocWeb.FindTopScreenBoundry(wndObj));
            var left = (0, $346VI.default).FindLeftScreenBoundry(wndObj);
            var top = (0, $346VI.default).FindTopScreenBoundry(wndObj);
            //var left = wndObj.screenX + (wndObj.screen.width / 2) - (w / 2);
            //var top = (wndObj.screen.height / 2) - (h / 2);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/x`, left);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/y`, top);
            if (wndObj.screen !== undefined) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/ext`, wndObj.screen.isExtended);
        } catch (ex) {
        //console.warn('setWndPos', ex, wnd);
        }
    };
    // window._docWindow[ARCHIVE]
    // Falls das Dokument-Fenster bereits geladen wurde, diese wiederverwenden, damit der Focus nicht verloren geht.
    if (window._docWindow == null || window._docWindow == undefined) window._docWindow = {};
    //console.log('DrDoc.GetDocumentWnd(1): ', window._docWindow, archiveName, create);
    let wnd = window._docWindow[archiveName];
    if (wnd !== undefined && wnd !== null) {
        //if (wnd.document.readyState !== 'complete')
        /*if (wnd.document !== undefined && wnd.document.readyState !== 'complete')
        {
            return DrDoc.GetDocumentWnd(archiveName, create, url);
        }*/ //if (wnd.closed === false)
        //    console.log('DrDoc.GetDocumentWnd A: SHOW 1 exit/ret', archiveName, ' closed: ', wnd.closed, wnd);
        //else
        //    console.log('DrDoc.GetDocumentWnd A: SHOW 2 close/open', archiveName, ' closed: ', wnd.closed, wnd);
        /*if (wnd.closed === true)
        {
            console.log('DrDoc.GetDocumentWnd: Window Reactivate');
            wnd.open('about:blank');
        }*/ //console.log('DrDoc.GetDocumentWnd: Window Reactivate 1 ', wnd, wnd.closed, wnd.width, 'x', wnd.height, ' / x', wnd.left, ', y', wnd.top);
        // A: Fenster immer schließen
        //wnd.close();
        // B: Fenster wiederverwenden, wenn es noch offen ist
        if (wnd.closed === undefined || wnd.closed === false) {
            setWndPos(wnd);
            //console.log('DrDoc.GetDocumentWnd A: Reuse ', archiveName, wnd, wnd.closed);
            if (!(0, $346VI.default).IsNullOrEmpty(url)) wnd.location.replace(url);
            // Im Fullscreen das neue Fenster immer fokussieren
            if ((0, $346VI.default).WindowIsMaximized()) {
                console.log('############ WINDOW FOCUS');
                wnd.focus();
            //setTimeout(function(){wnd.focus();},500);
            }
            return wnd;
        }
        console.log('DrDoc.GetDocumentWnd A: Try Close ', archiveName, wnd, wnd.closed);
        try {
            wnd.close();
        //wnd.close('','_parent','');
        } catch (ex) {}
        delete window._docWindow[archiveName];
    //wnd = null;
    }
    if (create) {
        //if (wnd !== undefined && wnd !== null)
        //console.log('DrDoc.GetDocumentWnd: Window reactivate 2 ', wnd, wnd.closed, wnd.width, 'x', wnd.height, ' / x', wnd.left, ', y', wnd.top);
        //console.log('DrDoc.GetDocumentWnd: OPEN', archiveName);
        var newDocWindow = window.open((0, $346VI.default).IsNullOrEmpty(url) ? 'about:blank' : url, //'Dokument_' + archiveName,
        //'Dokument (' + archiveName + ')',
        //'_self',
        '_blank', 'height=700,width=500,status=no,toolbar=no,location=no,menubar=no,scrollbars=yes,modal=yes'); //,alwaysRaised=yes,alwaysLowered=yes,dependent=yes');
        var setWindowPropsEvent = function(e) {
            if ($2687097d5145937a$export$2e2bcd8739ae039.configDevice.has(`window/${archiveName}/w`)) {
                //console.log('DrDoc.GetDocumentWnd Reset: ', archiveName, DrDoc.configDevice.get(`window/${archiveName}/w`));
                if (newDocWindow.screen != undefined) newDocWindow.screen.isExtended = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/ext`);
                //newDocWindow.left = +DrDoc.configDevice.get(`window/${archiveName}/x`);
                //newDocWindow.top = +DrDoc.configDevice.get(`window/${archiveName}/y`);
                //newDocWindow.leftScreenBoundry = +DrDoc.configDevice.get(`window/${archiveName}/x`);
                //newDocWindow.topScreenBoundry = +DrDoc.configDevice.get(`window/${archiveName}/y`);
                newDocWindow.moveTo($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/x`), $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/y`));
                //newDocWindow.moveBy(DrDoc.configDevice.get(`window/${archiveName}/x`), DrDoc.configDevice.get(`window/${archiveName}/y`));
                //newDocWindow.width = +DrDoc.configDevice.get(`window/${archiveName}/w`);
                //newDocWindow.height = +DrDoc.configDevice.get(`window/${archiveName}/h`);
                newDocWindow.resizeTo($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/w`), $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/h`));
            //if (newDocWindow.screen != undefined)
            //    newDocWindow.screen.isExtended = DrDoc.configDevice.get(`window/${archiveName}/ext`);
            }
        };
        window._docWindow[archiveName] = newDocWindow;
        //newDocWindow.postMessage("hello there!", "http://example.com");
        var fnEvent = function(e) {
            //console.log('DrDoc.GetDocumentWnd(load): ', '1:', e, '2:', e.target, '3:', this);
            //setWndPos(e.target);
            //setWndPos(newDocWindow);
            setWndPos(window._docWindow[archiveName]);
        //setWndPos(this);
        };
        setWindowPropsEvent();
        // Bei Änderung Fenster Pos. speichern
        newDocWindow.addEventListener('beforeunload', fnEvent, false);
        //newDocWindow.addEventListener('load', fnEvent);
        newDocWindow.addEventListener('resize', fnEvent);
        newDocWindow.addEventListener('mouseout', fnEvent);
        newDocWindow.addEventListener('close', fnEvent);
        newDocWindow.addEventListener('load', setWindowPropsEvent);
        /*setTimeout(function (e) {
            setWndPos(e.target);
            //setWndPos(newDocWindow);
            //setWndPos(this);
        }, 1000);
        setTimeout(function (e) {
            setWndPos(e.target);
            setWndPos(newDocWindow);
            //setWndPos(this);
        }, 5000);*/ /*var ro = new ResizeObserver(entries => {
            for (let entry of entries) {
              const cr = entry.contentRect;
              setWndPos(cr);
            }
        });
        ro.observe(newDocWindow.document);*/ /*newDocWindow.addEventListener('load', function(e)
        {
            console.log('New Window has been loadad', e, e.target.documentElement);
        }, true);
        mainWindow.focus();
        newDocWindow.blur();*/ //console.log('DrDoc.GetDocumentWnd(2): ', window._docWindow, archiveName, create);
        // Im Fullscreen das neue Fenster immer fokussieren
        if ((0, $346VI.default).WindowIsMaximized()) //console.log('############ WINDOW FOCUS');
        newDocWindow.focus();
        return newDocWindow;
    } else //console.log('DrDoc.GetDocumentWnd: Window delete ', archiveName, wnd);
    //delete window._docWindow[archiveName];
    return undefined;
};
// | ---        | ---      | --- |
// | Mode       | Readonly | OK |
// | ---        | ---      | --- |
// | Extern Wnd | true     | -   |
// | Modal      | true     | -   |
// | Control    | true     | -   |
// | Extern Wnd | false    | -   |
// | Modal      | false    | -   |
// | Control    | false    | -   | 
// | ---        | ---      | --- |
// DrDoc.CreateMarkdownElement('srcelemid', true, 'modal', null, true, false, `Name: (Name)`);
$2687097d5145937a$export$2e2bcd8739ae039.CreateMarkdownElement = function(sourceElement, isReadOnly, viewMode, mdMode, mdForceCreateWnd, mdAutosize, title) {
    let sourceElementOrig = sourceElement;
    if ((0, $346VI.default).IsNullOrEmpty(sourceElement)) {
        console.warn('DrDoc.CreateMarkdownElement: sourceElement == null: ', sourceElement);
        return null;
    }
    if (typeof sourceElement === 'string') sourceElement = document.querySelector(sourceElement);
    if (sourceElement == undefined || sourceElement == null) {
        console.warn('DrDoc.CreateMarkdownElement: sourceElement == null: ', sourceElementOrig);
        return;
    }
    let targetElementId = sourceElement.getAttribute('data-md-id');
    if (sourceElement == undefined || sourceElement == null) {
        console.warn('DrDoc.CreateMarkdownElement: sourceElement == null: ', targetElementId, sourceElement);
        return null;
    //return undefined;
    }
    // zufällige Element ID erstellen
    if ((0, $346VI.default).IsNullOrEmpty(targetElementId)) {
        targetElementId = (0, $346VI.default).RandomChars(12);
        sourceElement.setAttribute('data-md-id', targetElementId);
    }
    // Wenn kein MD-Mode angegeben wurde, dann aus Settings übernehmen
    if (mdMode === undefined || mdMode === null) {
        var mdModeCtrl = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/markdown-ctrl', false);
        var mdModeModal = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/markdown-modal', true);
        //console.log('DrDoc.CreateMarkdownElement: MD-Modal: Mode: ', mdMode, mdModeModal, mdModeCtrl);
        mdMode = mdModeModal === true || mdModeCtrl === true;
    //console.log('DrDoc.CreateMarkdownElement: MD-Modal: Mode 2: ', mdMode);
    }
    var validateElemValue = function(retValue) {
        if (mdMode == true && !(0, $346VI.default).IsNullOrEmpty(retValue)) {
            // keine "<br>" direkt vor einem "<ul>" für Markdown-Text erlauben!
            // da Toast-UI sonst den Text leert
            const lineBreakReplacement = "<br>"; // funktioniert nicht
            //const lineBreakReplacement = "<br/>"; // funktioniert nicht
            //const lineBreakReplacement = "\\"; // funktioniert nicht
            //const lineBreakReplacement = "\\\r\n"; // funktioniert nicht
            //const lineBreakReplacement = "&#10;"; // funktioniert nur zur Anzeige, jedoch nicht wenn man zum Markdown Modus in den WYSIWYG Modus wechselt
            //const lineBreakReplacement = "&#10;\\"; // funktioniert nicht
            //const lineBreakReplacement = "  &#10;"; // <space><space>\n
            //const lineBreakReplacement = '\\\\\\n'; // "\\\n"
            //const lineBreakReplacement = "\\\\\n"; // "\\ \n"
            //const lineBreakReplacement = "<br/>";
            retValue = retValue.replaceAll('<br>', lineBreakReplacement).replaceAll('<br/>', lineBreakReplacement).replaceAll('<br />', lineBreakReplacement);
            retValue = retValue.replaceAll(lineBreakReplacement + '<ul>', '<ul>').replaceAll(lineBreakReplacement + '<ol>', '<ol>');
            retValue = retValue.replaceAll(lineBreakReplacement + '<ul>', '<ul>').replaceAll(lineBreakReplacement + '<ol>', '<ol>');
            // MD Inline Code in Auflistungen verbieten
            // <li>`Test`</li>
            //retValue = retValue.replace(/(?<=\<li.*\>.*)\`([^\`]+)\`(?=.*\<\/li\>)/gi, '$1');
            // Pipe Symbol "|" in Tabellen-Zellen escapen, auch wenn es innerhalb von Inline-Code (z.B. `Code1|Code2`) steht.
            // ab 17.12.2024 eingetragen
            //retValue = retValue.replace(/(?<=\n\|\x20[^\r\n]*\`[^\r\n]*)(?<!\\)(\|)(?=[^\r\n]*\`)/gi, '\\$1');
            //retValue = retValue.replace(/(?<=\n\|\x20.*\`.*)(?<!\\)(\|)(?=.*\`)/gi, '\\$1');
            // ab 06.02.2025
            // retValue = retValue.replace(/(?<=(\x20|\>)\`[^\r\n\`]*)(?<!\\)(\|)(?=[^\r\n\`]*\`(\x20|\<))/gi, '\\$1');
            // ab 20.02.2025
            retValue = retValue.replace(/(?<=\|[^\r\n\|\`\>]*(?:\x20|\>)\`[^\r\n\`]*)(?<!\\)(\|)(?=[^\r\n\`]*\`(\x20|\<))/gi, '\\$1');
            // Pipe Symbol "|" In <li> Auflistungen escapen
            //retValue = retValue.replace(/(?<=\<li[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/li\>)/gi, '\\$1');
            // Pipe Symbol "|" Innerhalb von HTML-Code escapen
            //retValue = retValue.replace(/(?<=\<[a-z]{1,2}[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/[a-z]{1,2}\>)/gi, '\\$1');
            // ab 17.12.2024 ausgetragen
            retValue = retValue.replace(/(?<=\<li[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/li\>)/gi, '\\$1');
            // innerhalb von ```text ...  ``` den Text "```" escapen
            retValue = retValue.replace(/(?<=\n\`\`\`[^\`]*)(?<!\\)(\`\`\`)(?=[^\`]*\`\`\`)/gi, '\`\`\`');
        }
        return retValue;
    };
    var getElemValue = function() {
        //console.log('DrDoc.CreateMarkdownElement: getElemValue: ', sourceElement.value, sourceElement.innerHTML);
        let retValue = '';
        if (!(0, $346VI.default).IsNullOrEmpty(sourceElement.value)) retValue = sourceElement.value;
        else if (!(0, $346VI.default).IsNullOrEmpty(sourceElement.innerHTML)) retValue = sourceElement.innerHTML;
        else if (!(0, $346VI.default).IsNullOrEmpty(sourceElement.innerText)) retValue = sourceElement.innerText;
        return validateElemValue(retValue);
    };
    var contentElement = null;
    if (mdMode == true || viewMode == 'window' || viewMode == 'iframe') {
        // => Markdown Mode
        let url = '/node/system/md?id=' + targetElementId + '&readonly=' + (isReadOnly === true ? 'true' : 'false');
        var mdCom = new BroadcastChannel('md-' + targetElementId);
        //var initValue = sourceElement.value;
        var updateValue = function() {
            //console.log('MD: updateValue Wnd ', getElemValue(), '   //    ', sourceElement.value);
            mdCom.postMessage(getElemValue());
        };
        // rekursion vermeiden
        var evIsActive = true;
        // Textarea/sourceElement updaten, wenn Markdown geändert wird
        mdCom.onmessage = function(event) {
            //console.log('MD: Receive Value', event);
            // textarea updaten
            evIsActive = false;
            sourceElement.value = validateElemValue(event.data);
            evIsActive = true;
        };
        // Markdown updaten, wenn Textarea/sourceElement geändert wird
        sourceElement.addEventListener('change', function(e) {
            if (evIsActive) updateValue();
        });
        if (viewMode == 'window') {
            // Window
            let wnd = $2687097d5145937a$export$2e2bcd8739ae039.GetDocumentWnd('md-' + targetElementId, mdForceCreateWnd === true, url); // + '#' + DrDocWeb.RandomChars(6));
            if (wnd == undefined || wnd == null) {
                console.log('MD Wnd: not found: ', targetElementId);
                // Window existiert nicht
                return null;
            }
            wnd.updateValue = updateValue;
            /*wnd.contentWindow.addEventListener('load', function(e) {
                wnd.updateValue();
            });*/ //wnd.location.href = url + '#' + DrDocWeb.RandomChars(6);
            // Wenn das Fenster bereits geladen wurdem dann direkt Wert updaten, ansonsten im Load-Event laden
            if (wnd && wnd.contentWindow && wnd.contentWindow.document.readyState === 'complete') updateValue();
            else wnd.addEventListener('load', function(e) {
                updateValue();
            });
            wnd.addEventListener('popstate', function(e) {
                console.log('MD Wnd: popstate');
                setTimeout(updateValue, 1000);
            });
            /*wnd.addEventListener('beforeunload', function(e) {
                console.log('MD Wnd: beforeunload');
                setTimeout(updateValue, 4000);
            });
            wnd.addEventListener('unload', function(e) {
                console.log('MD Wnd: unload');
                setTimeout(updateValue, 200);
            });
            updateValue();*/ //setTimeout(updateValue, 100);
            //setTimeout(updateValue, 300);
            setTimeout(updateValue, 2000);
            return wnd;
        } else {
            // Iframe
            contentElement = document.createElement('iframe');
            contentElement.src = url;
            // Textarea verbergen
            //sourceElement.style.display = 'none';
            contentElement.updateValue = updateValue;
            //setTimeout(updateValue, 2600);
            // erst wenn das Element eingebunden wurde, und anschließend die Seite geladen wurde, "postMessage" mit Text übergeben.
            //contentElement.addEventListener('load', function(e0) {
            /*setTimeout(function() {
                updateValue();
                while (contentElement.contentWindow == undefined || contentElement.contentWindow == null)
                {
                    // wait..
                    ;;
                }
                contentElement.contentWindow.addEventListener('load', function(e) {
                    console.log('DrDoc.CreateMarkdownElement / contentElement.contentWindow.addEventListener(load)');
                    updateValue();
                });
                console.log('DrDoc.CreateMarkdownElement / setTimeout');
                updateValue();
            }, 100);*/ contentElement.addEventListener('load', function(e) {
                console.log('DrDoc.CreateMarkdownElement: iframe.addEventListener(load)');
                updateValue();
            });
            //});
            contentElement.id = 'md-iframe-' + targetElementId;
            contentElement.style.outline = 'none';
            contentElement.style.border = 'none';
            contentElement.style.borderStyle = 'none';
            contentElement.style.borderWidth = '0';
            contentElement.frameborder = '0';
            updateValue();
            if (viewMode != 'window' && viewMode != 'modal') {
                if (mdAutosize === true) {
                    //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-main-container');
                    //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-contents');
                    // Readonly in voller Höhe anzeigen
                    if (isReadOnly === true) (0, $346VI.default).IframeAutosize(contentElement, '.ProseMirror');
                    else (0, $346VI.default).IframeAutosize(contentElement, '.ProseMirror', undefined, undefined, '100vw', '90vh');
                }
            //DrDocWeb.IframeAutosize(contentElement, '.ProseMirror.toastui-editor-contents');
            //DrDocWeb.IframeAutosize(contentElement, '');
            /*setTimeout(function(){
                        //DrDocWeb.IframeAutosize(contentElement, '.ProseMirror.toastui-editor-contents');
                        //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor.ww-mode');
                        DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-contents');
                    }, 1000);*/ }
        }
    } else {
        // Text Mode / kein Markdown Mode
        //console.log('DrDoc.CreateMarkdownElement: Element: ', sourceElement);
        var elemValue = getElemValue();
        //console.log('DrDoc.CreateMarkdownElement: Text (no MD): ', elemValue);
        if ((0, $346VI.default).IsNullOrEmpty(elemValue)) elemValue = '';
        //else
        //    elemValue = elemValue.replaceAll('<', '&lt;').replaceAll('>', '&gt;');
        contentElement = document.createElement('div');
        if (isReadOnly) {
            //contentElement.innerHTML = `<pre>${elemValue}</pre>`;
            contentElement.innerHTML = `<pre></pre>`;
            contentElement.querySelector('pre').innerText = elemValue;
        } else {
            //contentElement.innerHTML = `<textarea class="form-control" style="width: 100%; height: 100%;" rows="12" id="${targetElementId}--textarea" onchange="document.getElementById('${targetElementId}').value = this.value;">${elemValue}</textarea>`;
            contentElement.innerHTML = `<textarea class="form-control" style="width: 100%; height: 100%;" rows="12" id="${targetElementId}--textarea"></textarea>`;
            //contentElement.querySelector('textarea').innerText = elemValue;
            contentElement.querySelector('textarea').value = elemValue;
            contentElement.querySelector('textarea').onchange = function(e_t) {
                //document.getElementById(targetElementId).value = e_t.target.value;
                sourceElement.value = e_t.target.value;
            };
        }
    }
    if (viewMode != 'window' && viewMode != 'modal') {
        // sourceElement ausblenden
        sourceElement.style.display = 'none';
        // iframe anhängen
        if (sourceElement.parentNode) {
            if (!(0, $346VI.default).IsNullOrEmpty(contentElement.id)) {
                let contentElementOld = sourceElement.parentNode.querySelector('#' + contentElement.id);
                if (contentElementOld) sourceElement.parentNode.removeChild(contentElementOld);
            }
            sourceElement.parentNode.appendChild(contentElement);
            (0, $346VI.default).IframeAutosize(contentElement, '.ProseMirror', undefined, undefined, '100vw', '100vh');
        }
    }
    if (viewMode == 'modal') {
        if (contentElement.style !== undefined) {
            contentElement.style.width = 'calc(100% + 2rem)';
            contentElement.style.height = 'calc(100% + 1.75rem)';
            contentElement.style.margin = '-1rem -1rem -1rem -1rem';
        }
        (0, $346VI.default).Modal(title, contentElement, {
            //fullScreen: (md === true ? true : false)
            fullScreen: true
        }).show();
    }
    return contentElement;
};
$2687097d5145937a$export$2e2bcd8739ae039.SignIn = function() {
    return (0, $fWhbk.default).LoadComponent({
        title: 'Benutzer anmelden',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'signin',
            ret: window.location.href
        },
        modalOption: {
            static: true,
            fullScreen: false,
            size: 'xl'
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SignInAction = function(formElem) {
    return (0, $fWhbk.default).LoadComponent({
        title: 'Benutzer Anmeldung',
        sourceElement: formElem,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'signin',
            ret: window.location.href
        },
        postData: {
            username: formElem['username'].value,
            password: formElem['password'].value,
            totp: formElem['totp'] != null ? formElem['totp'].value : ''
        },
        requestMethod: 'POST'
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SignOut = function(allSessions) {
    return (0, $fWhbk.default).LoadComponent({
        title: 'Benutzer abmelden',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: allSessions === true ? 'signout-all' : 'signout',
            ret: window.location.href
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.TotpEnroll = function() {
    return (0, $fWhbk.default).LoadComponent({
        title: 'TOTP Enroll',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'totp-enroll',
            ret: window.location.href
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.TotpReset = function() {
    return (0, $fWhbk.default).LoadComponent({
        title: 'TOTP Reset',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'totp-reset',
            ret: window.location.href
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.DevTrust = function(devid) {
    (0, $346VI.default).SetCookie('devsid', devid, 365);
    return (0, $fWhbk.default).LoadComponent({
        title: 'Device Trust',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'dev-trust',
            ret: window.location.href
        }
    });
/*{
        username: elem['username'].value,
        password: elem['password'].value,
        totp: elem['totp'] != null ? elem['totp'].value : '',
        'dev-trust': elem['dev-trust'] != null ? elem['dev-trust'].value : ''
    }*/ };
// --
// Drag n Drop Files / Upload
$2687097d5145937a$export$2e2bcd8739ae039._Document_GetFormDataOnDropInternal = function(ev) {
    $2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragLeaveInternal(ev);
    console.log('DrDoc._Document_GetFormDataOnDropInternal: ', ev);
    return (0, $346VI.default).GetFormDataFromEvent(ev);
};
$2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragOverInternal = function(elem, ev) {
    console.log('DrDoc._Document_OnDragOverInternal');
    //console.log('DragOverHandler: File(s) in drop zone', ev, elem);
    /*if (elem.getAttribute('data-can-drop') != 'true')
    {
        return;
    }*/ // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
    //ev.target.classList.add('drop-hover');
    elem.classList.add('drop-hover');
};
$2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragLeaveInternal = function(ev) {
    if (ev !== undefined) {
        console.log('DrDoc._Document_OnDragLeaveInternal: ', ev.target);
        /*if (ev.target != undefined && ev.target != null && ev.target.getAttribute('data-can-drop') != 'true') {
            return;
        }*/ console.log('DrDoc._Document_OnDragLeaveInternal: ', ev.target.getAttribute('data-can-drop') != 'true', ev.target == this);
        document.querySelectorAll('.drop-hover').forEach(function(elem) {
            elem.classList.remove('drop-hover');
        });
        ev.preventDefault();
    /*if (ev.target)
            ev.target.classList.remove('drop-hover');
        }
        document.querySelectorAll('[ondragover]').forEach(function (elem) {
            elem.classList.remove('drop-hover');
        });*/ }
};
$2687097d5145937a$export$2e2bcd8739ae039.Document_OnDragOver = function(elem, _ev, archiveName, presetName, idFieldName, documentId, aiCreateMode) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    if (elem != undefined && elem.getAttribute('data-can-drop') != 'true') {
        console.log('DrDoc.Document_OnDragOver: elem data-can-drop != true: ', elem);
        return;
    }
    if (_ev != undefined && _ev.target.getAttribute('data-can-drop') != 'true') {
        if (_ev != undefined && _ev.target.parentNode.getAttribute('data-can-drop') != 'true') {
            console.log('DrDoc.Document_OnDragOver: _ev.target data-can-drop != true: ', elem);
            return;
        }
    }
    console.log('DrDoc.Document_OnDragOver', elem);
    // dragover, dragleave, drop
    $2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragOverInternal(elem, _ev);
    //console.log('DrDoc.Document_OnDragOver: on Drag ');
    // a dragged item leaves a valid drop target.
    elem.ondragleave = $2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragLeaveInternal;
    // an item is dropped on a valid drop target.
    elem.ondrop = function(ev) {
        /*if (ev.target.getAttribute('data-can-drop') != 'true')
        {
            return;
        }*/ document.querySelectorAll('.drop-hover').forEach(function(elem) {
            elem.classList.remove('drop-hover');
        });
        //console.log('DrDoc.Document_OnDragOver: File(s) dropped in zone', ev, this, elem);
        var formData = $2687097d5145937a$export$2e2bcd8739ae039._Document_GetFormDataOnDropInternal(ev);
        $2687097d5145937a$export$2e2bcd8739ae039.UploadDocument(ev.target, archiveName, presetName, idFieldName, documentId, aiCreateMode, formData);
    };
/*if (elem.childNodes != null)
    {
        elem.childNodes.forEach(function(childElem)
        {
            //childElem.ondrop = function(_ev2) { return elem.ondrop();
            childElem.ondrop = elem.ondrop;
            childElem.ondragleave = elem.ondragleave;
            childElem.ondragover = function(_ev2) {
                return DrDoc.Document_OnDragOver(elem, _ev2, archiveName, presetName, idFieldName, documentId, aiCreateMode);
            };
        });
    }*/ };
$2687097d5145937a$export$2e2bcd8739ae039.UploadDocumentFile = function(sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, multiple, mimeType, getDocument) {
    // <input type="file" id="fileElem" multiple accept="image/*" style="display:none" />
    var fileElem = document.createElement('input');
    fileElem.style.display = 'none';
    fileElem.setAttribute('type', 'file');
    if (!(0, $346VI.default).IsNullOrEmpty(mimeType)) fileElem.setAttribute('accept', mimeType); //'image/*');
    if (multiple) fileElem.setAttribute('multiple', 'true');
    fileElem.addEventListener("change", function(e) {
        $2687097d5145937a$export$2e2bcd8739ae039.UploadDocument(sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, fileElem, getDocument);
        fileElem.remove();
    }, false);
    fileElem.click();
};
$2687097d5145937a$export$2e2bcd8739ae039.UploadDocument = function(sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, formData, getDocument) {
    console.log(`DrDoc.UploadDocument(sourceElement: ${sourceElement}, archiveName: ${archiveName}, presetName: ${presetName}, idFieldName: ${idFieldName}, documentId: ${documentId}, aiCreateMode: ${aiCreateMode}, formData: ${formData}, getDocument: ${getDocument})`);
    if (formData == undefined || formData == null || formData === false) {
        // kein Dokument vorhanden
        console.log('DrDoc.Document_OnDragOver: elem.ondrop: kein Dokument beim Drop vorhanden');
        return;
    }
    //_ev.preventDefault();
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) {
        console.log('DrDoc.UploadDocument: 2nd order / sel archive / archiveName is empty');
        return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
            return $2687097d5145937a$export$2e2bcd8739ae039.UploadDocument(sourceElement, archive, presetName, idFieldName, documentId, aiCreateMode, formData, getDocument);
        });
    }
    let stateModal = (0, $346VI.default).ModalInfo('', 'Uploading Document...');
    formData = (0, $346VI.default).GetFormDataFromEvent(formData);
    var formGetData = {};
    var formPostData = {};
    (0, $fWhbk.default).ParseFormData(sourceElement, formGetData, formPostData, false);
    //let dsExists = searchNewVersionObj[idFieldName] != undefined && searchNewVersionObj[idFieldName].length > 0 && !DrDocWeb.IsNullOrEmpty(searchNewVersionObj[idFieldName]); // && !DrDocWeb.IsNullOrEmpty(documentId) && documentId != '0';
    let dsExists = !(0, $346VI.default).IsNullOrEmpty(idFieldName) && !(0, $346VI.default).IsNullOrEmpty(documentId) && documentId != '0';
    //let modeCreate = searchNewVersionObj[DrDoc.ID_FIELD].length > 0 && !DrDocWeb.IsNullOrEmpty(documentId) && documentId != '0';
    console.log('DrDoc.UploadDocument: dsExists: ', dsExists);
    let sendCallback = null;
    if (aiCreateMode === true) {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - AI-CREATE: ', formPostData, formData);
        sendCallback = (0, $346VI.default).Send('POST', 'model/document', {
            archive: archiveName,
            action: 'ai-create',
            preset: presetName,
            value: formPostData
        }, formData);
    } else if (dsExists) {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - SET: ', formPostData, formData);
        sendCallback = (0, $346VI.default).Send('POST', 'model/document', {
            archive: archiveName,
            action: 'set',
            id_field: idFieldName,
            id: documentId,
            value: formPostData
        }, formData);
    } else {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - CREATE: ', formPostData, formData);
        //sendCallback = DrDocWeb.Send('POST', 'model/document', { archive: archiveName, action: 'create', preset: presetName, value: formPostData }, formData, 'form');
        sendCallback = (0, $346VI.default).Send('POST', 'model/document', {
            archive: archiveName,
            action: 'create',
            preset: presetName,
            value: formPostData
        }, formData);
    }
    return sendCallback.then(function(reponse_Str) {
        let reponse = (0, $346VI.default).JsonToObject(reponse_Str);
        console.log('DrDoc.UploadDocument: response', reponse);
        if (stateModal) stateModal.close();
        if (reponse.HasError) (0, $346VI.default).ModalError('Upload Fehler', ("Datei konnte nicht erfolgreich hochgeladen werden.\r\n\n" + reponse.Error.Message + "\r\n\n" + reponse.Error.InternalMessage).replaceAll("\n", "\n<br/>\r\n"));
        else {
            //DrDocWeb.ModalOk('Upload Erfolgreich', 'Datei wurde erfolgreich hochgeladen.');
            let searchNewVersionObj = {};
            let uniqueIdFieldsArr = [
                $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD,
                'DokuNr',
                idFieldName
            ];
            for (let uniqueIdField of uniqueIdFieldsArr)if (!(0, $346VI.default).IsNullOrEmpty(uniqueIdField)) searchNewVersionObj[uniqueIdField] = [];
            let resultsArr = null;
            if (reponse.Result != undefined && reponse.Result != null) {
                if (Array.isArray(reponse.Result)) resultsArr = reponse.Result;
                else resultsArr = [
                    reponse.Result
                ];
                resultsArr.forEach(function(obj) {
                    //console.log('DrDoc.UploadDocument: ret: ', obj['DrDocGUID'], obj[DrDoc.ID_FIELD], obj['DokuNr']);
                    //searchNewVersionObj['DrDocGUID'].push(obj['DrDocGUID']);
                    if (!(0, $346VI.default).IsNullOrEmpty(obj['DokuNr']) && searchNewVersionObj['DokuNr'].indexOf(obj['DokuNr']) == -1) searchNewVersionObj['DokuNr'].push(obj['DokuNr']);
                    else if (!(0, $346VI.default).IsNullOrEmpty(obj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD]) && searchNewVersionObj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD].indexOf(obj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD]) == -1) searchNewVersionObj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD].push(obj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD]);
                    for (let uniqueIdField of uniqueIdFieldsArr)if (!(0, $346VI.default).IsNullOrEmpty(uniqueIdField) && !(0, $346VI.default).IsNullOrEmpty(obj[uniqueIdField]) && searchNewVersionObj[uniqueIdField].indexOf(obj[uniqueIdField]) == -1) {
                        searchNewVersionObj[uniqueIdField].push(obj[uniqueIdField]);
                        break;
                    }
                    if (!(0, $346VI.default).IsNullOrEmpty(obj.$ModelType)) {
                        console.log('DrDoc.UploadDocument: Change Archive: ', obj.$ModelType);
                        archiveName = obj.$ModelType;
                    }
                });
            }
            for(let propName in searchNewVersionObj)searchNewVersionObj[propName] = searchNewVersionObj[propName].join('|');
            //console.log('DrDoc.UploadDocument: SearchFields: in ', archiveName, ' / ', searchNewVersionObj);
            //console.log('DrDoc.UploadDocument: SearchFields: in ', archiveName, ' / ', searchNewVersionObj, ' / reponse.Result: ', resultsArr, ' / reponse.Result.length: ', resultsArr.length, ' / getDocument: ', getDocument, ' / ', reponse.Result != undefined && reponse.Result != null && reponse.Result.length == 1);
            if ((getDocument > 0 || getDocument === true) && resultsArr != undefined && resultsArr != null && resultsArr.length == 1) {
                for (let uniqueIdField of uniqueIdFieldsArr)if (!(0, $346VI.default).IsNullOrEmpty(uniqueIdField) && !(0, $346VI.default).IsNullOrEmpty(searchNewVersionObj[uniqueIdField])) {
                    if (getDocument === true || getDocument === 1) return $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField(sourceElement, archiveName, uniqueIdField, searchNewVersionObj[uniqueIdField]);
                    else {
                        let url = $2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField(archiveName, uniqueIdField, searchNewVersionObj[uniqueIdField]);
                        window.location.href = url;
                        return true;
                    }
                }
            }
            return $2687097d5145937a$export$2e2bcd8739ae039.SearchFields(sourceElement, archiveName, searchNewVersionObj, false);
        //DrDoc.GetDataset(elem, archiveName, documentIdField, documentId, 'lock');
        }
    }).catch(function(reponse_Str) {
        if (stateModal) stateModal.close();
        console.error(reponse_Str);
        let reponse = (0, $346VI.default).JsonToObject(reponse_Str);
        (0, $346VI.default).ModalError('Upload Fehler', ('Datei konnte nicht erfolgreich hochgeladen werden.' + (reponse && reponse.Error ? "\r\n\n" + reponse.Error.Message + "\r\n\n" + reponse.Error.InternalMessage : '')).replaceAll("\n", "\n<br/>\r\n"));
    });
};
// --
// Desktop
$2687097d5145937a$export$2e2bcd8739ae039.DesktopAction = function(sourceElement, xmlStr) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    //xmlStr = xmlStr.replaceAll('\\', '&#92;');
    //console.log('DrDoc.DesktopAction: ', xmlStr);
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlStr, "text/xml"); // text/xml application/xml
    //console.log('Desktop 1: ', doc, xmlStr, ' / Src: ', sourceElement);
    let xPathPrefix = 'DesktopSymbol>';
    let treeItemTyp = doc.querySelector(xPathPrefix + 'TreeItemTyp').innerHTML;
    //console.log(treeItemTyp);
    let archiveName = 'LEER';
    let archiveNameNode = doc.querySelector(xPathPrefix + 'ArchivPfad');
    if (archiveNameNode != null) archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveNameNode.innerHTML);
    //console.log(doc, ' / Archive-Path: ', archiveName, ' / Archive-Node: ', archiveNameNode, ' / Src: ', sourceElement);
    //console.log('Desktop 2: ', doc, ' / Archive-Path: ', archiveName, ' / Src: ', sourceElement);
    switch(treeItemTyp){
        case '1':
            break;
        // Archiv wählen
        case '2':
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
            break;
        // Volltextsuche
        case '3':
            let searchText = window.prompt('Volltextsuche in "' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName, archiveName) + '"');
            if (!(0, $346VI.default).IsNullOrEmpty(searchText)) $2687097d5145937a$export$2e2bcd8739ae039.SearchText(sourceElement, archiveName, searchText);
            break;
        // Feldsuche
        case '4':
            $2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsForm(sourceElement, archiveName);
            break;
        // Suchvorlage / Feldsuche mit Vorlage
        case '5':
            let searchTemplateNode = doc.querySelector(xPathPrefix + 'Suchvorlage');
            if (searchTemplateNode) $2687097d5145937a$export$2e2bcd8739ae039.SearchTemplate(sourceElement, archiveName, searchTemplateNode.innerHTML);
            else $2687097d5145937a$export$2e2bcd8739ae039.SearchTemplateForm(sourceElement, null);
            break;
        // Datensatz erstellen
        case '6':
            // Feldvorbelegung
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Neueingebe, Datensatz erstellen
        case '7':
            // Feldvorbelegung
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Scan erstellen als Dok. Definition
        case '8':
            // Feldvorbelegung
            // ScanjobNr
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Neues Dokument
        case '9':
            // Feldvorbelegung
            // ScanjobNr
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Hypersuche Volltext
        case '19':
            let searchTextHyper = window.prompt('Hyper-Volltextsuche in allen Archiven');
            if (!(0, $346VI.default).IsNullOrEmpty(searchTextHyper)) $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archiveName, '', searchTextHyper, 'Hyper-Volltextsuche in allen Archiven');
            break;
        // Workflow Instanz erstellen
        case '12':
            // WfTyp
            // OrgGuid
            (0, $346VI.default).ModalInfo('Desktop Type 12/WF-Instance not implemented yet.');
            break;
        // Export
        case '29':
            // Suchvorlage
            // ReportExportInfo/VorlagenSuche
            // ReportExportInfo/FaExport
            // ReportExportInfo/ZielDateiName
            // ReportExportInfo/DokExport
            // ReportExportInfo/EinzelDateien
            // ReportExportInfo/Ascii
            // ReportExportInfo/FeldTrenner
            // ReportExportInfo/SatzTrenner
            // ReportExportInfo/AbsatzMarke
            (0, $346VI.default).ModalInfo('Desktop Type 29/Export-Def. not implemented yet.');
            break;
        default:
            (0, $346VI.default).ModalInfo('Desktop Type ' + treeItemTyp + ' not implemented yet.');
            break;
    }
    (0, $346VI.default).ModalClose(sourceElement);
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.Client = function(obj) {
    /*let cookie_obj = {
        action: 'cookie'
    };*/ obj['server-url'] = (0, $346VI.default).ServerBase();
    obj['cookie-names'] = [];
    obj['cookie-values'] = [];
    var cookie_prefix_arr = (0, $346VI.default).GetCookiePrefix('uid_');
    if (cookie_prefix_arr != undefined && cookie_prefix_arr.length > 0) for (let cookie of cookie_prefix_arr){
        obj['cookie-names'].push(cookie.name);
        obj['cookie-values'].push(cookie.value);
    /*cookie_obj['name'] = cookie.name;
            cookie_obj['value'] = cookie.value;
            console.log('DrDoc.Client: ', cookie_obj);
            DrDoc.ClientInternal(cookie_obj);*/ }
    let uid_value = (0, $346VI.default).GetCookie('uid');
    if (!(0, $346VI.default).IsNullOrEmpty(uid_value)) {
        obj['cookie-names'].push('uid');
        obj['cookie-values'].push(uid_value);
    /*cookie_obj['name'] = 'uid';
        cookie_obj['value'] = uid_value;
        console.log('DrDoc.Client: ', cookie_obj);
        DrDoc.ClientInternal(cookie_obj);*/ }
    obj['cookie-names'] = obj['cookie-names'].join(';');
    obj['cookie-values'] = obj['cookie-values'].join(';');
    console.log('DrDoc.Client: ', obj['cookie-names'], obj['cookie-values']);
    $2687097d5145937a$export$2e2bcd8739ae039.ClientInternal(obj);
};
$2687097d5145937a$export$2e2bcd8739ae039.ClientInternal = function(obj) {
    window.open('drdoc://' + (0, $346VI.default).ObjectToQueryStr(obj), '_blank');
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.OpenPDF = function(pdfjsLib, url, canvasElem) {
    // If absolute URL from the remote server is provided, configure the CORS
    // header on that server.
    //var url = '{{$_this.Url(false, false)}}';
    // Loaded via <script> tag, create shortcut to access PDF.js exports.
    //var { pdfjsLib } = globalThis;
    // The workerSrc property shall be specified.
    //pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.mjs';
    // Asynchronous download of PDF
    var loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');
        // Fetch the first page
        var pageNumber = 1;
        pdf.getPage(pageNumber).then(function(page) {
            console.log('Page loaded');
            var scale = 1.5;
            var viewport = page.getViewport({
                scale: scale
            });
            // Prepare canvas using PDF page dimensions
            var canvas = canvasElem; //document.getElementById('the-canvas');
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            // Render PDF page into canvas context
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function() {
                console.log('Page rendered');
            });
        });
    }, function(reason) {
        // PDF loading error
        console.error(reason);
    });
};
// --
// Datensatz in Suchergebnisliste Drag n droppen unter Anwednung der Sortierung
$2687097d5145937a$export$2e2bcd8739ae039.ListDragAndDropDataset = function(name, e, archiveName) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //console.log('DrDoc.DragAndDropDataset: ', name, archiveName);
    let elemTarget = (0, $346VI.default).dnd_getElem(name, e.target);
    if (elemTarget == null || elemTarget == undefined) return;
    let elemPrev = elemTarget.previousElementSibling;
    let elemNext = elemTarget.nextElementSibling;
    //DrDoc.DatasetListSelectItem(elemTarget, archiveName, documentId);
    let documentId = $2687097d5145937a$export$2e2bcd8739ae039.GetListDatasetID(elemTarget);
    let elemPrevNodeId = '';
    let elemNextNodeId = '';
    // Beim Drag and Drop eines Datensatzes immer "sortFieldSub" wählen,
    // wenn alle Elemente in der gleichen Liste sind also den selben parentNode haben.
    //let selectedSortFieldName = sortField;
    let selectedSortFieldNames = (0, $346VI.default).dnd_getValue(elemTarget);
    //console.log('DrDoc.ListDragAndDropDataset: Sort by: ', selectedSortFieldNames);
    if (elemPrev != undefined && elemPrev != null) {
        let elemPrevNodeIdArr = (0, $fWhbk.default).GetNodeId(elemPrev).split('|');
        elemPrevNodeId = elemPrevNodeIdArr[elemPrevNodeIdArr.length - 1];
    }
    if (elemNext != undefined && elemNext != null) {
        let elemNextNodeIdArr = (0, $fWhbk.default).GetNodeId(elemNext).split('|');
        elemNextNodeId = elemNextNodeIdArr[elemNextNodeIdArr.length - 1];
    }
    //let searchTemplateName2 = DrDoc.GetListTemplateName(elemTarget);
    return (0, $fWhbk.default).LoadComponent({
        title: 'DragAndDropDataset ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: elemTarget,
        targetElement: elemTarget,
        getData: {
            archive: archiveName,
            mode: 'dragndrop',
            id: documentId,
            id_prev: elemPrevNodeId,
            id_next: elemNextNodeId,
            sort_fields: selectedSortFieldNames,
            searchTemplateName: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(rowElem, archiveName),
            selection: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchFieldSelection(rowElem, archiveName)
        }
    }).then((data)=>{
        //DrDoc.UpdateDatasetRow(elemTarget, archiveName, documentId)
        $2687097d5145937a$export$2e2bcd8739ae039.DatasetSelected(elemTarget, archiveName, '', documentId, 'get');
    });
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.ListSet = function(archiveName, array) {
    $2687097d5145937a$export$2e2bcd8739ae039._datasetList[archiveName] = array;
    console.log('DrDoc.ListSet', $2687097d5145937a$export$2e2bcd8739ae039._datasetList);
};
$2687097d5145937a$export$2e2bcd8739ae039.ListGet = function(archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039._datasetList[archiveName];
};
$2687097d5145937a$export$2e2bcd8739ae039.ListIndexOf = function(archiveName, id) {
    let list = $2687097d5145937a$export$2e2bcd8739ae039.ListGet(archiveName);
    return list.indexOf(id);
};
$2687097d5145937a$export$2e2bcd8739ae039.DatasetListUnselectItem = function(sourceElement, archiveName) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    var tableNodeElem = $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    if (tableNodeElem !== undefined && tableNodeElem !== null) sourceElement = tableNodeElem;
    var old_table_row = (0, $346VI.default).GetElement(sourceElement, 'tr.table-active');
    if (old_table_row != undefined) {
        old_table_row.classList.remove('table-active');
        old_table_row.classList.remove('table-dark');
        old_table_row.classList.remove('bg-primary');
        old_table_row.classList.remove('text-light');
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.DatasetListSelectItem = function(sourceElement, archiveName, documentId) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    if (sourceElement === undefined || sourceElement === window || sourceElement === document) {
        console.warn('DatasetListSelectItem: bad source element');
        return;
    }
    // --
    // Layout automatisch setzen je nach endgerät
    //DrDoc.SetViewDataset();
    /*var old_table_row = DrDocWeb.GetElement(sourceElement, 'tr.table-active');
    if (old_table_row != undefined) {
        old_table_row.classList.remove('table-active');
        old_table_row.classList.remove('table-dark');
        //old_table_row.classList.remove('bg-secondary');
        old_table_row.classList.remove('bg-primary');
        old_table_row.classList.remove('text-light');
    }*/ $2687097d5145937a$export$2e2bcd8739ae039.DatasetListUnselectItem(sourceElement, archiveName);
    let selectedSearchTemplate = $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(sourceElement, archiveName);
    //var row = DrDoc.GetTableRowElementByID(document, archiveName, documentId);
    var row = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
    //var row = sourceElement;
    //var row = DrDocWeb.GetElement(sourceElement, 'tr');
    // sourceElement.tagName == 'TR' ? sourceElement : DrDoc.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (row === undefined || row === null) {
        console.warn('DatasetListSelectItem: Row Element nicht gefunden!', ' / archiveName:', archiveName, ' / selectedSearchTemplate:', selectedSearchTemplate, ' / documentId:', documentId, sourceElement);
        return;
    } else {
        row.classList.add('table-active');
        row.classList.add('table-dark');
        //row.classList.add('bg-secondary');
        row.classList.add('bg-primary');
        row.classList.add('text-light');
        //console.log('DatasetSelected: ', sourceElement, row, documentId);
        //sourceElement = row;
        row.style.scrollMargin = '40px';
        row.scrollIntoView({
            block: 'nearest'
        });
    }
    return row;
};
$2687097d5145937a$export$2e2bcd8739ae039.DatasetSelected = function(sourceElement, archiveName, documentIdField, documentId, mode, sourceObjStr) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    //DrDoc._datasetIndex[archiveName] = DrDoc.ListIndexOf(archiveName, documentId);
    //DrDoc.UnlockOnlyDataset(sourceElement, archiveName, documentId);
    if (sourceElement === undefined || sourceElement === window || sourceElement === document) {
        console.warn('DatasetSelected: bad source element');
        return;
    }
    // --
    let sourceArchiveName = archiveName;
    let source_obj = null;
    if ((0, $346VI.default).IsNullOrEmpty(sourceObjStr)) ;
    else {
        if (typeof sourceObjStr === 'string') {
            var source_decoded = decodeURIComponent(sourceObjStr);
            source_obj = (0, $346VI.default).JsonToObject(source_decoded);
        } else source_obj = sourceObjStr;
        sourceArchiveName = source_obj.archive;
    }
    // --
    // Layout automatisch setzen je nach endgerät
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset();
    let row = $2687097d5145937a$export$2e2bcd8739ae039.DatasetListSelectItem(sourceElement, sourceArchiveName, documentId);
    if (row == undefined || row == null) return;
    // --
    //console.log('DatasetSelected: ', table);
    //console.log('DatasetSelected (1): ', archiveName, sourceArchiveName, documentId, mode);
    // Mode bezieht sich auf die Liste
    if (mode === 'get' || mode === 'info' || mode === 'searchfields' || mode === 'textretrieval' || mode === 'template' || mode === 'event' || mode === 'hyper' || mode === 'tmp' || mode === 'tmp-delete-last') {
        if (mode === 'info') (0, $346VI.default).ModalClose(sourceElement);
        //console.log('DatasetSelected: GET / ', sourceElement, archiveName, documentId, 'get');
        //if (prompt('ok?', true))
        //{
        $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(sourceElement, archiveName);
        return $2687097d5145937a$export$2e2bcd8739ae039.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'get').then(function(x) {
            //DrDoc.configDevice.update('view/list-width');
            //DrDoc.configDevice.set('view/list-width', DrDoc.configDevice.get('view/list-width')+0.1);
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateSplitPanel();
            //console.log('Mask Update List W: ',  DrDoc.configDevice.has('view/list-width'), DrDoc.configDevice.get('view/list-width', 50));
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
        });
    //}
    } else if (mode === 'thes') {
        // aus Ziel in Maske Daten importieren!
        //alert('Thes. not implemented yet.');
        // return DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'thes');
        if (source_obj == undefined || source_obj == null) {
            console.error('Thesaurus hat keinen Mode angegeben! ', this);
            //source_mode = mode;
            return;
        }
        //console.log('DatasetSelected (2.1): Thes/Zusatzinfo Source Obj', source_obj, archiveName, sourceArchiveName);
        // Thes
        source_obj.thes = true;
        // gesperrt laden
        source_obj.autolock = true;
        source_obj.thes_id = (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId;
        // Node.GetElement
        let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, sourceArchiveName);
        let elem = (0, $fWhbk.default).GetElement(nodeId);
        /*if (elem == undefined || elem == null) {
            nodeId = 'system/list|content|' + archiveName + '|dataset';
            elem = Node.GetElement(nodeId);
        }*/ //console.log('DatasetSelected (2.2):', nodeId, elem, sourceArchiveName);
        (0, $346VI.default).ModalClose(sourceElement);
        return (0, $fWhbk.default).LoadComponent({
            title: 'Thesaurus im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
            sourceElement: elem,
            targetElement: nodeId,
            getData: source_obj
        }).then((data)=>{
            // wieder zum Quellarchiv zurückwechseln
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', sourceArchiveName);
        });
    } else {
        alert('Bad Mode ' + mode);
        console.warn('Bad Mode', mode);
    }
};
// DOM Node für Listen
$2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement = function(sourceElement, archiveName, newWindow) {
    //var elem = null;
    /*if (newWindow === true) // || sourceElement == undefined || sourceElement == null)
    {
        //elem = Node.GetElement('system/list-info|content');
        //if (elem != null 
        return 'system/list-info|content';
    }*/ return $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal(sourceElement, archiveName, false, undefined);
};
$2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID = function(sourceElement, archiveName, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal(sourceElement, archiveName, true, documentId);
};
/*DrDoc.GetTableElement = function (sourceElement, archiveName) {
    return DrDocWeb.GetElement(DrDoc.GetTableNodeElement(sourceElement), 'table.list-datasets');
};*/ $2687097d5145937a$export$2e2bcd8739ae039.__GetTableRowElementByID = function(sourceElement, archiveName, documentId) {
    var table = $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    if (table == undefined || table === null) {
        console.warn('DrDoc.GetTableRowElementByID: ', sourceElement, archiveName, documentId);
        return undefined;
    }
    let tableNodeId = (0, $fWhbk.default).GetNodeId(table);
    let nodeId = '';
    let elem = null;
    nodeId = tableNodeId + '|' + documentId;
    elem = (0, $fWhbk.default).GetElement(nodeId, table);
    /*if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|_DEFAULT_|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }
    if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|' + DrDoc.configDevice.get('view/list/' + archiveName + '/selected-searchtemplate') + '|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }
    if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }*/ /*if (elem == undefined || elem == null)
    {
        nodeId = Node.GetNodeId(sourceElement) + '|_DEFAULT_|' + documentId;
        elem = Node.GetElement(nodeId, sourceElement);
    }
    if (elem == undefined || elem == null)
    {
        nodeId = Node.GetNodeId(sourceElement) + '|' + documentId;
        elem = Node.GetElement(nodeId, sourceElement);
    }*/ if (elem == undefined || elem == null) {
        console.warn('DrDoc.GetTableRowElementByID: Table found, but Elem/Row Not found! / documentId:', documentId, ' / NodeId: ', nodeId, ' / Table Node Id: ', tableNodeId, ' / Table: ', table);
        return undefined;
    }
    //console.log('DrDoc.GetTableRowElementByID', nodeId, elem); //, table);
    return elem;
};
//DrDoc.OnSelectRowElementRel = 
$2687097d5145937a$export$2e2bcd8739ae039.OnSelectDatasetRel = function(sourceElement, archiveName, documentIdField, documentId, rel) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    //var table = DrDoc.GetTableElement(sourceElement, archiveName);
    /*var tableNodeElem = DrDoc.GetTableNodeElement(sourceElement, archiveName);
    if (tableNodeElem === undefined || tableNodeElem === null) {
        console.warn('OnSelectRowElementRel: Table Element nicht gefunden!', sourceElement, archiveName, documentId, rel);
        return undefined;
    }
    var tbody = DrDocWeb.GetElement(tableNodeElem, 'table.list-datasets tbody');*/ var row = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (row === undefined || row === null) {
        console.warn('OnSelectRowElementRel: Row Element nicht gefunden!', sourceElement, archiveName, documentId, rel);
        return undefined;
    }
    var tbody = (0, $346VI.default).GetElement(row, 'tbody', -1);
    /*var tbody = null;
    while (row.parentNode != null)
    {
        tbody = row.parentNode;
        if (tbody.tagName == 'TBODY')
            break;
    }*/ //var tbody = table.getElementsByTagName('tbody')[0]; // table.tbody; //
    //console.log('OnSelectRowElementRel -> IST', sourceElement, tbody.children, table, row);
    //console.log('OnSelectRowElementRel -> IST', ' / sourceElement: ', sourceElement, ' / tbody: ', tbody, ' / row: ', row);
    if (row !== undefined && row !== null) {
        //row.removeClass('table-active');
        //int i = table.tbody.childNodes.indexOf(row);
        // table.children.indexOf(row);
        // Index der Row herausfinden
        var i = Array.prototype.indexOf.call(tbody.children, row);
        var i_selected = i + rel;
        if (i !== -1 && i_selected >= 0 && i_selected < tbody.children.length) {
            var row_selected = tbody.children[i_selected];
            //documentId = document.querySelector(tbody.children[i]).attr('data-id');
            let documentId_selected = $2687097d5145937a$export$2e2bcd8739ae039.GetListDatasetID(row_selected);
            //console.log('OnSelectRowElementRel -> SOLL Selected ID: ', documentId_selected, '  Elem: ', row_selected);
            //action(row_selected, documentId_selected);
            //return true;
            return $2687097d5145937a$export$2e2bcd8739ae039.DatasetSelected(row_selected, archiveName, documentIdField, documentId_selected, 'get');
        } else {
            console.log('OnSelectRowElementRel, bad index : ', i, sourceElement, archiveName, documentId, rel, tbody, tbody.children, row); //, Node.GetNodeId(tableNodeElem), tableNodeElem);
            return undefined;
        }
    }
    return undefined;
};
$2687097d5145937a$export$2e2bcd8739ae039.OnSelectPrevDataset = function(sourceElement, archiveName, documentIdField, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039.OnSelectDatasetRel(sourceElement, archiveName, documentIdField, documentId, -1);
};
$2687097d5145937a$export$2e2bcd8739ae039.OnSelectNextDataset = function(sourceElement, archiveName, documentIdField, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039.OnSelectDatasetRel(sourceElement, archiveName, documentIdField, documentId, 1);
};
$2687097d5145937a$export$2e2bcd8739ae039.RegisterShortcuts = function(archiveName, shortcuts) {};
// --
// Zeile leeren
$2687097d5145937a$export$2e2bcd8739ae039.TableClearRow = function(rowElem1) {
    rowElem1 = (0, $346VI.default).GetClosestTag(rowElem1, 'tr');
    if (rowElem1 == undefined || rowElem1 == null) return;
    // Tabellen-Zeile nicht entfernen, sondern nur leeren und ausblenden, sonst funktioniert der Row-Index nicht mehr (z.B. für Thesaurus)!
    //rowElem.parentNode.removeChild(rowElem);
    var inputElems = rowElem1.querySelectorAll('input');
    //console.log('DrDoc.TableRemoveRow: ', inputElems);
    if (inputElems) inputElems.forEach(function(inputElem) {
        inputElem.value = '';
        inputElem.innerHTML = '';
        inputElem.checked = undefined;
        inputElem.required = false;
    //console.log('DrDoc.TableRemoveRow - Cell Input: ', inputElem.value, inputElem);
    });
    inputElems = rowElem1.querySelectorAll('textarea');
    if (inputElems) inputElems.forEach(function(inputElem) {
        inputElem.value = '';
        inputElem.innerHTML = '';
        inputElem.checked = undefined;
        inputElem.required = false;
    });
    inputElems = rowElem1.querySelectorAll('textarea');
    if (inputElems) inputElems.forEach(function(inputElem) {
        inputElem.value = '';
        inputElem.innerHTML = '';
        inputElem.checked = undefined;
        inputElem.required = false;
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.TableRemoveRow = function(rowElem1) {
    rowElem1 = (0, $346VI.default).GetClosestTag(rowElem1, 'tr');
    if (rowElem1 == undefined || rowElem1 == null) return;
    // Zeile leeren
    $2687097d5145937a$export$2e2bcd8739ae039.TableClearRow(rowElem1);
    // Zeile ausblenden
    rowElem1.style.display = 'none';
};
$2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow = function(rowElem1) {
    rowElem1 = (0, $346VI.default).GetClosestTag(rowElem1, 'tr');
    if (rowElem1 == undefined || rowElem1 == null) return;
    // Achtung: Element-IDs bleiben gleich!
    let row2Elem = rowElem1.cloneNode(true);
    // element.insertBefore(new, existing)
    rowElem1.parentNode.insertBefore(row2Elem, rowElem1);
};
$2687097d5145937a$export$2e2bcd8739ae039.TableOpenModal = function(sourceElement, title) {
    if (!sourceElement || !sourceElement.parentNode) return;
    let tmp_top = sourceElement.style.top;
    let tmp_left = sourceElement.style.left;
    let tmp_width = sourceElement.style.width;
    let tmp_height = sourceElement.style.height;
    let tmp_position = sourceElement.style.position;
    sourceElement.style.top = '';
    sourceElement.style.left = '';
    sourceElement.style.width = '100%';
    sourceElement.style.height = '100%';
    sourceElement.style.position = 'relative';
    // Placeholder erstellen und mit Tabelle mit Placeholder ersetzen
    let elemPlaceholder = document.createElement('div');
    elemPlaceholder.innerText = 'PLACEHOLDER';
    sourceElement.parentNode.insertBefore(elemPlaceholder, sourceElement);
    // Element aus Maske holen und im Modal einbinden
    sourceElement.parentNode.removeChild(sourceElement);
    let modal = (0, $346VI.default).Modal(title, sourceElement, {
        //color: 'danger',
        fullScreen: true,
        size: 'lg'
    });
    //console.log('DrDoc.TableOpenModal: ', modal);
    // beim Schließen des Modal Tabelle aus dem Modal wieder in die Maske setzen
    modal._element.addEventListener('hidden.bs.modal', function(event) {
        //console.log('DrDoc.TableOpenModal: hidden.bs.modal');
        elemPlaceholder.parentNode.replaceChild(sourceElement, elemPlaceholder);
        // Styles zurücksetzen
        sourceElement.style.top = tmp_top;
        sourceElement.style.left = tmp_left;
        sourceElement.style.width = tmp_width;
        sourceElement.style.height = tmp_height;
        sourceElement.style.position = tmp_position;
    });
};
// --
// Anzahl der Datensatz-Treffer in ein DOM Element laden
// Suche nach Attributen [data-search-archive] und [data-search-template] oder [data-search-hyper]
$2687097d5145937a$export$2e2bcd8739ae039.SearchCountElement = function(elem) {
    if (!(0, $346VI.default).IsNullOrEmpty(elem) && typeof elem === 'string') elem = (0, $fWhbk.default).GetElement(elem);
    if (elem == undefined || elem == null) elem = document;
    let crudAction = function(counterElem) {
        //counterElem.innerText = '..';
        counterElem.innerHtml = `<div class="spinner-border text-danger" role="status">
  <span class="visually-hidden">...</span>
</div>`;
        counterElem.parentNode.style.position = 'relative'; // !important';
        counterElem.style.position = 'absolute'; // !important';
        //counterElem.style.top = 'min(15%, 12px)'; //!important';
        //counterElem.style.left = 'min(85%, 12px)'; //!important';
        //counterElem.style.transform = 'translate(-50%,-50%)'; //!important';
        counterElem.style.top = '0px';
        counterElem.style.right = '0px';
        counterElem.style.transform = 'translate(0%,-20%)';
        //counterElem.style.transform = 'translate(0%,-0.5rem)';
        //counterElem.className = 'position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary';
        return function(dataArr, dataObj) {
            // dataObj = { Count, CountTotal, SortTree }
            //console.log(this, counterElem, dataArr, dataObj, dataObj.CountTotal);
            counterElem.innerHtml = '';
            //console.log('COUNTER!!!!!!!!!!!!!!!!!!', dataObj.CountTotal);
            if (dataObj.CountTotal !== undefined && dataObj.CountTotal > 0) {
                /*if (dataObj.CountTotal > 500)
                    counterElem.classList.add('bg-danger');
                else if (dataObj.CountTotal > 100)
                    counterElem.classList.add('bg-warning');
                else
                    counterElem.classList.add('bg-secondary');*/ counterElem.classList.add('bg-secondary');
                counterElem.classList.add('badge');
                counterElem.innerText = dataObj.CountTotal;
            } else {
                counterElem.classList.add('bg-success');
                counterElem.classList.add('badge');
                counterElem.classList.add('d-none');
                counterElem.innerText = '0';
            }
        };
    };
    let loadDsCountElems1 = elem.querySelectorAll('[data-search-template]');
    if (loadDsCountElems1 != null) for (let loadDsCountElem of loadDsCountElems1){
        let archiveName = loadDsCountElem.getAttribute('data-search-archive');
        let searchTemplateName = loadDsCountElem.getAttribute('data-search-template');
        if ((0, $346VI.default).IsNullOrEmpty(archiveName)) continue;
        if ((0, $346VI.default).IsNullOrEmpty(searchTemplateName)) continue;
        //console.log('Search Template: ', archiveName, searchTemplateName, loadDsCountElem);
        let getObj = {
            action: 'searchtemplate',
            archive: archiveName,
            value: searchTemplateName,
            count: 0,
            max: -1
        };
        (0, $iuVXB.default).Crud(getObj, crudAction(loadDsCountElem));
    }
    let loadDsCountElems2 = elem.querySelectorAll('[data-search-hyper]');
    if (loadDsCountElems2 != null) for (let loadDsCountElem of loadDsCountElems2){
        let archiveName = loadDsCountElem.getAttribute('data-search-archive');
        let searchHyperName = loadDsCountElem.getAttribute('data-search-hyper');
        if ((0, $346VI.default).IsNullOrEmpty(searchHyperName)) continue;
        //console.log('Search Hyper: ', archiveName, searchHyperName, loadDsCountElem);
        let getObj = {
            action: 'hyper',
            archive: archiveName,
            value: searchHyperName,
            count: 0,
            max: -1
        };
        (0, $iuVXB.default).Crud(getObj, crudAction(loadDsCountElem));
    }
};
// ---
// User Data
/*DrDoc.SelectedArchiveName = '';
DrDoc.SetSelectedArchive = function(selectedArchiveName) {
    
    DrDoc.SelectedArchiveName = selectedArchiveName;
    DrDoc.ConfSet('view/selected-archive', selectedArchiveName);
};*/ //DrDoc.configUser.subscribeBool('view/select-archive', false);
//DrDoc.configUser.subscribeBool('view/select-archive');
$2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive = function(callback) {
    if (typeof callback !== 'function') {
        console.warn('GetSelectedArchive', "Funktion muss als Argument ein Callback \xfcbergeben!");
        return undefined;
    }
    let isSelectArchive = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/select-archive', false);
    console.log('view/select-archive', isSelectArchive);
    let archiveName = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/selected-archive');
    //let hasSelectedArchive = DrDoc.SelectedArchiveName !== undefined && DrDoc.SelectedArchiveName !== null && DrDoc.SelectedArchiveName.length > 0;
    let hasSelectedArchive = $2687097d5145937a$export$2e2bcd8739ae039.configUser.has('view/selected-archive');
    if (isSelectArchive === false && hasSelectedArchive) callback(archiveName);
    else {
        let modalSrc = '<div class="list-group">';
        let archives = $2687097d5145937a$export$2e2bcd8739ae039.GetUserData().Result.Archives;
        for(let i in archives)modalSrc += `<button class="list-group-item list-group-item-action ${archives[i].Archive.SimpleName === archiveName ? 'active' : ''}" onclick="DrDocWeb.ModalGet(this).callback('${archives[i].Archive.SimpleName}'); ">${archives[i].Label}</button>`;
        modalSrc += '</div>';
        let modal = (0, $346VI.default).Modal("Archiv w\xe4hlen", modalSrc, {
            fullScreen: false
        });
        modal.callback = (selectedArchiveName)=>{
            //DrDoc.SetSelectedArchive(selectedArchiveName);
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.set('view/selected-archive', selectedArchiveName);
            modal.hide();
            callback(selectedArchiveName);
        //console.log('GetSelectedArchive (Callback)',  selectedArchiveName);
        };
    //console.log('GetSelectedArchive', modal, callback);
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.GetUserData = function() {
    return $2687097d5145937a$export$2e2bcd8739ae039.store.get('userdata');
};
$2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession = function(archiveName) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return null;
    // ip\port\archive
    if (archiveName.indexOf('\\') > 0) {
        let archiveNameComponents = archiveName.split('\\');
        if (archiveNameComponents.length == 3 && (0, $346VI.default).ParseInt(archiveNameComponents[1]) > 0) archiveName = archiveNameComponents[2];
    }
    let userdata = $2687097d5145937a$export$2e2bcd8739ae039.GetUserData();
    if (userdata == null || userdata == undefined) return null;
    if (userdata.Result == null || userdata.Result == undefined) return null;
    let archives = userdata.Result.Archives;
    if (archives == null || archives == undefined) return null;
    for(let i in archives){
        if (archives[i].Archive.SimpleName.toLowerCase() === archiveName.toLowerCase() || archives[i].Archive.FilenameServerDA.toLowerCase() === archiveName.toLowerCase() || archives[i].Archive.FilenameServerDA.toLowerCase() === archiveName.toLowerCase() + '.da') return archives[i];
    }
    return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel = function(archiveName, defaultLabel) {
    let session = $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName);
    if (session == null) return defaultLabel === undefined ? archiveName : defaultLabel;
    return session.Label;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetArchive = function(archiveName) {
    let archObj = $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName);
    if (archObj != undefined && archObj != null) return archObj.Archive;
    return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName = function(archiveName) {
    let archObj = $2687097d5145937a$export$2e2bcd8739ae039.GetArchive(archiveName);
    if (archObj != undefined && archObj != null) return archObj.SimpleName;
    console.warn('DrDoc.GetSimpleArchiveName Archive Name not found: ', archiveName);
    return archiveName;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetField = function(archiveName, fieldName) {
    let archive = $2687097d5145937a$export$2e2bcd8739ae039.GetArchive(archiveName);
    if (archive == null) return null;
    if ((0, $346VI.default).IsNullOrEmpty(fieldName)) return null;
    let fields = archive.Fields;
    for(let i in fields){
        if (fields[i].Name === fieldName) return fields[i];
    }
    return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.TestUser = function(archiveName, fieldName) {
    console.log('Archive', $2687097d5145937a$export$2e2bcd8739ae039.GetArchive(archiveName));
    console.log('Archive Label', $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName).Label);
    console.log('Field', $2687097d5145937a$export$2e2bcd8739ae039.GetField(archiveName, $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD));
};
// --
// Split Panel
var $2687097d5145937a$var$_splitPanels = {};
$2687097d5145937a$export$2e2bcd8739ae039.SplitPanel = function(elemSelContaier, elemSel1, elemSel2, direction, size, onSizeChanged) {
    var obj = $2687097d5145937a$var$_splitPanels[elemSelContaier];
    if (size == null || size == undefined || isNaN(size)) size = 35;
    size = Math.min(Math.max(size, 0), 100);
    if (direction == 'v' || direction == undefined || direction == null) direction = 'vertical';
    if (direction == 'h') direction = 'horizontal';
    // erst altes Objekt freigeben
    /*try
    {
        if (obj != null && obj != undefined) {
            obj.destroy();
            obj = null;
        }
    }
    catch(ex)
    {

    }*/ var elemContainer = document.querySelector(elemSelContaier);
    var elemSplitter = document.querySelector(elemSelContaier + ' > .gutter');
    var elem1 = document.querySelector(elemSel1);
    var elem2 = document.querySelector(elemSel2);
    if (elemContainer == null || elemContainer == undefined) return;
    if (elem1 == null || elem1 == undefined) return;
    if (elem2 == null || elem2 == undefined) return;
    // --
    // bei 100% Splitter garnicht erst anwenden
    if (elemSplitter) elemSplitter.classList.remove('d-none');
    if (elem1) elem1.classList.remove('d-none');
    if (elem2) elem2.classList.remove('d-none');
    if (size >= 99) {
        if (elemSplitter) elemSplitter.classList.add('d-none');
        elem2.classList.add('d-none');
        //console.log('Split Hide 2: ', elem2, elemSplitter1, elemSplitter2);
        elem1.style.width = '100%';
        elem1.style.height = '100%';
        return;
    } else if (size < 1) {
        if (elemSplitter) elemSplitter.classList.add('d-none');
        elem1.classList.add('d-none');
        //console.log('Split Hide 1: ', elem1, elemSplitter1, elemSplitter2);
        elem2.style.width = '100%';
        elem2.style.height = '100%';
        return;
    }
    // --
    // Scroll Pos. merken
    var elem1_scrollTop = elem1.scrollTop;
    var elem1_scrollLeft = elem1.scrollLeft;
    var elem2_scrollTop = elem2.scrollTop;
    var elem2_scrollLeft = elem2.scrollLeft;
    //if (obj)
    //console.log('DrDoc.SplitPanel:  ', obj._elemContainer != elemContainer, obj._elem1 !== elem1, obj._elem2 !== elem2);
    if (obj == null || obj == undefined || obj._elemContainer != elemContainer || obj._elem1 !== elem1 || obj._elem2 !== elem2 || obj.splitObj.pairs[0].direction != direction) //if (obj == null || obj == undefined || obj.splitObj.pairs[0].direction != direction)
    {
        // => Split-Contaoner existiert noch nicht oder Richtung wurde geändert
        /*if (obj != undefined && obj._elemContainer !== elemContainer)
            console.warn('DrDoc.SplitPanel: Elem Container has Changed! ', elemSelContaier);
        if (obj != undefined && obj._elem1 !== elem1)
            console.warn('DrDoc.SplitPanel: Elem 1 has Changed! ', elem1);
        if (obj != undefined && obj._elem2 !== elem2)
            console.warn('DrDoc.SplitPanel: Elem 2 has Changed! ', elem2);*/ if (elemContainer == null || elemContainer == undefined) //console.log('SplitPanel: Element Container exisitert nicht! ', elemSelContaier);
        return;
        if (elem1 == null || elem1 == undefined) //console.log('SplitPanel: Element 1 exisitert nicht! ', elemSel1);
        return;
        if (elem2 == null || elem2 == undefined) //console.log('SplitPanel: Element 2 exisitert nicht! ', elemSel2);
        return;
        // erst altes Objekt freigeben
        if (obj != null && obj != undefined && elem1.nextElementSibling != undefined && elem1.nextElementSibling != null && elem1.nextElementSibling.classList.contains('gutter') && obj.splitObj.pairs[0].direction == direction) {
            // bereits initialisiert, wenn gutter vorhanden
            //console.log('Split, bereits initialisiert', obj, elem1.nextElementSibling);
            var sizes = obj.splitObj.getSizes();
            if (sizes == null || sizes == undefined || sizes.length > 0 && sizes[0] != size) obj.splitObj.setSizes([
                size,
                100 - size
            ]);
        } else {
            //console.log('Split, neu initialisieren', obj); //, elem1.nextElementSibling);
            if (obj != null && obj != undefined) try {
                obj.splitObj.destroy(false, false);
            } catch (ex) {}
            // https://split.js.org/#/?layout=float
            obj = {
                _elemContainer: elemContainer,
                splitObj: window.Split([
                    elemSel1,
                    elemSel2
                ], {
                    sizes: [
                        size,
                        100 - size
                    ],
                    minSize: [
                        15,
                        15
                    ],
                    //expandToMin: true,
                    direction: direction,
                    onDragEnd: onSizeChanged
                })
            };
        }
        $2687097d5145937a$var$_splitPanels[elemSelContaier] = obj;
        // Fallback
        elem1.style.display = 'block';
        elem1.style.float = 'left';
        elem2.style.display = 'block';
        elem2.style.float = 'left';
        // gutter.gutter-vertical: float: left + width: 100%;
        if (direction == 'vertical') {
            // vertical
            elemContainer.style.display = 'flex';
            elemContainer.style.flexDirection = 'column';
        } else {
            // horizontal
            elemContainer.style.display = 'flex';
            elemContainer.style.flexDirection = 'row';
        }
        // Scroll Pos. wiederherstellen
        elem1.scrollTop = elem1_scrollTop;
        elem1.scrollLeft = elem1_scrollLeft;
        elem2.scrollTop = elem2_scrollTop;
        elem2.scrollLeft = elem2_scrollLeft;
    } else {
        // => Split-Contaoner existiert bereits und Richtung wurde nicht geändert
        var sizes = obj.splitObj.getSizes();
        if (sizes == null || sizes == undefined || sizes.length > 0 && sizes[0] != size) obj.splitObj.setSizes([
            size,
            100 - size
        ]);
    }
    return obj;
};
$2687097d5145937a$export$2e2bcd8739ae039.HideSplitPanel = function() {
    //if (false && DrDocWeb.IsMobile() && DrDoc.configUser.get('view/list/show-tree')) {
    //    DrDoc.configDevice.set('view/list-sort-width', 20);
    //}
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-dataset-width', 100);
};
$2687097d5145937a$export$2e2bcd8739ae039.UpdateSplitPanel = function() {
    let mode = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/layout-mode');
    let size_abs = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-width');
};
/*
DrDoc.configDevice.subscribeInt('view/list-width', function (value, oldValue) {
    //console.log('subscribe: view/list-width: ', value, oldValue, ' / from cookie');
    
    //console.log('view/list-width: ', value, size_abs);
}, 50);

DrDoc.configDevice.subscribe('view/layout-mode', function (value, oldValue) {
    //console.log('subscribe: view/layout-mode: ', value, oldValue, ' / from cookie');
    if (DrDocWeb.IsNullOrEmpty(value))
        value = 'v';
    let size_abs = DrDoc.configDevice.get('view/list-width', 50);
    
}, 'v');*/ $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset = async function(archiveName) {
    console.log('DrDoc.SetViewDataset');
    //if (DrDoc.configDevice.get('view/list-dataset-width') > 95 || DrDoc.configDevice.get('view/list-dataset-width') < 5)
    if ($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-dataset-width') > 70) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-dataset-width', 40);
    if (!(0, $346VI.default).IsNullOrEmpty(archiveName)) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
};
$2687097d5145937a$export$2e2bcd8739ae039.SetViewList = async function(archiveName) {
    if ($2687097d5145937a$export$2e2bcd8739ae039._setViewInit == undefined) $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
    console.log('DrDoc.SetViewList');
    //console.log('DrDoc.SetViewList: view/list-dataset-width: ', DrDoc.configDevice.get('view/list-dataset-width'));
    //if (DrDoc.configDevice.get('view/list-dataset-width') > 1 && DrDoc.configDevice.get('view/list-dataset-width') < 10)
    if (!$2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-dataset-width') || $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-dataset-width') < 10) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-dataset-width', 50);
    $2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode();
    if (!(0, $346VI.default).IsNullOrEmpty(archiveName)) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
};
$2687097d5145937a$export$2e2bcd8739ae039.SetViewInit = async function() {
    if ($2687097d5145937a$export$2e2bcd8739ae039._setViewInit == undefined) {
        console.log('DrDoc.SetViewInit (1) Initial');
        $2687097d5145937a$export$2e2bcd8739ae039._setViewInit = true;
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribe('view/list-sort-mode', function(value) {
            //console.log('DatasetListContaionerWebNode 2 - sort mode - {{$_this.NamePath}}');
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-sort-width');
        }, 'h');
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribe('view/list-dataset-mode', function(value) {
            //console.log('DatasetListContaionerWebNode 2 - dataset mode - {{$_this.NamePath}}');
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-dataset-width');
        }, 'v');
        setTimeout($2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode, 500);
    }
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/layout-sm');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/selected-archive');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.Write = false;
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.update('view/label-style-classes');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.update('view/button-style-classes');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.update('view/read-only-style-classes');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.Write = true;
};
$2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode = async function() {
    //console.log('DrDoc.UpdateView');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-sort-mode');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-dataset-mode');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list/tree/cols');
};
$2687097d5145937a$export$2e2bcd8739ae039.DisplayDataseListTreeCols = function(cols) {
    //let tree = document.querySelector('.dataset-list .dataset-list-tree-container > .row');
    let treeElementList = document.querySelectorAll('.dataset-list-tree-container');
    //console.log('SetViewInit 1: ', tree, tree.children);
    //console.log('DrDoc.DisplayDataseListTreeCols: ', treeElementList);
    for (var tree of treeElementList)if (tree != null) {
        tree.classList.remove('flex-nowrap');
        tree.classList.remove('flex-wrap');
        tree.classList.remove('card');
        if (cols) tree.classList.add('flex-nowrap');
        else tree.classList.add('flex-wrap');
        if (tree.children) for (var cn of tree.children){
            cn.className = cols ? 'col-sm-12 col-md-6 col-lg-6 col-xxl-6 me-3 tree-item card' : 'col-12 tree-item';
            cn.style.width = cols ? '' : '100%';
        }
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn = function(searchElemSelector) {
    return function(value, oldValue) {
        // console.log('DrDoc.getOnChangeStyleFn', this);
        var elemRoot = null;
        if (elemRoot == null || elemRoot == undefined) elemRoot = null;
        if (elemRoot == null || elemRoot == undefined) elemRoot = document;
        elemRoot.querySelectorAll(searchElemSelector).forEach(function(elem) {
            // alte Classes suchen und aus Elementen entfernen
            if (!(0, $346VI.default).IsNullOrEmpty(oldValue)) for (let className of oldValue.split(' ')){
                if ((0, $346VI.default).IsNullOrEmpty(className)) continue;
                elem.classList.remove(className);
            }
            // neue Classes an Elemente anfügen
            if (!(0, $346VI.default).IsNullOrEmpty(value)) for (let className of value.split(' ')){
                if ((0, $346VI.default).IsNullOrEmpty(className)) continue;
                elem.classList.add(className);
            }
        });
    };
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.PageSetName = function(oldName, newName) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-set-name',
        name: oldName,
        value: newName
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.PageSetUser = function(oldName, newName) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-set-user',
        name: oldName,
        value: newName
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.PageAdd = function(name) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-add',
        preset: 'PAGE',
        name: name
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.PageDelete = function(name) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-delete',
        name: name
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.AddFav = function(value) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'add-fav',
        name: prompt('Favoriten Name:'),
        value: value
    });
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.UserActionObj = function(action, obj) {
    if (obj == undefined) obj = {};
    obj.action = action;
    return (0, $346VI.default).Send('GET', '/user', obj, undefined, 'json', '', '', true).then((data)=>{
        console.log('UserAction: ', action, obj);
        (0, $346VI.default).ModalInfo('UserAction: ' + action, data.Result + '\r\n<br>\r\n<br>' + (0, $346VI.default).ObjectToQueryStr(obj));
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetObj = function(archiveName, value) {
    let getObj = {};
    getObj.archive = archiveName;
    getObj.action = 'add';
    getObj.value = value;
    return (0, $346VI.default).Send('GET', '/model/crud', getObj, undefined, 'json', '', '', true);
};
$2687097d5145937a$export$2e2bcd8739ae039.ConfigDeleteDatasetObj = function(archiveName, value) {
    let getObj = {};
    getObj.archive = archiveName;
    getObj.action = 'delete-all';
    getObj.value = value;
    getObj.usermanager = 'Config.BVD';
    return (0, $346VI.default).Send('GET', '/model/crud', getObj, undefined, 'json', '', '', true);
};
$2687097d5145937a$export$2e2bcd8739ae039.SaveWebNode = function(nodeId, properties) {
    return (0, $346VI.default).Send('PUT', '/node/' + nodeId, {}, properties);
};
// --
// Menu Main
$2687097d5145937a$export$2e2bcd8739ae039.toggleMainMenuExpansion = function() {
    if ($2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion()) $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion(true);
    else $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion(false);
//var elem = document.getElementById('menu-main-drdoc');
//DrDoc.updateMainMenuExpansion();
/*
    // Toggle: Hauptmenü links ein-/ausklappen
    if (elem.classList.contains('expanded'))
    {
        elem.classList.remove('expanded');
    }
    else
    {
        elem.classList.add('expanded');
    }
    */ /*
    // Toggle: Hauptmenü links vollständig ein-/ausblenden
    if (elem.classList.contains('d-none'))
    {
        elem.classList.remove('d-none');
    }
    else
    {
        elem.classList.add('d-none');
    }*/ };
$2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion = function(hide) {
    if (!document.querySelector('#menu-main-drdoc')) return;
    document.querySelector('#menu-main-drdoc-container').classList.remove('d-none');
    // Ausklappen, wenn noch ausgeklappte Menüs vorhanden sind
    let openMenuItems = document.querySelectorAll('#menu-main-drdoc button[aria-expanded]');
    let openMenuItemsExpanded = document.querySelectorAll('#menu-main-drdoc button[aria-expanded="true"]');
    // if ((DrDocWeb.IsMobile() && window.innerWidth > 800) || (!DrDocWeb.IsMobile() && openMenuItems != null && openMenuItems.length > 0))
    if (hide === true) {
        //console.log('DrDoc.updateMainMenuExpansion: CLOSE');
        document.querySelector('#menu-main-drdoc').classList.remove('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.remove('expanded');
        if (openMenuItems != null) openMenuItems.forEach(function(openMenuItem) {
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).hide();
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).toggle();
            /*openMenuItem.classList.remove('show');
                openMenuItem.classList.remove('open');*/ openMenuItem.setAttribute('aria-expanded', 'false');
            openMenuItem.classList.remove('expanded');
        });
        openMenuItems = document.querySelectorAll('#menu-main-drdoc .show');
        if (openMenuItems != null) openMenuItems.forEach(function(openMenuItem) {
            openMenuItem.classList.remove('show');
        });
        return false;
    } else if (hide === false) {
        //console.log('DrDoc.updateMainMenuExpansion: OPEN');
        document.querySelector('#menu-main-drdoc').classList.add('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.add('expanded');
        if (openMenuItems != null) openMenuItems.forEach(function(openMenuItem) {
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).open();
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).toggle();
            /*openMenuItem.classList.add('show');
                openMenuItem.classList.add('open');*/ openMenuItem.setAttribute('aria-expanded', 'true');
            openMenuItem.classList.add('expanded');
        });
        /*openMenuItems = document.querySelectorAll('#menu-main-drdoc .show');
        if (openMenuItems != null)
        {
            openMenuItems.forEach(function(openMenuItem) {
                openMenuItem.classList.remove('show');
            });
        }*/ return true;
    }
    //if (!DrDocWeb.IsMobile() && openMenuItems != null && openMenuItems.length > 0)
    if (openMenuItemsExpanded != null && openMenuItemsExpanded.length > 0) {
        //console.log('DrDoc.updateMainMenuExpansion: UPDATE - is OPEN');
        document.querySelector('#menu-main-drdoc').classList.add('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.add('expanded');
        return true;
    } else {
        //console.log('DrDoc.updateMainMenuExpansion: UPDATE - is CLOSED');
        document.querySelector('#menu-main-drdoc').classList.remove('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.remove('expanded');
        return false;
    }
};
//// ---------------------------------
$2687097d5145937a$export$2e2bcd8739ae039.Init = async function() {
    if (window.DrDoc !== undefined) {
        console.warn("Dr.DOC RE-INIT");
        return window.DrDoc;
    }
    window.DrDoc = $2687097d5145937a$export$2e2bcd8739ae039;
    console.log('Dr.DOC Init() START');
    (0, $hkmmp.default)._debug = false;
    $2687097d5145937a$export$2e2bcd8739ae039.store = new (0, $hkmmp.default)();
    $2687097d5145937a$export$2e2bcd8739ae039.configUser = new (0, $9hg18.default)($2687097d5145937a$export$2e2bcd8739ae039.store, false);
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.readonly = true;
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice = new (0, $9hg18.default)($2687097d5145937a$export$2e2bcd8739ae039.store, true);
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.readonly = false;
    //console.log('DrDoc.store initialized');
    $2687097d5145937a$export$2e2bcd8739ae039.store.init('userdata', function() {
        let userdata = null;
        if (window.__drdoc_ignore_userdata === true) {
            console.log('DrDoc.store: userdata __drdoc_ignore_userdata');
            //userdata = { };
            userdata = new Promise(function(resolve, reject) {
                resolve({});
            });
        } else {
            console.log('DrDoc.store: userdata get..');
            userdata = (0, $346VI.default).SendGet('/user', {
                action: 'status'
            }, 'json');
        }
        $2687097d5145937a$export$2e2bcd8739ae039.store.set('userdata', userdata);
        //DrDoc.TestUser()
        return userdata;
    }).then(function() {
        //console.log('userdata subscribe _sub1 then ok');
        // --
        // wenn "view/selected-archive" nicht gefunden werden kann, dann das erstes verfügbares Archiv wählen.
        $2687097d5145937a$export$2e2bcd8739ae039.store.subscribe('userdata', function(data) {
            if (data && data.Count > 0) $2687097d5145937a$export$2e2bcd8739ae039.configUser.readonly = false;
            console.log('DrDoc.store.subscribe: ', data);
            let selectedArchive = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/selected-archive');
            if ($2687097d5145937a$export$2e2bcd8739ae039.GetArchive(selectedArchive) == null) {
                if (data != undefined && data.Result != undefined && data.Result.Archives != undefined && data.Result.Archives && data.Result.Archives.length > 0) //console.log('Selected Archive (configDevice) NOT found: ', selectedArchive, ' - selecting: ', data.Result.Archives[0].Archive.SimpleName);
                $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', data.Result.Archives[0].Archive.SimpleName);
            //console.log('Selected Archive (configDevice) NOT found: Noch Archive found.');
            }
        });
        // --
        // Subscribe
        if (window.__drdoc_ignore_userdata !== true) {
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/selected-usermanager', function(value, oldValue) {
                // User Daten neu laden
                //DrDoc.store.update('userdata');
                //DrDoc.SearchInbox(document.documentElement);
                console.log('Usermanager has changed: ', value, ' <- ', oldValue);
                if (!(0, $346VI.default).IsNullOrEmpty(oldValue)) setTimeout(function() {
                    window.location.reload();
                }, 1500);
            });
            // Sortierung anzeigen/ausblenden
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribeBool('view/list/show-tree', function(value, oldValue) {
                if (value) {
                    if ($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-sort-width') <= 1) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-sort-width', 15);
                } else {
                    // Tree ausblenden
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-sort-width', 2);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-sort-width', 0);
                }
            }, false);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribeBool('view/list/tree/cols', function(value, oldValue) {
                $2687097d5145937a$export$2e2bcd8739ae039.DisplayDataseListTreeCols(value);
            }, false);
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/label-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-label-style-classes'));
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/button-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-button-style-classes'));
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/read-only-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-read-only-style-classes'));
        } else $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/button-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-button-style-classes'));
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribeBool('view/layout-sm', function(value) {
            // 'table-sm', 
            let selectorClasses = [
                'btn-sm',
                'btn-group-sm',
                'btn-toolbar-sm',
                'input-group-sm',
                'form-select-sm',
                'form-control-sm',
                'pagination-sm',
                'table-sm'
            ];
            selectorClasses.forEach(function(selector) {
                // $('.btn .btn-sm').addClass();
                if (value === true) {
                    // *-sm Klassen hinzufügen
                    document.querySelectorAll('.dd-' + selector).forEach(function(elem) {
                        elem.classList.add(selector);
                        elem.classList.remove('dd-' + selector);
                    });
                    document.querySelectorAll(selector).forEach(function(elem) {
                        elem.classList.remove('dd-' + selector);
                    });
                } else {
                    document.querySelectorAll('.' + selector).forEach(function(elem) {
                        elem.classList.add('dd-' + selector);
                        elem.classList.remove(selector);
                    });
                    document.querySelectorAll('.dd-' + selector).forEach(function(elem) {
                        elem.classList.remove(selector);
                    });
                }
            /*else {
                    console.warn('dafuq Value.. ', value);
                }*/ });
        }, true);
        $2687097d5145937a$export$2e2bcd8739ae039._navLastArchive = '';
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribe('view/selected-archive', function(value) {
            if (value == undefined || value == null) return;
            console.log('Archive has changed: ', value);
            if ($2687097d5145937a$export$2e2bcd8739ae039._navLastArchive != value) {
                $2687097d5145937a$export$2e2bcd8739ae039._navLastArchive = value;
                console.log('DrDoc.historyAddPage: Archive has changed: ', value);
                window.history.pushState({
                    action: 'change-archive',
                    value: value
                }, window.location.href, window.location.href);
            }
            // Liste als Ansicht wählen
            //DrDoc.SetViewList();
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode();
        }, '__none__');
        if (window.__drdoc_ignore_userdata !== true) {
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribeBool('view/list/show-tree-list-group', function(value) {
                if (value === true) $2687097d5145937a$export$2e2bcd8739ae039.configUser.set('view/list/show-tree', false);
            }, false);
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribeBool('view/list/show-tree', function(value) {
                if (value === true) $2687097d5145937a$export$2e2bcd8739ae039.configUser.set('view/list/show-tree-list-group', false);
            }, false);
        }
    /*
        DrDoc.configUser.subscribeBool('view/menu-system/mask-show', function(value) {
            let elem = document.querySelector('#collapseToolbarMask');
            if (value)
                elem.addClass('show');
            else
                elem.removeClass('show');
        });
         
        DrDoc.configUser.subscribeBool('view/menu-system/mask-list', function(value) {
            let elem = document.querySelector('#collapseToolbarList');
            if (value)
                elem.addClass('show');
            else
                elem.removeClass('show');
        });
        */ }).catch(function(err) {
        // abbrechen, wenn 'userdata' fehlschlägt
        console.log('userdata subscribe _sub1 failed', err);
    //DrDoc.configUser.clear();
    });
    // init('userdata') Ende
    //window.removeEventListener('popstate', Node.OnNavigateComponentEvent);
    window.addEventListener('popstate', function(e) {
        if (e.state != undefined && e.state != null && e.state.action == 'change-archive') {
            e.preventDefault();
            console.warn('DrDoc.historyAddPage: change Archive: ', e.state.value);
            //console.warn('DrDoc.historyAddPage: set archive: ', e.state.value);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', e.state.value);
        }
    });
    document.addEventListener('NodeUnloaded', function(e) {
        //console.log("NodeUnloaded");
        let nodeLoadedTarget = e.target;
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(triggerElem) {
            let bs_elem = bootstrap.Tooltip.getInstance(triggerElem);
            if (bs_elem) bs_elem.dispose();
        });
        nodeLoadedTarget.querySelectorAll('.tooltip.bs-tooltip-auto').forEach(function(triggerElem) {
            triggerElem.remove();
        });
    /*nodeLoadedTarget.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function (triggerElem) {
            let bs_elem = bootstrap.Dropdown.getInstance(triggerElem);
            if (bs_elem)
                bs_elem.dispose();
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function (triggerElem) {
            let bs_elem = bootstrap.Collapse.getInstance(triggerElem);
            if (bs_elem)
                bs_elem.dispose();
        });*/ });
    //window.addEventListener('dragover', null);
    //window.addEventListener('drop', null);
    //document.addEventListener('dragover', null);
    //document.addEventListener('drop', null);
    // Initialisierung
    document.addEventListener('NodeLoaded', function(e) {
        console.log("NodeLoaded DrDOC: ", e, e.target);
        let nodeLoadedTarget = e.target;
        $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
        //DrDoc.UpdateSplitPanel();
        //nodeLoadedTarget.querySelector('.selected-archive').val(value);
        //nodeLoadedTarget.querySelectorAll('[bind-conf-user]').forEach(DrDoc.configUser.BindConfig.bind(DrDoc.configUser));
        //nodeLoadedTarget.querySelectorAll('[bind-conf-dev]').forEach(DrDoc.configDevice.BindConfig.bind(DrDoc.configDevice));
        /*nodeLoadedTarget.querySelectorAll('[ondragover]').forEach(function (elem) {
            elem.setAttribute('draggable', 'true');
            elem.setAttribute('droppable', 'true');
            //if (elem.ondrop === undefined)
            //    elem.ondrop = function (ev) { };
    
            elem.addEventListener('dragover', function(ev)
            {
                console.log('dragover TEST');
              ev.preventDefault(); // Necessary. Allows us to drop.    
              ev.currentTarget.setAttribute('style', "border-top:solid;");   
            });
    
            //console.log('Drag/Drop: ', elem);
        });*/ nodeLoadedTarget.querySelectorAll('[bind-conf-user]').forEach(function(elem) {
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.BindConfig(elem, 'bind-conf-user');
        });
        nodeLoadedTarget.querySelectorAll('[bind-conf-dev]').forEach(function(elem) {
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.BindConfig(elem, 'bind-conf-dev');
        });
        /*var treeToggler = document.getElementsByClassName("tree-caret");
        if (treeToggler != undefined && treeToggler != null)
        {
            let updateTreeElem = function(elem) {
                if (elem.parentElement.querySelector(".tree-nested").classList.contains('tree-active'))
                    elem.classList.add("tree-caret-down");
                else
                    elem.classList.remove("tree-caret-down");
            }
            for (let i = 0; i < treeToggler.length; i++) {
                updateTreeElem(treeToggler[i]);
                treeToggler[i].addEventListener("click", function(e) {
                    e.target.parentElement.querySelector(".tree-nested").classList.toggle("tree-active");
                    updateTreeElem(e.target);
                });
            }
        }*/ // Tree View
        (0, $346VI.default).TreeView();
        //window.addEventListener("beforeunload", function() {
        //    return "Are you sure? You didn't finish the form!";
        //});
        // Drag n Drop
        (0, $346VI.default).dnd_init(document);
        /*document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!DrDocWeb.IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
                console.log('TAB: ', target, ' / ', bs_elem);
            }
        });*/ nodeLoadedTarget.querySelectorAll('[data-bs-toggle="tab"]').forEach(function(triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!(0, $346VI.default).IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
            //console.log('TAB: ', target, ' / ', bs_elem);
            }
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="pill"]').forEach(function(triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!(0, $346VI.default).IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
            }
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="popover"]').forEach(function(triggerElem) {
            let title = triggerElem.getAttribute('data-bs-content');
            if (!(0, $346VI.default).IsNullOrEmpty(title)) {
                const bs_elem = bootstrap.Popover.getOrCreateInstance(triggerElem);
            }
        //bs_elem.update();
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(triggerElem) {
            let title = triggerElem.getAttribute('data-bs-title');
            if (!(0, $346VI.default).IsNullOrEmpty(title)) {
                const bs_elem = bootstrap.Tooltip.getOrCreateInstance(triggerElem);
            }
        //bs_elem.update();
        });
        // --
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function(triggerElem) {
            if (triggerElem._hasHandlerX === true) return;
            triggerElem._hasHandlerX = true;
            let dropdown = triggerElem.parentNode;
            let dropdownMenu = null;
            let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
            if (!(0, $346VI.default).IsNullOrEmpty(triggerElemSelector)) dropdownMenu = nodeLoadedTarget.querySelector(triggerElemSelector);
            if (dropdownMenu == undefined || dropdownMenu == null) dropdownMenu = dropdown.querySelector('.dropdown-menu');
            let bsDropdown = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
            triggerElem.addEventListener('click', function() {
                //dropdown.classList.add('position-static');
                if (triggerElem._popper != undefined) triggerElem._popper.destroy();
                // noch nicht angezeigt? => anzeigen
                if (dropdownMenu.classList.contains('show')) {
                    dropdown.classList.remove('show');
                    dropdownMenu.classList.remove('show');
                    triggerElem.setAttribute('aria-expanded', false);
                } else {
                    let popperTmp = window.createPopper(dropdown, dropdownMenu, {
                        placement: 'bottom-end',
                        modifiers: {
                            offset: 0,
                            flip: {
                                enabled: true
                            },
                            preventOverflow: {
                                boundariesElement: 'viewport'
                            }
                        }
                    });
                    bsDropdown._popper = popperTmp;
                    triggerElem._popper = popperTmp;
                    triggerElem.focus();
                    triggerElem.setAttribute('aria-expanded', true);
                    dropdown.classList.add('show');
                    dropdownMenu.classList.add('show');
                //console.log('BS Dropdown Click: ', triggerElem, ' => ', dropdownMenu, ' / BS: ', triggerElem._popper);
                }
            });
        /*
            const bs_elem = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
            bs_elem._popper = window.createPopper;
            bs_elem.update();
            bs_elem.show();
            console.log('BS Dropdown Init: ', bs_elem);
            */ //DrDocWeb.BS_DropdownInit(triggerElem);
        });
        // Dropdowns beim Click nicht automatisch schließen
        // .dropdown-menu 
        // .dropdown-leave-open > .dropdown-item
        if (nodeLoadedTarget.querySelectorAll('.dropdown-leave-open > li > a.dropdown-item')) nodeLoadedTarget.querySelectorAll('.dropdown-leave-open > li > a.dropdown-item').forEach(function(elem) {
            elem.addEventListener("click", function(e) {
                e.stopPropagation();
            //console.log('click!');
            });
        });
        // --
        // Menu Main
        // Die Klasse "expanded" dem Element "#menu-main-drdoc" hinzufügen
        $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
        // --
        // Collapese Zustand aus Config laden/merken
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function(triggerElem) {
            if (triggerElem._hasCollapseHandler === true) return;
            triggerElem._hasCollapseHandler = true;
            let triggerElemExpandedValue = triggerElem.getAttribute('aria-expanded');
            let triggerElemExpanded = (0, $346VI.default).IsNullOrEmpty(triggerElemExpandedValue) ? null : triggerElemExpandedValue == 'true';
            let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
            let targetElemArr = nodeLoadedTarget.querySelectorAll(triggerElemSelector);
            if (targetElemArr == null) return;
            if (targetElemArr.length > 1) console.log('more then one target: [data-bs-toggle="collapse"]: ', targetElemArr.length, ' / ', targetElemArr);
            let targetElem = targetElemArr[0];
            //targetElemArr.forEach(function (targetElem) {
            if (targetElem == null) return;
            const bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem, {
                toggle: false
            });
            // Attribute [aria-expanded] undefined?
            // Init State from Config
            if (!(0, $346VI.default).IsNullOrEmpty(triggerElemSelector) && targetElem != undefined && targetElem != null) {
                let confName = 'view/collapse-menu/' + triggerElemSelector.substring(1);
                // on Show
                targetElem.addEventListener('show.bs.collapse', function(e) {
                    //console.log('show.bs.collapse: ', targetElem, confName);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(confName, true);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                // on Hide
                targetElem.addEventListener('hide.bs.collapse', function(e) {
                    //console.log('hide.bs.collapse: ', targetElem, confName);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(confName, false);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                // Menü links einklappen/ausklappen
                targetElem.addEventListener('shown.bs.collapse', function(e) {
                    //console.log('shown.bs.collapse: ', targetElem);
                    //DrDoc.configDevice.set(confName, true);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                targetElem.addEventListener('hidden.bs.collapse', function(e) {
                    //console.log('hidden.bs.collapse: ', targetElem);
                    //DrDoc.configDevice.set(confName, false);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                if (triggerElemExpanded == null) {
                    console.log('init.bs.collapse: ', triggerElem, confName);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribeBool(confName, function(valueNew, valueOld) {
                        const bs_elem2 = bootstrap.Collapse.getOrCreateInstance(targetElem);
                        if (valueNew === true) //console.log('init.bs.collapse SHOW: onChange: ', confName, valueNew, valueOld);
                        bs_elem2.show();
                        if (valueNew === false) //console.log('init.bs.collapse HIDE: onChange: ', confName, valueNew, valueOld);
                        bs_elem2.hide();
                    }, false);
                }
            }
            // Element inital einklappen / ausklappen
            if (triggerElemExpanded === true) //console.log('init.bs.collapse: aria-expanded=true SHOW: ', targetElem, triggerElem, confName);
            bs_elem.show();
            else if (triggerElemExpanded === false) //console.log('init.bs.collapse: aria-expanded=false HIDE: ', targetElem, triggerElem, confName);
            bs_elem.hide();
        //});
        });
        // --
        // es können keine Attribute ohne Wert mit Expressions gesetzt werden.
        // für required, readonly, checked kann data-* verwendet werden
        // Allen Pflichtfeldern die Klasse "is-required-empty" hinzufügen
        function initMandatoryFields(e) {
            //console.log('mandatory field changed ', e, this);
            let elems = e.target; //$('[data-required="true"]');
            tmpval = elems.value;
            if ((0, $346VI.default).IsNullOrEmpty(tmpval)) {
                elems.classList.add('is-required-empty');
                elems.classList.remove('is-required-not-empty');
            } else {
                elems.classList.add('is-required-not-empty');
                elems.classList.remove('is-required-empty');
            }
        }
        nodeLoadedTarget.querySelectorAll('[data-required]').forEach(function(elem) {
            elem.removeAttribute('required');
        });
        nodeLoadedTarget.querySelectorAll('[data-required="true"]').forEach(function(elem) {
            elem.setAttribute('required', true);
            elem.addEventListener('change', initMandatoryFields);
            initMandatoryFields({
                target: elem
            });
        });
        let boolAttrs = [
            'readonly',
            'checked',
            'selected'
        ];
        for (let attrName of boolAttrs){
            if (!nodeLoadedTarget.querySelectorAll('[data-' + attrName + ']')) continue;
            nodeLoadedTarget.querySelectorAll('[data-' + attrName + ']').forEach(function(elem) {
                elem.removeAttribute(attrName);
            });
            var setCheckElem = function(elem, attrName, checked) {
                elem.setAttribute('data-' + attrName, checked);
                if (checked) elem.setAttribute(attrName, true);
                else elem.removeAttribute(attrName);
            };
            nodeLoadedTarget.querySelectorAll('[data-' + attrName + '="false"]').forEach(function(elem) {
                setCheckElem(elem, attrName, false);
                elem.addEventListener('change', function(e) {
                    setCheckElem(e.target, attrName, e.target.checked);
                });
            });
            nodeLoadedTarget.querySelectorAll('[data-' + attrName + '="true"]').forEach(function(elem) {
                setCheckElem(elem, attrName, true);
                elem.addEventListener('change', function(e) {
                    setCheckElem(e.target, attrName, e.target.checked);
                });
            });
        }
        if (nodeLoadedTarget.querySelector('[required] [data-selected]')) nodeLoadedTarget.querySelectorAll('[required] [data-selected]').forEach(function(optionElem) {
            //nodeLoadedTarget.querySelector(optionElem.parentNode).on('change', initMandatoryFields);
            //nodeLoadedTarget.querySelector(optionElem.parentNode).each(initMandatoryFields);
            initMandatoryFields({
                target: optionElem
            });
        });
        // Focus auf SteuerElemente bei Click
        let allLabels = nodeLoadedTarget.querySelectorAll('label[data-for]');
        if (allLabels != undefined && allLabels != null && allLabels.length > 0) //console.log('Label A: ', allLabels);
        allLabels.forEach(function(labelElem) {
            // document.querySelector('[form={{$@_this.Dataset.FormIDName}}][name={{$@_this.Name}}]')
            let selector = labelElem.getAttribute('data-for');
            if ((0, $346VI.default).IsNullOrEmpty(selector)) return;
            //console.log('Label B: ', selector, ' / ', labelElem);
            labelElem.addEventListener('click', function(e) {
                let selectorElem = nodeLoadedTarget.querySelector(selector);
                //console.log('Label C: ', selector, ' / node: ', selectorElem.nodeName.toLowerCase(), ' / type: ', selectorElem.getAttribute('type'), ' / ', selectorElem);
                if (selectorElem != undefined && selectorElem != null) /*if (selectorElem.nodeName.toLowerCase() == 'input' && selectorElem.getAttribute('type') == 'checkbox')
                        {
                            selectorElem.checked = !selectorElem.checked;
                        }
                        else
                        {*/ selectorElem.focus();
            });
        });
        // --
        /*
        // Toggle Control automatisch öffnen/schließen je nach Endgerät
        $('.ds-nav').each(function(i) {
            let bsCollapse = bootstrap.Collapse.getInstance(this);
     
            // falls bereits eine Instanz exisitert, überspringen
            if (bsCollapse !== undefined && bsCollapse !== null)
                return;
     
            bsCollapse = new bootstrap.Collapse(this, {
              toggle: false
            });
     
            //console.log('toggler', bsCollapse, DrDocWeb.IsMobile());
     
            //if (DrDocWeb.IsMobile())
            //    bsCollapse.hide();
            //else
                bsCollapse.show();
        });
     
        // --
        */ let onLoadDoc = function(e) {
            if (window.DrDoc == undefined) return;
            console.log('Dr.DOC Init(): onLoadDocument');
            $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
            (0, $346VI.default).TreeView();
            //window.addEventListener('resize', DrDoc.SetViewInit);
            window.addEventListener('beforeunload', $2687097d5145937a$export$2e2bcd8739ae039.CloseAllDocumentWnd);
            //DrDoc.UpdateViewMode();
            // SetViewList() ruft intern UpdateView() auf
            //DrDoc.SetViewList();
            //setTimeout(DrDoc.SetViewInit, 500);
            (0, $346VI.default).TreeView();
        };
        if (document.readyState === "loading") //console.log('document.readyState === "loading"');
        document.addEventListener('DOMContentLoaded', onLoadDoc);
        else //console.log('onLoadDoc()');
        onLoadDoc();
    });
    // NodeLoaded Ende
    console.log('Dr.DOC Init() END');
};
$2687097d5145937a$export$2e2bcd8739ae039.Init();

});
parcelRegister("a7Paw", function(module, exports) {
//import Popper from 'popperjs'
//import './node_modules/@popperjs/core/dist/esm/index.js';
//import * as Popper from './node_modules/@popperjs/core/dist/umd/popper.min.js';
//window.Popper = Popper;
//import * as Popper from "@popperjs/core"
//window.Popper = Popper;
// // import '@popperjs/core';
//import * from './node_modules/@popperjs/core/dist/esm/index.js';
//import { createPopper } from './node_modules/@popperjs/core/dist/esm/popper.js';

var $2oJ1v = parcelRequire("2oJ1v");

var $cw24N = parcelRequire("cw24N");

var $346VI = parcelRequire("346VI");
window.createPopper = (0, $2oJ1v.createPopper);
// Or import only needed plugins, specify which plugins you need:
// import { Tooltip, Toast, Popover } from 'bootstrap'
// Or import just one
//import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
window.bootstrap = $cw24N;
// --
// Bootstrap Modal
(0, $346VI.default).Modal = function(title, body, options) {
    if ((0, $346VI.default).IsNullOrEmpty(title) && (0, $346VI.default).IsNullOrEmpty(body)) {
        console.warn('DrDocWeb.Modal: empty arg title + body');
        return;
    }
    !(0, $346VI.default).IsNullOrEmpty(title) && (0, $346VI.default).IsNullOrEmpty(body);
    /*if (doc === undefined || doc === null)
    {
        doc = document;
    }*/ //var doc = (elm.ownerDocument || document);
    var doc = document;
    if (body != undefined && typeof body !== 'string' && body.ownerDocument !== undefined) doc = body.ownerDocument;
    var id = 'modal-dialog-id-' + (0, $346VI.default).RandomChars(12);
    // https://getbootstrap.com/docs/5.0/components/modal/
    var modalClassName = 'modal drdoc-modal';
    var dialogClassName = 'modal-dialog modal-dialog-scrollable';
    let className = 'modal-content';
    //let attributesName = '';
    let optionBackdrop = true;
    if (options !== null && options !== undefined && typeof options === 'object') {
        if (options.fullScreen === true) dialogClassName += ' modal-fullscreen';
        else {
            let size = options.size ? options.size : 'xl';
            // automatisch full-screen, wenn kleiner als XXL
            dialogClassName += ` modal-${size} modal-fullscreen-${size}-down`;
        //dialogClassName += ' modal-xl modal-fullscreen-lg-down';
        }
        //if (options.scrollable === true || options.scrollable === undefined)
        //    dialogClassName += ' modal-fullscreen-sm-down'; // ' modal-xl'; // ' modal-lg';
        if (options.color == 'success') className = 'alert alert-success';
        else if (options.color == 'warning') className = 'alert alert-warning';
        else if (options.color == 'info') className = 'alert alert-info';
        else if (options.color == 'danger' || options.color == 'error') className = 'alert alert-danger';
        if (options.static === true) optionBackdrop = 'static';
        else if (options.backdrop === true) optionBackdrop = true;
        else if (options.backdrop === false) optionBackdrop = false;
    }
    let bodyHtml = `
      <div class="modal-body">

      </div>`;
    /*if (body !== undefined)
    {
        body = `
      <div class="modal-body">
        ${body}
      </div>`;
    }*/ if (!(0, $346VI.default).IsNullOrEmpty(title)) title = `
      <h5 class="modal-title">
        ${title.toHtmlEntities()}
      </h5>`;
    let modalsAll = doc.querySelectorAll('.drdoc-modal');
    // console.log('Modals', modalsAll);
    if (modalsAll !== undefined && modalsAll !== null) {
        modalClassName += ' l' + (modalsAll.length + 1).toString();
        // die "active"-Klasse aus allen Modals entfernen
        for (let itm of modalsAll)//$(modalsAll[i]).removeClass('active');
        itm.classList.remove('active');
    } else modalClassName += 'l0';
    modalClassName += ' active';
    var elem = doc.createElement('div');
    // elem.innerHTML
    (0, $346VI.default).setInnerHTML(elem, `
<div class="${modalClassName}" x-tabindex="-1" id="${id}">
  <div class="${dialogClassName}">
    <div class="${className}">
      <div class="modal-header pt-2 pb-2 x-bg-gradient x-box x-bg-light">
        ${title}
        <!--<div style="margin-left: auto">
        <button type="button" class="btn btn-secondary">Prev</button>
        <button type="button" class="btn btn-secondary" onclick="">Next</button>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>-->
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onclick="DrDocWeb.ModalClose(this);"></button>
      </div>
      ${bodyHtml}
      <!--
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
      -->
    </div>
  </div>
</div>
    `, doc);
    // Modal DOM-Elem der Seite hinzufpgen
    // getElementById('modal-container')
    doc.body.appendChild(elem);
    // elem neu laden
    elem = doc.getElementById(id);
    if (elem === undefined || elem === null) console.error('Modal: elem ist null, obwohl es gerade erstellt wurde', id);
    var bs = new $cw24N.Modal(elem, {
        keyboard: true,
        focus: true,
        backdrop: optionBackdrop
    });
    console.log('BS Backdrop: ', optionBackdrop);
    // Wenn Body ein Element ist, dann als Element einbinden
    if (body != undefined) {
        let bodyModalElem = elem.querySelector('.modal-body');
        if (bodyModalElem != undefined) {
            if (typeof body === 'string') {
                if (body != title) bodyModalElem.innerHTML = body; //.toHtmlEntities();
            } else bodyModalElem.appendChild(body);
        }
    }
    //setTimeout(function() {
    bs.show();
    //bs.toggle();
    //}, 1000);
    //bs.focus();
    // Event, wenn Modal geschlossen wird
    elem.addEventListener('hide.bs.modal', function(event) {
        //console.log('hide.bs.modal');
        let elem = doc.getElementById(id);
        elem.classList.add('hide');
        elem.classList.remove('active');
        // vorletztes Modal wieder aktivieren durch Setzen der "active"-Klasse
        let modalsAll = doc.querySelectorAll('.drdoc-modal');
        if (modalsAll !== undefined && modalsAll !== null && modalsAll.length > 1) modalsAll[modalsAll.length - 2].classList.add('active');
    });
    bs.close = function(event, removeChilds) {
        if (bs == null || bs._closed === true) return;
        bs._closed = true;
        //console.log('close hidden.bs.modal 1');
        bs.hide();
        // alle Elemente des Modal Content aus dem DOM entfernen
        if (removeChilds === undefined || removeChilds === true) while(elem.firstChild)elem.removeChild(elem.lastChild);
        //console.log('close hidden.bs.modal 2');
        setTimeout(function() {
            let elem = doc.getElementById(id);
            if (elem != undefined) elem.remove();
            if (bs != undefined) bs.dispose();
        //console.log('close hidden.bs.modal 3');
        }, 200);
    };
    // Beim schließen aus DOM entfernen
    elem.addEventListener('hidden.bs.modal', bs.close);
    return bs;
};
(0, $346VI.default).ModalSecondary = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'secondary',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalInfo = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'info',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalWarning = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'warning',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalWarn = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'warning',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalOk = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'success',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalError = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'danger',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).GetModalError = function(title, body) {
    return function(error) {
        console.warn(error);
        return (0, $346VI.default).ModalError(title, body);
    };
};
(0, $346VI.default).ModalGet = function(element) {
    if (element === null || element === undefined) return undefined;
    if (typeof element === 'string') element = document.querySelector(element);
    if (element.classList !== undefined && element.classList.contains('drdoc-modal')) {
        //var modal = bootstrap.Modal.getOrCreateInstance(element);
        var modal = $cw24N.Modal.getInstance(element);
        return modal;
    } else if (element.parentNode !== undefined && element.parentNode !== null) return (0, $346VI.default).ModalGet(element.parentNode);
};
(0, $346VI.default).ModalClose = function(element, removeChilds) {
    let modal = (0, $346VI.default).ModalGet(element);
    if (modal !== null && modal !== undefined) {
        //modal.hide();
        modal.close(undefined, removeChilds);
        return true;
    } else //console.log('DrDocWeb.ModalClose: Element nicht gefunden: ', element);
    return false;
};
(0, $346VI.default).ModalProgress = function(title) {
    let progressBarId = 'progress-' + (0, $346VI.default).RandomChars(12);
    let progressBarHtml = `
<div id="${progressBarId}-spinner" class="d-flex justify-content-center">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div id="${progressBarId}" style="display: none;" class="progress" role="progressbar" aria-label="${title}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
    <div id="${progressBarId}-bar" class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 0%;"></div>
</div>
`;
    let progressBarModal = (0, $346VI.default).ModalSecondary(title, progressBarHtml);
    progressBarModal.setPercentComplete = function(percentComplete) {
        // Spinner ausblenden und Bar einblenden, wenn Complete verwendet wird
        if (percentComplete == null || percentComplete == undefined) percentComplete = 0;
        if (percentComplete > 100) percentComplete = 100;
        console.log('Modal setPercentComplete = function (percentComplete) => ', percentComplete);
        let progressBarElem = document.getElementById(progressBarId);
        progressBarElem.style.display = 'block';
        progressBarElem.setAttribute('aria-valuenow', percentComplete);
        if (document.getElementById(progressBarId + '-spinner')) {
            document.getElementById(progressBarId + '-spinner').style.display = 'none!important';
            document.getElementById(progressBarId + '-spinner').classList.add('d-none');
        }
        if (document.getElementById(progressBarId + '-bar')) {
            document.getElementById(progressBarId + '-bar').style.width = percentComplete + '%';
            document.getElementById(progressBarId + '-bar').innerText = Math.round(percentComplete) + '%';
        }
    };
    //progressBarModal.setPercentComplete(0);
    return progressBarModal;
};
// --
// Bootstrap Wrapper
(0, $346VI.default).BS_TabShowFirst = function(containerElem) {
    if (containerElem == undefined || containerElem == null) containerElem = document;
    //if (typeof containerElem === 'string')
    var tabElems = containerElem.querySelectorAll('[data-bs-toggle="pill"], [data-bs-toggle="tab"]');
    if (tabElems != null && tabElems != undefined && tabElems.length > 0) (0, $346VI.default).BS_TabShow(tabElems[0]);
    tabElems.forEach(function(tabElem, tabIndex) {
        tabElem.addEventListener('click', function(e) {
            //console.log('Tab Click', tabIndex, e, tabElem);
            (0, $346VI.default).BS_TabShow(tabElems[tabIndex]);
        //DrDocWeb.BS_TabShow(e.target);
        });
    });
};
(0, $346VI.default).BS_TabShow = function(tabElem) {
    if (tabElem == null || tabElem == undefined) return undefined;
    if (typeof tabElem === 'string') tabElem = (0, $346VI.default).BS_TabShow(document.querySelector(tabElem));
    let elemTriggerBS = $cw24N.Tab.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Tab.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Tab(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_TabShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_TabShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_CollapseShow = function(tabElem) {
    if (tabElem == null || tabElem == undefined) return undefined;
    if (typeof tabElem === 'string') tabElem = document.querySelector(tabElem);
    let elemTriggerBS = $cw24N.Collapse.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Collapse.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Collapse(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_CollapseShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_CollapseShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_DropdownShow = function(tabElem) {
    if (tabElem == null || tabElem == undefined) return undefined;
    if (typeof tabElem === 'string') tabElem = document.querySelector(tabElem);
    let elemTriggerBS = $cw24N.Dropdown.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Dropdown.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Dropdown(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_DropdownShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_DropdownShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_TabHide = function(tabElem) {
    if (typeof tabElem === 'string') tabElem = document.querySelector(tabElem);
    let elemTriggerBS = $cw24N.Tab.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Tab.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Tab(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.hide();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_TabHide: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_TabHide: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_DropdownInit = function(triggerElem) {
    /*const dropdown = new bootstrap.Dropdown(triggerElem, {
        popperConfig(defaultBsPopperConfig) {
          // const newPopperConfig = {...}
          // use defaultBsPopperConfig if needed...
          // return newPopperConfig
        }
      });
      dropdown.update();*/ triggerElem.removeEventListener('click', (0, $346VI.default).BS_Dropdown_OnClick);
    triggerElem.addEventListener('click', (0, $346VI.default).BS_Dropdown_OnClick);
//let dropdown = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
//dropdown.update();
};
(0, $346VI.default).BS_Dropdown_OnClick = function(e) {
    // Dropdown anzeigen
    //e.preventDefault();
    if (e.target == undefined || e.target == null) return;
    let dropdownElem = e.target.parentNode.querySelector('.dropdown-menu');
    if (dropdownElem == undefined || dropdownElem == null) return;
    //dropdownElem.style.marginTop = '1.8rem';
    dropdownElem.style.position = 'absolute';
    //dropdownElem.style.transform = 'translate(148px)';
    if (dropdownElem.classList.contains('dropend')) dropdownElem.style.transform = `translate(${dropdownElem.parentNode.offsetWidth.toString()}px, -${dropdownElem.parentNode.offsetHeight.toString()}px)`;
    else dropdownElem.style.transform = `translate(0px, ${dropdownElem.parentNode.offsetHeight.toString()}px)`;
    dropdownElem.classList.toggle('show');
    console.log('BS_Dropdown_OnClick', e, this);
    //dropdownElem.trigger('click.bs.dropdown');
    //$(this).trigger('click.bs.dropdown');
    //$(this).trigger('show.bs.dropdown');
    let elemTriggerBS = $cw24N.Dropdown.getOrCreateInstance(e.target);
    //let elemTriggerBS = bootstrap.Dropdown.getInstance(this);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Dropdown(this);
    //console.log('BS_Dropdown_OnClick -> OPEN 1', e, elemTriggerBS._config);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        elemTriggerBS.update();
        //elemTriggerBS.toggle();
        //console.log(elemTriggerBS);
        return elemTriggerBS;
    }
    return undefined;
};
// onInitTargetElem (triggerElem, triggerElemSelector targetElem, cb_bs_elem_open, cb_bs_elem_close)
(0, $346VI.default).BS_Collapse = function(onInitTargetElem, onOpen, onClose) {
    // button[data-bs-toggle="collapse"]
    document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function(triggerElem) {
        if (triggerElem._hasHandler === true) return;
        triggerElem._hasHandler = true;
        //if (triggerElem.getAttribute('data-has-config-handler') == 'true')
        //    return;
        //triggerElem.setAttribute('data-has-config-handler', 'true');
        // Attribut [aria-expanded] verwenden, um die initiale
        let triggerElemExpandedValue = triggerElem.getAttribute('aria-expanded');
        let triggerElemExpanded = (0, $346VI.default).IsNullOrEmpty(triggerElemExpandedValue) ? null : triggerElemExpandedValue == 'true';
        let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
        if ((0, $346VI.default).IsNullOrEmpty(triggerElemSelector)) {
            console.warn('Collapse ', 'elemSelector === undefined', triggerElem);
            return;
        }
        let confName = 'view/collapse-menu/' + triggerElemSelector.substring(1);
        let targetElem_arr = document.querySelectorAll(triggerElemSelector);
        if (targetElem_arr === undefined || targetElem_arr == null) console.warn('Collapse ', 'targetElem_arr === undefined', triggerElem);
        //console.log('Collapse New ', triggerElemSelector, targetElem_arr, confName);
        targetElem_arr.forEach(function(targetElem) {
            if (targetElem._hasHandler === true) return;
            targetElem._hasHandler = true;
            let bs_elem = $cw24N.Collapse.getOrCreateInstance(targetElem);
            /*let bs_elem = bootstrap.Collapse.getInstance(targetElem);
            if (bs_elem == undefined || bs_elem == null)
            {
            bs_elem = new bootstrap.Collapse(targetElem, {
                toggle: false
            });
            }*/ //let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
            if (bs_elem._hasHandler === true) return;
            bs_elem._hasHandler = true;
            //bs_elem.hide();
            //bs_elem._isOpen = false;
            const WAIT_TIME = 10;
            var bs_elem_open = function(signal) {
                bs_elem = $cw24N.Collapse.getOrCreateInstance(targetElem);
                //console.warn('[+] Target Show ', confName, triggerElemSelector, bs_elem);
                //DrDoc.configDevice.set(confName, true);
                bs_elem._isOpen = true;
                bs_elem.show();
                bs_elem._element.classList.add('show');
                triggerElem.setAttribute('aria-expanded', 'true');
                targetElem.classList.add('show');
                targetElem.classList.remove('collapsed');
                onOpen(triggerElem, triggerElemSelector);
            /*if (signal)
                {
                setTimeout(function () {
                    bs_elem_open(false);
                    //triggerElem.setAttribute('aria-expanded', 'true');
                    //targetElem.classList.add('show');
                    //if (window.updateMainMenuExpansion !== undefined)
                    //    window.updateMainMenuExpansion();
                    onOpen(triggerElem, triggerElemSelector);
                }, WAIT_TIME/2);
                }*/ };
            var bs_elem_close = function(signal) {
                bs_elem = $cw24N.Collapse.getOrCreateInstance(targetElem);
                //console.warn('[-] Target Hide ', confName, triggerElemSelector, bs_elem);
                //DrDoc.configDevice.set(confName, false);
                bs_elem._isOpen = false;
                bs_elem.hide();
                triggerElem.setAttribute('aria-expanded', 'false');
                targetElem.classList.remove('show');
                targetElem.classList.add('collapsed');
                if (signal) {
                    setTimeout(function() {
                        bs_elem_close(false);
                        //triggerElem.setAttribute('aria-expanded', 'false');
                        //targetElem.classList.remove('show');
                        //if (window.updateMainMenuExpansion !== undefined)
                        //    window.updateMainMenuExpansion();
                        onClose(triggerElem, triggerElemSelector);
                    }, WAIT_TIME / 2);
                    setTimeout(function() {
                        bs_elem_close(false);
                    }, 2 * WAIT_TIME);
                    setTimeout(function() {
                        bs_elem_close(false);
                    }, 10 * WAIT_TIME);
                    setTimeout(function() {
                        bs_elem_close(false);
                    }, 50 * WAIT_TIME);
                }
            };
            //console.log('try close 1', bs_elem);
            bs_elem_close(false);
            if (triggerElemExpanded === true) bs_elem_open(true);
            else if (triggerElemExpanded === false) //console.log('BS Collapse Init: Force Close: ', triggerElemExpanded, triggerElem);
            bs_elem_close(true);
            // Collapse lässt sich nicht soofort schlieeßen!
            setTimeout(function() {
                //console.log('init', bs_elem);
                onInitTargetElem(triggerElem, triggerElemSelector, targetElem, bs_elem_open, bs_elem_close, triggerElemExpanded);
                /*console.log('try close 2');
                bs_elem_close(false);

                setTimeout(function () {
                    console.log('init')
                onInitTargetElem(triggerElem, triggerElemSelector, targetElem); //, bs_elem_open, bs_elem_close);
                //}, 5000);*/ // Wenn irgendwo ins Dokument geklickt wird, das Dropdown schließen
                // Event handler erst nach ein paar Millisekunden aufrufen, da er sonst sofort aufgerufen wird, da gerade geklickt wird.
                /*triggerElem.addEventListener('click', function(e_click) {
                    console.log('BS_Collapse: onClick: triggerElem: ', e_click.target, triggerElem, targetElem);
                    bs_elem_close(true);
                });*/ // Beim Click auf Menu Item, das Menü schließen
                if ((0, $346VI.default).IsMobile()) {
                    targetElem.querySelectorAll('a').forEach(function(targetElemLink) {
                        targetElemLink.addEventListener('click', function(e_click) {
                            console.log('BS_Collapse: onClick: targetElem: ', e_click.target, triggerElem, targetElem);
                            bs_elem_close(true);
                        });
                    });
                    targetElem.querySelectorAll('button').forEach(function(targetElemLink) {
                        targetElemLink.addEventListener('click', function(e_click) {
                            console.log('BS_Collapse: onClick: targetElem: ', e_click.target, triggerElem, targetElem);
                            bs_elem_close(true);
                        });
                    });
                }
            }, WAIT_TIME);
            triggerElem.addEventListener('click', function(e) {
                e.preventDefault();
                if (!bs_elem._isOpen) //if (!targetElem.classList.contains('show'))
                {
                    console.log('Menu is closed -> open: ', targetElem.className, targetElem.classList.contains('show'), bs_elem._isOpen);
                    bs_elem_open(true);
                } else {
                    console.log('Menu is open -> close: ', targetElem.className, targetElem.classList.contains('show'), bs_elem._isOpen);
                    bs_elem_close(true);
                }
            });
        /*
            //console.warn('DrDoc.configDevice.subscribeBool PRE ', confName);
            DrDoc.configDevice.subscribeBool(confName, function (valueNew, valueOld) {
                //let bs_elem = new bootstrap.Collapse(targetElem);
                //let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                console.info('DrDoc.configDevice.subscribeBool POST ', confName, ' => ', valueNew); //, '  ', triggerElemSelector, bs_elem);

                //if (bs_elem) {
                    if (valueNew === true) {
                        bs_elem_open();
                    }
                    else {
                        bs_elem_close();
                    }
                //}
            }, false);

            triggerElem.addEventListener('click', function () {
                let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                DrDoc.configDevice.set(confName, !bs_elem._isOpen);
            });*/ /*targetElem.addEventListener('hidden.bs.collapse', function () {
                console.warn('Target Hide ', confName, triggerElemSelector, bs_elem);
                DrDoc.configDevice.set(confName, false);
                bs_elem._isOpen = false;
                bs_elem.hide();
            });
            targetElem.addEventListener('shown.bs.collapse', function () {
                console.warn('Target Show ', confName, triggerElemSelector, bs_elem);
                DrDoc.configDevice.set(confName, true);
                bs_elem._isOpen = true;
                bs_elem.show();
            });*/ });
    });
}; // --
 /*
DrDoc.BS_NavInitTabs = function(id)
{
    // Ersten Tab automatisch laden
    //var triggerTabList = document.querySelectorAll('#nav-tab button');
    //var triggerTab = document.querySelector('#nav-tab-' + id + ' button:first-child');
    //var triggerTab = document.querySelector('#' + id + ' button:first-child');
    var triggerTab = DrDocWeb.GetElement('#' + id);
    if (triggerTab !== undefined && triggerTab !== null)
    {
        let tabs = triggerTab.querySelectorAll('button'); //:first-child');
        
        console.log('BS_NavInitTabs', id); //, triggerTab);
        if (tabs === undefined || tabs === null)
        {
            console.warn('MaskLoadFirstTab: Erster Tab (BS) konnte nicht gefunden werden!', id);
        }
        else
        {
            if (tabs.length === 0)
            {
                console.warn('MaskLoadFirstTab: 0 Tabs gefunden', id);
            }
            else
            {
                //for (let i = 0; i < 1; i++)
                for (let i = 0; i < tabs.length; i++)
                {
                    let triggerEl = tabs[i];
                    let tabTriggerBS = bootstrap.Tab.getInstance(triggerEl);
                    if (tabTriggerBS === undefined || tabTriggerBS === null)
                        tabTriggerBS = new bootstrap.Tab(triggerEl);
                        
                    triggerEl.addEventListener('click', function (event) {
                        //console.log('Show!');
                        event.preventDefault();
                        tabTriggerBS.show();
                    });

                    if (i === 0)
                    {
                        //console.log('MaskLoadFirstTab: Erster Tab wurde geladen', id, i, tabTriggerBS);
                        //tabTriggerBS.show();

                    }
                    else
                    {
                        //console.log('MaskLoadFirstTab: X-ter Tab wurde geladen', id, i);
                        //tabTriggerBS.show();
                    }
                }
                for (let i = 0; i < 1; i++)
                {
                    let triggerEl = tabs[i];
                    let tabTriggerBS = bootstrap.Tab.getInstance(triggerEl);

                        setTimeout(function() {
                            tabTriggerBS.show();
                            console.log(tabTriggerBS);
                        }, 1000);
                }
            }
        }
    }
    else {
        console.warn('MaskLoadFirstTab: Erster Tab konnte nicht gefunden werden!', id);
    }
};*/ 

});
parcelRegister("2oJ1v", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);

var $fqRLw = parcelRequire("fqRLw");

var $lUt2x = parcelRequire("lUt2x");

var $k1fcs = parcelRequire("k1fcs");

var $hfLNM = parcelRequire("hfLNM");

var $bjlic = parcelRequire("bjlic");

var $aE9ix = parcelRequire("aE9ix");

var $fhdOY = parcelRequire("fhdOY");

var $4lgpD = parcelRequire("4lgpD");

var $2c83k = parcelRequire("2c83k");

var $201VR = parcelRequire("201VR");


var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $lUt2x.default),
    (0, $k1fcs.default),
    (0, $hfLNM.default),
    (0, $bjlic.default),
    (0, $aE9ix.default),
    (0, $fhdOY.default),
    (0, $4lgpD.default),
    (0, $2c83k.default),
    (0, $201VR.default)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fqRLw.popperGenerator)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fqRLw", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);
$parcel$export(module.exports, "createPopper", () => $b3c2fd6800546b4b$export$8f7491d57c8f97a9);

var $4wmXH = parcelRequire("4wmXH");

var $4bNP2 = parcelRequire("4bNP2");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $10cit = parcelRequire("10cit");

var $dlaWb = parcelRequire("dlaWb");

var $657FY = parcelRequire("657FY");

var $leSQw = parcelRequire("leSQw");

var $iG0HL = parcelRequire("iG0HL");
var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $iG0HL.isElement)(reference) ? (0, $egjGe.default)(reference) : reference.contextElement ? (0, $egjGe.default)(reference.contextElement) : [],
                    popper: (0, $egjGe.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $10cit.default)((0, $657FY.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4wmXH.default)(reference, (0, $ecwzm.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $4bNP2.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlaWb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4wmXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34abf65a06d63352$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $hlFJX = parcelRequire("hlFJX");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $5LRDP = parcelRequire("5LRDP");

var $25Alw = parcelRequire("25Alw");

var $aPr9y = parcelRequire("aPr9y");
function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $aPr9y.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $aPr9y.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $iG0HL.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $iG0HL.isHTMLElement)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $5LRDP.default)(offsetParent);
    var rect = (0, $bkFj6.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6NwRo.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $25Alw.default)(documentElement)) scroll = (0, $hlFJX.default)(offsetParent);
        if ((0, $iG0HL.isHTMLElement)(offsetParent)) {
            offsets = (0, $bkFj6.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $cJ1Bs.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bkFj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $84019ab652aa921b$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");

var $aPr9y = parcelRequire("aPr9y");

var $jc5j7 = parcelRequire("jc5j7");

var $d9GIF = parcelRequire("d9GIF");
function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $iG0HL.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $aPr9y.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $aPr9y.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $iG0HL.isElement)(element) ? (0, $jc5j7.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d9GIF.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("iG0HL", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $d98cb23738a6d9d0$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $d98cb23738a6d9d0$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $d98cb23738a6d9d0$export$af51f0f06c0f328a);

var $jc5j7 = parcelRequire("jc5j7");
function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jc5j7.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jc5j7.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $jc5j7.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jc5j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $df9341392e6ed7b1$export$2e2bcd8739ae039);
function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("aPr9y", function(module, exports) {

$parcel$export(module.exports, "max", () => $7e23bad950468b82$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $7e23bad950468b82$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $7e23bad950468b82$export$2077e0241d6afd3c);
var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d9GIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $993d40d65cc118cd$export$2e2bcd8739ae039);

var $cqLtw = parcelRequire("cqLtw");
function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cqLtw.default)());
}

});
parcelRegister("cqLtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $90ccbd5892233dd2$export$2e2bcd8739ae039);
function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("hlFJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca14c6927ef497ac$export$2e2bcd8739ae039);

var $8Z1VN = parcelRequire("8Z1VN");

var $jc5j7 = parcelRequire("jc5j7");

var $iG0HL = parcelRequire("iG0HL");

var $crSja = parcelRequire("crSja");
function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $jc5j7.default)(node) || !(0, $iG0HL.isHTMLElement)(node)) return (0, $8Z1VN.default)(node);
    else return (0, $crSja.default)(node);
}

});
parcelRegister("8Z1VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a584be1dc90596$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $jc5j7.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("crSja", function(module, exports) {

$parcel$export(module.exports, "default", () => $9102221f9e13ae54$export$2e2bcd8739ae039);
function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("6NwRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f30cf0ce50e075e$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("cJ1Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $943aee5c7065ad53$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $5LRDP = parcelRequire("5LRDP");

var $8Z1VN = parcelRequire("8Z1VN");
function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bkFj6.default)((0, $5LRDP.default)(element)).left + (0, $8Z1VN.default)(element).scrollLeft;
}

});
parcelRegister("5LRDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $433af39bc2fae35d$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $iG0HL.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("25Alw", function(module, exports) {

$parcel$export(module.exports, "default", () => $18583dfdff147fd4$export$2e2bcd8739ae039);

var $5Edas = parcelRequire("5Edas");
function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5Edas.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5Edas", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cae7042543c5d5$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $jc5j7.default)(element).getComputedStyle(element);
}

});



parcelRegister("4bNP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ced62b744c6cfe$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");
function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bkFj6.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("egjGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a621d360f1a81b88$export$2e2bcd8739ae039);

var $5nNqk = parcelRequire("5nNqk");

var $23yvR = parcelRequire("23yvR");

var $jc5j7 = parcelRequire("jc5j7");

var $25Alw = parcelRequire("25Alw");
function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $5nNqk.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jc5j7.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $25Alw.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $23yvR.default)(target)));
}

});
parcelRegister("5nNqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb5703c925e0e5d$export$2e2bcd8739ae039);

var $23yvR = parcelRequire("23yvR");

var $25Alw = parcelRequire("25Alw");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $6NwRo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $iG0HL.isHTMLElement)(node) && (0, $25Alw.default)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $23yvR.default)(node));
}

});
parcelRegister("23yvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f6a21d28fc02f5$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $5LRDP = parcelRequire("5LRDP");

var $iG0HL = parcelRequire("iG0HL");
function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $6NwRo.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $iG0HL.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $5LRDP.default)(element) // fallback
    );
}

});



parcelRegister("ecwzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56b734280245ffb$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $6NwRo = parcelRequire("6NwRo");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $8WsnW = parcelRequire("8WsnW");

var $23yvR = parcelRequire("23yvR");

var $cqLtw = parcelRequire("cqLtw");
function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $iG0HL.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5Edas.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cqLtw.default)());
    var isIE = /Trident/i.test((0, $cqLtw.default)());
    if (isIE && (0, $iG0HL.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5Edas.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $23yvR.default)(element);
    if ((0, $iG0HL.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $iG0HL.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $6NwRo.default)(currentNode)) < 0){
        var css = (0, $5Edas.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $jc5j7.default)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $8WsnW.default)(offsetParent) && (0, $5Edas.default)(offsetParent).position === 'static')offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6NwRo.default)(offsetParent) === 'html' || (0, $6NwRo.default)(offsetParent) === 'body' && (0, $5Edas.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}

});
parcelRegister("8WsnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6829c22fb01dde5a$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");
function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $6NwRo.default)(element)) >= 0;
}

});


parcelRegister("10cit", function(module, exports) {

$parcel$export(module.exports, "default", () => $0baf5472b5ad4a5a$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");
function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $l6ej2.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("l6ej2", function(module, exports) {

$parcel$export(module.exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export(module.exports, "beforeRead", () => $f5c54167a3c62105$export$421679a7c3d56e);
$parcel$export(module.exports, "read", () => $f5c54167a3c62105$export$aafa59e2e03f2942);
$parcel$export(module.exports, "afterRead", () => $f5c54167a3c62105$export$6964f6c886723980);
$parcel$export(module.exports, "beforeMain", () => $f5c54167a3c62105$export$c65e99957a05207c);
$parcel$export(module.exports, "main", () => $f5c54167a3c62105$export$f22da7240b7add18);
$parcel$export(module.exports, "afterMain", () => $f5c54167a3c62105$export$bab79516f2d662fe);
$parcel$export(module.exports, "beforeWrite", () => $f5c54167a3c62105$export$8d4d2d70e7d46032);
$parcel$export(module.exports, "write", () => $f5c54167a3c62105$export$68d8715fc104d294);
$parcel$export(module.exports, "afterWrite", () => $f5c54167a3c62105$export$70a6e5159acce2e6);
$parcel$export(module.exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = 'top';
var $f5c54167a3c62105$export$40e543e69a8b3fbb = 'bottom';
var $f5c54167a3c62105$export$79ffe56a765070d2 = 'right';
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = 'left';
var $f5c54167a3c62105$export$dfb5619354ba860 = 'auto';
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = 'start';
var $f5c54167a3c62105$export$bd5df0f255a350f8 = 'end';
var $f5c54167a3c62105$export$390fd549c5303b4d = 'clippingParents';
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = 'viewport';
var $f5c54167a3c62105$export$ae5ab1c730825774 = 'popper';
var $f5c54167a3c62105$export$ca50aac9f3ba507f = 'reference';
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = 'beforeRead';
var $f5c54167a3c62105$export$aafa59e2e03f2942 = 'read';
var $f5c54167a3c62105$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = 'beforeMain';
var $f5c54167a3c62105$export$f22da7240b7add18 = 'main';
var $f5c54167a3c62105$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5c54167a3c62105$export$68d8715fc104d294 = 'write';
var $f5c54167a3c62105$export$70a6e5159acce2e6 = 'afterWrite';
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];

});


parcelRegister("dlaWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b65b878009bf47f$export$2e2bcd8739ae039);
function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("657FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d929ffbbd3136a$export$2e2bcd8739ae039);
function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});

parcelRegister("leSQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f765731200b57f98$export$2e2bcd8739ae039);

var $8vjqA = parcelRequire("8vjqA");

var $5LRDP = parcelRequire("5LRDP");

var $bkFj6 = parcelRequire("bkFj6");

var $kcANe = parcelRequire("kcANe");

var $fbi7z = parcelRequire("fbi7z");

var $l6ej2 = parcelRequire("l6ej2");

var $iG0HL = parcelRequire("iG0HL");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");
function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $l6ej2.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $l6ej2.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $l6ej2.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4QECX.default)(typeof padding !== 'number' ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
    var altContext = elementContext === (0, $l6ej2.popper) ? (0, $l6ej2.reference) : (0, $l6ej2.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $8vjqA.default)((0, $iG0HL.isElement)(element) ? element : element.contextElement || (0, $5LRDP.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bkFj6.default)(state.elements.reference);
    var popperOffsets = (0, $kcANe.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $fbi7z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $l6ej2.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $l6ej2.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $l6ej2.right),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $l6ej2.top),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("8vjqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $631049efb60e96c6$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ayVYt = parcelRequire("ayVYt");

var $5mmoF = parcelRequire("5mmoF");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $bkFj6 = parcelRequire("bkFj6");

var $23yvR = parcelRequire("23yvR");

var $ioj8K = parcelRequire("ioj8K");

var $6NwRo = parcelRequire("6NwRo");

var $fbi7z = parcelRequire("fbi7z");

var $aPr9y = parcelRequire("aPr9y");
function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bkFj6.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $l6ej2.viewport) ? (0, $fbi7z.default)((0, $ayVYt.default)(element, strategy)) : (0, $iG0HL.isElement)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fbi7z.default)((0, $5mmoF.default)((0, $5LRDP.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $egjGe.default)((0, $23yvR.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5Edas.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $iG0HL.isHTMLElement)(element) ? (0, $ecwzm.default)(element) : element;
    if (!(0, $iG0HL.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $iG0HL.isElement)(clippingParent) && (0, $ioj8K.default)(clippingParent, clipperElement) && (0, $6NwRo.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $aPr9y.max)(rect.top, accRect.top);
        accRect.right = (0, $aPr9y.min)(rect.right, accRect.right);
        accRect.bottom = (0, $aPr9y.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $aPr9y.max)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("ayVYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0a0ce1fa68929f$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $d9GIF = parcelRequire("d9GIF");
function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jc5j7.default)(element);
    var html = (0, $5LRDP.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d9GIF.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $cJ1Bs.default)(element),
        y: y
    };
}

});

parcelRegister("5mmoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e70615fb3e74824$export$2e2bcd8739ae039);

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $8Z1VN = parcelRequire("8Z1VN");

var $aPr9y = parcelRequire("aPr9y");
function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $5LRDP.default)(element);
    var winScroll = (0, $8Z1VN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $aPr9y.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $aPr9y.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $cJ1Bs.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5Edas.default)(body || html).direction === 'rtl') x += (0, $aPr9y.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ioj8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63950b756706495$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $iG0HL.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("fbi7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d5f0927fb8bf5c$export$2e2bcd8739ae039);
function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("kcANe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03cba2f7a1498b5f$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $fxYmH = parcelRequire("fxYmH");

var $l6ej2 = parcelRequire("l6ej2");
function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f6ekA.default)(placement) : null;
    var variation = placement ? (0, $ayUxD.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $l6ej2.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $l6ej2.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $l6ej2.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $l6ej2.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fxYmH.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $l6ej2.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $l6ej2.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("f6ekA", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe288682115fde3$export$2e2bcd8739ae039);

function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("ayUxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f0526e425773$export$2e2bcd8739ae039);
function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("fxYmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b518c35b71cf930f$export$2e2bcd8739ae039);
function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});


parcelRegister("4QECX", function(module, exports) {

$parcel$export(module.exports, "default", () => $387b887da02b7e69$export$2e2bcd8739ae039);

var $8WQnk = parcelRequire("8WQnk");
function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8WQnk.default)(), paddingObject);
}

});
parcelRegister("8WQnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $683c5e26d5f8bfe5$export$2e2bcd8739ae039);
function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("6CeE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d11a6decde23bf9$export$2e2bcd8739ae039);
function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});



parcelRegister("lUt2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jc5j7.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};

});

parcelRegister("k1fcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92fb10df1450f31$export$2e2bcd8739ae039);

var $kcANe = parcelRequire("kcANe");
function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $kcANe.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};

});

parcelRegister("hfLNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ecwzm = parcelRequire("ecwzm");

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $aPr9y = parcelRequire("aPr9y");
var $c8f8eadcf7685dc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $aPr9y.round)(x * dpr) / dpr || 0,
        y: (0, $aPr9y.round)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $l6ej2.left);
    var sideY = (0, $l6ej2.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ecwzm.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $jc5j7.default)(popper)) {
            offsetParent = (0, $5LRDP.default)(popper);
            if ((0, $5Edas.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $l6ej2.top) || (placement === (0, $l6ej2.left) || placement === (0, $l6ej2.right)) && variation === (0, $l6ej2.end)) {
            sideY = (0, $l6ej2.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $l6ej2.left) || (placement === (0, $l6ej2.top) || placement === (0, $l6ej2.bottom)) && variation === (0, $l6ej2.end)) {
            sideX = (0, $l6ej2.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jc5j7.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f6ekA.default)(state.placement),
        variation: (0, $ayUxD.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};

});

parcelRegister("bjlic", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("aE9ix", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $l6ej2 = parcelRequire("l6ej2");
function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f6ekA.default)(placement);
    var invertDistance = [
        (0, $l6ej2.left),
        (0, $l6ej2.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $l6ej2.placements).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7c04da2e958a3fe8$var$offset
};

});

parcelRegister("fhdOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);

var $bbSog = parcelRequire("bbSog");

var $f6ekA = parcelRequire("f6ekA");

var $ac6AR = parcelRequire("ac6AR");

var $leSQw = parcelRequire("leSQw");

var $iScBU = parcelRequire("iScBU");

var $l6ej2 = parcelRequire("l6ej2");

var $ayUxD = parcelRequire("ayUxD");
function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f6ekA.default)(placement) === (0, $l6ej2.auto)) return [];
    var oppositePlacement = (0, $bbSog.default)(placement);
    return [
        (0, $ac6AR.default)(placement),
        oppositePlacement,
        (0, $ac6AR.default)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f6ekA.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $bbSog.default)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f6ekA.default)(placement) === (0, $l6ej2.auto) ? (0, $iScBU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f6ekA.default)(placement);
        var isStartVariation = (0, $ayUxD.default)(placement) === (0, $l6ej2.start);
        var isVertical = [
            (0, $l6ej2.top),
            (0, $l6ej2.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $l6ej2.right) : (0, $l6ej2.left) : isStartVariation ? (0, $l6ej2.bottom) : (0, $l6ej2.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $bbSog.default)(mainVariationSide);
        var altVariationSide = (0, $bbSog.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("bbSog", function(module, exports) {

$parcel$export(module.exports, "default", () => $825ae98fe4f5d029$export$2e2bcd8739ae039);
var $825ae98fe4f5d029$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}

});

parcelRegister("ac6AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c023b5f4bd6339$export$2e2bcd8739ae039);
var $76c023b5f4bd6339$var$hash = {
    start: 'end',
    end: 'start'
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}

});

parcelRegister("iScBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd70d4ba9902caa$export$2e2bcd8739ae039);

var $ayUxD = parcelRequire("ayUxD");

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");

var $f6ekA = parcelRequire("f6ekA");
function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $l6ej2.placements) : _options$allowedAutoP;
    var variation = (0, $ayUxD.default)(placement);
    var placements = variation ? flipVariations ? (0, $l6ej2.variationPlacements) : (0, $l6ej2.variationPlacements).filter(function(placement) {
        return (0, $ayUxD.default)(placement) === variation;
    }) : (0, $l6ej2.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f6ekA.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("4lgpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3295dac8746ffe59$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $f6ekA = parcelRequire("f6ekA");

var $fxYmH = parcelRequire("fxYmH");

var $iByzU = parcelRequire("iByzU");

var $fHMKD = parcelRequire("fHMKD");

var $4bNP2 = parcelRequire("4bNP2");

var $ecwzm = parcelRequire("ecwzm");

var $leSQw = parcelRequire("leSQw");

var $ayUxD = parcelRequire("ayUxD");

var $8WQnk = parcelRequire("8WQnk");

var $aPr9y = parcelRequire("aPr9y");
function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $leSQw.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var variation = (0, $ayUxD.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fxYmH.default)(basePlacement);
    var altAxis = (0, $iByzU.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var altSide = mainAxis === 'y' ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $l6ej2.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $l6ej2.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4bNP2.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $8WQnk.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $fHMKD.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ecwzm.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $fHMKD.within)(tether ? (0, $aPr9y.min)(min, tetherMin) : min, offset, tether ? (0, $aPr9y.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var _altSide = mainAxis === 'x' ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $l6ej2.top),
            (0, $l6ej2.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $fHMKD.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $fHMKD.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("iByzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b68132b61080af$export$2e2bcd8739ae039);
function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("fHMKD", function(module, exports) {

$parcel$export(module.exports, "within", () => $b6f0b0266e764faa$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $b6f0b0266e764faa$export$86c8af6d3ef0b4a);

var $aPr9y = parcelRequire("aPr9y");
function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $aPr9y.max)(min, (0, $aPr9y.min)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("2c83k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1992f2d714808ab6$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $4bNP2 = parcelRequire("4bNP2");

var $ioj8K = parcelRequire("ioj8K");

var $ecwzm = parcelRequire("ecwzm");

var $fxYmH = parcelRequire("fxYmH");

var $fHMKD = parcelRequire("fHMKD");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");

var $l6ej2 = parcelRequire("l6ej2");
var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4QECX.default)(typeof padding !== 'number' ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var axis = (0, $fxYmH.default)(basePlacement);
    var isVertical = [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4bNP2.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $l6ej2.top) : (0, $l6ej2.left);
    var maxProp = axis === 'y' ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ecwzm.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $fHMKD.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ioj8K.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("201VR", function(module, exports) {

$parcel$export(module.exports, "default", () => $174d14927bb4f43b$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");
function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $l6ej2.top),
        (0, $l6ej2.right),
        (0, $l6ej2.bottom),
        (0, $l6ej2.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $leSQw.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $leSQw.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $174d14927bb4f43b$var$hide
};

});


parcelRegister("cw24N", function(module, exports) {

$parcel$export(module.exports, "Alert", () => $91ca15859685b28b$export$caec2af78bcc877f);
$parcel$export(module.exports, "Button", () => $91ca15859685b28b$export$353f5b6fc5456de1);
$parcel$export(module.exports, "Carousel", () => $91ca15859685b28b$export$144901db2ea8e967);
$parcel$export(module.exports, "Collapse", () => $91ca15859685b28b$export$78768a9af065a7b);
$parcel$export(module.exports, "Dropdown", () => $91ca15859685b28b$export$931cbfb6bfb85fc);
$parcel$export(module.exports, "Modal", () => $91ca15859685b28b$export$2b77a92f1a5ad772);
$parcel$export(module.exports, "Offcanvas", () => $91ca15859685b28b$export$591ca0244c9dfcd4);
$parcel$export(module.exports, "Tooltip", () => $91ca15859685b28b$export$28c660c63b792dea);
$parcel$export(module.exports, "Popover", () => $91ca15859685b28b$export$5b6b19405a83ff9d);
$parcel$export(module.exports, "ScrollSpy", () => $91ca15859685b28b$export$a6472a5298a374be);
$parcel$export(module.exports, "Tab", () => $91ca15859685b28b$export$3e41faf802a29e71);
$parcel$export(module.exports, "Toast", () => $91ca15859685b28b$export$8d8dc7d5f743331b);
/*!
  * Bootstrap v5.3.7 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $i9Aqn = parcelRequire("i9Aqn");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$elementMap = new Map();
const $91ca15859685b28b$var$Data = {
    set (element, key, instance) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) $91ca15859685b28b$var$elementMap.set(element, new Map());
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($91ca15859685b28b$var$elementMap.has(element)) return $91ca15859685b28b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) return;
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $91ca15859685b28b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$MAX_UID = 1000000;
const $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER = 1000;
const $91ca15859685b28b$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $91ca15859685b28b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $91ca15859685b28b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $91ca15859685b28b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $91ca15859685b28b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $91ca15859685b28b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER;
};
const $91ca15859685b28b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($91ca15859685b28b$var$TRANSITION_END));
};
const $91ca15859685b28b$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $91ca15859685b28b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($91ca15859685b28b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($91ca15859685b28b$var$parseSelector(object));
    return null;
};
const $91ca15859685b28b$var$isVisible = (element)=>{
    if (!$91ca15859685b28b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $91ca15859685b28b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $91ca15859685b28b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $91ca15859685b28b$var$findShadowRoot(element.parentNode);
};
const $91ca15859685b28b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $91ca15859685b28b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $91ca15859685b28b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $91ca15859685b28b$var$DOMContentLoadedCallbacks = [];
const $91ca15859685b28b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$91ca15859685b28b$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $91ca15859685b28b$var$DOMContentLoadedCallbacks)callback();
        });
        $91ca15859685b28b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $91ca15859685b28b$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $91ca15859685b28b$var$defineJQueryPlugin = (plugin)=>{
    $91ca15859685b28b$var$onDOMContentLoaded(()=>{
        const $ = $91ca15859685b28b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $91ca15859685b28b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $91ca15859685b28b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $91ca15859685b28b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $91ca15859685b28b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
        $91ca15859685b28b$var$execute(callback);
    };
    transitionElement.addEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $91ca15859685b28b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $91ca15859685b28b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $91ca15859685b28b$var$stripNameRegex = /\..*/;
const $91ca15859685b28b$var$stripUidRegex = /::\d+$/;
const $91ca15859685b28b$var$eventRegistry = {}; // Events storage
let $91ca15859685b28b$var$uidEvent = 1;
const $91ca15859685b28b$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $91ca15859685b28b$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $91ca15859685b28b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$91ca15859685b28b$var$uidEvent++}` || element.uidEvent || $91ca15859685b28b$var$uidEvent++;
}
function $91ca15859685b28b$var$getElementEvents(element) {
    const uid = $91ca15859685b28b$var$makeEventUid(element);
    element.uidEvent = uid;
    $91ca15859685b28b$var$eventRegistry[uid] = $91ca15859685b28b$var$eventRegistry[uid] || {};
    return $91ca15859685b28b$var$eventRegistry[uid];
}
function $91ca15859685b28b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $91ca15859685b28b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $91ca15859685b28b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $91ca15859685b28b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $91ca15859685b28b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $91ca15859685b28b$var$getTypeEvent(originalTypeEvent);
    if (!$91ca15859685b28b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $91ca15859685b28b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $91ca15859685b28b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $91ca15859685b28b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $91ca15859685b28b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $91ca15859685b28b$var$makeEventUid(callable, originalTypeEvent.replace($91ca15859685b28b$var$namespaceRegex, ''));
    const fn = isDelegated ? $91ca15859685b28b$var$bootstrapDelegationHandler(element, handler, callable) : $91ca15859685b28b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $91ca15859685b28b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $91ca15859685b28b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $91ca15859685b28b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $91ca15859685b28b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($91ca15859685b28b$var$stripNameRegex, '');
    return $91ca15859685b28b$var$customEvents[event] || event;
}
const $91ca15859685b28b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $91ca15859685b28b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $91ca15859685b28b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$91ca15859685b28b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($91ca15859685b28b$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $91ca15859685b28b$var$getjQuery();
        const typeEvent = $91ca15859685b28b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $91ca15859685b28b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $91ca15859685b28b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $91ca15859685b28b$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $91ca15859685b28b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $91ca15859685b28b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $91ca15859685b28b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $91ca15859685b28b$var$normalizeData(element.getAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $91ca15859685b28b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $91ca15859685b28b$var$isElement(value) ? 'element' : $91ca15859685b28b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$VERSION = '5.3.7';
/**
 * Class definition
 */ class $91ca15859685b28b$var$BaseComponent extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        element = $91ca15859685b28b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $91ca15859685b28b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $91ca15859685b28b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $91ca15859685b28b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $91ca15859685b28b$var$Data.get($91ca15859685b28b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $91ca15859685b28b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$91ca15859685b28b$var$parseSelector(sel)).join(',') : null;
};
const $91ca15859685b28b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$91ca15859685b28b$var$isDisabled(el) && $91ca15859685b28b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        if (selector) return $91ca15859685b28b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $91ca15859685b28b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($91ca15859685b28b$var$isDisabled(this)) return;
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$f = 'alert';
const $91ca15859685b28b$var$DATA_KEY$a = 'bs.alert';
const $91ca15859685b28b$var$EVENT_KEY$b = `.${$91ca15859685b28b$var$DATA_KEY$a}`;
const $91ca15859685b28b$var$EVENT_CLOSE = `close${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$EVENT_CLOSED = `closed${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE$5 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $91ca15859685b28b$export$caec2af78bcc877f extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$e = 'button';
const $91ca15859685b28b$var$DATA_KEY$9 = 'bs.button';
const $91ca15859685b28b$var$EVENT_KEY$a = `.${$91ca15859685b28b$var$DATA_KEY$9}`;
const $91ca15859685b28b$var$DATA_API_KEY$6 = '.data-api';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$3 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6 = `click${$91ca15859685b28b$var$EVENT_KEY$a}${$91ca15859685b28b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$353f5b6fc5456de1 extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$d = 'swipe';
const $91ca15859685b28b$var$EVENT_KEY$9 = '.bs.swipe';
const $91ca15859685b28b$var$EVENT_TOUCHSTART = `touchstart${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHMOVE = `touchmove${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHEND = `touchend${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERDOWN = `pointerdown${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERUP = `pointerup${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$POINTER_TYPE_TOUCH = 'touch';
const $91ca15859685b28b$var$POINTER_TYPE_PEN = 'pen';
const $91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $91ca15859685b28b$var$SWIPE_THRESHOLD = 40;
const $91ca15859685b28b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $91ca15859685b28b$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Swipe extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$91ca15859685b28b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$c;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$c;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$d;
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $91ca15859685b28b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $91ca15859685b28b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $91ca15859685b28b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_PEN || event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$c = 'carousel';
const $91ca15859685b28b$var$DATA_KEY$8 = 'bs.carousel';
const $91ca15859685b28b$var$EVENT_KEY$8 = `.${$91ca15859685b28b$var$DATA_KEY$8}`;
const $91ca15859685b28b$var$DATA_API_KEY$5 = '.data-api';
const $91ca15859685b28b$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $91ca15859685b28b$var$ORDER_NEXT = 'next';
const $91ca15859685b28b$var$ORDER_PREV = 'prev';
const $91ca15859685b28b$var$DIRECTION_LEFT = 'left';
const $91ca15859685b28b$var$DIRECTION_RIGHT = 'right';
const $91ca15859685b28b$var$EVENT_SLIDE = `slide${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_SLID = `slid${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN$1 = `keydown${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSEENTER$1 = `mouseenter${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_DRAG_START = `dragstart${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3 = `load${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5 = `click${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$CLASS_NAME_CAROUSEL = 'carousel';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$2 = 'active';
const $91ca15859685b28b$var$CLASS_NAME_SLIDE = 'slide';
const $91ca15859685b28b$var$CLASS_NAME_END = 'carousel-item-end';
const $91ca15859685b28b$var$CLASS_NAME_START = 'carousel-item-start';
const $91ca15859685b28b$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $91ca15859685b28b$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $91ca15859685b28b$var$SELECTOR_ACTIVE = '.active';
const $91ca15859685b28b$var$SELECTOR_ITEM = '.carousel-item';
const $91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM = $91ca15859685b28b$var$SELECTOR_ACTIVE + $91ca15859685b28b$var$SELECTOR_ITEM;
const $91ca15859685b28b$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $91ca15859685b28b$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $91ca15859685b28b$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $91ca15859685b28b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $91ca15859685b28b$var$KEY_TO_DIRECTION = {
    [$91ca15859685b28b$var$ARROW_LEFT_KEY$1]: $91ca15859685b28b$var$DIRECTION_RIGHT,
    [$91ca15859685b28b$var$ARROW_RIGHT_KEY$1]: $91ca15859685b28b$var$DIRECTION_LEFT
};
const $91ca15859685b28b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $91ca15859685b28b$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$144901db2ea8e967 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $91ca15859685b28b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$b;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$b;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($91ca15859685b28b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $91ca15859685b28b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($91ca15859685b28b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $91ca15859685b28b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $91ca15859685b28b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM_IMG, this._element))$91ca15859685b28b$var$EventHandler.on(img, $91ca15859685b28b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $91ca15859685b28b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $91ca15859685b28b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $91ca15859685b28b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $91ca15859685b28b$var$ORDER_NEXT;
        const nextElement = element || $91ca15859685b28b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $91ca15859685b28b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($91ca15859685b28b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_START : $91ca15859685b28b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_NEXT : $91ca15859685b28b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $91ca15859685b28b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($91ca15859685b28b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($91ca15859685b28b$var$isRTL()) return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_PREV : $91ca15859685b28b$var$ORDER_NEXT;
        return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($91ca15859685b28b$var$isRTL()) return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_LEFT : $91ca15859685b28b$var$DIRECTION_RIGHT;
        return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_RIGHT : $91ca15859685b28b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5, $91ca15859685b28b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($91ca15859685b28b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($91ca15859685b28b$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$b = 'collapse';
const $91ca15859685b28b$var$DATA_KEY$7 = 'bs.collapse';
const $91ca15859685b28b$var$EVENT_KEY$7 = `.${$91ca15859685b28b$var$DATA_KEY$7}`;
const $91ca15859685b28b$var$DATA_API_KEY$4 = '.data-api';
const $91ca15859685b28b$var$EVENT_SHOW$6 = `show${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_SHOWN$6 = `shown${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDE$6 = `hide${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$6 = `hidden${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4 = `click${$91ca15859685b28b$var$EVENT_KEY$7}${$91ca15859685b28b$var$DATA_API_KEY$4}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$7 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSE = 'collapse';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE} .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE}`;
const $91ca15859685b28b$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $91ca15859685b28b$var$WIDTH = 'width';
const $91ca15859685b28b$var$HEIGHT = 'height';
const $91ca15859685b28b$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $91ca15859685b28b$var$Default$a = {
    parent: null,
    toggle: true
};
const $91ca15859685b28b$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$78768a9af065a7b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $91ca15859685b28b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $91ca15859685b28b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$a;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$a;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $91ca15859685b28b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_HORIZONTAL) ? $91ca15859685b28b$var$WIDTH : $91ca15859685b28b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $91ca15859685b28b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $91ca15859685b28b$var$SelectorEngine.getMultipleElementsFromSelector(this))$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$a = 'dropdown';
const $91ca15859685b28b$var$DATA_KEY$6 = 'bs.dropdown';
const $91ca15859685b28b$var$EVENT_KEY$6 = `.${$91ca15859685b28b$var$DATA_KEY$6}`;
const $91ca15859685b28b$var$DATA_API_KEY$3 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$2 = 'Escape';
const $91ca15859685b28b$var$TAB_KEY$1 = 'Tab';
const $91ca15859685b28b$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $91ca15859685b28b$var$EVENT_HIDE$5 = `hide${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$5 = `hidden${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOW$5 = `show${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOWN$5 = `shown${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3 = `click${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API = `keydown${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYUP_DATA_API = `keyup${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$6 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP = 'dropup';
const $91ca15859685b28b$var$CLASS_NAME_DROPEND = 'dropend';
const $91ca15859685b28b$var$CLASS_NAME_DROPSTART = 'dropstart';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3}.${$91ca15859685b28b$var$CLASS_NAME_SHOW$6}`;
const $91ca15859685b28b$var$SELECTOR_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$SELECTOR_NAVBAR = '.navbar';
const $91ca15859685b28b$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$PLACEMENT_TOP = $91ca15859685b28b$var$isRTL() ? 'top-end' : 'top-start';
const $91ca15859685b28b$var$PLACEMENT_TOPEND = $91ca15859685b28b$var$isRTL() ? 'top-start' : 'top-end';
const $91ca15859685b28b$var$PLACEMENT_BOTTOM = $91ca15859685b28b$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMEND = $91ca15859685b28b$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $91ca15859685b28b$var$PLACEMENT_RIGHT = $91ca15859685b28b$var$isRTL() ? 'left-start' : 'right-start';
const $91ca15859685b28b$var$PLACEMENT_LEFT = $91ca15859685b28b$var$isRTL() ? 'right-start' : 'left-start';
const $91ca15859685b28b$var$PLACEMENT_TOPCENTER = 'top';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $91ca15859685b28b$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $91ca15859685b28b$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$931cbfb6bfb85fc extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $91ca15859685b28b$var$SelectorEngine.next(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.prev(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$9;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$9;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($91ca15859685b28b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $91ca15859685b28b$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$5, relatedTarget);
        // Explicitly return focus to the trigger element
        this._element.focus();
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$91ca15859685b28b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$91ca15859685b28b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $i9Aqn === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($91ca15859685b28b$var$isElement(this._config.reference)) referenceElement = $91ca15859685b28b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $i9Aqn.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPEND)) return $91ca15859685b28b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPSTART)) return $91ca15859685b28b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER)) return $91ca15859685b28b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER)) return $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP)) return isEnd ? $91ca15859685b28b$var$PLACEMENT_TOPEND : $91ca15859685b28b$var$PLACEMENT_TOP;
        return isEnd ? $91ca15859685b28b$var$PLACEMENT_BOTTOMEND : $91ca15859685b28b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($91ca15859685b28b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $91ca15859685b28b$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$91ca15859685b28b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $91ca15859685b28b$var$getNextActiveElement(items, target, key === $91ca15859685b28b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $91ca15859685b28b$var$TAB_KEY$1) return;
        const openToggles = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $91ca15859685b28b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $91ca15859685b28b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $91ca15859685b28b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $91ca15859685b28b$var$ARROW_UP_KEY$1,
            $91ca15859685b28b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3) ? this : $91ca15859685b28b$var$SelectorEngine.prev(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.next(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_MENU, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYUP_DATA_API, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$9 = 'backdrop';
const $91ca15859685b28b$var$CLASS_NAME_FADE$4 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$5 = 'show';
const $91ca15859685b28b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$91ca15859685b28b$var$NAME$9}`;
const $91ca15859685b28b$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $91ca15859685b28b$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Backdrop extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$8;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$8;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $91ca15859685b28b$var$reflow(element);
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $91ca15859685b28b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $91ca15859685b28b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $91ca15859685b28b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $91ca15859685b28b$var$EventHandler.on(element, $91ca15859685b28b$var$EVENT_MOUSEDOWN, ()=>{
            $91ca15859685b28b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $91ca15859685b28b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$8 = 'focustrap';
const $91ca15859685b28b$var$DATA_KEY$5 = 'bs.focustrap';
const $91ca15859685b28b$var$EVENT_KEY$5 = `.${$91ca15859685b28b$var$DATA_KEY$5}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN$2 = `focusin${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$TAB_KEY = 'Tab';
const $91ca15859685b28b$var$TAB_NAV_FORWARD = 'forward';
const $91ca15859685b28b$var$TAB_NAV_BACKWARD = 'backward';
const $91ca15859685b28b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $91ca15859685b28b$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$FocusTrap extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$7;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$7;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5); // guard against infinite focus loop
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $91ca15859685b28b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $91ca15859685b28b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $91ca15859685b28b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $91ca15859685b28b$var$TAB_NAV_BACKWARD : $91ca15859685b28b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $91ca15859685b28b$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $91ca15859685b28b$var$PROPERTY_PADDING = 'padding-right';
const $91ca15859685b28b$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $91ca15859685b28b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $91ca15859685b28b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $91ca15859685b28b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $91ca15859685b28b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($91ca15859685b28b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $91ca15859685b28b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$7 = 'modal';
const $91ca15859685b28b$var$DATA_KEY$4 = 'bs.modal';
const $91ca15859685b28b$var$EVENT_KEY$4 = `.${$91ca15859685b28b$var$DATA_KEY$4}`;
const $91ca15859685b28b$var$DATA_API_KEY$2 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$1 = 'Escape';
const $91ca15859685b28b$var$EVENT_HIDE$4 = `hide${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$4 = `hidden${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOW$4 = `show${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOWN$4 = `shown${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_RESIZE$1 = `resize${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DISMISS = `click.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2 = `click${$91ca15859685b28b$var$EVENT_KEY$4}${$91ca15859685b28b$var$DATA_API_KEY$2}`;
const $91ca15859685b28b$var$CLASS_NAME_OPEN = 'modal-open';
const $91ca15859685b28b$var$CLASS_NAME_FADE$3 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$4 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_STATIC = 'modal-static';
const $91ca15859685b28b$var$OPEN_SELECTOR$1 = '.modal.show';
const $91ca15859685b28b$var$SELECTOR_DIALOG = '.modal-dialog';
const $91ca15859685b28b$var$SELECTOR_MODAL_BODY = '.modal-body';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $91ca15859685b28b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $91ca15859685b28b$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$2b77a92f1a5ad772 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $91ca15859685b28b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$6;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$6;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($91ca15859685b28b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(window, $91ca15859685b28b$var$EVENT_KEY$4);
        $91ca15859685b28b$var$EventHandler.off(this._dialog, $91ca15859685b28b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $91ca15859685b28b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($91ca15859685b28b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$4, ()=>{
            if ($91ca15859685b28b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $91ca15859685b28b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$6 = 'offcanvas';
const $91ca15859685b28b$var$DATA_KEY$3 = 'bs.offcanvas';
const $91ca15859685b28b$var$EVENT_KEY$3 = `.${$91ca15859685b28b$var$DATA_KEY$3}`;
const $91ca15859685b28b$var$DATA_API_KEY$1 = '.data-api';
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2 = `load${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$ESCAPE_KEY = 'Escape';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$3 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING$1 = 'showing';
const $91ca15859685b28b$var$CLASS_NAME_HIDING = 'hiding';
const $91ca15859685b28b$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $91ca15859685b28b$var$OPEN_SELECTOR = '.offcanvas.show';
const $91ca15859685b28b$var$EVENT_SHOW$3 = `show${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_SHOWN$3 = `shown${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE$3 = `hide${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$3 = `hidden${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_RESIZE = `resize${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1 = `click${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $91ca15859685b28b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $91ca15859685b28b$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$591ca0244c9dfcd4 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$5;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$5;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$3, $91ca15859685b28b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $91ca15859685b28b$var$Backdrop({
            className: $91ca15859685b28b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($91ca15859685b28b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $91ca15859685b28b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$OPEN_SELECTOR))$91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $91ca15859685b28b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $91ca15859685b28b$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $91ca15859685b28b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $91ca15859685b28b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($91ca15859685b28b$var$uriAttributes.has(attributeName)) return Boolean($91ca15859685b28b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $91ca15859685b28b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$91ca15859685b28b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$5 = 'TemplateFactory';
const $91ca15859685b28b$var$Default$4 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $91ca15859685b28b$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $91ca15859685b28b$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$TemplateFactory extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$4;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$4;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $91ca15859685b28b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $91ca15859685b28b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($91ca15859685b28b$var$isElement(content)) {
            this._putElementInTemplate($91ca15859685b28b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $91ca15859685b28b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$4 = 'tooltip';
const $91ca15859685b28b$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $91ca15859685b28b$var$CLASS_NAME_FADE$2 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_MODAL = 'modal';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$2 = 'show';
const $91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $91ca15859685b28b$var$SELECTOR_MODAL = `.${$91ca15859685b28b$var$CLASS_NAME_MODAL}`;
const $91ca15859685b28b$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $91ca15859685b28b$var$TRIGGER_HOVER = 'hover';
const $91ca15859685b28b$var$TRIGGER_FOCUS = 'focus';
const $91ca15859685b28b$var$TRIGGER_CLICK = 'click';
const $91ca15859685b28b$var$TRIGGER_MANUAL = 'manual';
const $91ca15859685b28b$var$EVENT_HIDE$2 = 'hide';
const $91ca15859685b28b$var$EVENT_HIDDEN$2 = 'hidden';
const $91ca15859685b28b$var$EVENT_SHOW$2 = 'show';
const $91ca15859685b28b$var$EVENT_SHOWN$2 = 'shown';
const $91ca15859685b28b$var$EVENT_INSERTED = 'inserted';
const $91ca15859685b28b$var$EVENT_CLICK$1 = 'click';
const $91ca15859685b28b$var$EVENT_FOCUSIN$1 = 'focusin';
const $91ca15859685b28b$var$EVENT_FOCUSOUT$1 = 'focusout';
const $91ca15859685b28b$var$EVENT_MOUSEENTER = 'mouseenter';
const $91ca15859685b28b$var$EVENT_MOUSELEAVE = 'mouseleave';
const $91ca15859685b28b$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $91ca15859685b28b$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $91ca15859685b28b$var$isRTL() ? 'right' : 'left'
};
const $91ca15859685b28b$var$Default$3 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $91ca15859685b28b$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$28c660c63b792dea extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        if (typeof $i9Aqn === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$3;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$3;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $91ca15859685b28b$var$EventHandler.off(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOW$2));
        const shadowRoot = $91ca15859685b28b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        const complete = ()=>{
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_FADE$2, $91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $91ca15859685b28b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $91ca15859685b28b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $91ca15859685b28b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $91ca15859685b28b$var$AttachmentMap[placement.toUpperCase()];
        return $i9Aqn.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $91ca15859685b28b$var$EventHandler.on(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $91ca15859685b28b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSEENTER) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSOUT$1);
                $91ca15859685b28b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $91ca15859685b28b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $91ca15859685b28b$var$EventHandler.on(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $91ca15859685b28b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($91ca15859685b28b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $91ca15859685b28b$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$3 = 'popover';
const $91ca15859685b28b$var$SELECTOR_TITLE = '.popover-header';
const $91ca15859685b28b$var$SELECTOR_CONTENT = '.popover-body';
const $91ca15859685b28b$var$Default$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $91ca15859685b28b$var$DefaultType$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$5b6b19405a83ff9d extends $91ca15859685b28b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$2;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$2;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TITLE]: this._getTitle(),
            [$91ca15859685b28b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$2 = 'scrollspy';
const $91ca15859685b28b$var$DATA_KEY$2 = 'bs.scrollspy';
const $91ca15859685b28b$var$EVENT_KEY$2 = `.${$91ca15859685b28b$var$DATA_KEY$2}`;
const $91ca15859685b28b$var$DATA_API_KEY = '.data-api';
const $91ca15859685b28b$var$EVENT_ACTIVATE = `activate${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_CLICK = `click${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1 = `load${$91ca15859685b28b$var$EVENT_KEY$2}${$91ca15859685b28b$var$DATA_API_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$1 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $91ca15859685b28b$var$SELECTOR_TARGET_LINKS = '[href]';
const $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $91ca15859685b28b$var$SELECTOR_NAV_LINKS = '.nav-link';
const $91ca15859685b28b$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $91ca15859685b28b$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $91ca15859685b28b$var$SELECTOR_LINK_ITEMS = `${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_NAV_ITEMS} > ${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_LIST_ITEMS}`;
const $91ca15859685b28b$var$SELECTOR_DROPDOWN = '.dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $91ca15859685b28b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $91ca15859685b28b$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$a6472a5298a374be extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$1;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$1;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $91ca15859685b28b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $91ca15859685b28b$var$EventHandler.off(this._config.target, $91ca15859685b28b$var$EVENT_CLICK);
        $91ca15859685b28b$var$EventHandler.on(this._config.target, $91ca15859685b28b$var$EVENT_CLICK, $91ca15859685b28b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $91ca15859685b28b$var$isDisabled(anchor)) continue;
            const observableSection = $91ca15859685b28b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($91ca15859685b28b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($91ca15859685b28b$var$SELECTOR_DROPDOWN)).classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $91ca15859685b28b$var$SelectorEngine.parents(target, $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $91ca15859685b28b$var$SelectorEngine.prev(listGroup, $91ca15859685b28b$var$SELECTOR_LINK_ITEMS))item.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $91ca15859685b28b$var$SelectorEngine.find(`${$91ca15859685b28b$var$SELECTOR_TARGET_LINKS}.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_SPY))$91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$1 = 'tab';
const $91ca15859685b28b$var$DATA_KEY$1 = 'bs.tab';
const $91ca15859685b28b$var$EVENT_KEY$1 = `.${$91ca15859685b28b$var$DATA_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDE$1 = `hide${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$1 = `hidden${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOW$1 = `show${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOWN$1 = `shown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API = `click${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN = `keydown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API = `load${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $91ca15859685b28b$var$ARROW_UP_KEY = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY = 'ArrowDown';
const $91ca15859685b28b$var$HOME_KEY = 'Home';
const $91ca15859685b28b$var$END_KEY = 'End';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE = 'active';
const $91ca15859685b28b$var$CLASS_NAME_FADE$1 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$1 = 'show';
const $91ca15859685b28b$var$CLASS_DROPDOWN = 'dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $91ca15859685b28b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $91ca15859685b28b$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $91ca15859685b28b$var$SELECTOR_INNER = `.nav-link${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $91ca15859685b28b$var$SELECTOR_INNER_ELEM = `${$91ca15859685b28b$var$SELECTOR_INNER}, ${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$3e41faf802a29e71 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($91ca15859685b28b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $91ca15859685b28b$var$EventHandler.trigger(active, $91ca15859685b28b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(innerElem, $91ca15859685b28b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        this._activate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $91ca15859685b28b$var$ARROW_LEFT_KEY,
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_UP_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY,
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$91ca15859685b28b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $91ca15859685b28b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $91ca15859685b28b$var$ARROW_RIGHT_KEY,
                $91ca15859685b28b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $91ca15859685b28b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($91ca15859685b28b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $91ca15859685b28b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE, $91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU, $91ca15859685b28b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($91ca15859685b28b$var$SELECTOR_INNER_ELEM) ? elem : $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($91ca15859685b28b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME = 'toast';
const $91ca15859685b28b$var$DATA_KEY = 'bs.toast';
const $91ca15859685b28b$var$EVENT_KEY = `.${$91ca15859685b28b$var$DATA_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOVER = `mouseover${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOUT = `mouseout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN = `focusin${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSOUT = `focusout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDE = `hide${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDDEN = `hidden${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOW = `show${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOWN = `shown${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $91ca15859685b28b$var$CLASS_NAME_SHOW = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING = 'showing';
const $91ca15859685b28b$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $91ca15859685b28b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$8d8dc7d5f743331b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW, $91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING, $91ca15859685b28b$var$CLASS_NAME_SHOW);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$8d8dc7d5f743331b);

});
parcelRegister("i9Aqn", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => (parcelRequire("fqRLw")).popperGenerator);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("leSQw")).default);
$parcel$export(module.exports, "createPopperBase", () => (parcelRequire("fqRLw")).createPopper);
$parcel$export(module.exports, "createPopper", () => (parcelRequire("2oJ1v")).createPopper);
$parcel$export(module.exports, "createPopperLite", () => (parcelRequire("hQXXi")).createPopper);

var $l6ej2 = parcelRequire("l6ej2");

var $1Evkg = parcelRequire("1Evkg");

var $fqRLw = parcelRequire("fqRLw");
var $leSQw = parcelRequire("leSQw");

var $2oJ1v = parcelRequire("2oJ1v");

var $hQXXi = parcelRequire("hQXXi");
$parcel$exportWildcard(module.exports, $l6ej2);
$parcel$exportWildcard(module.exports, $1Evkg);

});
parcelRegister("1Evkg", function(module, exports) {

$parcel$export(module.exports, "applyStyles", () => (parcelRequire("bjlic")).default);
$parcel$export(module.exports, "arrow", () => (parcelRequire("2c83k")).default);
$parcel$export(module.exports, "computeStyles", () => (parcelRequire("hfLNM")).default);
$parcel$export(module.exports, "eventListeners", () => (parcelRequire("lUt2x")).default);
$parcel$export(module.exports, "flip", () => (parcelRequire("fhdOY")).default);
$parcel$export(module.exports, "hide", () => (parcelRequire("201VR")).default);
$parcel$export(module.exports, "offset", () => (parcelRequire("aE9ix")).default);
$parcel$export(module.exports, "popperOffsets", () => (parcelRequire("k1fcs")).default);
$parcel$export(module.exports, "preventOverflow", () => (parcelRequire("4lgpD")).default);

var $bjlic = parcelRequire("bjlic");

var $2c83k = parcelRequire("2c83k");

var $hfLNM = parcelRequire("hfLNM");

var $lUt2x = parcelRequire("lUt2x");

var $fhdOY = parcelRequire("fhdOY");

var $201VR = parcelRequire("201VR");

var $aE9ix = parcelRequire("aE9ix");

var $k1fcs = parcelRequire("k1fcs");

var $4lgpD = parcelRequire("4lgpD");

});

parcelRegister("hQXXi", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $cff5cce2532d9fa1$export$8f7491d57c8f97a9);

var $fqRLw = parcelRequire("fqRLw");

var $lUt2x = parcelRequire("lUt2x");

var $k1fcs = parcelRequire("k1fcs");

var $hfLNM = parcelRequire("hfLNM");

var $bjlic = parcelRequire("bjlic");
var $cff5cce2532d9fa1$export$d34966752335dd47 = [
    (0, $lUt2x.default),
    (0, $k1fcs.default),
    (0, $hfLNM.default),
    (0, $bjlic.default)
];
var $cff5cce2532d9fa1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fqRLw.popperGenerator)({
    defaultModifiers: $cff5cce2532d9fa1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});




parcelRegister("iuVXB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d777fd1172dec09c$export$2e2bcd8739ae039);

var $346VI = parcelRequire("346VI");
function $d777fd1172dec09c$export$2e2bcd8739ae039(obj) {
    //return obj;
    // obj { ID, Dataset:{Value} }
    if (!$d777fd1172dec09c$export$2e2bcd8739ae039.IsDataset(obj)) {
        // => kein IDataset Model
        console.warn('Dataset: kein Model Type! ' + obj);
        return obj;
    }
    var id1 = $d777fd1172dec09c$export$2e2bcd8739ae039.GetID(obj); // obj[Dataset.ID_FIELD] !== undefined ? obj[Dataset.ID_FIELD] : 0;
    //var thisObj = null;
    var newObj = obj;
    // Namespace.ClassName, AssemblyName => Namespace.ClassName
    /*if (obj.$ModelType == undefined) {
		if (obj.$type === undefined) {
			//console.warn(obj);
		} else
			obj.$ModelType = obj.$type.indexOf(',') === -1 ? obj.$type : obj.$type.substr(0, obj.$type.indexOf(','));
	}*/ //console.log('Model-Name: ' + obj.$ModelType);
    // Namespace.ClassName => ClassName
    /*if (obj.$ClassName == undefined && obj.$ModelType != undefined) {
		obj.$ClassName = obj.$ModelType.lastIndexOf('.') === -1 ? obj.$ModelType : obj.$ModelType.substr(obj.$ModelType.lastIndexOf('.') + 1);
	}**/ //console.log('Class-Name: ' + obj.$ClassName);
    // Dataset Singleton Check
    obj.$id = undefined;
    if (id1 != undefined && id1 > 0 && $d777fd1172dec09c$export$2e2bcd8739ae039.CacheExists(obj)) ;
    else {
        var customInstance = $d777fd1172dec09c$export$2e2bcd8739ae039.InvokeCtor(obj.$ModelType); //obj.$ClassName);
        if (customInstance !== undefined) {
            //console.log('Call: ' + obj.$ClassName);
            (0, $346VI.default).CloneCopyTo(obj, customInstance, [
                'prototype',
                '__proto__',
                '__ob__',
                '$id',
                '$Username',
                '$Emitter',
                '$Dataset'
            ]); //, '$ModelType', '$type', '$id']);
            //Object.assign(customInstance, obj);
            obj = customInstance;
            console.log('Dataset: new ' + obj.$ModelType + '();');
        //console.log(obj);
        }
    }
    if (id1 != undefined && id1 > 0) {
        // $ModelType setzen
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType] == undefined) $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType] = [];
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1] == undefined || $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1] == null) // Cache Set Dataset
        $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1] = obj;
        else {
            // Cache Merge Dataset (Obj. Identität beibehalten)
            (0, $346VI.default).CloneCopyTo(obj, $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1], [
                'prototype',
                '__proto__',
                '__ob__',
                '$id',
                '$type',
                '$Username',
                '$Emitter',
                '$Dataset'
            ]);
            if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1].$Dataset != null) (0, $346VI.default).CloneCopyTo($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1].$Dataset, this);
        }
        obj = $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1];
        //obj.ID = id;
        $d777fd1172dec09c$export$2e2bcd8739ae039.OnDatasetChanged(obj);
    }
    // ALT: obj.$Dataset = this;
    // ALT: this.ID = id;
    // ALT: this.Value = obj;
    // ALT: setIDatasetProperties(obj);
    obj.$Dataset = this;
    this.Value = obj;
    this.ID = id1;
    // Response von update-field?
    if (newObj.$Username !== undefined && newObj.$Emitter !== undefined && newObj.$Emitter != $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID) {
        let fieldNames = [];
        for(let propName in newObj)if (!propName.startsWith('$') && propName != $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD) {
            fieldNames.push(propName);
            break;
        }
        if (fieldNames != null && fieldNames.length > 0) {
            if (this.UpdateInfos === undefined) {
                this.UpdateInfos = [];
                console.log('Push Update Info: ', 'new UpdateInfos();');
            }
            this.UpdateInfos.push({
                Username: newObj.$Username,
                Date: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString(),
                FieldNames: fieldNames
            });
        //obj.$Username = undefined;
        //obj.$Emitter = undefined;
        //console.log('Push Update Info: ', this, newObj);
        } else console.log('Push Update Info: ', 'empty fieldName');
    }
    /*this.SetPropsGetValue = function()
	{
		setIDatasetProperties(obj);
		return obj;
	};*/ // Funktionen:
    // - Remove
    // - Update
    this.Store = function(successCallback1, errorCallback, finallyCallback1) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'set',
            value: $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(this.Value),
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, successCallback1, errorCallback, finallyCallback1);
    //obj.UpdateInternal(refObj);
    };
    // 1. Datensatz Remove-Anfrage an den Server
    // 2. statisches Object _datasets[archiveName][id] löschen
    // 3. Object aus allen refListObj löschen
    this.Remove = function(successCallback1, errorCallback, finallyCallback1) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'remove',
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, successCallback1, errorCallback, function() {
            //obj.RemoveInternal();
            $d777fd1172dec09c$export$2e2bcd8739ae039.Remove(obj.$ModelType, id1);
            if (finallyCallback1) finallyCallback1();
        });
    };
    /*this.RemoveInternal = function()
	{
		Dataset.Remove(this.$ModelType, this.ID);
	};*/ this.CopyTo = function(targetObj) {
        for(var i in this)targetObj[i] = this[i];
    };
    this.Call = function(methodName, inputObj, storeAfterCall, successCallback1, errorCallback) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'call',
            method: methodName,
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD,
            input: inputObj,
            store: storeAfterCall
        }, successCallback1, errorCallback, undefined);
    };
    this.Refresh = function(successCallback1, errorCallback) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'get',
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, (succ_obj)=>{
            this.Value = succ_obj;
            successCallback1(succ_obj);
        }, errorCallback, undefined);
    };
    this.Unlock = function(successCallback1, errorCallback) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'unlock',
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, (succ_obj)=>{
            this.Value = succ_obj;
            successCallback1(succ_obj);
        }, errorCallback, undefined);
    };
    this.SetTableRow = function(fieldName, fieldValue, forceAppend, save, lineFormat) {
        let ret = false;
        let value_tmp = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(this.Value);
        //let fieldValueArray = lineFormat === true ? Dataset.GetLineArr(this.Value[fieldName]) : Dataset.GetTableRows(this.Value[fieldName]);
        let fieldValueArray = $d777fd1172dec09c$export$2e2bcd8739ae039.GetTableRows(value_tmp[fieldName]);
        if (!(0, $346VI.default).IsNullOrEmpty(fieldValue)) {
            let fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
            if (forceAppend === true || fieldValueIndex === -1) {
                fieldValueArray.push(fieldValue);
                ret = true;
            //console.log('Dataset.SetTableRow: ', typeof fieldValue, fieldValue, fieldValueArray);
            //ret = false;
            }
        }
        if (ret) {
            //this.Value[fieldName] = lineFormat === true ? Dataset.SetLineArr(fieldValueArray) : Dataset.SetTableRows(fieldValueArray);
            value_tmp[fieldName] = $d777fd1172dec09c$export$2e2bcd8739ae039.SetTableRows(fieldValueArray);
            this.Value = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(value_tmp);
            if (save === undefined || save === true) return this.Store();
        }
        return ret;
    };
    this.RemoveTableRow = function(fieldName, fieldValue, save, lineFormat) {
        let ret = false;
        let value_tmp = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(this.Value);
        //let fieldValueArray = lineFormat === true ? Dataset.GetLineArr(this.Value[fieldName]) : Dataset.GetTableRows(this.Value[fieldName]);
        let fieldValueArray = $d777fd1172dec09c$export$2e2bcd8739ae039.GetTableRows(value_tmp[fieldName]);
        if (!(0, $346VI.default).IsNullOrEmpty(fieldValue)) {
            let fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
            // alle Werte entfernen
            while(fieldValueIndex !== -1){
                fieldValueArray.splice(fieldValueIndex, 1);
                ret = true;
                fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
            //console.log('Dataset.RemoveTableRow: ', typeof fieldValue, fieldValue, fieldValueArray);
            }
        }
        if (ret) {
            //this.Value[fieldName] = lineFormat === true ? Dataset.SetLineArr(fieldValueArray) : Dataset.SetTableRows(fieldValueArray);
            value_tmp[fieldName] = $d777fd1172dec09c$export$2e2bcd8739ae039.SetTableRows(fieldValueArray);
            this.Value = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(value_tmp);
            if (save === undefined || save === true) return this.Store();
        }
        return ret;
    };
    if (obj.Init !== undefined && typeof obj.Init === 'function') //console.warn('init');
    obj.Init();
    return this;
}
// --
// Statische Funktionen/Member
// Singleton Data
$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD = 'Dokument-Nr.';
$d777fd1172dec09c$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER = String.fromCharCode(1);
$d777fd1172dec09c$export$2e2bcd8739ae039.WindowID = Math.random().toString(36).substring(2, 9);
$d777fd1172dec09c$export$2e2bcd8739ae039.Model = [];
//Dataset.ServerHost = document.location.protocol + '//' + document.location.hostname;
//Dataset.ServerPort = document.location.port;
//Dataset.ServerHost = 'http://127.0.0.1';
//Dataset.ServerPort = '8080';
$d777fd1172dec09c$export$2e2bcd8739ae039.DEBUG = true;
$d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError = null;
$d777fd1172dec09c$export$2e2bcd8739ae039.Ctors = {};
$d777fd1172dec09c$export$2e2bcd8739ae039.ListenState = null;
// --
// Model Constructors
$d777fd1172dec09c$export$2e2bcd8739ae039.AddCtor = function(archiveName1, ctor) {
    //Dataset.Ctors[ctor.prototype.constructor.name] = ctor;
    $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[archiveName1] = ctor;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.HasCtor = function(ctorName) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[ctorName] !== undefined;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.InvokeCtor = function(ctorName) {
    /*var i = Dataset.Ctors.indexOf(ctor);
	if ( === -1)
	{
		Dataset.Ctors.push(ctor);
	}*/ return $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[ctorName] === undefined ? undefined : new $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[ctorName]();
};
// --
$d777fd1172dec09c$export$2e2bcd8739ae039.GetTableRows = function(fieldValue) {
    if ((0, $346VI.default).IsNullOrEmpty(fieldValue)) return [];
    else return fieldValue.split($d777fd1172dec09c$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.SetTableRows = function(array) {
    if (array != undefined && array != null && array.length > 0) return array.join($d777fd1172dec09c$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
    else return '';
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetLineArr = function(fieldValue) {
    if ((0, $346VI.default).IsNullOrEmpty(fieldValue)) return [];
    else return fieldValue.replaceAll("\r", "").split("\n");
};
$d777fd1172dec09c$export$2e2bcd8739ae039.SetLineArr = function(array) {
    if (array != undefined && array != null && array.length > 0) return array.join("\r\n");
    else return '';
};
$d777fd1172dec09c$export$2e2bcd8739ae039.IsDataset = function(obj) {
    //if (obj == null && obj.$ModelType == undefined)
    //	return false;
    if (obj == null) return false;
    if (obj.$ModelType == undefined) return false;
    if (typeof obj == "object") return true;
    //if (typeof obj == "dataset")
    //	return true;
    return false;
//return (obj != null && obj.$type != undefined && ((typeof obj === "object") || (typeof obj === "dataset")));
//return (obj != null && obj.$type !== undefined && (typeof obj === "object" || typeof obj === "dataset"));
//return (obj != null && obj.ID !== undefined && obj.$type !== undefined && (typeof obj === "object" || typeof obj === "dataset"));
};
// --
// Crud
/*
Dataset.GetDataRaw = function (url, paramsObj, loadEvent, errorCallback) {
	let onErrorEvent = function (e) {
		let responseObject = {
			Error: {
				Message: 'Verbindungsfehler',
				Error: 'Verbindungsfehler',
				InternalMessage: 'Verbindungsfehler'
			}
		};
		if (errorCallback != null)
			errorCallback(e); //responseObject.Error);
		else if (Dataset.DefaultError != null)
			Dataset.DefaultError(e); //responseObject.Error); //, event.target.status);
		//else
		//	alert(responseObject.Error.Message + '\n\n' + responseObject.Error.InternalMessage);

		console.error('Verbindungsfehler', e);
	};

	if (Dataset.WindowID == undefined || Dataset.WindowID == null)
		Dataset.WindowID = Math.random().toString(36).substring(2, 9) + '-';
	if (paramsObj == null) {
		paramsObj = { emitter: Dataset.WindowID };
	}
	else {
		paramsObj.emitter = Dataset.WindowID;
	}
	// ToDo:
	// statt Callback Promise verwenden
	var requestUrl = Dataset.ServerHost + ':' + Dataset.ServerPort + url;
	var request = new XMLHttpRequest();
	request.open('POST', requestUrl);
	request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	request.addEventListener('load', loadEvent);
	request.addEventListener('error', onErrorEvent);
	request.addEventListener('abort', onErrorEvent);
	request.send(Dataset.ObjectToQueryStr(paramsObj));
};*/ // Crud
$d777fd1172dec09c$export$2e2bcd8739ae039.GetDataRaw = function(url, paramsObj) {
    if ($d777fd1172dec09c$export$2e2bcd8739ae039.WindowID == undefined || $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID == null) $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID = Math.random().toString(36).substring(2, 9) + '-';
    if (paramsObj == null) paramsObj = {
        emitter: $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID
    };
    else paramsObj.emitter = $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID;
    let getStr = $d777fd1172dec09c$export$2e2bcd8739ae039.ObjectToQueryStr(paramsObj);
    return (0, $346VI.default).Send('GET', url, getStr, undefined, 'json', '', '', true);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetData = function(url, paramsObj, successCallback1, errorCallback, finallyCallback1) {
    var loadEvent = function(responseObject) {
        return new Promise(function(resolve, reject) {
            //console.log(event);
            /*var responseObject = null;
			if (event.target.getResponseHeader('Content-Type').indexOf('text/json') !== 0) {
				responseObject = {
					HasError: true,
					Result: null,
					Error: {
						Message: 'Der Server hat eine ungültige Antwort geliefert:\n' + event.target.responseText,
						InternalMessage: event.target.responseText
					}
				};
			} else {
				try {
					//responseObject = resolveReferences(JSON.parse(request.responseText));
					//console.warn(responseObject);
					//responseObject = DrDocWeb.JsonRetrocycle(JSON.parse(event.target.responseText));
					responseObject = DrDocWeb.JsonParse(event.target.responseText);
					if (responseObject == null) {
						responseObject = {
							HasError: false,
							Result: null,
							Error: null
						};
					}
					//if (responseObject.$id !== undefined || responseObject.$ref !== undefined || responseObject.$values !== undefined) //console.warn(responseObject);
				} catch (e) {
					console.error('Dataset Deserialize', e);
					responseObject = {
						HasError: true,
						Result: null,
						Error: {
							Message: 'Fehler',
							InternalMessage: event.target.responseText
						}
					};
					if (errorCallback != null)
						errorCallback(e);
					else if (Dataset.DefaultError != null)
						Dataset.DefaultError(e);
				}
			}*/ // $ModelType setzen
            try {
                if (responseObject.$ModelType === undefined) responseObject.$ModelType = paramsObj.archive;
                if (responseObject.$ModelType !== undefined) {
                    if (responseObject.Result != null && responseObject.Result instanceof Array) {
                        for(var i in responseObject.Result)if (typeof responseObject.Result[i] !== 'string' && typeof responseObject.Result[i] !== 'boolean' && responseObject.Result[i].$ModelType === undefined) responseObject.Result[i].$ModelType = responseObject.$ModelType;
                    } else if (typeof responseObject.Result !== 'string' && typeof responseObject.Result !== 'boolean' && responseObject.Result !== undefined && responseObject.Result.$ModelType === undefined) responseObject.Result.$ModelType = responseObject.$ModelType;
                }
            } catch (x) {}
            //console.log(responseObject);
            if (responseObject.HasError === false) {
                // kein Fehler im Response
                var data_obj = null;
                var data_arr = null;
                if (responseObject.Result != null) {
                    if (responseObject.Result instanceof Array) {
                        // Result ist ein Array
                        data_arr = [];
                        $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Add(data_arr);
                        for(var arri in responseObject.Result){
                            if (responseObject.Result[arri].$ModelType === undefined) data_arr[arri] = responseObject.Result[arri];
                            else data_arr[arri] = new $d777fd1172dec09c$export$2e2bcd8739ae039(responseObject.Result[arri]).Value;
                            data_arr[arri] = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(data_arr[arri]);
                        }
                    } else {
                        // Result ist ein Objekt
                        // obj-Objekt-Referenz erhalten
                        if (data_obj == null) {
                            if (responseObject.Result.$ModelType === undefined) data_obj = responseObject.Result;
                            else data_obj = new $d777fd1172dec09c$export$2e2bcd8739ae039(responseObject.Result).Value;
                        } else (0, $346VI.default).CloneCopyTo(responseObject.Result, data_obj);
                        data_obj = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(data_obj);
                    }
                }
                if (resolve != undefined && resolve != null) resolve(data_arr ? data_arr : data_obj);
                if (successCallback1 != undefined && successCallback1 != null) {
                    var metaObj = {
                        SortTree: responseObject.MetaSortTree,
                        Count: responseObject.Count,
                        CountTotal: responseObject.CountTotal
                    };
                    if (data_obj == null && data_arr != null) successCallback1(data_arr, metaObj);
                    else if (data_obj != null && data_arr == null) successCallback1(data_obj, metaObj);
                    else successCallback1(null, metaObj);
                }
            } else {
                // Fehler im Reponse vorhanden
                if ($d777fd1172dec09c$export$2e2bcd8739ae039.DEBUG) {
                    if (responseObject != null && responseObject.HasError && responseObject.Error) console.warn(responseObject.Error.Message, responseObject.Error.InternalMessage);
                    else console.warn(event.target.statusText, event.target.responseText);
                }
                if (reject != undefined && reject != null) reject(responseObject.Error);
                if (errorCallback != null) errorCallback(responseObject.Error); //, event.target.status);
                else if ($d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError != null) $d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError(responseObject.Error); //, event.target.status);
                else alert(responseObject.Error.Message + '\n\n' + responseObject.Error.InternalMessage);
            }
            if (finallyCallback1 != undefined && finallyCallback1 != null) finallyCallback1();
        }); // Promise end
    };
    return $d777fd1172dec09c$export$2e2bcd8739ae039.GetDataRaw(url, paramsObj).catch(errorCallback).then(loadEvent);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Crud = function(paramsObj, successCallback1, errorCallback, finallyCallback1) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.GetData('/model/crud', paramsObj, successCallback1, errorCallback, finallyCallback1);
};
/*Dataset.Add = function (obj, successCallback, errorCallback, finallyCallback) {
	return Dataset.Crud({
		archive: obj.$ModelType,
		model: obj.$ModelType,
		action: 'add',
		value: obj
	}, successCallback, errorCallback, finallyCallback);
};*/ $d777fd1172dec09c$export$2e2bcd8739ae039.Add = function(archiveName1, obj, preset) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
        usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
        archive: archiveName1,
        model: archiveName1,
        action: 'add',
        value: $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(obj),
        preset: preset == undefined ? '' : preset
    }); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Get = function(archiveName1, id1, lock) {
    //var className = archiveName.lastIndexOf('.') === -1 ? archiveName : archiveName.substr(archiveName.lastIndexOf('.') + 1);
    //var obj = Dataset.InvokeCtor(className);
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
        //usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
        archive: archiveName1,
        model: archiveName1,
        action: 'get',
        id: id1,
        id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD,
        lock: lock
    }); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Listen = function(callback) {
    /*if (callback != null)
	{
		callback(null, null);
	}*/ // Dataset.GetData = function (url, paramsObj, successCallback, errorCallback, finallyCallback)
    return $d777fd1172dec09c$export$2e2bcd8739ae039.GetData('/model/cache', {
        listener: $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID
    }, (obj)=>{
        //console.warn('MAIN Load', e.target.responseText);
        //console.warn('MAIN Load', e);
        //Vue.set(Dataset.Model[obj.$ModelType], Dataset.GetID(obj), obj);
        if (callback != null) callback(obj, true);
        //Dataset.ListenState = true;
        //Vue.set(Dataset, 'ListenState', true);
        $d777fd1172dec09c$export$2e2bcd8739ae039.Listen(callback);
    }, (obj)=>{
        //Dataset.ListenState = false;
        //Vue.set(Dataset, 'ListenState', false);
        // Bei Fehler, nach einigen Sekunden erneut versuchen.
        setTimeout(()=>{
            $d777fd1172dec09c$export$2e2bcd8739ae039.Listen(callback);
        }, 1000);
        if (callback != null) callback(null, false);
        console.warn('MAIN Error', obj, callback, false);
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError != null) $d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError(obj);
    });
};
$d777fd1172dec09c$export$2e2bcd8739ae039.OnDatasetChanged = function(value) {};
$d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode = function(value) {
    return value;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode = function(value) {
    return value;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetCached = function(archiveName1, id1) {
    if ($d777fd1172dec09c$export$2e2bcd8739ae039.CacheExistsExt(archiveName1, id1)) {
        //ds.CopyTo(obj);
        if (successCallback != null) successCallback($d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1]);
        if (finallyCallback != null) finallyCallback();
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1];
    } else {
        //return null;
        var className = archiveName1.lastIndexOf('.') === -1 ? archiveName1 : archiveName1.substr(archiveName1.lastIndexOf('.') + 1);
        var obj = $d777fd1172dec09c$export$2e2bcd8739ae039.InvokeCtor(className);
        console.log('Dataset.GetCached: 1 ', '/ CacheExistsExt: false', ' / Archive: ', archiveName1, ' / ID: ', id1);
        //Dataset.Get(archiveName, id, false);
        $d777fd1172dec09c$export$2e2bcd8739ae039.Get(archiveName1, id1, false).then(function(result) {
            console.log('Dataset.GetCached: 2', '/ CacheExistsExt: false', ' / Archive: ', archiveName1, ' / ID: ', id1, ' / Result: ', result);
        });
        return obj;
    }
};
$d777fd1172dec09c$export$2e2bcd8739ae039.List = function(archiveName1, actionParams) {
    /*console.log('-------');
	console.log(archiveName);
	console.log(obj);
	console.log(actionParamArr);
	console.log(successCallback);
	console.log(errorCallback);
	console.log(finallyCallback);
	console.log('-------');*/ if (actionParams == undefined || actionParams == null) actionParams = {};
    actionParams.archive = archiveName1;
    actionParams.action = 'searchfields';
    if (actionParams.value == undefined || actionParams.value == null) {
        actionParams.value = {
        };
        actionParams.value[$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD] = '*';
    }
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud(actionParams); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Template = function(archiveName1, searchTemplate, actionParams) {
    if (actionParams == undefined || actionParams == null) actionParams = {};
    actionParams.archive = archiveName1;
    actionParams.action = 'searchtemplate';
    if (actionParams.value == undefined || actionParams.value == null) actionParams.value = searchTemplate;
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud(actionParams); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetID = function(obj) {
    if (obj == undefined || obj == null) return 0;
    //if (obj['DokuNr'] !== undefined)
    //return $event['DokuNr'];
    if (obj[$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD] !== undefined) return obj[$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD];
    return 0;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Tree = function(archiveName1) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
        archive: archiveName1,
        model: archiveName1,
        action: 'tree'
    }); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.ExistsQ = function(obj) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Get(obj.$ModelType, obj.ID) != null;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.CacheExists = function(obj) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType] != undefined && $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][$d777fd1172dec09c$export$2e2bcd8739ae039.GetID(obj)] !== undefined;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.CacheExistsExt = function(archiveName1, id1) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1] != undefined && $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1] != undefined;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.CacheGet = function(obj) {
    $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName] != undefined && $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName][id];
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Remove = function(archiveName1, id1) {
    if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1] == undefined || $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1] == undefined) return;
    // aus allen List References entfernen
    $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.RemoveObjects(archiveName1, id1);
    $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1].splice(id1, 1);
    delete $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1];
};
$d777fd1172dec09c$export$2e2bcd8739ae039.ClearAll = function() {
    $d777fd1172dec09c$export$2e2bcd8739ae039.Model = [];
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Equals = function(ds1, ds2) {
    if (ds1 == null && ds2 == null) return true;
    if (ds1 != null && ds2 == null || ds1 == null && ds2 != null) return false;
    return ds1.$ModelType !== undefined && ds2.$ModelType !== undefined && ds1.$ModelType == ds2.$ModelType && $d777fd1172dec09c$export$2e2bcd8739ae039.GetID(ds1) == $d777fd1172dec09c$export$2e2bcd8739ae039.GetID(ds2);
//return Dataset.GetID(ds1) == Dataset.GetID(ds2);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.IndexOf = function(list, obj) {
    if (list == null) return -1;
    for(var i in list){
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.Equals(list[i], obj) === true) return i;
    }
    return -1;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Cmp = $d777fd1172dec09c$export$2e2bcd8739ae039.Equals;
/*function (a, b) {
	if (a == null || b == null) return false;
	else return (a.ID == b.ID && a.$type == b.$type);
};*/ $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays = {
    list: [],
    Find: function(action) {
        for(var i in $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list){
            if (action($d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list[i]) === true) return i;
        }
        return -1;
    },
    Add: function(targetArrayToAdd) {
        var index = $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            return targetArray == targetArrayToAdd;
        });
        if (index == -1) $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list.push(targetArrayToAdd);
    },
    Remove: function(targetArrayToRemove) {
        var index = $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            return targetArray == targetArrayToRemove;
        });
        if (index >= 0) {
            $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list.splice(index, 1);
            delete $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list[index];
        }
    },
    RemoveObjects: function(archiveName1, id1) {
        $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            for(var elem_i in targetArray)if (targetArray[elem_i].$ModelType == archiveName1 && targetArray[elem_i].ID == id1) {
                //console.log('RemoveFromTargetArrays');
                targetArray.splice(elem_i, 1);
                delete targetArray[elem_i];
            }
            return false;
        });
    },
    Refresh: function() {
        //console.log('Refresh');
        $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            targetArray.$refresh();
            return false;
        });
    }
};
// --
// Helpers
function $d777fd1172dec09c$var$setIDatasetProperties(obj) {
    if (typeof obj === 'object') {
        if (obj.$setIDatasetProperties !== undefined) return;
        else obj.$setIDatasetProperties = true;
    //if (obj.$id !== undefined) delete obj.$id;
    }
    for(var prop in obj){
        if (obj[prop] == null) ;
        else if (obj[prop] instanceof Array) /*if (obj[prop].$id !== undefined)
			{
				//obj = DrDocWeb.JsonRetrocycle(obj);
				// aus Gott gegebenen Gründen werden nach dem Deserialisieren nicht alle Referenzen aufgelöst. Daher nochmals:
				obj[prop] = resolveReferences(obj[prop]);
			}*/ $d777fd1172dec09c$var$setIDatasetProperties(obj[prop]);
        else if ($d777fd1172dec09c$export$2e2bcd8739ae039.IsDataset(obj[prop])) obj[prop] = new $d777fd1172dec09c$export$2e2bcd8739ae039(obj[prop]).Value;
        else if (typeof obj[prop] === 'object') //delete obj.$id;
        /*if (obj[prop].$id !== undefined)
			{
				//obj = DrDocWeb.JsonRetrocycle(obj);
				// aus Gott gegebenen Gründen werden nach dem Deserialisieren nicht alle Referenzen aufgelöst. Daher nochmals:
				obj[prop] = resolveReferences(obj[prop]);
			}*/ $d777fd1172dec09c$var$setIDatasetProperties(obj[prop]);
    //else // => ValueType
    //{}
    }
}
$d777fd1172dec09c$export$2e2bcd8739ae039.ObjectToQueryStr = function(obj) {
    if (obj == null) return '';
    var strArr = [];
    for(var p in obj)if (obj.hasOwnProperty(p)) {
        var v = obj[p];
        /*strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? JSON.stringify(JsonResolve(v), function(key, value)
			{
				// => typeof Dataset
				// IDataset / Dataset.IsDataset(value): $ModelType, $ClassName, Dataset
				if (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset') return;
				else return value;
			}) : v));*/ strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? $d777fd1172dec09c$export$2e2bcd8739ae039.JsonToStr(v) : v));
    }
    var str = strArr.join("&");
    //return (str.length == 0 ? '' : '?' + str);
    return str;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.JsonToStr = function(objToConvert) {
    //var cacheObjs = [];
    //var cacheIDs = [];
    /*var seenObjects = [];

	function detect(obj)
	{
		if (obj && (typeof obj === 'object' || obj instanceof Array))
		{
			if (seenObjects.indexOf(obj) !== -1)
			{
				return true;
			}
			seenObjects.push(obj);
			for (var key in obj)
			{
				if (obj.hasOwnProperty(key) && detect(obj[key]))
				{
					console.log(obj, 'cycle at ' + key);
					return true;
				}
			}
		}
		return false;
	};*/ //return detect(obj);
    //return JSON.stringify(DrDocWeb.JsonDecycle(objToConvert));
    return JSON.stringify((0, $346VI.default).JsonDecycle(objToConvert), function(key, value) {
        //if (detect(value)) console.log(value);
        //if (cacheObjs.length > 4) console.log(cacheObjs);
        // => typeof Dataset
        // IDataset / Dataset.IsDataset(value): $ModelType, $ClassName, Dataset
        // Properties, die mit "_out_" beginnen (z.B. _out_DynamicModel) sollen am nicht deserialisiert werden; die Übertragung wäre sinnlos.
        //if (typeof value === 'object' && (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset' || key.indexOf('_out_') === 0 || key.indexOf('_ignore_') === 0))
        if (typeof value === 'object' && key == 'Dataset') // Property "Dataset" ignorieren
        return;
        else if (key.indexOf('__') === 0) // Properties ignorieren, die mit "__" anfangen
        return;
        else if (key.indexOf('_') === 0 && key.endsWith('_') === true || key.indexOf('_out_') === 0 || key.indexOf('_ignore_') === 0) // Properties ignorieren, die mit "_" anfangen und enden, z.B. "_test_"
        return;
        else if (key.indexOf('$') === 0) // Properties ignorieren, die mit "$" beginnen, außer die Property $ModelType
        return;
        else if (key != '' && key != null && value != null && typeof value === 'Dataset' && value.ID !== undefined && value.ID !== 0) // key == 'archive' &&
        // Wenn das Model (als Root-Node) gespeichert wird, ist key == ''
        //console.log(key);
        return {
            ID: value.ID,
            $type: value.$type
        };
        else return value;
    });
};
window.Dataset = $d777fd1172dec09c$export$2e2bcd8739ae039; //export default Dataset

});

parcelRegister("hkmmp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9d5a63fc97996b1$export$2e2bcd8739ae039);
var $c9d5a63fc97996b1$var$LOCK_INDEX = [];
function $c9d5a63fc97996b1$var$LockCallback(key, action, manual) {
    if ($c9d5a63fc97996b1$var$LOCK_INDEX[key]) return;
    $c9d5a63fc97996b1$var$LOCK_INDEX[key] = true;
    var ret = action(function() {
        delete $c9d5a63fc97996b1$var$LOCK_INDEX[key];
    });
    if (!manual) delete $c9d5a63fc97996b1$var$LOCK_INDEX[key];
    return ret;
}
function $c9d5a63fc97996b1$export$2e2bcd8739ae039() {
    this._handlers = {};
}
//module.exports = Store
//export default Store
window.Store = $c9d5a63fc97996b1$export$2e2bcd8739ae039;
// Static
$c9d5a63fc97996b1$export$2e2bcd8739ae039._debug = false;
$c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise = function(value) {
    return (value != undefined && typeof value === 'object' || typeof value === 'Promise' || typeof value === 'promise') && value.then !== undefined && value.then !== null && typeof value.then === 'function';
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse = function(value) {
    return value == undefined || value == null ? '' : value;
//return value;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseInt = function(value) {
    let valueInt = typeof value === 'number' ? value : parseInt(value, 10);
    if (value === undefined || value === null || isNaN(value) || value === 'NaN') return 0;
    else return valueInt;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseBool = function(value) {
    if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('parse bool ', value, typeof value);
    let valueBool = typeof value === 'bool' || typeof value === 'boolean' ? value : value === 'true' || value === 'True' || value === 'TRUE' || value === '1';
    return valueBool;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName = function(name, event) {
    if (name === undefined || name === null || typeof name !== 'string' || name.length === 0) {
        console.warn('Store: Bad Name!');
        return false;
    }
    name = name.toLowerCase();
    return name;
};
// Instance
/*
'action/type': { value: 'foo', handlers: [ function(newValue, oldValue) { } ] }
Stati:
this._handlers["name"] = undefined => not set / undefined
this._handlers["name"] = [] => initializing..
this._handlers["name"] = [ event ] => initialized / set

this._handlers["name"] = handlerObj
{
    value: 'foo',
    parser: function(value) => value,
    handlers: [
        function(newValue, oldValue) { }
    ]
}
*/ $c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype._handlers = {};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.initEx = function(name, value, parser) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    if (value === undefined || value === null) {
        console.warn('Store->init: Bad value (NULL) ', name, value);
        return false;
    }
    if (this.has(name)) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->init: bereits initialisiert ', name, value);
        return false;
    }
    // Parser setzen
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        handlerObj = {
            value: null,
            handlers: []
        };
        this._handlers[name] = handlerObj;
    }
    if (parser != undefined && parser != null && typeof parser === 'function') handlerObj.parser = parser;
    else handlerObj.parser = $c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse;
    return this.set(name, value, true);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.init = function(name, event) {
    return this.initEx(name, event, $c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.initBool = function(name, event) {
    return this.initEx(name, event, $c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseBool);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.initInt = function(name, event) {
    return this.initEx(name, event, $c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseInt);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.subscribe = function(name, event, setInitial) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    let toe = typeof event;
    if (event === undefined || event === null || toe !== 'function') {
        console.warn('Store->subscribe: Bad Event!', name, event, toe);
        return false;
    }
    //var hasValue =  this.has(name);
    var oldValue = undefined;
    if (setInitial === true) oldValue = this.get(name);
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) this._handlers[name] = {
        value: null,
        handlers: [
            event
        ]
    };
    else handlerObj.handlers.push(event);
    if (setInitial === true) event(oldValue, oldValue);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.unsubscribe = function(name, event) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        console.warn('Store->unsubscribe: no Handler found', name);
        return false;
    }
    if (event === undefined || event === null) {
        // alle Handler entfernen
        handlerObj.handlers = [];
        return true;
    } else {
        if (typeof event !== 'function') {
            console.warn('Store->unsubscribe: Bad Event! / function');
            return false;
        }
        let handlers = handlerObj.handlers;
        if (handlers === undefined || handlers === null) {
            console.warn('Store->unsubscribe: no Handler found');
            return false;
        }
        let ret = false;
        if (handlers.length > 0) {
            for(let i = handlers.length - 1; i >= 0; i--)if (handlers[i] === event) {
                handlers.slice(i, 1);
                ret = true;
            }
        }
        return ret;
    }
};
/*Store.prototype.unsubscribeAll = function(name)
{
    name = Store.validateName(name);
    if (name === false)
        return false;
    
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null)
    {
        console.warn('Store->unsubscribeAll: no Handler found');
        return false;
    }
    handlerObj.handlers = [];
    return true;
};*/ $c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.remove = function(name) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    this._handlers[name] = undefined;
    delete this._handlers[name];
    return true;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.clear = function() {
    this._handlers = {};
    return true;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.getFnReturnValueInternal = function(value, parser) {
    // Funktion auflösen
    while(value != null && value !== undefined && !$c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value) && typeof value === 'function')value = value();
    // Promise auflösen
    if ($c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value)) {
        let store = this;
        // Falls es ein Promise ist, diesen auflösen
        return value.then(function(ret_value) {
        //value = store.getFnReturnValueInternal(ret_value, parser);
        //return value;
        });
    }
    if (parser !== undefined && parser !== null && typeof parser === 'function') value = parser(value);
    return value;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.set = function(name, value, signal) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) {
        console.log('Store->set - name not found', name, value, this);
        return false;
    }
    //return LockCallback('someKey',() => {
    var oldValue = this.get(name);
    var isNewValue = false;
    // Falls noch kein Handler existiert, werstmal Wert undefined setzen, damit init nicht öfter aufgerufen wird.
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->set - initialized', name, this);
        handlerObj = {
            value: undefined,
            handlers: []
        };
        this._handlers[name] = handlerObj;
        isNewValue = true;
    }
    // --
    // Funktion auflösen
    // so lange auflösen, bis value einen Wert darstellt
    while(value != null && value !== undefined && !$c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value) && typeof value === 'function')value = value();
    // Promise auflösen
    if (value != null && value !== undefined && $c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value)) {
        //console.warn(`Store->set: Promise sind nicht erlaubt! Name: "${name}" `);
        //return;
        let store = this;
        // Falls es ein Promise ist, diesen auflösen
        return value.then(function(ret_value) {
            store.set(name, ret_value, signal);
        });
    }
    // neuen Wert parsen
    if (handlerObj.parser !== undefined && handlerObj.parser !== null && typeof handlerObj.parser === 'function') value = handlerObj.parser(value);
    else value = $c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse(value);
    // --
    let handlers = handlerObj.handlers;
    //var oldValue = handlerObj.value;
    if (oldValue != value || signal === true) {
        handlerObj.value = value;
        //if (Store._debug === true)
        //if (!isNewValue && handlers.length > 0)
        if (oldValue != value && (signal === undefined || signal === null) || signal === true) {
            if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.warn('Store->set NOTIFY "' + name + '" / Value has Changed  ', oldValue, '  ->  ', value, ' / Signal:' + signal + ' / Listeners: ' + handlers.length);
            let count = handlers.length;
            //for (let i = handlers.length - 1; i >= 0; i--)
            for(let i = 0; i < count; i++)//console.log('set notify', handlers[i]);
            handlers[i](value, oldValue);
        }
        return true;
    } else {
        // Keine Änderung!
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->set X-NOTIFY "' + name + '" / Value has NOT Changed  ', oldValue, '  ==  ', value);
        return false;
    }
//});
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.has = function(name) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) return false;
    else {
        if (handlerObj.value === undefined || handlerObj.value === null) return false;
        else if (typeof handlerObj.value === 'string' && handlerObj.value.length == 0) return false;
        else if (typeof handlerObj.value === 'bool' || typeof handlerObj.value === 'boolean') return true;
        else if (typeof handlerObj.value === 'number' && isNaN(handlerObj.value)) return false;
        else return true;
    }
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.get = function(name, defaultValue) {
    if (!this.has(name)) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->get - name not found', name, this);
        return defaultValue;
    }
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->get - name is null', name);
        return defaultValue;
    }
    let handlerObj = this._handlers[name];
    if (handlerObj.value === undefined || handlerObj.value === null) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.warning('Store->get - empty value', name);
        return defaultValue;
    } else return handlerObj.value;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.update = function(name) {
    if (this.has(name)) {
        let value = this.get(name);
        //if (Store._debug === true)
        //console.log('Store->update: ', name, ' => ', value, typeof value);
        this.set(name, value, true);
    } else if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.warn('Store->update: Nothing to update..: ', name);
}; /*
var store = new Store();
console.log('Store 1', store);
store.subscribe('selected-archive', (value, oldValue) => {
    console.log('Changed selected-archive  ', oldValue, ' => ', value);
});
console.log('Store 2', store);
store.set('selected-archive', 1);
console.log('Store 3', store);
console.log('Store 3 get: ', store.get('selected-archive'));
store.set('selected-archive', { sdsd: 'dsdsdsdsdsds'});
console.log('Store 4 get: ', store.get('selected-archive'));
store.unsubscribeAll('selected-archive');
console.log('Store 5', store);
store.remove('selected-archive');
console.log('Store 6', store);
*/ 

});

parcelRegister("9hg18", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c12204ffc79a36c$export$2e2bcd8739ae039);
//import * as $ from "jquery";

var $346VI = parcelRequire("346VI");

var $hkmmp = parcelRequire("hkmmp");
function $6c12204ffc79a36c$export$2e2bcd8739ae039(store, isLocal) {
    this._isLocal = isLocal === true;
    this._store = store;
    this._config = this;
    this.Write = true;
    this.readonly = false;
    //console.log("Dr.DOC INIT 2");
    //Store._debug = true;
    // keep alive senden
    if (!this._isLocal) {
        let _this = this;
        setInterval(function() {
            if ((0, $hkmmp.default)._debug) console.log('CONF keep alive..');
            //_this.get('view/selected-usermanager');
            //_this.subscribeEx = function (name, event, defaultValue, parser);
            //_this.subscribeEx('view/selected-usermanager');
            let ret = _this.getValueInternal('view/selected-usermanager');
            if (ret != undefined) ret.catch(function() {
                (0, $346VI.default).ModalWarning('Keine Internetverbindung oder Server nicht erreichbar.');
            });
        }, 120000);
    }
}
window.DrDocConfig = $6c12204ffc79a36c$export$2e2bcd8739ae039;
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.initEx = function(name, event, defaultValue, parser) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeEx: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, defaultValue, parser);
};
// Subscriber um die geänderten Werte zu speichern
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.initAutoSaveInternal = function(thisInstance, name, isInitMode) {
    if (thisInstance.has(name)) {
        if ((0, $hkmmp.default)._debug) console.log('DrDocConfig.initAutoSaveInternal: wurde bereits initialisiert!', name);
    } else {
        if ((0, $hkmmp.default)._debug) console.log('DrDocConfig.initAutoSaveInternal: wird jetzt initialisiert.. ', name);
        // Veränderung der Werte abspeichern
        thisInstance._store.subscribe(name, function(valueNew, valueOld) {
            //var isInitMode = thisInstance._store.has(name) === false;
            //if (Store._debug === true)
            //console.log('subscribeEx -> initEx -> subscribe: ', name, '  isInitMode: ', isInitMode);
            if (thisInstance.readonly) return;
            // "initEx" für via "set" mit Signal diesen Subscriber erneut aus,
            // die Daten sollen aber nicht gesetzt/gesendet werden
            if (isInitMode) {
                if ((0, $hkmmp.default)._debug) console.log('CONF Value has changed (INIT):', name, valueNew);
                isInitMode = false;
            } else thisInstance.setValueInternal(name, valueNew);
        });
        if ((0, $hkmmp.default)._debug) console.log('DrDocConfig.initAutoSaveInternal: state: ', thisInstance.has(name), ' / isInitMode: ', isInitMode);
    }
    return isInitMode;
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.setValueInternal = function(name, valueNew) {
    if ((0, $hkmmp.default)._debug) console.log('CONF Value has changed:', name, valueNew);
    if (this.Write === true) {
        if (this._isLocal) {
            if (window.localStorage !== undefined) window.localStorage.setItem(name, valueNew);
            else (0, $346VI.default).SetCookie(name, valueNew, 365);
        } else (0, $346VI.default).Send('GET', '/config', {
            mode: 'set',
            names: name,
            value: valueNew
        });
    }
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.getValueInternal = function(name, defaultValue) {
    // gespeicherten Wert zu Initialisierung abrufen
    if (this._isLocal) {
        if (window.localStorage !== undefined) {
            let valRet = window.localStorage.getItem(name);
            if (valRet !== undefined && valRet !== null) return valRet;
            else return defaultValue;
        } else {
            if ((0, $hkmmp.default)._debug) console.log('CONF Value wurde aus Cookie geladen:', name, ' == ', (0, $346VI.default).GetCookie(name, defaultValue, 365), '  / [DEFAULT]: ', defaultValue);
            return (0, $346VI.default).GetCookie(name, defaultValue, 365);
        }
    } else // Wer vom Server laden und initialisieren
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'get',
        names: name
    }).then(function(val) {
        if ((0, $hkmmp.default)._debug) console.log('CONF Value wurde vom Server geladen:', name, val);
        return val != undefined && val != null ? val : defaultValue;
    });
};
// Config Variable initialisieren
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribeEx = function(name, event, defaultValue, parser) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeEx: Instance not found!', this);
    // Subscribe zuvor aufrufen, damit der Rückgabewert auch das Event feuert
    if (event !== undefined && event !== null) thisInstance._store.subscribe(name, event);
    thisInstance._store.initEx(name, function() {
        //if (Store._debug === true)
        //console.log('subscribeEx -> initEx: ', name);
        if ((0, $hkmmp.default)._debug) console.log('CONF wurde noch nicht initialisiert:', name, ' / default: ', defaultValue);
        // Wert wurde noch nicht geladen
        // Subscribe for Value Changes
        var isNewValue = thisInstance.initAutoSaveInternal(thisInstance, name, true);
        // Default-Value zurückgeben für die Initialisierung
        // gespeicherten Wert zu Initialisierung abrufen
        return thisInstance.getValueInternal(name, defaultValue);
    }, parser);
//if (!isNewValue)
//    thisInstance._store.subscribe(name, event);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribe = function(name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribe: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, defaultValue, (0, $hkmmp.default).Parse);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribeInt = function(name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeInt: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, (0, $hkmmp.default).ParseInt(defaultValue), (0, $hkmmp.default).ParseInt);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribeBool = function(name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeBool: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, (0, $hkmmp.default).ParseBool(defaultValue), (0, $hkmmp.default).ParseBool);
};
//set: this._store.set.bind(this._store),
//setInt: this._store.setInt.bind(this._store),
//setBool: this._store.setBool.bind(this._store),
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.set = function(name, value, signal) {
    var thisInstance = this;
    /*if (!thisInstance.has(name) && signal)
    {
        // initialisieren, wenn noch nicht geschehen
        console.log('DrDocConfig.set: wurde noch nicht initialisiert: ', name);
        //thisInstance.subscribe(name, null, value);
    }*/ thisInstance.initAutoSaveInternal(thisInstance, name, false);
    //this._config.subscribe(name, undefined);
    return this._store.set(name, value, signal);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.get = function(name, defaultValue) {
    //this._config.subscribe(name, undefined);
    return this._store.get(name, defaultValue);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.has = function(name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.has: Instance not found!', this);
    return thisInstance._store.has(name);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.update = function(name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.update: Instance not found!', this);
    return thisInstance._store.update(name);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.remove = function(name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.remove: Instance not found!', this);
    return thisInstance._store.remove(name);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.clear = function() {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.clear: Instance not found!', this);
    return thisInstance._store.clear();
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.unsubscribe = function(name, event) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.unsubscribe: Instance not found!', this);
    return thisInstance._store.unsubscribe(name, event);
};
/*
function BindConfigValue(elem, attrName)
{
    let confName = elem.getAttribute(attrName);
    if (confName == undefined || confName == null || confName == '')
        return;
    //console.log('Conf: ' + confName, elem);
    
    $(elem).on('change', function (newValue, oldValue)
    {
        console.log('Conf: ' + confName, ' | onchange | ', newValue, oldValue);
        DrDoc.configUser.set(confName, elem.value);
    });
 
    DrDoc.configUser.subscribe(confName, function(value) {
        if (value == undefined || value == null)
        {
            elem.value = '';
            return;
        }
        elem.value = value;
        console.log('Conf: ' + confName, ' | new value: ', value);
    });
};
    document.querySelectorAll('select['+attrName+']').forEach(BindConfigValue);
    document.querySelectorAll('input['+attrName+'][type="text"]').forEach(BindConfigValue);
    document.querySelectorAll('input['+attrName+'][type="checkbox"]').forEach(BindConfigCheck);
    document.querySelectorAll('input['+attrName+'][type="number"]').forEach(BindConfigInt);
    document.querySelectorAll('span['+attrName+']').forEach(BindConfigHtml);
*/ // bind-conf-user
// bind-conf-dev="config/view/name"
// bind-conf-dev-value="A"
// bind-conf-dev-default="Default Value"
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.BindConfig = function(elem, attrName) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.BindConfig: Instance not found!', this);
    //thisInstance = DrDocConfig.prototype;
    if (elem._bindConf === true) return;
    elem._bindConf = true;
    attrName = (0, $346VI.default).IsNullOrEmpty(attrName) ? 'bind-conf' : attrName;
    let confName = elem.getAttribute(attrName);
    if (confName == undefined || confName == null || confName == '') {
        console.warn('Biund Conf: empty confName', attrName, elem);
        return;
    }
    let tagName = elem.tagName.toLowerCase();
    let typeName = elem.getAttribute('type') == undefined ? '' : elem.getAttribute('type').toLowerCase();
    let bsToggleName = elem.getAttribute('data-bs-toggle') == undefined ? '' : elem.getAttribute('data-bs-toggle').toLowerCase();
    let defaultValue = elem.getAttribute(attrName + '-default') == undefined ? '' : elem.getAttribute(attrName + '-default');
    let optionValue = elem.getAttribute(attrName + '-value') == undefined ? '' : elem.getAttribute(attrName + '-value');
    let selectValue = elem.getAttribute(attrName + '-select') == undefined ? '' : elem.getAttribute(attrName + '-select');
    //if (defaultValue)
    //console.log('CONF ' , confName, ' = ', defaultValue, ' / tag: ', tagName, ' / bsToggleName: ', bsToggleName);
    function setElemValue(value, oldValue) {
        //console.log('CONF Bind Subsribe fired', confName, '  == ', value, elem);
        switch(tagName){
            case 'select':
            case 'input':
                switch(typeName){
                    case 'checkbox':
                        elem.checked = (0, $hkmmp.default).ParseBool(value); // value == undefined || value == null ? false : value;
                        break;
                    case 'radio':
                        var radioOptionElems = document.querySelectorAll('input[type="radio"][name="' + (0, $346VI.default).SelectorAttributeEncode(elem.getAttribute('name')) + '"]');
                        if (radioOptionElems != null) {
                            //var radioOptionElems2 = document.getElementsByName(elem.getAttribute('name'));
                            //console.log('CONF set elem from conf', value, radioOptionElems, radioOptionElems2);
                            for(var i = 0; i < radioOptionElems.length; i++)if (radioOptionElems[i].value == value) radioOptionElems[i].checked = true;
                        }
                        break;
                    case 'number':
                    case 'text':
                    default:
                        elem.value = value;
                        break;
                }
                break;
            case 'textarea':
                elem.value = value;
                break;
            case 'li':
            case 'button':
            case 'a':
                //console.log('CONF toggle tab: ', confName, ' = ', value, ' | ', optionValue, ' | ', value == optionValue);
                if (value == optionValue) switch(bsToggleName){
                    case 'dropdown':
                        (0, $346VI.default).BS_DropdownShow(elem);
                        break;
                    case 'collapse':
                        (0, $346VI.default).BS_CollapseShow(elem);
                        break;
                    default:
                    case 'tab':
                        (0, $346VI.default).BS_TabShow(elem);
                        break;
                }
                break;
            default:
                elem.innerHTML = value; // value == undefined || value == null ? '' : value;
                break;
        }
    }
    // Default Value aus dem ersten verfügbaren Element wählen
    if ((0, $346VI.default).IsNullOrEmpty(defaultValue)) {
        let selectValueNum = (0, $346VI.default).ParseInt(selectValue);
        // suche nach [bind-conf-dev=confName][bind-conf-dev-value=".."] oder [bind-conf-dev=confName]>[bind-conf-dev-value=".."]
        let elemDefault = document.querySelector(`[${attrName}="${(0, $346VI.default).SelectorAttributeEncode(confName)}"][${(0, $346VI.default).SelectorAttributeEncode(attrName)}-value], [${(0, $346VI.default).SelectorAttributeEncode(attrName)}="${(0, $346VI.default).SelectorAttributeEncode(confName)}"]>[${(0, $346VI.default).SelectorAttributeEncode(attrName)}-value]`);
        if (elemDefault != undefined && elemDefault != null) {
            defaultValue = elemDefault.getAttribute(attrName + '-value');
            if (defaultValue == undefined) defaultValue = '';
            if (!(0, $346VI.default).IsNullOrEmpty(defaultValue) && !(0, $346VI.default).IsNullOrEmpty(bsToggleName)) //console.log('Dr.DOC Config: ', 'Name: ', confName, ' / Select-Num: ', selectValueNum, ' / ', ' => ', defaultValue);
            setElemValue(defaultValue);
        }
    }
    // Subscriber einrichten
    // Auf neue Werte warten (listen)
    switch(tagName){
        case 'select':
        case 'input':
            switch(typeName){
                case 'number':
                    thisInstance.subscribeInt(confName, setElemValue, defaultValue);
                    break;
                case 'checkbox':
                    thisInstance.subscribeBool(confName, setElemValue, defaultValue);
                    break;
                case 'radio':
                case 'text':
                default:
                    thisInstance.subscribe(confName, setElemValue, defaultValue);
                    break;
            }
            break;
        case 'textarea':
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;
        case 'li':
        case 'button':
        case 'a':
            //switch (bsToggleName) {
            //    case 'tab':
            //DrDocWeb.BS_TabShow(elem);
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;
        default:
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;
    }
    //thisInstance.update(confName);
    if (thisInstance.has(confName)) setElemValue(thisInstance.get(confName));
    // Über neue Werte benachrichtigen
    // bei Änderung des Werts
    elem.addEventListener('change', function(newValue, oldValue) {
        if ((0, $hkmmp.default)._debug) console.log('Conf onChange: ' + confName, ' | onchange: ', oldValue, ' => ', newValue.data, ' / ', elem.value, elem);
        switch(tagName){
            case 'select':
            case 'input':
                switch(typeName){
                    case 'checkbox':
                        thisInstance.set(confName, elem.checked);
                        break;
                    case 'radio':
                        var radioOptionElems = document.querySelectorAll('input[type="radio"][name="' + (0, $346VI.default).SelectorAttributeEncode(elem.getAttribute('name')) + '"]');
                        if (radioOptionElems != null) {
                            //var radioOptionElems2 = document.getElementsByName(elem.getAttribute('name'));
                            //console.log('CONF set conf from elem', newValue, radioOptionElems, radioOptionElems2);
                            for(var i = 0; i < radioOptionElems.length; i++)if (radioOptionElems[i].checked) {
                                thisInstance.set(confName, radioOptionElems[i].value);
                                break;
                            }
                        }
                        break;
                    case 'number':
                    case 'text':
                    default:
                        thisInstance.set(confName, elem.value);
                        break;
                }
                break;
            case 'textarea':
                thisInstance.set(confName, elem.value.replaceAll("\r", "").replaceAll("\n", "\r\n"));
                break;
            case 'button':
            case 'li':
            case 'a':
                break;
            default:
                console.warn('Conf onChange: Unknown Tag Name: ', tagName, ' | ', confName);
                break;
        }
    });
    // Über neue Werte benachrichtigen
    // bei Click
    switch(tagName){
        case 'li':
        case 'button':
        case 'a':
            //switch (bsToggleName) {
            //    case 'tab':
            elem.addEventListener('click', function(x) {
                //console.log('CONF click ', confName, ' = ', optionValue);
                //DrDocWeb.BS_TabShow(x.target);
                thisInstance.set(confName, optionValue);
            });
            break;
    }
};

});

parcelRegister("fWhbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a999bb32e8c605$export$2e2bcd8739ae039);

var $346VI = parcelRequire("346VI");
// --
// Node
// Lädt, holt Dr.DOC Node Components
// Requires: DrDocWeb, Bootstrap
if (window.Node !== undefined) console.warn('Lib Duplicate: DrDocNode');
function $b9a999bb32e8c605$export$2e2bcd8739ae039() {}
//module.exports = Node
//export default Node
window.Node = $b9a999bb32e8c605$export$2e2bcd8739ae039;
$b9a999bb32e8c605$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER = String.fromCharCode(1);
$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME = 'node-id';
$b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement = function(nodeId, targetElement, allElements) {
    /*
            let targetElement_arr = DrDocWeb.FindChildElements(document.documentElement, Node.ATTR_NAME, nodeId);
            //targetElement = DrDocWeb.FindChildElement(document.documentElement, Node.ATTR_NAME, nodeId);
            if (targetElement_arr !== undefined)
            {
                let targetElement = targetElement_arr[targetElement_arr.length-1];
                return targetElement;
            }
            return undefined;*/ if ((0, $346VI.default).IsNullOrEmpty(nodeId)) return undefined;
    if (typeof nodeId !== 'string') return nodeId;
    if (nodeId == $b9a999bb32e8c605$export$2e2bcd8739ae039.GetNodeId(targetElement)) // Angefragte Element war bereits das richtige!
    //console.warn('Node.GetElement: Angefragte Element war bereits das richtige!', nodeId, '  ', targetElement);
    return targetElement;
    // ignoriert normalerweise alle Child-Elements von Elementen mit Attribut "data-form-ignore"
    // Für rekursive Formulare notwendig
    if (allElements === true) return (0, $346VI.default).GetElement(targetElement, '[node-id="' + (0, $346VI.default).SelectorAttributeEncode(nodeId) + '"]');
    else return (0, $346VI.default).GetElement(targetElement, '[node-id="' + (0, $346VI.default).SelectorAttributeEncode(nodeId) + '"]:not([data-form-ignore] *)');
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.GetNodeId = function(targetElement) {
    if (targetElement !== undefined && targetElement !== null) {
        if (typeof targetElement === 'string') // annehmen, dass es sich um eine node-id handelt
        return targetElement;
        //console.log('LoadComponent', targetElement);
        let nodeId = targetElement.getAttribute($b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME);
        if (nodeId != undefined && nodeId != null) return nodeId;
    }
    return undefined;
};
//Node.OnRootComponentLoaded
// Lädt eine Komponente in ein DOM-Node
// title, view, sourceElement, targetElement, getData, postData, formFieldsOr, newWindow, ignoreUnloadEvent, closeModalBefore, requestMethod, ignoreLoadEvent, nav, nodeId
// sourceElement: DOM Element für Form Daten, Attribute Daten, Modal
// targetElement: Ziel Node-Name-Path (noodeId) oder DOM Element; nach targetElement kopieren; Wenn Node-Name-Path (noodeId) im zu ladenden Element gefunden wird, dieses Child DOM Element verwenden.
$b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent = function(obj) {
    // title, sourceElement, targetElement, getData, postData, formFieldsOr, newWindow, ignoreUnloadEvent, requestMethod, ignoreLoadEvent
    //console.log('Node.LoadComponent', ' / title:', title, ' / sourceElement:', sourceElement, ' / targetElement:', targetElement, ' / getData:', getData);
    // 1. Target Element und Node-ID laden
    if (!(0, $346VI.default).IsNullOrEmpty(obj.nodeId) && (0, $346VI.default).IsNullOrEmpty(obj.targetElement)) obj.targetElement = obj.nodeId;
    if (obj.targetElement !== undefined && obj.targetElement !== null && obj.targetElement !== '') {
        if (typeof obj.targetElement === 'string') {
            // obj.targetElement ist ein String im Format "NodePath"
            if ((0, $346VI.default).IsNullOrEmpty(obj.nodeId)) obj.nodeId = obj.targetElement;
            obj.targetElement = null;
            obj.targetElement = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(obj.nodeId); //, obj.sourceElement);
        } else // obj.targetElement ist ein DOM Element
        // Node-Path-ID aus 'node-id' Attribut hoeln
        if ((0, $346VI.default).IsNullOrEmpty(obj.nodeId)) obj.nodeId = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetNodeId(obj.targetElement);
    }
    if ((0, $346VI.default).IsNullOrEmpty(obj.nodeId)) {
        console.warn("LoadComponent: Element (obj.targetElement) konnte nicht geladen werden, da keine Node-ID \xfcbergeben wurde!", obj);
        return undefined;
    }
    if (obj.navRoot == true) {
        if (obj.nav == undefined || obj.nav == null) obj.nav = 'push';
        if ((0, $346VI.default).IsNullOrEmpty(obj.progressTitle) && !(0, $346VI.default).IsNullOrEmpty(obj.title)) obj.progressTitle = 'Loading ' + obj.title + '...';
        if ((0, $346VI.default).IsNullOrEmpty(obj.progressTitle)) obj.progressTitle = 'Loading...';
        let progressBarModal = (0, $346VI.default).ModalProgress(obj.progressTitle);
        let nodeIdRoot = obj.nodeId.split('|')[0];
        let targetElementTmp = obj.targetElement;
        let targetElementRoot = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeIdRoot);
        if (window.onNodeRootComponentLoaded !== undefined && typeof window.onNodeRootComponentLoaded === 'function') window.onNodeRootComponentLoaded(obj);
        // Ziel Komponente in Ziel nodeId laden
        let loadComponentNoRoot = function() {
            //console.log('loadComponentNoRoot loading (2)..');
            //obj.sourceElement = targetElementTmp;
            obj.targetElement = obj.nodeId;
            if (obj.sourceElement == undefined || obj.sourceElement == null) obj.sourceElement = obj.targetElement;
            // Rekursion vermeiden, navRoot = false setzen
            obj.navRoot = false;
            //console.log('Node.LoadComponent: navRoot: / targetElementRoot wurde gefunden: ', targetElementRoot);
            return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent(obj).then(function(result) {
                if (window.onNodeRootComponentLoaded !== undefined && typeof window.onNodeRootComponentLoaded === 'function') window.onNodeRootComponentLoaded(obj);
                progressBarModal.close();
                //console.log('loadComponentNoRoot loaded!');
                if (result !== undefined) return result;
            });
        };
        if (targetElementRoot == undefined || targetElementRoot == null) //console.log('loadComponentNoRoot loading (1)..');
        // Element für nodeId Root nicht gefunden
        // => Komponente mit Root Node-Name-Path (noodeId) laden
        //console.log('Node.LoadComponent: navRoot: / nodeIdRoot: ', nodeIdRoot, ' / obj.navRoot: ', obj.navRoot, ' / obj.nodeId: ', obj.nodeId);
        return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
            nodeId: nodeIdRoot,
            targetElement: targetElementTmp,
            sourceElement: targetElementTmp
        }).then(loadComponentNoRoot);
        else loadComponentNoRoot();
    }
    // --
    // 2. Url bauen
    //console.log('Load Com - Target Elem', obj.targetElement, obj.targetElement.innerHTML);
    //let url = target_url !== undefined && target_url.length > 0 ? target_url : window.location.href;
    //console.log('Url', url);
    let url = '/node/' + obj.nodeId;
    // --
    // 3. POST Data
    let hasPostData = false;
    if (obj.postData === undefined || obj.postData === null) {
        obj.postData = {};
        hasPostData = false;
    } else {
        hasPostData = true;
        if (typeof obj.postData === 'string') obj.postData = (0, $346VI.default).QueryStrToObject(obj.postData);
    }
    // --
    // 4. GET Data laden
    let hasGetData = false;
    if (obj.getData === undefined || obj.getData === null) {
        obj.getData = {};
        hasGetData = false;
    } else {
        hasGetData = true;
        // Falls obj.getData ein Query-String ist, in ein Objekt verwandeln
        if (typeof obj.getData === 'string') obj.getData = (0, $346VI.default).QueryStrToObject(obj.getData);
    }
    /// TODO: viewName aus URL oder aus Element obj.targetElement laden
    let viewName = 'None'; // 'Inline';
    //getArgs['prop'] = props;
    //obj.getData['prop_orig'] = obj.nodeId;
    if (!(0, $346VI.default).IsNullOrEmpty(obj.view)) viewName = obj.view;
    if ((0, $346VI.default).IsNullOrEmpty(obj.getData['view'])) obj.getData['view'] = viewName;
    if (obj.ignoreUnloadEvent === true) window.onbeforeunload = undefined;
    let attrElementsArr = [];
    // --
    // 5. Source Element / Node-id + Formular-Daten laden
    // Form Daten in obj.getData setzen
    // Alle Felder mit "$" am Anfang werden direkt als "<FieldName>" übernommen, alle anderen in "form_<FieldName>" umgewandelt
    if (obj.sourceElement !== undefined && obj.sourceElement !== null) {
        if (typeof obj.sourceElement === 'string') obj.sourceElement = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(obj.sourceElement);
        if (obj.sourceElement !== undefined && obj.sourceElement !== null) // Existiert ein "beforeunload" Event auf dem Element?
        {
            if (obj.ignoreUnloadEvent !== true && //(obj.ignoreUnloadEvent == undefined || obj.ignoreUnloadEvent == null || obj.ignoreUnloadEvent == false) &&
            obj.sourceElement.beforeunload !== undefined && obj.sourceElement.beforeunload !== null && typeof obj.sourceElement.beforeunload === 'function') {
                // Wenn nicht true (also false oder undefined) zurückgegeben wurde, dann abbrechen.
                if (obj.sourceElement.beforeunload() !== true) return undefined;
            }
        } else console.warn('Node.LoadComponent', 'obj.sourceElement == undefined');
        attrElementsArr.push(obj.sourceElement);
    } else console.warn('Node.LoadComponent', 'obj.sourceElement (DOM) == undefined');
    // --
    // Wenn keine POST Daten vorhanden sind, Feldwerte aus Formular laden
    if (!hasPostData) $b9a999bb32e8c605$export$2e2bcd8739ae039.ParseFormData(obj.sourceElement, obj.getData, obj.postData, obj.formFieldsOr, obj.writeToGetData);
    // --
    // DOM Node Objekt löschen, damit es nicht zwei mal im DOM vorkommt
    //DrDoc.store.set('node|' + obj.nodeId, undefined);
    // --
    // Daten aus Target-Element lesen
    if (obj.targetElement !== undefined && obj.targetElement !== null) {
        // Existiert ein "beforeunload" Event auf dem Element?
        if (obj.ignoreUnloadEvent !== true && //(obj.ignoreUnloadEvent == undefined || obj.ignoreUnloadEvent == null || obj.ignoreUnloadEvent == false) &&
        obj.targetElement.beforeunload !== undefined && obj.targetElement.beforeunload !== null && typeof obj.targetElement.beforeunload === 'function') {
            // Wenn nicht true (also false oder undefined) zurückgegeben wurde, dann abbrechen.
            if (obj.targetElement.beforeunload() !== true) return undefined;
        }
        attrElementsArr.push(obj.targetElement);
    }
    for (let attrElement of attrElementsArr){
        //console.log("node form ", attrElement, attrElement.attributes);
        // Html/DOM Attribute aus dem "attrElement" extrahieren und in POST/GET-Parameter mergen
        if (attrElement == null || attrElement == undefined || attrElement.attributes == undefined) continue;
        var attrs = attrElement.attributes;
        if (attrs != undefined && attrs != null && attrs.length > 0) {
            //if (!hasPostData) {
            for(var i = attrs.length - 1; i >= 0; i--)if (attrs[i].name.indexOf('node-post-') === 0) {
                let fieldName = attrs[i].name.substring(10);
                //console.log("node form post " + fieldName + " -> " + attrs[i].value);
                obj.postData[fieldName] = attrs[i].value;
            }
            //}
            //if (!hasGetData) {
            for(var i = attrs.length - 1; i >= 0; i--)if (attrs[i].name.indexOf('node-get-') === 0) {
                let fieldName = attrs[i].name.substring(9);
                //console.log("node form get " + fieldName + " -> " + attrs[i].value);
                obj.getData[fieldName] = attrs[i].value;
            }
        //}
        }
        let attrTitle = attrElement.getAttribute('node-title');
        if (!(0, $346VI.default).IsNullOrEmpty(attrTitle)) obj.title = attrTitle;
        // Navigation
        let attrNav = attrElement.getAttribute('node-nav');
        if (!(0, $346VI.default).IsNullOrEmpty(attrNav)) // Url für den Root WebNode
        //let navUrl = DrDocWeb.GetRequestUrl(url.split('|')[0], obj.getData);
        //console.log('NAVIGATE Node B: ', obj.title, navUrl, attrElement);
        obj.nav = attrNav;
    }
    // --
    // Modal schließen, NACHDEM die Form Felder geladen wurden
    if (obj.closeModalBefore === true) (0, $346VI.default).ModalClose(obj.sourceElement, true);
    // --
    // navigieren
    if (obj.nav !== undefined && obj.nav !== null && !(obj.nav === 'false' || obj.nav === '0' || obj.nav === false)) $b9a999bb32e8c605$export$2e2bcd8739ae039.NavigateComponent(obj);
    // Scroll Position und Focus merken, um diese nach dem Laden wiederherzustellen
    let sourceScrollTop = obj.sourceElement != undefined && obj.sourceElement != null ? obj.sourceElement.scrollTop : 0;
    let sourceScrollLeft = obj.sourceElement != undefined && obj.sourceElement != null ? obj.sourceElement.scrollLeft : 0;
    let targetScrollTop = obj.targetElement != undefined && obj.targetElement != null ? obj.targetElement.scrollTop : 0;
    let targetScrollLeft = obj.targetElement != undefined && obj.targetElement != null ? obj.targetElement.scrollLeft : 0;
    let activeElementId = document.activeElement != null ? document.activeElement.id : null;
    return $b9a999bb32e8c605$export$2e2bcd8739ae039._initTargetElement(obj).then(function(targetElement) {
        // Modal schließen
        if (obj.closeModalAfter === true) (0, $346VI.default).ModalClose(obj.sourceElement, true);
        //if ((obj.sourceElement !== undefined && obj.sourceElement !== null) && (targetElement !== undefined && targetElement !== null)) {
        //    targetElement._triggerElement = obj.sourceElement;
        //    obj.sourceElement._triggerElement = targetElement;
        //}
        targetElement.UpdateComponent = function() {
            obj.targetElement = targetElement;
            //if (obj.getData == undefined || obj.getData == null)
            obj.getData.update = 'true';
            //Node.UpdateComponent(obj.nodeId);
            //return Node.LoadComponent(obj.title, obj.sourceElement, targetElement, obj.getData, obj.postData);
            return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent(obj);
        };
        if (obj.requestMethod == undefined || obj.requestMethod == null || obj.requestMethod.length == 0) //obj.requestMethod = 'GET';
        obj.requestMethod = 'POST';
        // Dr.DOC Server anfragen
        // DrDocWeb.Send = function (method, url, getData, postData, parseAs, sendAs, cookie, retAsync)
        return (0, $346VI.default).Send(obj.requestMethod, url, obj.getData, obj.postData, undefined, undefined, undefined, true).then(function(response) {
            if (targetElement === null || targetElement === undefined) // Öffnet ein Modal, falls kein DOM-Element vorhanden ist.
            console.warn('LoadComponent', 'targetElement == null');
            else {
                //console.log('LoadComponent', 'Response ok');
                //DrDocWeb.setInnerHTML(targetElement, '...');
                //DrDocWeb.setInnerHTML(targetElement, response);
                //DrDocWeb.EventFire(targetElement, 'NodeLoaded');
                if (obj.ignoreLoadEvent !== true) (0, $346VI.default).EventFire(targetElement, 'NodeUnloaded');
                //targetElement.innerHTML = response;
                //var v_elem = document.createElement('div');
                var doc = targetElement.ownerDocument || document;
                var v_elem = doc.createElement('div');
                v_elem.innerHTML = response;
                //var v_elem_child = DrDocWeb.FindChildElement(v_elem, Node.ATTR_NAME, obj.nodeId);
                var v_elem_child = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(obj.nodeId, v_elem);
                if (v_elem_child !== undefined && v_elem_child !== null) //console.log(`LoadComponent: DOM-Element ${Node.ATTR_NAME}="${obj.nodeId}"`, 'target', targetElement, v_elem, v_elem_child, response);
                //targetElement.innerHTML = v_elem_child.innerHTML;
                // über setInnerHTML aufrufen, damit Scripts ausgeführt werden können
                //--DrDocWeb.setInnerHTML(targetElement, v_elem_child.outerHTML);
                (0, $346VI.default).setInnerHTML(targetElement, v_elem_child.innerHTML);
                else {
                    console.warn(`LoadComponent: DOM-Element ${$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME}="${obj.nodeId}" konnte nicht gefunden werden!`, ' / response: ', response, ' / v_elem: ', v_elem, ' / targetElement: ', targetElement, ' / sourceElement: ', obj.sourceElement);
                    //targetElement.outerHTML = v_elem.innerHTML;
                    //DrDocWeb.setInnerHTML(targetElement, v_elem.innerHTML);
                    if (obj.exact === true) (0, $346VI.default).setInnerHTML(targetElement, `Zugriff verweigert: Element ${$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME} ${obj.nodeId} konnte nicht gefunden werden!`);
                    else (0, $346VI.default).setInnerHTML(targetElement, v_elem.innerHTML);
                }
                // node-id Attribute des Target Elements ändern
                if (targetElement.hasAttribute('node-id')) targetElement.setAttribute('node-id', obj.nodeId);
                if (obj.ignoreLoadEvent !== true) (0, $346VI.default).EventFire(targetElement, 'NodeLoaded');
                if (obj.sourceElement != undefined && obj.sourceElement != null) {
                    obj.sourceElement.scrollTop = sourceScrollTop;
                    obj.sourceElement.scrollLeft = sourceScrollLeft;
                }
                if (obj.targetElement != undefined && obj.targetElement != null) {
                    obj.targetElement.scrollTop = targetScrollTop;
                    obj.targetElement.scrollLeft = targetScrollLeft;
                }
                if (!(0, $346VI.default).IsNullOrEmpty(activeElementId)) {
                    //console.log('LoadComponent: Reload active elem', activeElementId, document.getElementById(activeElementId));
                    var activeElementTmp = document.getElementById(activeElementId);
                    if (activeElementTmp != undefined && activeElementTmp != null) {
                        document.activeElement = activeElementTmp;
                        if (activeElementTmp.focus !== undefined && typeof activeElementTmp.focus === 'function') activeElementTmp.focus();
                    }
                }
            // DOM Node in Store setzen
            //DrDoc.store.set('node|' + obj.nodeId, targetElement);
            }
        }).catch($b9a999bb32e8c605$export$2e2bcd8739ae039._onErrorLoadElem(obj.title, obj.nodeId, targetElement));
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.ParseFormData = function(sourceElement, getData, postData, formFieldsOr, writeToGetData) {
    let splitter_char = formFieldsOr === true ? '|' : $b9a999bb32e8c605$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER;
    let formData = (0, $346VI.default).GetClosestFormToObject(sourceElement, splitter_char);
    // Formular-Daten in GET Parameter übertragen
    if (formData !== undefined && formData !== null) //console.log('Node.ParseFormData: ', formData);
    for(let fieldName in formData){
        let fieldValue = formData[fieldName];
        // Leere Feldwerte überspringen
        if (formFieldsOr === true) {
            if (fieldValue === undefined || fieldValue === null || fieldValue === '') continue;
        //else
        //    fieldValue = fieldValue.replace(/[\|]+$/, '');
        //fieldValue = fieldValue.replace(/[\s\|]+$/, '');
        }
        // Formular-Daten kommen in POST
        // Formulardaten mit Prefix "$" kommen in GET
        if (fieldName.substring(0, 1) === '$') getData[fieldName.substring(1)] = fieldValue;
        else if (writeToGetData === true) getData['field_' + fieldName] = fieldValue;
        else postData[fieldName] = fieldValue;
    }
    return formData;
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SetFormFieldGetData = function(getObj, data) {
    //console.log('Node.SetFormFieldGetData() 1: ', getObj, data);
    if (data != undefined && data != null) {
        if (typeof data === 'string') {
            // Wenn "data" ein "String" ist, dann annehmen, dass die Feld-Namen im Format "field_<FieldName>" ist
            data = (0, $346VI.default).QueryStrToObject(data);
            for(let i in data)getObj[i] = data[i];
        } else {
            // "data" ist ein Object, daher "field" voranstellen
            for(let name in data)if (name[0] == '$') getObj[name.substring(1)] = data[name];
            else getObj['field_' + name] = data[name];
        }
    }
};
$b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading = function(targetElement) {
    if (targetElement == undefined || targetElement == null) return;
    // "Loading" Info in das Element schreiben
    // Manche Elemente müssen gesondert behandelt werden
    switch(targetElement.tagName.toLowerCase()){
        case 'button':
        case 'input':
            targetElement.innerHTML = 'loading..';
            break;
        case 'select':
            targetElement.innerHTML = '<option>loading..</option>';
            break;
        default:
            if (targetElement.querySelectorAll !== undefined && typeof targetElement.querySelectorAll === 'function') {
                let containerArr = targetElement.querySelectorAll('span, input, textarea, select, button, label, a');
                if (containerArr != undefined && containerArr != null && containerArr.length > 0) //console.log('Arr: ', containerArr);
                for (let childElem of containerArr){
                    if (childElem.classList !== undefined) childElem.classList.add('placeholder');
                    if (childElem.classList !== undefined) childElem.classList.add('disabled');
                    if (childElem.classList !== undefined) childElem.classList.add('bg-secondary');
                    if (childElem.setAttribute !== undefined && typeof childElem.setAttribute === 'function') childElem.setAttribute('disabled', true);
                }
                let leafArr = targetElement.querySelectorAll('p, h1, h2, h3, h4, h5, tr, td, li, .card-title, .card-body');
                if (leafArr != undefined && leafArr != null && leafArr.length > 0) {
                    for (let childElem of leafArr)if (childElem.classList !== undefined) childElem.classList.add('placeholder-wave');
                }
            }
            break;
    }
};
$b9a999bb32e8c605$export$2e2bcd8739ae039._onErrorLoadElem = function(title, nodeId, targetElement) {
    return function(err) {
        console.warn('ERROR Node.LoadComponent / Node._onErrorLoadElem', err);
        //console.log('ERROR / LoadComponent 1', err);
        (0, $346VI.default).ModalError(`Fehler f\xfcr: ${title}`, `Komponente "${$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME}"="${nodeId}" konnte nicht abgerufen werden!`);
        //DrDocWeb.ModalError(`Fehler für: ${title} konnte nicht abgerufen werden!`);
        //alert(`Fehler für: ${title}`, `Komponente "${Node.ATTR_NAME}"="${nodeId}" konnte nicht abgerufen werden!`);
        if (targetElement != undefined && targetElement != null) {
            var origInnerHtml = targetElement.innerHTML;
            // Im Fehlerfall die Kompontente zurücksetzen
            if (origInnerHtml.length > 0) origInnerHtml = `<b>Komponente konnte nicht abgerufen werden! Die Komponente wird auf den vorherigen Wert zur\xfcckgesetzt. Bitte Internetverbindung \xfcberpr\xfcfen.</b>
        <br />
        <button class="btn btn-lg btn-primary" onclick="Node.GetElement('${nodeId}').UpdateComponent();">Neu laden</button>
        <br />${origInnerHtml}`;
            else origInnerHtml = `<b>Bitte Internetverbindung \xfcberpr\xfcfen.</b>
        <br />
        <button class="btn btn-lg btn-primary" onclick="Node.GetElement('${nodeId}').UpdateComponent();">Neu laden</button>`;
            targetElement.innerHTML = origInnerHtml;
        } else console.warn('ERROR Node.LoadComponent / Node._onErrorLoadElem: targetElement == null', err);
    //reject(err);
    };
};
// Target Element erstellen oder initialisieren
// Return: Promise(targetElement)
$b9a999bb32e8c605$export$2e2bcd8739ae039._initTargetElement = function(obj) {
    let origInnerHtml = '';
    return new Promise(function(resolve, reject) {
        //try
        //{
        // falls kein "targetElement" übergeben wurde, ein Modal erstellen oder ein neues Fenster öffnen.
        if (obj.targetElement === undefined || obj.targetElement === null || obj.newWindow === true) {
            if (obj.newWindow === true) // Get New Window
            return $b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindowSelectElement(obj.title, obj.nodeId).then(function(targetElementArg) {
                obj.targetElement = targetElementArg;
                $b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading(obj.targetElement);
                resolve(targetElementArg);
            }).catch(reject);
            else {
                // falls kein "targetElement" übergeben wurde, ein Modal erstellen.
                obj.targetElement = document.createElement('div');
                obj.targetElement.setAttribute($b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME, obj.nodeId);
                $b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading(obj.targetElement);
                if (obj.modalOption === undefined || obj.modalOption === null) obj.modalOption = {
                    fullScreen: false,
                    size: 'xl'
                };
                (0, $346VI.default).Modal(obj.title, obj.targetElement, obj.modalOption);
            }
        } else {
            // Original-Element für den Fehlerfall zwischenspeichern
            origInnerHtml = obj.targetElement.innerHTML;
            $b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading(obj.targetElement);
        }
        resolve(obj.targetElement);
    /*}
        catch (err)
        {
            onError(err);
        }*/ }).catch($b9a999bb32e8c605$export$2e2bcd8739ae039._onErrorLoadElem(obj.title, obj.nodeId, obj.targetElement));
};
// Node DOM Element im Temp Window wählen
$b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindowSelectElement = function(title, nodeId) {
    return new Promise(function(resolve, reject) {
        $b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindow(nodeId).then(function(newWindow) {
            newWindow.title = title;
            var newWindowDoc = newWindow.document.documentElement;
            console.log('New Window Target Elem', newWindowDoc);
            resolve(newWindowDoc);
        }).catch(reject);
    });
};
// Temp Window für den Node öffnen und Promis zurückgeben
$b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindow = function(nodeId) {
    return new Promise(function(resolve, reject) {
        try {
            // falls kein "targetElement" übergeben wurde, ein neues Fenster öffnen.
            //var newWindow = window.open(url, '_blank'); //'/node/')
            var thisDocHtml = null; //document.documentElement.innerHTML;
            // Fenster speichern in "window._comWindow[Node-Path]"
            if (window._comWindow === undefined || window._comWindow === null) window._comWindow = {};
            if (window._comWindowCounter === undefined || window._comWindowCounter === null) window._comWindowCounter = 0;
            var newWindow = null;
            if (window._comWindow[nodeId] !== undefined && window._comWindow[nodeId] !== null && window._comWindow[nodeId].closed === false) {
                newWindow = window._comWindow[nodeId];
                newWindow.focus();
                resolve(newWindow);
            } else {
                window._comWindowCounter++;
                newWindow = window.open('/node/system/empty#nr-' + window._comWindowCounter, nodeId + " - " + window._comWindowCounter, 'width=1200, height=1000');
                //newWindow = window.open('about:blank', nodeId, 'width=700, height=800');
                window._comWindow[nodeId] = newWindow;
                newWindow.addEventListener('load', function(e) {
                    //console.log('_getTempNodeWindow: New Window has been loadad', e, e.target.documentElement);
                    newWindow.focus();
                    resolve(newWindow);
                }, true);
                newWindow.addEventListener('beforeunload', function(e) {
                    if (window._comWindow != undefined) window._comWindow[nodeId] = undefined;
                }, false);
                if (thisDocHtml != null && thisDocHtml != undefined) {
                    var newWindowDoc = newWindow.document.open();
                    newWindowDoc.write(thisDocHtml);
                    newWindowDoc.close();
                }
            //console.log('New Window ', newWindow, newWindow.documentElement, newWindowDoc);
            //console.log('New Window ', nodeId, newWindow, newWindowDoc, newWindow.document, newWindow.document.documentElement);
            /*while (newWindow.document.readyState != 'complete')
                {
                    // wait..
                }*/ }
        } catch (err) {
            reject(err);
        }
    });
};
// Aktualisiert alle Nodes, die diesen Node im NodePath enthalten
$b9a999bb32e8c605$export$2e2bcd8739ae039.UpdateComponent = function(nodeName) {
    let nodeElem = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeName);
    if (nodeElem != undefined && nodeElem != null && typeof nodeElem.UpdateComponent === 'function') {
        console.log('Node.UpdateComponent: ', nodeName, nodeElem);
        return nodeElem.UpdateComponent();
    } else {
        console.log('Node.UpdateComponent: ', nodeName, 'Nicht gefunden!');
        return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
            title: 'Komponente aktualisieren',
            sourceElement: nodeElem,
            targetElement: nodeElem
        });
    }
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
        title: 'Komponente aktualisieren',
        sourceElement: $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeName),
        targetElement: $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeName)
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom = {
    nodeId: '',
    getData: '',
    postData: ''
};
// History Verlauf
$b9a999bb32e8c605$export$2e2bcd8739ae039.NavigateComponent = function(obj) {
    var replace = obj.nav == 'replace';
    var state = (0, $346VI.default).CloneCopy(obj);
    state.sourceElement = obj.nodeId;
    state.targetElement = obj.nodeId;
    state.action = 'nav';
    state.nav = undefined;
    if ($b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.nodeId == obj.nodeId && $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.getData == (0, $346VI.default).ObjectToQueryStr(state.getData) && $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.postData == (0, $346VI.default).ObjectToQueryStr(state.postData)) return;
    $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.nodeId = obj.nodeId;
    $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.getData = (0, $346VI.default).ObjectToQueryStr(state.getData);
    $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.postData = (0, $346VI.default).ObjectToQueryStr(state.postData);
    var navUrl = '/node/' + obj.nodeId.split('|')[0] + '?' + (0, $346VI.default).ObjectToQueryStr(state.getData);
    var navTitle = !(0, $346VI.default).IsNullOrEmpty(state.title) ? state.title : document.title;
    /*var navSourceElem = Node.GetElement(obj.nodeId);
    if (navSourceElem == undefined || navSourceElem == null) {
        console.log('Node.NavigateComponent: Node id not found / title: ', navTitle, ' / navUrl: ', navUrl, ' / nodeId: ', obj.nodeId);
        return;
    }*/ /*var setState = {
        //html: sourceElem.innerHTML,
        //html: navSourceElem.innerHTML,
        nodeId: obj.nodeId,
        pageTitle: navTitle,
        url: navUrl
    };*/ try {
        if (replace) {
            console.log('Node.NavigateComponent: REPLACE state / title: ', navTitle, ' / navUrl: ', navUrl, ' / nodeId: ', obj.nodeId);
            window.history.replaceState(state, navTitle, navUrl);
        } else {
            console.log('Node.NavigateComponent: PUSH state / title: ', navTitle, ' / navUrl: ', navUrl, ' / nodeId: ', obj.nodeId);
            window.history.pushState(state, navTitle, navUrl);
        }
    } catch (ex) {
        console.warn('Node.NavigateComponent:', obj.nodeId, obj, ex);
    }
    //if (window.onpopstate != Node.OnNavigateComponentEvent)
    //    window.onpopstate = Node.OnNavigateComponentEvent;
    window.removeEventListener('popstate', $b9a999bb32e8c605$export$2e2bcd8739ae039.OnNavigateComponentEvent);
    window.addEventListener('popstate', $b9a999bb32e8c605$export$2e2bcd8739ae039.OnNavigateComponentEvent);
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.OnNavigateComponentEvent = function(e) //window.addEventListener('popstate', function(e)
{
    if (e.state) /*if (e.state.url == navUrl)
        {
            //console.log('window.onpopstate->e.state: ENDE! ', e, e.state);
            return;
        }*/ //document.getElementById("content").innerHTML = e.state.html;
    //var navSourceElem = Node.GetElement(e.state.nodeId);
    //navSourceElem.innerHTML = e.state.html;
    //document.title = e.state.pageTitle;
    {
        if (e.state.action == 'nav') {
            console.log('Node.OnNavigateComponentEvent: window.onpopstate->e.state:', e.state);
            e.preventDefault();
            $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent(e.state);
        }
    }
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SaveThis = function(node_id, node_prop_name, node_prop_value, node_prop_type, node_prop_inherit, new_name) {
    if ((0, $346VI.default).IsNullOrEmpty(node_id)) {
        console.error("Node.Save: Kein Argument f\xfcr node_id angegeben!");
        return;
    }
    // HTTP PUT
    // POST Object = {
    //    __name: <Name>
    //    __prototype: <Prototype>
    //    <PropertyName>: <PropertyValue>
    //    $<PropertyName>: <PropertyType>
    //    ~<OldPropertyName>: <NewPropertyName>
    //    -<RemovePropertyName>: ''
    //    +<InheritPropertyName>: true
    //}
    let postData = {};
    if (!(0, $346VI.default).IsNullOrEmpty(new_name)) postData['__name'] = new_name;
    //if (!DrDocWeb.IsNullOrEmpty(new_prototype)) {
    //    postData['__prototype'] = new_prototype;
    //}
    if (!(0, $346VI.default).IsNullOrEmpty(node_prop_name)) {
        postData[node_prop_name] = !(0, $346VI.default).IsNullOrEmpty(node_prop_value) ? node_prop_value : '';
        // Property Type
        if (!(0, $346VI.default).IsNullOrEmpty(node_prop_type)) postData['$' + node_prop_name] = node_prop_type;
        // Property vererben
        if (node_prop_inherit != null && node_prop_inherit != undefined) postData['+' + node_prop_name] = node_prop_inherit == true;
    }
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
        //getData,
        postData: postData,
        view: 'Inline',
        targetElement: node_id,
        sourceElement: node_id,
        //sourceElement: (!DrDocWeb.IsNullOrEmpty(node_prop_name) ? (node_id + '|' + node_prop_name) : node_id),
        requestMethod: 'PUT'
    });
//let path = '/node/' + node_id;
//console.log('SendValue, load inline editor', node_id, node_id, path, getData, postData);
//return DrDocWeb.Send('PUT', path, getData, postData).then(function (data) {
//    return Node.UpdateComponent(node_id);
//});
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.Save = function(node_id, node_prop_value, node_prop_type, ode_prop_inherit, new_name) {
    if (node_id == undefined || node_id == null || node_id == '') {
        console.error("Node.Save: Kein Argument f\xfcr node_id angegeben!");
        return;
    }
    // node_id = page_home|menu_main|de/property
    let node_id_path_arr = node_id.split('|');
    let node_prop_name = node_id_path_arr[node_id_path_arr.length - 1];
    node_id_path_arr.splice(node_id_path_arr.length - 1, 1);
    let node_id_parent = node_id_path_arr.join('|');
    // =>
    // node_id_parent = page_home|menu_main
    // node_prop_name = de/property
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SaveThis(node_id_parent, node_prop_name, node_prop_value, node_prop_type, ode_prop_inherit, new_name);
};
//Node.SendElementValue = function(path, node_id, node_name, element, elemBase)
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement = function(node_id, element, elemBase, parser) {
    let elem = element !== undefined && element !== null && typeof element === 'string' ? (0, $346VI.default).GetElement(elemBase, element) : element;
    if (element == undefined || element == null) {
        console.warn('Node.SendElementValue: Element not found (by id)!', element, elem);
        return false;
    }
    //let elem = Node.GetElement(element);
    let value = parser(elem);
    //console.log('Node.SendElementValue: ', 'Path: ', path, 'Node-ID: ', element, 'Value: ', value, 'Elements: ', elem);
    //return Node.Save(path, node_id, node_name, value, '');
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.Save(node_id, value, undefined, undefined);
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementContentMarkdown = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('Node.SendElementContentMarkdown', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.value;
        return ret_value;
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementContentHtml = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('Node.SendElementContent', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.innerHTML;
        ret_value = ret_value.replaceAll('<br data-mce-bogus=&quot;1&quot;>', '<br />');
        ret_value = ret_value.replaceAll('<br data-mce-bogus="1">', '<br />');
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus=&quot;1&quot;&gt;', '<br />');
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus="1"&gt;', '<br />');
        return ret_value;
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementContentText = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('Node.SendElementContent', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.InnerText !== undefined ? _elem.InnerText : _elem.innerHTML;
        console.log('Node.SendElementContent', 'Text 1', ret_value);
        ret_value = ret_value.replaceAll('&nbsp;', " ");
        ret_value = ret_value.replaceAll('&lt;', "<");
        ret_value = ret_value.replaceAll('&gt;', ">");
        ret_value = ret_value.replaceAll('<br data-mce-bogus=&quot;1&quot;>', "\r\n");
        ret_value = ret_value.replaceAll('<br data-mce-bogus="1">', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus=&quot;1&quot;&gt;', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus="1"&gt;', "\r\n");
        ret_value = ret_value.replaceAll('<br>', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br&gt;', "\r\n");
        ret_value = ret_value.replaceAll('<br/>', "\r\n");
        ret_value = ret_value.replaceAll('<br />', "\r\n");
        ret_value = ret_value.replaceAll('</p>', "\r\n");
        ret_value = ret_value.replaceAll('<p>', '');
        console.log('Node.SendElementContent', 'Text 2', ret_value);
        return ret_value;
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementChecked = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('SendElementChecked', _elem);
        return _elem.checked ? 'true' : 'false';
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementValue = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('SendElementValue', _elem);
        return _elem.value;
    });
};
//Node.SendElementName = function(path, node_id, new_name)
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementName = function(node_id, new_name, elemBase) {
    // ist new_name ein Element?
    if (new_name !== undefined && typeof new_name !== 'string' && new_name.value !== undefined) new_name = new_name.value;
    //return Node.Save(path, node_id, undefined, undefined, new_name);
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.Save(node_id, undefined, undefined, new_name);
};

});

parcelRegister("iiLdM", function(module, exports) {
/**
* Generate unique and beautiful colors from any texts or numbers
 * @version v1.1.1
 * @link https://github.com/dastoori/uniqolor#README
 * @author Rasool Dastoori
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var SATURATION_BOUND = [
        0,
        100
    ];
    var LIGHTNESS_BOUND = [
        0,
        100
    ];
    var pad2 = function pad2(str) {
        return "".concat(str.length === 1 ? '0' : '').concat(str);
    };
    var clamp = function clamp(num, min, max) {
        return Math.max(Math.min(num, max), min);
    };
    var random = function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    var randomExclude = function randomExclude(min, max, exclude) {
        var r = random(min, max);
        for(var i = 0; i < (exclude === null || exclude === void 0 ? void 0 : exclude.length); i++){
            var value = exclude[i];
            if ((value === null || value === void 0 ? void 0 : value.length) === 2 && r >= value[0] && r <= value[1]) return randomExclude(min, max, exclude);
        }
        return r;
    };
    /**
   * Generate hashCode
   * @param  {string} str
   * @return {number}
   */ var hashCode = function hashCode(str) {
        var len = str.length;
        var hash = 0;
        for(var i = 0; i < len; i++){
            hash = (hash << 5) - hash + str.charCodeAt(i);
            hash &= hash; // Convert to 32bit integer
        }
        return hash;
    };
    /**
  * Clamps `num` within the inclusive `range` bounds
  * @param  {number}       num
  * @param  {number|Array} range
  * @return {number}
  */ var boundHashCode = function boundHashCode(num, range) {
        if (typeof range === 'number') return range;
        return num % Math.abs(range[1] - range[0]) + range[0];
    };
    /**
   * Sanitizing the `range`
   * @param  {number|Array} range
   * @param  {Array}        bound
   * @return {number|Array}
   */ var sanitizeRange = function sanitizeRange(range, bound) {
        if (typeof range === 'number') return clamp.apply(void 0, [
            Math.abs(range)
        ].concat(_toConsumableArray(bound)));
        if (range.length === 1 || range[0] === range[1]) return clamp.apply(void 0, [
            Math.abs(range[0])
        ].concat(_toConsumableArray(bound)));
        return [
            Math.abs(clamp.apply(void 0, [
                range[0]
            ].concat(_toConsumableArray(bound)))),
            clamp.apply(void 0, [
                Math.abs(range[1])
            ].concat(_toConsumableArray(bound)))
        ];
    };
    /**
   * @param  {number} p
   * @param  {number} q
   * @param  {number} t
   * @return {number}
   */ var hueToRgb = function hueToRgb(p, q, t) {
        if (t < 0) t += 1;
        else if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    };
    /**
   * Converts an HSL color to RGB
   * @param  {number} h Hue
   * @param  {number} s Saturation
   * @param  {number} l Lightness
   * @return {Array}
   */ var hslToRgb = function hslToRgb(h, s, l) {
        var r;
        var g;
        var b;
        h /= 360;
        s /= 100;
        l /= 100;
        if (s === 0) // achromatic
        r = g = b = l;
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hueToRgb(p, q, h + 1 / 3);
            g = hueToRgb(p, q, h);
            b = hueToRgb(p, q, h - 1 / 3);
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255)
        ];
    };
    /**
   * Determines whether the RGB color is light or not
   * http://www.w3.org/TR/AERT#color-contrast
   * @param  {number}  r               Red
   * @param  {number}  g               Green
   * @param  {number}  b               Blue
   * @param  {number}  differencePoint
   * @return {boolean}
   */ var rgbIsLight = function rgbIsLight(r, g, b, differencePoint) {
        return (r * 299 + g * 587 + b * 114) / 1000 >= differencePoint;
    }; // eslint-disable-line max-len
    /**
   * Converts an HSL color to string format
   * @param  {number} h Hue
   * @param  {number} s Saturation
   * @param  {number} l Lightness
   * @return {string}
   */ var hslToString = function hslToString(h, s, l) {
        return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
    };
    /**
   * Converts RGB color to string format
   * @param  {number}  r      Red
   * @param  {number}  g      Green
   * @param  {number}  b      Blue
   * @param  {string}  format Color format
   * @return {string}
   */ var rgbFormat = function rgbFormat(r, g, b, format) {
        switch(format){
            case 'rgb':
                return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
            case 'hex':
            default:
                return "#".concat(pad2(r.toString(16))).concat(pad2(g.toString(16))).concat(pad2(b.toString(16)));
        }
    };
    /**
   * Generate unique color from `value`
   * @param  {string|number} value
   * @param  {Object}        [options={}]
   * @param  {string}        [options.format='hex']
   *  The color format, it can be one of `hex`, `rgb` or `hsl`
   * @param  {number|Array}  [options.saturation=[50, 55]]
   *  Determines the color saturation, it can be a number or a range between 0 and 100
   * @param  {number|Array}  [options.lightness=[50, 60]]
   *  Determines the color lightness, it can be a number or a range between 0 and 100
   * @param  {number}        [options.differencePoint=130]
   *  Determines the color brightness difference point. We use it to obtain the `isLight` value
   *  in the output, it can be a number between 0 and 255
   * @return {Object}
   * @example
   *
   * ```js
   * uniqolor('Hello world!')
   * // { color: "#5cc653", isLight: true }
   *
   * uniqolor('Hello world!', { format: 'rgb' })
   * // { color: "rgb(92, 198, 83)", isLight: true }
   *
   * uniqolor('Hello world!', {
   *   saturation: 30,
   *   lightness: [70, 80],
   * })
   * // { color: "#afd2ac", isLight: true }
   *
   * uniqolor('Hello world!', {
   *   saturation: 30,
   *   lightness: [70, 80],
   *   differencePoint: 200,
   * })
   * // { color: "#afd2ac", isLight: false }
   * ```
   */ var uniqolor = function uniqolor(value) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$format = _ref.format, format = _ref$format === void 0 ? 'hex' : _ref$format, _ref$saturation = _ref.saturation, saturation = _ref$saturation === void 0 ? [
            50,
            55
        ] : _ref$saturation, _ref$lightness = _ref.lightness, lightness = _ref$lightness === void 0 ? [
            50,
            60
        ] : _ref$lightness, _ref$differencePoint = _ref.differencePoint, differencePoint = _ref$differencePoint === void 0 ? 130 : _ref$differencePoint;
        var hash = Math.abs(hashCode(String(value)));
        var h = boundHashCode(hash, [
            0,
            360
        ]);
        var s = boundHashCode(hash, sanitizeRange(saturation, SATURATION_BOUND));
        var l = boundHashCode(hash, sanitizeRange(lightness, LIGHTNESS_BOUND));
        var _hslToRgb = hslToRgb(h, s, l), _hslToRgb2 = _slicedToArray(_hslToRgb, 3), r = _hslToRgb2[0], g = _hslToRgb2[1], b = _hslToRgb2[2];
        return {
            color: format === 'hsl' ? hslToString(h, s, l) : rgbFormat(r, g, b, format),
            isLight: rgbIsLight(r, g, b, differencePoint)
        };
    };
    /**
   * Generate random color
   * @param  {Object}       [options={}]
   * @param  {string}       [options.format='hex']
   *  The color format, it can be one of `hex`, `rgb` or `hsl`
   * @param  {number|Array} [options.saturation=[50, 55]]
   *  Determines the color saturation, it can be a number or a range between 0 and 100
   * @param  {number|Array} [options.lightness=[50, 60]]
   *  Determines the color lightness, it can be a number or a range between 0 and 100
   * @param  {number}       [options.differencePoint=130]
   *  Determines the color brightness difference point. We use it to obtain the `isLight` value
   *  in the output, it can be a number between 0 and 255
   * @param  {Array}        [options.excludeHue]
   *  Exclude certain hue ranges. For example to exclude red color range: `[[0, 20], [325, 359]]`
   * @return {Object}
   * @example
   *
   * ```js
   * // Generate random color
   * uniqolor.random()
   * // { color: "#644cc8", isLight: false }
   *
   * // Generate a random color with HSL format
   * uniqolor.random({ format: 'hsl' })
   * // { color: "hsl(89, 55%, 60%)", isLight: true }
   *
   * // Generate a random color in specific saturation and lightness
   * uniqolor.random({
   *   saturation: 80,
   *   lightness: [70, 80],
   * })
   * // { color: "#c7b9da", isLight: true }
   *
   * // Generate a random color but exclude red color range
   * uniqolor.random({
   *   excludeHue: [[0, 20], [325, 359]],
   * })
   * // {color: '#53caab', isLight: true}
   * ```
   */ uniqolor.random = function() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$format = _ref2.format, format = _ref2$format === void 0 ? 'hex' : _ref2$format, _ref2$saturation = _ref2.saturation, saturation = _ref2$saturation === void 0 ? [
            50,
            55
        ] : _ref2$saturation, _ref2$lightness = _ref2.lightness, lightness = _ref2$lightness === void 0 ? [
            50,
            60
        ] : _ref2$lightness, _ref2$differencePoint = _ref2.differencePoint, differencePoint = _ref2$differencePoint === void 0 ? 130 : _ref2$differencePoint, excludeHue = _ref2.excludeHue;
        saturation = sanitizeRange(saturation, SATURATION_BOUND);
        lightness = sanitizeRange(lightness, LIGHTNESS_BOUND);
        var h = excludeHue ? randomExclude(0, 359, excludeHue) : random(0, 359);
        var s = typeof saturation === 'number' ? saturation : random.apply(void 0, _toConsumableArray(saturation));
        var l = typeof lightness === 'number' ? lightness : random.apply(void 0, _toConsumableArray(lightness));
        var _hslToRgb3 = hslToRgb(h, s, l), _hslToRgb4 = _slicedToArray(_hslToRgb3, 3), r = _hslToRgb4[0], g = _hslToRgb4[1], b = _hslToRgb4[2];
        return {
            color: format === 'hsl' ? hslToString(h, s, l) : rgbFormat(r, g, b, format),
            isLight: rgbIsLight(r, g, b, differencePoint)
        };
    };
    return uniqolor;
});

});


parcelRegister("eesPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c8bba187bd1238$export$2e2bcd8739ae039);
// (c) Dr.DOC GmbH 2022
/*
// import DrawConnection from 'F:/DrDoc.WebServer/web-src/draw-connection-line.js'
// DrawConnection.init(this.$el.parentElement, initEvents);
// DrawConnection.update();
// Linien/Connection Container Element setzen:
// DrawConnection.con_lineContainer = elemRoot;
// [data-con-to=<selector>]
// [data-con-color]
// [data-con-width]
// [data-con-title]

  <div class="col align-self-center">
	<div class="con-dd-db card m-3 bg-grey text-dark text-center" data-con-to=".con-dd-serv"
	  data-con-color="darkred">
	  <div class="card-header fs-3">Dr.DOC<br />Datenbank</div>
	  <div class="card-body p-1">
		<ul class="list-group list-group-flush">
		  <li class="list-group-item">An item</li>
		  <li class="list-group-item">A second item</li>
		</ul>
	  </div>
	</div>
  </div>

  <div class="col align-self-left">
	<div class="con-dd-serv card m-3 bg-grey text-dark text-center" data-con-to=".con-dd-db"
	  data-con-color="green">
	  <div class="card-header fs-3">Dr.DOC<br />Server</div>
	  <div class="card-body p-1">
		<ul class="list-group list-group-flush">
		  <li class="list-group-item">An item</li>
		  <li class="list-group-item">A second item</li>
		</ul>
	  </div>
	</div>
  </div>

  <div class="col align-self-right">
	<div class="con-dd-client card m-3 bg-grey text-dark text-center" data-con-to=".con-dd-serv"
	  data-con-color="grey">
	  <div class="card-header fs-3">Dr.DOC<br />Client</div>
	  <div class="card-body p-1">
		<ul class="list-group list-group-flush">
		  <li class="list-group-item">Xtra</li>
		  <li class="list-group-item">Tapi</li>
		  <li class="list-group-item">VB API</li>
		</ul>
	  </div>
	</div>
  </div>



  
	<div>
		<table class="table table-lg">
			<tr>
				<td data-con-to="#tc">1 A</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 B</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 C</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 D</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 E</td>
			</tr>
			<tr>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
			</tr>
			<tr>
				<td data-con-to="#tc">2 A</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td id="tc">CENTER</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">2 C</td>
			</tr>
			<tr>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
			</tr>
			<tr>
				<td data-con-to="#tc">3 A</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 B</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 C</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 D</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 E</td>
			</tr>
		</table>
	</div>
*/ function $a5c8bba187bd1238$export$2e2bcd8739ae039() {}
window.DrawConnection = $a5c8bba187bd1238$export$2e2bcd8739ae039;
$a5c8bba187bd1238$export$2e2bcd8739ae039.DefaultColor = 'rgba(64,64,64,0.8)'; // 'rgb(32,32,32)'; // 'black';
$a5c8bba187bd1238$export$2e2bcd8739ae039.DefaultWidth = 1;
/*
export default function DrawConnection()
{
	
};
*/ /*
data-con-to="d-main" data-con-color="darkblue" data-con-width="1"
*/ /*connect('d-1', 'd-main', 'darkgreen', 2);
connect('d-2', 'd-main', 'darkgreen', 2);

connect('d-3', 'd-main', 'darkblue', 2);
connect('d-4', 'd-main', 'darkred', 2);
connect('d-5', 'd-main', 'darkred', 2);*/ $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getElem = function(el) {
    if (el != undefined && el != null) return el;
    return document;
};
$a5c8bba187bd1238$export$2e2bcd8739ae039.con_getOffset = function(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        width: rect.width || el.offsetWidth,
        height: rect.height || el.offsetHeight
    };
};
$a5c8bba187bd1238$export$2e2bcd8739ae039.con_getLength = function(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
};
$a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer = document.body;
$a5c8bba187bd1238$export$2e2bcd8739ae039.con_connectElements = function(div1, div2, color, thickness, title) {
    const off1 = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getOffset(div1);
    const off2 = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getOffset(div2);
    /*
	const x1 = off1.left + off1.width;
	const y1 = off1.top + off1.height;

	const x2 = off2.left + off2.width;
	const y2 = off2.top;
    
	const length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
	*/ // --
    // Linie mit dem geringsten Abstanf finden
    let x1 = 0;
    let x2 = 0;
    let y1 = 0;
    let y2 = 0;
    let length = -1;
    //let f_y_arr = [0.5, 0.25, 0.15];
    //let f_y_arr = [0.5, 0.25, 0.75, 0.0, 1.0];
    //let f_y_arr = [0.0, 1.0, 0.5];
    //let f_x_arr = [0.0, 1.0, 0.5, 0.25, 0.75];
    let f_x_arr = [
        0.5,
        0.0,
        1.0,
        0.2,
        0.3,
        0.4,
        0.6,
        0.7,
        0.8
    ];
    let f_y_arr = [
        0.5,
        0.0,
        1.0,
        0.2,
        0.3,
        0.4,
        0.6,
        0.7,
        0.8
    ];
    for (let f_x1 of f_x_arr)for (let f_x2 of f_x_arr){
        for (let f_y1 of f_y_arr)for (let f_y2 of f_y_arr){
            /*if (off1.top == off2.top)
					{
					  f_y1 = 0.5;
					  f_y2 = 0.5;
					}
					if (off1.left == off2.left)
					{
					  f_x1 = 0.5;
					  f_x2 = 0.5;
					}*/ // Prüfen: Punkte müssen am Rand sein und nicht im Element
            if (f_x1 > 0.0 && f_x1 < 1.0 && f_y1 > 0.0 && f_y1 < 1.0) continue;
            if (f_x2 > 0.0 && f_x2 < 1.0 && f_y2 > 0.0 && f_y2 < 1.0) continue;
            // Ecke vermeiden
            if ((f_x1 == 0.0 || f_x1 == 1.0) && (f_y1 == 0.0 || f_y1 == 1.0)) continue;
            // Ecke vermeiden
            if ((f_x2 == 0.0 || f_x2 == 1.0) && (f_y2 == 0.0 || f_y2 == 1.0)) continue;
            let tmp_x1 = off1.left + off1.width * f_x1;
            let tmp_y1 = off1.top + off1.height * f_y1;
            let tmp_x2 = off2.left + off2.width * f_x2;
            let tmp_y2 = off2.top + off2.height * f_y2;
            if ($a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.offsetLeft) {
                tmp_x1 -= $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.offsetLeft;
                tmp_x2 -= $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.offsetLeft;
            }
            if ($a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.scrollLeft) {
                tmp_x1 += $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.scrollLeft;
                tmp_x2 += $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.scrollLeft;
            }
            if ($a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.offsetTop) {
                tmp_y1 -= $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.offsetTop;
                tmp_y2 -= $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.offsetTop;
            }
            if ($a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.scrollTop) {
                tmp_y1 += $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.scrollTop;
                tmp_y2 += $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.scrollTop;
            }
            let m = Math.abs((y2 - y1) / (x2 - x1));
            if (isNaN(m) || m == Number.NaN || m == NaN) m = 0.0;
            //console.log(m);
            /*
					// Y oben/unten nur anwenden, wenn "to" deutlich darüber/darunter liegt (und nicht daneben liegt) = m hat große Steigung
					if (!((f_y1 >= 0.2 || f_y1 <= 0.8) && m >= 1.0))
						continue;
					if (!((f_y2 >= 0.2 || f_y2 <= 0.8) && m >= 1.0))
						continue;
						
					// X links/rechts nur anwenden, wenn "to" deutlich links/rechts daneben liegt (und nicht drüber/drunter)
					if (!((f_x1 >= 0.2 || f_x1 <= 0.8) && m <= 1.0))
						continue;
					if (!((f_x2 >= 0.2 || f_x2 <= 0.8) && m <= 1.0))
						continue;
*/ /*
					// kleine Steigung + ganz open/unten => überspringen
					if (m < 0.5 && (f_y1 == 1.0 || f_y1 == 0.0))
						continue;
					// kleine Steigung + ganz open/unten => überspringen
					if (m < 0.5 && (f_y2 == 1.0 || f_y2 == 0.0))
						continue;

					// große Steigung + ganz links/rechts => überspringen
					if (m > 4.0 && (f_x1 == 1.0 || f_x1 == 0.0))
						continue;
					// große Steigung + ganz links/rechts => überspringen
					if (m > 4.0 && (f_x2 == 1.0 || f_x2 == 0.0))
						continue;
*/ let tmp_length = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getLength(tmp_x1, tmp_y1, tmp_x2, tmp_y2);
            // das Ergebnis mit der geringsten Länge übernehmen
            if (length == -1 || tmp_length < length && tmp_length > 0) {
                x1 = tmp_x1;
                y1 = tmp_y1;
                x2 = tmp_x2;
                y2 = tmp_y2;
                length = tmp_length;
            }
        }
    }
    if (length < 0) return;
    // --
    //const curveSize = Math.max(Math.max(thickness + 2, 10), Math.min(150, Math.min(Math.abs(y1 - y2), Math.abs(x1 - x2)) / 3));
    const curveSize = Math.max(Math.max(thickness + 2, 10), Math.min(150, Math.min(Math.abs(y1 - y2), Math.abs(x1 - x2)) / 3));
    const arrowSizeRadius = Math.max(3, 1.5 * thickness);
    const height = Math.max(curveSize, 2 * arrowSizeRadius);
    const cx = (x1 + x2) / 2 - length / 2;
    const cy = (y1 + y2) / 2 - height / 2;
    const angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI);
    if (cx < 0) return;
    if (cy < 0) return;
    // --
    const elemCanvas = document.createElement("canvas");
    elemCanvas.classList.add('line-connection-elem');
    elemCanvas.style.margin = '0px';
    elemCanvas.style.padding = '0px';
    elemCanvas.style.position = 'absolute';
    elemCanvas.style.left = cx + 'px';
    elemCanvas.style.top = cy + 'px';
    elemCanvas.style.width = length + 'px';
    elemCanvas.width = length;
    elemCanvas.style.height = height + 'px';
    elemCanvas.style.lineHeight = height + 'px';
    elemCanvas.height = height;
    elemCanvas.style.transform = `rotate(${angle}deg)`;
    elemCanvas.style.mozTransform = `rotate(${angle}deg)`;
    elemCanvas.style.webkitTransform = `rotate(${angle}deg)`;
    elemCanvas.style.pointerEvents = 'none';
    //elemCanvas.style.zIndex = -1;
    //elemCanvas.style.zIndex = 1000;
    const ctx = elemCanvas.getContext("2d");
    //let start = { x: cx, y: cy };
    let start = {
        x: arrowSizeRadius,
        y: height / 2
    };
    let end = {
        x: length - arrowSizeRadius,
        y: height / 2
    };
    let cp1 = {
        x: Math.max(thickness, length / 4),
        y: height / 2
    };
    let cp2 = {
        x: length - cp1.x,
        y: height / 2
    };
    let heightX = height / 4;
    // erst ab 5° "bezierCurveTo" mit abweichendem cp1.y und cp2.y
    const angleMargin = 5;
    //if ((angle < 0 && angle >= -45) || (angle > 45 && angle <= 90) || (angle < -90 && angle >= -135) || (angle > 135 && angle <= 180))
    if (angle < 0 - angleMargin && angle >= -45 || angle > 45 && angle < 90 - angleMargin || angle < -90 - angleMargin && angle >= -135 || angle > 135 && angle < 180 - angleMargin) {
        cp1.y = curveSize + heightX;
        cp2.y = 0 - heightX;
    }
    //if ((angle > 0 && angle <= 45) || (angle < -45 && angle >= -90) || (angle > 90 && angle <= 135) || (angle < -135 && angle >= -180))
    if (angle > 0 + angleMargin && angle <= 45 || angle < -45 && angle > -90 + angleMargin || angle > 90 + angleMargin && angle <= 135 || angle < -135 && angle > -180 + angleMargin) {
        cp2.y = 0 - heightX;
        cp2.y = curveSize + heightX;
    }
    ctx.fillStyle = color;
    ctx.strokeStyle = color;
    ctx.lineWidth = thickness;
    // Start Punkt
    ctx.beginPath();
    //ctx.arc(start.x + arrowSizeRadius, start.y, arrowSizeRadius, 0, 2 * Math.PI);
    ctx.arc(end.x, end.y, arrowSizeRadius, 0, 2 * Math.PI);
    ctx.fill();
    // Ziel Pfeil
    ctx.beginPath();
    //ctx.moveTo(end.x + arrowSizeRadius, end.y);
    //ctx.lineTo(end.x - arrowSizeRadius*1.5, end.y - arrowSizeRadius*1);
    //ctx.lineTo(end.x - arrowSizeRadius*1.5, end.y + arrowSizeRadius*1);
    ctx.moveTo(start.x - arrowSizeRadius, start.y);
    ctx.lineTo(start.x + arrowSizeRadius * 1.69, start.y - arrowSizeRadius * 1);
    ctx.lineTo(start.x + arrowSizeRadius * 1.69, start.y + arrowSizeRadius * 1);
    ctx.fill();
    // Cubic Bézier curve
    ctx.beginPath();
    ctx.moveTo(start.x, start.y);
    ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, end.x, end.y);
    ctx.stroke();
    if (title != undefined && title != null && title.length > 0) {
        //elemCanvas.setAttribute('data-bs-toggle', 'tooltip');
        //elemCanvas.setAttribute('data-bs-title', title);
        //elemCanvas.setAttribute('data-bs-placement', 'top');
        //elemCanvas.setAttribute('data-bs-offset',);
        //elemCanvas.setAttribute('title', title);
        let fontSize = Math.max(28, Math.min(80, height));
        ctx.font = `Segoe-UI light {fontSize}px serif`;
        ctx.textAlign = 'center';
        //ctx.textBaseline = 'middle';
        ctx.lineWidth = 1.5;
        ctx.fillStyle = 'black';
        ctx.strokeStyle = 'black';
        //ctx.strokeText(title, Math.max(15, length / 2 - (fontSize/5*title.length)/2), Math.max(2, height/2+fontSize/8));
        ctx.fillText(title, Math.max(15, length / 2 - fontSize / 6 * title.length / 2), Math.max(2, height / 2 + fontSize / 8), length);
    }
    $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.appendChild(elemCanvas);
    // Tooltips rendern
    if (window.bootstrap !== undefined) {
        //document.querySelectorAll('.line-connection-elem[data-bs-toggle="tooltip"]').forEach(function (triggerElem) {
        let triggerElem = elemCanvas;
        let title = triggerElem.getAttribute('data-bs-title');
        if (!DrDocWeb.IsNullOrEmpty(title)) {
            const bs_elem = window.bootstrap.Tooltip.getOrCreateInstance(triggerElem);
        }
    //bs_elem.update();
    //});
    }
// --
/*
		const cssStyle = `
		padding:0px;
		margin:0px;
		height:${thickness}px;
		background-color:${color};
		line-height:1px;
		position:absolute;
		left:${cx}px;
		top:${cy}px;
		width:${length}px;
		-moz-transform:rotate(${angle}deg);
		-webkit-transform:rotate(${angle}deg);
		-o-transform:rotate(${angle}deg);
		-ms-transform:rotate(${angle}deg);
		transform:rotate(${angle}deg);
		x-box-shadow: 0px 0px ${DrawConnection.DefaultWidth * 2}px rgba(0,0,0, 0.1);
		`;
	
		//const htmlLine = `<div class="line-connection-elem" style="${cssStyle}" />`;
	
		//DrawConnection.con_lineContainer.innerHTML += htmlLine.replaceAll("\r", "").replaceAll("\n", "");
		var elemDiv = document.createElement('div');
		elemDiv.classList.add('line-connection-elem');
		elemDiv.style.cssText = cssStyle;
		DrawConnection.con_lineContainer.appendChild(elemDiv);*/ };
$a5c8bba187bd1238$export$2e2bcd8739ae039._staticCounter = 1;
$a5c8bba187bd1238$export$2e2bcd8739ae039.con_reset = function(el) {
    let connectionElemList = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getElem(el).querySelectorAll('.line-connection-elem');
    if (connectionElemList != undefined && connectionElemList != null && connectionElemList.length > 0) {
        //console.log('Connection: removing nr of lines: ', connectionElemList.length, connectionElemList);
        connectionElemList.forEach(function(lineItm) {
            //lineItm.parentNode.removeChild(lineItm);
            lineItm.remove();
        });
        return true;
    }
    /*document.querySelectorAll('.line-connection-elem').forEach(function (lineItm) {
		lineItm.remove();
	});*/ return false;
};
$a5c8bba187bd1238$export$2e2bcd8739ae039.con_getBoxElements = function(el) {
    var boxElements = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getElem(el).querySelectorAll('[data-con-to]');
    if (boxElements != undefined && boxElements != null && boxElements.length > 0) return boxElements;
    else return undefined;
};
$a5c8bba187bd1238$export$2e2bcd8739ae039.con_render = function(el) {
    // bisher gerenderte linien entfernen
    $a5c8bba187bd1238$export$2e2bcd8739ae039.con_reset(el);
    /*
	// alte Connection Classes entfernen
	for (let i = 1; i < 500; i++)
	{
		document.querySelectorAll('.con-id-' + i).forEach(function (itm) {
			if (itm.classList)
			{
				for (let className of itm.classList)
				{
					if (className.indexOf('con-id-') === 0)
					itm.classList.remove(className);
				}
			}
		});
	}*/ // data-con-to="d-main" data-con-color="darkblue" data-con-width="1"
    // [data-con-to="*"]
    //document.querySelectorAll('div[data-con-to]').forEach(function(elemItem) { });
    var boxElements = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getBoxElements(el);
    if (boxElements == undefined) return;
    //for (var index = 0; index < boxElements.length; index++) {
    //	var elemItem = boxElements[index];
    boxElements.forEach((elemItem)=>{
        if (elemItem.style.display == 'none') {
            console.log('DrawConnection.con_render: skip 1: ', elemItem);
            return;
        }
        if (elemItem._conInitialized === true) ;
        else {
            // noch nicht initialisiert
            elemItem._conInitialized = true;
            // beim Click rendern
            elemItem.addEventListener('click', function(e) {
                //DrawConnection.update(e);
                setTimeout(function() {
                    //DrawConnection.con_render(elemItem);
                    $a5c8bba187bd1238$export$2e2bcd8739ae039.update(e);
                }, 50);
            });
        }
        //let id = elemItem.id;
        //let id = elemItem.getAttribute('id');
        let toSelector = elemItem.getAttribute('data-con-to');
        let color = elemItem.getAttribute('data-con-color');
        let width = elemItem.getAttribute('data-con-width');
        let title = elemItem.getAttribute('data-con-title');
        /*if (id == undefined || id == null || id == '') {
		//id = 'con-id-' + index;
		id = 'con-id-' + DrawConnection._staticCounter;
		DrawConnection._staticCounter++;
		//elemItem.setAttribute('id', id);
		//elemItem.id = id;
		elemItem.classList.add(id);
		console.log(elemItem);
		}*/ let srcSelector = '';
        let id = elemItem.getAttribute('id');
        if (id != undefined && id != null && id != '') srcSelector = '#' + id;
        else {
            // wenn kein Selektor vorhanden ist, einen erstellen
            //if (elemItem._conInitName === undefined) {
            /*srcSelector = '.con-id-' + DrawConnection._staticCounter;
			DrawConnection._staticCounter++;
			elemItem._conInitName = srcSelector;
			elemItem.classList.add(srcSelector.substring(1));*/ // immer über eindeutige ID steuern
            srcSelector = '#con-id-' + $a5c8bba187bd1238$export$2e2bcd8739ae039._staticCounter;
            elemItem.id = srcSelector.substring(1);
            //elemItem._conInitName = srcSelector;
            $a5c8bba187bd1238$export$2e2bcd8739ae039._staticCounter++;
        /*}
			else {
				srcSelector = elemItem._conInitName;
			}*/ }
        if (color == null || color == undefined || color == '') color = $a5c8bba187bd1238$export$2e2bcd8739ae039.DefaultColor;
        //if (typeof width === 'string')
        //	width = +width;
        if (width == null || width == undefined || width == '' || width == '0' || +width <= 0) width = $a5c8bba187bd1238$export$2e2bcd8739ae039.DefaultWidth;
        if (toSelector != undefined && toSelector != null && toSelector != '') {
            var el_from = typeof srcSelector === 'string' && srcSelector ? $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getElem(el).querySelectorAll(srcSelector) : elemItem;
            var el_to = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getElem(el).querySelectorAll(toSelector);
            if (el_from == null || el_from.length == 0 || el_to == null || el_to.length == 0) ;
            else //console.log('con_render, elem!=null: ', el_from, ' -> ', el_to);
            el_from.forEach((el_from_item)=>{
                if (el_from_item.style.display == 'none') {
                    console.log('DrawConnection.con_render: skip from: ', el_from_item);
                    return;
                }
                el_to.forEach((el_to_item)=>{
                    if (el_to_item.style.display == 'none') {
                        console.log('DrawConnection.con_render: skip to: ', el_to_item);
                        return;
                    }
                    $a5c8bba187bd1238$export$2e2bcd8739ae039.con_connectElements(el_from_item, el_to_item, color, +width, title);
                });
            });
        }
    });
};
$a5c8bba187bd1238$export$2e2bcd8739ae039.update = function(e) {
    $a5c8bba187bd1238$export$2e2bcd8739ae039.con_render(null);
};
$a5c8bba187bd1238$export$2e2bcd8739ae039.init = function(el, listener, lineContainerElem) {
    if (lineContainerElem != undefined && lineContainerElem != null) {
        $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer = lineContainerElem;
        $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer.style.position = 'relative';
    //console.log('con init container: X: ', DrawConnection.con_lineContainer.left, DrawConnection.con_lineContainer.offsetLeft);
    //console.log('con init container: Y: ', DrawConnection.con_lineContainer.top, DrawConnection.con_lineContainer.offsetTop);
    } else $a5c8bba187bd1238$export$2e2bcd8739ae039.con_lineContainer = document.body;
    // keine Elemente vorhanden!
    var boxElements = $a5c8bba187bd1238$export$2e2bcd8739ae039.con_getBoxElements(el);
    if (boxElements == undefined) {
        console.log('Connection: keine Elemente vorhanden!');
        return;
    }
    // wurde bereits initialisiert?
    if ($a5c8bba187bd1238$export$2e2bcd8739ae039.con_reset(el)) {
        console.log('Connection: wurde bereits initialisiert!');
        return;
    }
    //DrawConnection.con_render(null);
    $a5c8bba187bd1238$export$2e2bcd8739ae039.con_render(el);
    //window.addEventListener('resize', DrawConnection.con_render);
    //document.addEventListener('DOMContentLoaded', DrawConnection.con_render);
    if (listener == undefined || listener == true) {
        setTimeout($a5c8bba187bd1238$export$2e2bcd8739ae039.update, 100);
        //setTimeout(DrawConnection.update, 2 * 1000);
        setInterval($a5c8bba187bd1238$export$2e2bcd8739ae039.update, 6000);
        window.removeEventListener('resize', $a5c8bba187bd1238$export$2e2bcd8739ae039.update);
        window.addEventListener('resize', $a5c8bba187bd1238$export$2e2bcd8739ae039.update);
        document.removeEventListener('DOMContentLoaded', $a5c8bba187bd1238$export$2e2bcd8739ae039.update);
        document.addEventListener('DOMContentLoaded', $a5c8bba187bd1238$export$2e2bcd8739ae039.update);
    }
};

});



parcelRequire("8prog");
 //console.log('Hello :)');

})();
//# sourceMappingURL=res_drdoc_lg.js.map
